export default {
  en: {
    noCommunityData: 'No community data available',
    password: 'Password',
    verifyPassword: 'Verify password',
    passwordsDontMatch: "Passwords don't match",
    userName: 'Username (e-mail)',
    language: 'Language',
    fullName: 'Full name',
    next: 'Next',
    nameRequired: 'Please enter a name',
    cityRequired: 'Please enter a city',
    descriptionRequired: 'Please enter a description',
    selectCountry: 'Please select a country',
    name: 'Name',
    city: 'City',
    postalCode: 'Postal code',
    streetAndNumber: 'Street and number',
    country: 'Country',
    createUser: 'Create user',
    signLegalDocuments: 'Agree with Terms of Use',
    suggestionsRequired: 'Please select an organisation',
    streetAndNumberRequired: 'Street and number are required',
    postalCodeRequired: 'Postal code is required',
    suggestions: 'Suggestions',
    selectPlaceholder: 'Select...',
    createAnAccount: 'Create an account',
    loginToYourAccount: 'Login to your account',
    join: 'Join',
    joinOrganisationOnPlatform: 'Join an organisation already on the platform',
    register: 'Register',
    registerOrganisationOnPlatform: 'Register an organisation new to the platform',
    confirmationEmailSent: 'Check your e-mail',
    resendEmail: 'Resend e-mail',
    confirmationEmailContent:
      "An e-mail has been sent to {{email}}.\n\nPlease open your e-mail and click the validation link to proceed with your registration. If you can't find an e-mail, check your SPAM or resend the e-mail with the button below.\n\nThis window can be closed.",
    passwordRequired: 'Please enter a password',
    passwordMinimum12charactersErr: 'A password needs to be minimum 12 characters',
    passwordMaximum80charactersErr: 'A password can be maximum 80 characters',
    reEnterPassword: 'Please re-enter your password',
    joinRequestSent: 'Join request sent',
    joinRequestContent:
      'Please wait for the organisation admin to accept your join request. Contact your organisation manager/admin for further follow-up.',
    readAllLegalDocuments: 'I have read and agree with above documents',
    sign: 'Agree',
    welcome: 'Welcome',
    chooseRoles: 'Choose roles',
    login: 'Sign in',
    communityMembershipTemplateGetFailed:
      'Something went wrong, could not get community membership template',
    membershipAlreadyRequested: 'Membership already requested',
    noLegalDocumentsToSign: 'No documents to agree',
    welcomeToTheCommunity: 'Welcome to the community.',
    viewApps: 'View apps',
    membershipRequestFailed: 'Oops, request to join community failed',
    error: 'Error',
    chooseSuggestedOrganisationToJoin:
      'Based on your e-mail address you might want to join one of the following existing organisations.',
    joinSuggestedOrganisation:
      'Based on your e-mail adress you might want to join this existing organisation.',
    selectAnOrganisation: 'Please select an organisation',
    organisationName: 'Organisation name',
    requestedAt: 'Requested at',
    back: 'Back',
    addIdentificationCode: 'Add identification code',
    identificationCode: 'Identification code',
    identificationcode: 'Identification codes',
    welcomeMessageTitle: 'Welcome to the platform!',
    selectLanguage: 'Please select a language',
    selectTimezone: 'please select a timezone',
    type: 'Type',
    organisationNameAlreadyExists: 'Organisation name already exists',
    errorWhileValidatingOrganisationName:
      'Oops, an error occured while validating the organisation name',
    thisIdentificationCodeIsAlreadyInUse: 'This identification code is already in use',
    errorWhileIdentificationCodeName:
      'Oops, an error occured while validating the identification code',
    continue: 'Continue',
    invalidEmailErr: 'Please enter a valid email address',
    dear: 'Dear {{user}},',
    successfullyReceivedRegistration:
      ' We have successfully received your registration. You will soon receive an email with a link that will give you access to the application(s) you have registered for.',
    furtherQuestions:
      'Should you have any further questions, please contact your community administrator.',
    'sorry!': 'Sorry!',
    pageRequestedNotFound: 'The page you requested was not found.',
    toTheCommunityPortal: 'To the nallian portal.',
    validateUsernameFailed: 'Error while validation the username',

    /* user mgmt + request membership */
    myOrganisation: 'My organisation',
    noMembershipRequests: 'No membership requests present',
    membershipRequests: 'Membership requests',
    createdOn: 'Created on',
    areYouSureYouWantToDenyUser: 'Are you sure you want to deny access to this user?',
    cancel: 'Cancel',
    deny: 'Deny',
    requestOfOrganisation: 'Request of {{organisation}}',
    applications: 'Applications',
    roles: 'Roles',
    signedLegalDocuments: 'Agreed legal documents',
    accept: 'Accept',
    membershipRequestUpdateFailed: 'Oops, could not update membership request',
    membershipRequestUpdateSuccess: 'Membership request updated',
    areYouSureYouWantToendMembership: 'Are you sure you want to end the membership?',
    overview: 'Overview',
    eMailaddress: 'Email address (professional)',
    membershipRequestAccepted: 'Membership request accepted',
    membershipRequestDenied: 'Membership request denied',
    dashboard: 'Dashboard',
    getLanguagesErr: 'Oops, could not fetch languages',
    getAuthorizationRolesErr: 'Oops, could not fetch authorization roles',
    getTimezonesErr: 'Oops, could not fetch timezones',
    getOrganisationStatsErr: 'Oops, could not fetch statistics',
    users: 'Users',
    noUserPresent: 'No users present',
    state: 'State',
    editUser: 'Edit user',
    deleteUser: 'Remove user',
    areYouSureYouWantToDeleteUser: 'Do you want to remove {{userName}}?',
    inviteNewUser: 'Invite new user',
    save: 'Save',
    invite: 'Invite',
    inviteUserSendEmailToAddress: 'Invite user, send email to following address:',
    createUserWithPassword: 'Create user with password:',
    enterPassword: 'Enter password',
    forceUserToChooseNewPassword: 'Force user to choose a new password on first login',
    pleaseEnterEmailAddress: 'Please enter a valid emailaddress',
    pleaseEnterRecipient: 'Please enter a recipient',
    pleaseEnterPassword: 'Please enter a password',
    selectRole: 'Please select at least one role.',
    usernameTaken: 'This username is already taken',
    userUpdated: 'User updated',
    inviteUserFailed: 'Oops, could not invite user',
    inviteUser: 'Invite user',
    userInvited: 'User invited',
    userDeleted: 'User deleted',
    deleteUserFailed: 'Oops, could not delete user',
    delete: 'Delete',
    noOrganisationRegistrations: 'No organisation registrations',
    trustedDomains: 'Trusted domain',
    trustedDomains_plural: 'Trusted domains',
    trustedDomainsOverview: 'Trusted domains',
    createTrustedDomainSuccess: 'Trusted domain is created',
    createTrustedDomainFailed: 'Something went wrong, could not create trusted domain',
    updateTrustedDomainSuccess: 'Updated trusted domain',
    addTrustedDomain: 'Add trusted domain',
    updateTrustedDomainFailed: 'Something went wrong, could not update trusted domain',
    domain: 'Domain',
    domainEmptyErr: 'Please enter an domain',
    domainInvalidErr: 'Please check the domain name.',
    autoJoin: 'Auto-join',

    /* community mgmt */
    remove: 'Remove',
    organisation: 'Organisation',
    areYouSureYouWantToDenyOrganisation:
      'Are you sure you want to deny access to this organisation?',
    areYouSureYouWantToRemoveTheRequest: 'Are you sure you want to remove the request?',
    myCommunity: 'My community',
    noMembersPresent: 'No members present.',
    addMember: 'Add member',
    edit: 'Edit',
    endMembership: 'Cancel membership',
    editMembership: 'Edit membership',
    areYouSureYouWantToEndMembership:
      'Are you sure you want to end the membership of {{organisationName}}?',
    communityMembershipEnded: 'Community membership ended',
    endCommunityMembershipFailed: 'Something went wrong, could not end membership',
    communityMembershipUpdate: 'Updated community membership',
    updateCommunityMembershipFailed: 'Something went wrong, could not update community membership',
    getCommunityMembershipFailed: 'Something went wrong, could not retrieve community membership',
    communityMembershipCreated: 'Community member created',
    createCommunityMembershipFailed: 'Something went wrong, could not create community member',
    addACommunityMember: 'Add a community member',
    updateMembershipOf: 'Update membership {{organisationName}}',
    members: 'Members',
    getUserStatesErr: 'Something went wrong, could not get userstates',
    rejectionNotice: 'Rejection notice',
    addApp: 'Add app',
    app: 'App',
    actions: 'Actions',
    role: 'Role',
    registerError: 'Something went wrong during the registration.',
    contactAdministrator:
      'For more information on the use of this Nallian Portal, please contact your Community Administrator.',
    registerEmailDomainAsTrustedRequired: 'You must enable or disable this field.',
    proceed: 'Proceed',
    privateCommunityTitle: 'Private community',
    privateCommunityDescription: 'This is a private community which can not be joined.',

    pleaseSelectOrganisation: 'Please select an organisation',
    pleaseSelectMinimumOneRole: 'Please select minimum one role',
    none: 'None',
    membershipRequestGetFailed: 'Something went wrong, could not get membership request',
    getCommunityStatsErr: 'Something went wrong, could not get community stats',
    communityMember: 'Community member',
    registrationGetFailed: 'Something went wrong, could not get registration',
    getTrustedDomainFailed: 'Something went wrong, could not get trusted domain',
    pleaseEnterAnEmailAddress: 'Please enter an e-mail address',
    noUsersPresent: 'No users present',
    communities: 'Communities',
    noCommunitiesFound: 'No communities found',
    home: 'Home',
    getIdentificationCodeTypesFailed:
      'Something went wrong, failed to get identification code types',
    pleaseSelectAType: 'Please select a type',
    pleaseEnterAValue: 'Please enter a value',
    disabled: 'Disabled',
    unverified: 'Unverified',
    verified: 'Verified',
    userState: 'User state',
    couldNotGetCommunityTemplate:
      'Something went wrong, could not retrieve the community description',
    getTermsAndConditionsFailed:
      'Something went wrong, could not retrieve the Terms and Conditions',
    chooseAPassword: 'Choose a password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    userAccountReady: 'User account ready!',
    passwordResetSuccess:
      'Your password has been successfully reset. You can now sign in to your apps.',
    failedContactOur: 'Failed to reset password, please contact our',
    support: 'Support',
    department: 'department',
    pleaseConfirmUserAccount: 'Please confirm this is your user-account',
    confirm: 'Confirm',
    invalidToken: 'Invalid token',
    needTechnicalSupport: 'If you need technical assistance , please contact our',
    passwordMin8Char: 'Choose a password of minimum 8 charaters',
    passwordConfirmIncorrect: 'Confirmation of password is incorrect',
    pleaseEnterValidEmail: 'Please enter a valid emailaddress',
    forgotPassword: 'Forgot password',
    requestNewPassword: 'Request new password',
    resetPasswordRequested: 'Reset password requested!',
    resetPasswordRequestText:
      'If you are a registered user an e-mail has been sent to your mailbox to reset your password. Please click the link in this e-mail to proceed. You can now close this window.',
    somethingWentWrong: 'Something went wrong',
    pleaseContactOur: 'Please contact our',
    failedResentEmail: 'Failed to resend invitation e-mail',
    resentEmailSuccess: 'Invitation e-mail has been resent',
    ohNo: 'Oh no!',
    invitationExpired: 'Your invitation is expired. Let us send you a new invitation:',
    resentInvitationEmail: 'Resend invitation e-mail',
    thanksForSubscribing: 'Thank you for subscribing and welcome to the Platform!',
    activatedBasicAccount:
      'We have activated your basic account which will allow you to access the various applications available to your account.',
    accessApplications:
      'You will be able to access the applications as soon as we have received the related signed agreement form(s).',
    beAware:
      'Please be aware that a Go - Live date at a later time might be applicable for certain applications.',
    contactUs: 'Contact us',
    ifQuestions: 'in case of any questions.',
    failedToActivateUserAccount: 'Failed to activate user account',
    goodNews: 'Good news!',
    accountAlreadyActivated:
      'Your account is already activated. Please go to the app using the direct link as provided in the App instructions.',
    invalidTokenText:
      'Your activation token is invalid, make sure to use the activation link in the last received invitation e-mail. If you did not receive this e-mail (do not forget your spam!), you can always contact our',
    passwordInvalidErr: 'Please enter a valid password',
    inviteSuccessMessage:
      'Your user account has been successfully registered on the Nallian platform. To continue and start using the applications, please click "Proceed" to login to the Nallian Portal.',
    address: 'Address',
    getOrganisationIdentificationCodesFailed:
      'Failed to retrieve organisation identification codes',
    getOrganisationFailed: 'Failed to retrieve organisation info',
    identificationCodes: 'Identification codes',
    getOrganisationAddressFailed: 'Failed to retrieve organisation address',
    membershipOf: 'Membership of {{organisation}}',
    organisationInfo: 'Organisation info',
    noRolesFound: 'No roles found',
    noAppsFound: 'No apps found',
    organisationUsers: 'User',
    userReinvited: 'User re-invited',
    userReinviteFailed: 'Could not re-invite user',
    reinviteUser: 'Reinvite user',
    areYouSureReinvite: 'Are you sure you want to re-invite {{userName}}?',
    yes: 'Yes',
    no: 'No',
    dontHaveAnAccountYet: "Don't have an account yet?",
    registerHere: 'Register here!',
    inviteInfo:
      'Someone from your organisation has invited you to join the platform. Please confirm that the details that are shown below are yours.',
    chooseAPasswordInfo: 'Please choose a password to finalize the invitation process.',
    resetYourPassword: 'Reset your password',
    createAnotherUser: 'Create another user',
    createdBy: 'Created by',
    createCommunityMember: 'Create community member',
    isTest: 'Is test',
    isDefault: 'Is default',
    isMessageCode: 'Is message code',
    code: 'Code',
    codeValue: 'Code',
    description: 'Description',
    updateIdentificationCodeFailed: 'Update identification code failed',
    updateIdentificationCodeSuccess: 'Update identification code success',
    addIdentificationCodeFailed: 'Add identification code failed',
    addIdentificationCodeSuccess: 'Add identification code success',
    getIdentificationCodeFailed: 'Get identification code failed',
    identificationCodeType: 'Identification code type',
    removeIdentificationCode: 'Remove identification code',
    add: 'Add',
    editIdentificationCode: 'Edit identification code',
    viewIdentificationCode: 'View identification code',
    routings: 'Routings',
    order: 'Order',
    regex: 'Regex',
    emailAddresses: 'E-mail addresses',
    toZendesk: 'To Zendesk',
    enabled: 'Enabled',
    editRouting: 'Edit routing',
    addRouting: 'Add routing',
    removeRouting: 'Are you sure you want to remove this routing?',
    toVoid: 'To void',
    addAttachments: 'Add attachments',
    stopProcessing: 'Stop processing',
    zendeskTags: 'Zendesk tags',
    priority: 'Priority',
    mustFillInEmailNoZendeskAndNoVoid:
      'You must fill in an e-mail if To Void or To Zendesk is not enabled',
    nameEmptyErr: 'Please fill in a name',
    orderEmptyErr: 'Please fill in an order',
    regexEmptyErr: 'Please fill in a regex',
    priorityIdEmptyErr: 'Please select a priority',
    routingsOrder: 'Routings order',
    updateRoutingsOrderSuccess: 'Update routings order success',
    updateRoutingsOrderFailed: 'Update routings order failed',
    saveOrder: 'Save order',
    apiResources: 'Api resource',
    apiResources_plural: 'Api resources',
    tokenLifetime: 'Token lifetime',
    stsclients: 'STS Client',
    stsclients_plural: 'STS Clients',
    clientName: 'Client name',
    clientId: 'Client ID',
    fillForm: 'Fill form',
    clientNameInfo: 'Client display name (used for logging and consent screen)',
    clientIdInfo: 'Unique ID of the client',
    clientUri: 'Client Uri',
    clientUriInfo: 'URI to further information about client (used on consent screen)',
    logoUri: 'Logo Uri',
    logoUriInfo: 'URI to client logo (used on consent screen)',
    allowedScopes: 'Allowed scopes',
    allowedScopesInfo:
      'By default a client has no access to any resources - specify the allowed resources by adding the corresponding scopes names',
    allowedGranttypes: 'Allowed granttypes',
    allowedGranttypesInfo:
      'Specifies the grant types the client is allowed to use. Use the GrantTypes class for common combinations.',
    protocolType: 'Protocol type',
    rowVersion: 'Row version',
    enableClient: 'Enable client',
    enableClientInfo: 'Specifies if client is enabled. Defaults to true.',
    allowOfflineAccessInfo:
      'Specifies whether this client can request refresh tokens (be requesting the offline_access scope)',
    allowOfflineAccess: 'Allow refreshtokens',
    requireClientSecret: 'Require client secret',
    requireClientSecretInfo:
      'Specifies whether this client needs a secret to request tokens from the token endpoint (defaults to true)',
    noAppSubscriptionRequired: 'No App Subscription required',
    allowAccessTokensViaBrowser: 'Allowe accesstokens via browser',
    allowAccessTokensViaBrowserInfo:
      'Specifies whether this client is allowed to receive access tokens via the browser. This is useful to harden flows that allow multiple response types (e.g. by disallowing a hybrid flow client that is supposed to use code id_token to add the token response type and thus leaking the token to the browser.',
    requirePkce: 'Require PKCE',
    requirePkceInfo:
      'Specifies whether clients using an authorization code based grant type must send a proof key (defaults to true).',
    allowPlainTextPkce: 'Allow plain text PKCE',
    allowPlainTextPkceInfo:
      'Specifies whether clients using PKCE can use a plain text code challenge (not recommended - and default to false)',
    redirectUrisInfo: 'Specifies the allowed URIs to return tokens or authorization codes to',
    redirectUris: 'Redirect uris',
    postLogoutRedirectUris: 'Post logout redirect uris',
    postLogoutRedirectUrisInfo:
      'Specifies allowed URIs to redirect to after logout. See the OIDC Connect Session Management spec for more details.',
    identityProviderRestrictions: 'Identity Provider Restrictions',
    identityProviderRestrictionsInfo:
      'Specifies which external IdPs can be used with this client (if list is empty all IdPs are allowed). Defaults to empty.',
    frontChannelLogoutSessionRequired: 'Frontchannel logoutsession is required',
    frontChannelLogoutSessionRequiredInfo:
      'Specifies if the user’s session id should be sent to the FrontChannelLogoutUri. Defaults to true.',
    frontChannelLogoutUri: 'Front channel logout uri',
    frontChannelLogoutUriInfo:
      'Specifies logout URI at client for HTTP based front-channel logout. See the OIDC Front-Channel spec for more details.',
    backChannelLogoutSessionRequired: 'Backchannel logoutsession is required',
    backChannelLogoutSessionRequiredInfo:
      'Specifies if the user’s session id should be sent in the request to the BackChannelLogoutUri. Defaults to true.',
    backChannelLogoutUri: 'Logout-uri:',
    backChannelLogoutUriInfo:
      'Specifies logout URI at client for HTTP based back-channel logout. See the OIDC Back-Channel spec for more details.',
    logoutSession: 'Logout session',
    enableLocalLogin: 'Enable local login',
    enableLocalLoginInfo:
      'Specifies if this client can use local accounts, or external IdPs only. Defaults to true.',
    accessTokenLifetime: 'Accesstoken lifetime',
    accessTokenLifetimeInfo:
      'Lifetime of access token in seconds (defaults to 3600 seconds / 1 hour)',
    absoluteRefreshTokenLifetime: 'Absolute refreshtoken lifetime',
    absoluteRefreshTokenLifetimeInfo:
      'Maximum lifetime of a refresh token in seconds. Defaults to 2592000 seconds / 30 days',
    identityTokenLifetime: 'Identitytoken lifetime',
    identityTokenLifetimeInfo:
      'Lifetime to identity token in seconds (defaults to 300 seconds / 5 minutes)',
    authorizationCodeLifetime: 'Authorization code lifetime',
    authorizationCodeLifetimeInfo:
      'Lifetime of authorization code in seconds (defaults to 300 seconds / 5 minutes)',
    slidingRefreshTokenLifetime: 'Sliding refreshtoken lifetime',
    slidingRefreshTokenLifetimeInfo:
      'Sliding lifetime of a refresh token in seconds. Defaults to 1296000 seconds / 15 days',
    clientClaimsPrefix: 'Client claims prefix',
    clientClaimsPrefixInfo:
      'If set, the prefix client claim types will be prefixed with. Defaults to client_. The intent is to make sure they don’t accidentally collide with user claims.',
    pairWiseSubjectSalt: 'Paire wise subject salt',
    pairWiseSubjectSaltInfo:
      'Salt value used in pair-wise subjectId generation for users of this client.',
    updateAccessTokenClaimsOnRefresh: 'Update accesstoken claims on refresh',
    updateAccessTokenClaimsOnRefreshInfo:
      'Gets or sets a value indicating whether the access token (and its claims) should be updated on a refresh token request.',
    accessTokenType: 'Reference accesstoken',
    accessTokenTypeInfo:
      'Specifies whether the access token is a reference token or a self contained JWT token (defaults to Jwt).',
    includeJwtId: 'Include JWT ID',
    includeJwtIdInfo:
      'Specifies whether JWT access tokens should have an embedded unique ID (via the jti claim). Defaults to true.',
    alwaysSendClientClaims: 'Always send client claims',
    alwaysSendClientClaimsInfo:
      'If set, the client claims will be sent for every flow. If not, only for client credentials flow (default is false)',
    alwaysIncludeUserClaimsInIdToken: 'Always include user claims in identity token',
    alwaysIncludeUserClaimsInIdTokenInfo:
      'When requesting both an id token and access token, should the user claims always be added to the id token instead of requiring the client to use the userinfo endpoint. Default is false.',
    allowedCorsOriginsInfo:
      'If specified, will be used by the default CORS policy service implementations (In-Memory and EF) to build a CORS policy for JavaScript clients.',
    allowedCorsOrigins: 'Allowed CORS origins',
    consentLifetimeInfo: 'Lifetime of a user consent in seconds. Defaults to null (no expiration).',
    consentLifetime: 'Consent lifetime',
    requireConsent: 'Require consent',
    requireConsentInfo: 'Specifies whether a consent screen is required. Defaults to false.',
    allowRememberConsent: 'Allow remember consent',
    allowRememberConsentInfo:
      'Specifies whether user can choose to store consent decisions. Defaults to true.',
    refreshTokenUsage: 'Refresh token usage',
    refreshTokenUsageInfo:
      "'ReUse' the refresh token handle will stay the same when refreshing tokens. 'OneTime' the refresh token handle will be updated when refreshing tokens. This is the default.",
    refreshTokenExpiration: 'Refreshtoken expiration',
    refreshTokenExpirationInfo:
      "'Absolute' the refresh token will expire on a fixed point in time (specified by the AbsoluteRefreshTokenLifetime). This is the default. 'Sliding' when refreshing the token, the lifetime of the refresh token will be renewed (by the amount specified in SlidingRefreshTokenLifetime). The lifetime will not exceed AbsoluteRefreshTokenLifetime.",
    reUse: 'Reuse',
    oneTimeOnly: 'One time only',
    sliding: 'Sliding',
    absolute: 'Absolute',
    updateUserFailed: 'Update user failed',
    getUserFailed: 'Get user failed',
    isHidden: 'Hidden',
    isOwner: 'Owner',
    updateSuiteFailed: 'Update suite failed',
    updateSuiteSuccess: 'Update suite success',
    suites_plural: 'Suites',
    suites: 'Suite',
    tiers: 'Tiers',
    apps: 'App',
    allApplications: 'All Applications',
    appCountSingular: '{{count}} application',
    appCountPlural: '{{count}} applications',
    addAppFeature: 'Add app feature',
    tierApps: 'Tier apps',
    suite: 'Suite',
    tier: 'Tier',
    suiteTier: 'Tier',
    suiteIdEmptyErr: 'Please select a suite',
    suiteTierIdEmptyErr: 'Please select a tier',
    timezone: 'Time zone',
    communityMembers: 'community member',
    communityMembers_plural: 'Community members',
    getCommunityRolesFailed: 'Get community roles failed',
    myApps: 'My apps',
    principalJoinRequests: 'Join requests',
    selectExistingUser:
      "Search for an existing user (this will override the existing user's profile with the information below)",
    acceptJoinRequestFor: 'Accept join request of {{user}}',
    preApproveForLinking: 'Pre-approve for linking',
    areYouSureYouWantToUnlinkIdentity: 'Are you sure you want to unlink the account from the user?',
    preApproveForLinkingInfo:
      'Automatically approve the join request if someone wants to link his account to this user',
    acceptJoinRequestFailed: 'Accept join request failed',
    acceptJoinRequestSuccess: 'Accept join request success',
    viewOrganisation: 'View organisation',
    myIdentity: 'My account',
    active: 'Active',
    activeState: 'Active state',
    activeStatus: 'Active status',
    addApplication: 'Add app',
    addAppSubscription: 'Add app subscription',
    addCommunityRoleFailed: "Couldn't add the community role",
    addCommunityRoleSuccess: 'The community role has been added',
    addFeature: 'Add feature',
    addOwner: 'Add owner',
    addRole: 'Add role',
    addSubscription: 'Add subscription',
    addSuite: 'Add suite',
    addTier: 'Add tier',
    addUser: 'Add user',
    alias: 'Alias',
    aliasEmptyErr: 'Please enter an alias',
    appDetailsAliasEmptyErr: 'Please enter an alias',
    appDetailsTagEmptyErr: 'Please select an app',
    appDetailsUrlEmptyErr: 'Please enter an url',
    appFeatures: 'App features',
    appInstallationFeatureTagEmptyErr: 'Please select a feature',
    appInstallationIdEmptyErr: 'Please select an app',
    appInstallations: 'App installations',
    application: 'App',
    apps_plural: 'Apps',
    appSubscription: 'App subscription',
    appTypeIdEmptyErr: 'Please select an app type',
    areYouSureRemoveIdentificationCodeType:
      'Are you sure you want to remove this identificationcode type?',
    areYouSureRemoveOnboardingTemplate: 'Are you sure you want to remove this onboarding template?',
    areYouSureRemovePrincipal: 'Are you sure you want to remove {{name}} ({{email}})?',
    areYouSureActivatePrincipal: 'Are you sure you want to activate {{name}}?',
    activatePrincipal: 'Activate User',
    activate: 'Activate',
    activatePrincipalSuccess: 'The user has been activated',
    activatePrincipalFailed: "Couldn't activate the user",
    areYouSureRemoveRelation: 'Are you sure you want to remove this relation?',
    areYouSureYouWantToDenyJoinRequest: 'Are you sure you want to deny this join request?',
    cityEmptyErr: 'Please fill in a city',
    close: 'Close',
    community: 'Community',
    communityApps: 'Community app',
    communityApps_plural: 'Community apps',
    communityMemberCreatedAndInvited:
      'The community member has been created and user has been invited',
    communityMemberCreatedAndInvitedError:
      "Couldn't create the community member and invite the user",
    communityRoles: 'Community role',
    communityRoles_plural: 'Community roles',
    communitySuites: 'Community suite',
    communitySuites_plural: 'Community suites',
    communityInfo: 'Community Information',
    communityManagement: 'Community Management',
    confirmInvitationInfo:
      'Please confirm the details below are correct. In the next steps you can complete your account information and finish the registration process.',
    couldNotCompleteInvitation:
      'Unfortunately we could not complete your invitation.<0></0>Try again or contact our support desk <1>{{text}}</1>.',
    countryEmptyErr: 'Please select a country',
    createAppFailed: "Couldn't create the app",
    createAppSubscriptionFailed: "Couldn't create the app subscription",
    createAppSubscriptionSuccess: 'The app subscription has been created',
    createAppSuccess: 'The app has been created',
    createCommunityAppFailed: "Couldn't create the community app",
    createCommunityAppSuccess: 'The community app has been created',
    createCommunityMemberFailed: "Couldn't create the community member",
    createCommunityMemberSuccess: 'The community member has been created',
    createCommunitySuiteFailed: "Couldn't create the community suite",
    createCommunitySuiteSuccess: 'The community suite has been created',
    createIdentificationCodeTypeFailed: "Couldn't create the identificationcode type",
    createIdentificationCodeTypeSuccess: 'The identificationcode type has been created',
    createNewMember: 'Create new member',
    createNewOrganisation: 'Create new organisation',
    createOnboardingTemplateFailed: "Couldn't create the onboarding template",
    createOnboardingTemplateSuccess: 'The onboarding template has been created',
    createOrganisationRoleFailed: "Couldn't create the organisation role",
    createOrganisationRoleSuccess: 'The organisation role has been created',
    createPrincipalFailed: "Couldn't create the user",
    createPrincipalSuccess: 'The user has been created',
    createRelationFailed: "Couldn't create the relation",
    createRelationSuccess: 'The relation has been created',
    createRelationTypeFailed: "Couldn't create the relation type",
    createRelationTypeSuccess: 'The relation type has been created',
    createSuiteFailed: "Couldn't create the suite",
    createSuiteSuccess: 'The suite has been created',
    createUserFailed: "Couldn't create the user",
    createUserSuccess: 'The user has been created',
    defaultCommunity: 'Default community',
    deleted: 'Deleted',
    denyJoinRequestFailed: "Couldn't deny the join request",
    denyJoinRequestSuccess: 'The join request has been denied',
    markUniqueJoinRequestFailed: "Couldn't mark the join request as not a duplicate",
    markUniqueJoinRequestSuccess: 'Join request marked as not a duplicate',
    markNotDuplicateConfirmation:
      'Mark this join request as not a duplicate. This will change the status to New and notify the Community admin.',
    descriptionEmptyErr: 'Please fill in a description',
    details: 'Details',
    displayName: 'Display name',
    editApp: 'Edit app',
    editCommunityApp: 'Edit community app',
    editCommunityMember: 'Edit community member',
    editCommunityRole: 'Edit community role',
    editFeature: 'Edit feature',
    editOrganisationRole: 'Edit organisation role',
    editSubscription: 'Edit subscription',
    email: 'Email address',
    emailAddress: 'Email address',
    emailAddressEmptyErr: 'Please fill in an e-mail address',
    emailOrPhoneNumberRequiredError: 'A valid email address or phone number is required',
    externalIdentifier: 'External identifier',
    feature: 'Feature',
    featureName: 'Feature name',
    features: 'Features',
    featureSubscriptions: 'Subscriptions',
    subscriptions: 'Subscriptions',
    subscriptionRequired: 'Subscription Required',
    noSubscriptionRequired: 'No Subscription Required',
    firstSelectAFeature: 'First select a feature',
    firstSelectAnApp: 'First select an app',
    fullNameEmptyErr: 'Please enter a full name',
    general: 'General',
    getAppFailed: "Couldn't get the app",
    getAppInstallationFailed: "Couldn't get the app installation",
    getAppInstallationsFailed: "Couldn't get the app installations",
    getAppsFailed: "Couldn't get the apps",
    getAppSubscriptionsFailed: "Couldn't get the app subscriptions",
    getAvailableRolesFailed: "Couldn't get the available roles",
    getCommunityAppsFailed: "Couldn't get the community apps",
    getCommunityMemberRolesFailed: "Couldn't get the roles for this organisation",
    getIdentificationCodeTypeFailed: "Couldn't get the identification type",
    getJoinRequestFailed: "Couldn't get the join request",
    getOnboardingTemplateFailed: "Couldn't get the onboarding template",
    getOrganisationRolesFailed: "Couldn't get the roles",
    getPrincipalFailed: "Couldn't get the user",
    getRelationFailed: "Couldn't get the relation",
    getRelationsFailed: "Couldn't get the relations",
    getRelationTypeFailed: "Couldn't get the relation type",
    getRelationTypesFailed: "Couldn't get the relation types",
    getSuiteFailed: "Couldn't get the suite",
    getSuitesFailed: "Couldn't get the suites",
    global: 'Global',
    here: 'here',
    hostedAt: 'Hosted at',
    identificationcodetypes: 'Identificationcode type',
    identificationcodetypes_plural: 'Identificationcode types',
    identities: 'Accounts',
    identity: 'Account',
    inactive: 'Inactive',
    installationIndex: 'Installation index',
    introducedInVersion: 'Introduced in version',
    introducedInVersionEmptyErr: 'Please enter in which version this feature was introduced',
    invalidInvitation1: 'Something went wrong while getting your invitation.',
    invalidInvitation2: 'It may be expired or it does not exist.',
    invitationExpiresOn: 'Invitation expires on',
    invitationInfo:
      '<bold>{{username}}</bold> from organisation <bold>{{organisation}}</bold> has invited you to join the <bold>{{community}}</bold> community.',
    invitationSentOn: 'Invitation sent on',
    invitationState: 'Invitation state',
    invitationType: 'Invitation type',
    invited: 'Invited',
    inviteFreeText: 'Add a message that will be included in the invitation e-mail',
    isCustomer: 'Is customer',
    isGloballyManaged: 'Available for community admins',
    isOptional: 'Is optional',
    isSystem: 'Is system',
    isVisible: 'Is visible',
    joinMessage: 'Your message for the community admin',
    joinRequestAcceptedInfo: 'Dear {{fullName}}, your join request has been approved.',
    joinRequestError: 'Join request could not be sent',
    joinRequestErrorMessage:
      'Something went wrong while sending your join request to the community admin. Please try again later.',
    joinRequests: 'Join requests',
    joinRequestSentToCommunityAdmin: 'Join request sent to community admins',
    joinRequestSentToCommunityAdminDescription:
      'Your join request has been sent to the community admins to grant you access to community apps.',
    new: 'New',
    notADuplicate: 'Not a duplicate',
    potentialDuplicate: 'Potential duplicate',
    potentialDuplicates: 'Potential duplicates',
    potentialDuplicateTooltip: 'This request is under review by Nallian before proceeding.',
    potentialDuplicationDetails: 'Potential Duplication Details',
    potentialDuplicateCannotManage:
      'Since this join request might be a potential duplicate, it is under review by Nallian before proceeding. This join request cannot be accepted or denied at this time.',
    duplicateByIdentificationCode:
      'This duplication was detected by one or more matching identification codes',
    joinRequest: 'Join request',
    score: 'Score',
    languageEmptyErr: 'Please select a language',
    languageIdEmptyErr: 'Please select a language',
    linkExistingOrganisation: 'Link existing organisation',
    linkIdentityFailed: 'Could not link account to user',
    linkIdentitySuccess: 'Account linked to user',
    linkMyIdentityToPrincipal: 'Link my account to user',
    location: 'Location',
    lockedOut: 'Locked out',
    management: 'Management',
    mine: '(my account)',
    newApp: 'New app',
    newAppSubscription: 'New app subscription',
    newCommunityApp: 'New community app',
    newCommunityMember: 'New community member',
    newCommunityRole: 'New community role',
    newCommunitySuite: 'New community suite',
    newFeature: 'New feature',
    newIdentificationCodeType: 'Add type',
    newOnboardingTemplate: 'New onboarding template',
    newOrganisationRole: 'New organisation role',
    newRelation: 'New relation',
    newRelationType: 'New relation type',
    newSuite: 'New suite',
    newUser: 'New user',
    noAppsConfiguredForOnboardingTemplate: 'No apps configured for template.',
    noFeaturesDefined: 'No features defined',
    noFeaturesDefinedYet: 'No features configured yet',
    noFeaturesFound: 'No features found',
    noLinkedAccountsYet: 'No linked accounts yet.',
    noPendingInvitationsFound: 'No pending invitations found',
    noRolesDefined: 'No roles defined',
    noSuitesFound: 'No suites found',
    noTiersFound: 'No tiers found',
    noUsersFound: 'No users found',
    noAssignmentsFound: 'No assignments found',
    noSubscriptionsFound: 'No subscriptions found',
    subscriptionId: 'Subscription ID',
    createFeatureSubscription: 'Create feature subscription',
    createSubscription: 'Create subscription',
    createFeatureSubscriptionSuccess: 'Feature subscription created successfully',
    createFeatureSubscriptionFailed: 'Failed to create feature subscription',
    createRoleAssignmentSuccess: 'The assignment has been updated.',
    createRoleAssignmentFailed: 'Failed to add the user to the role',
    removeUser: 'Remove user',
    areYouSureRemoveRoleAssignment:
      'Are you sure you want to remove {{name}} - {{email}} from this role?',
    removeRoleAssignmentSuccess: 'The user has been removed from the role.',
    removeRoleAssignmentFailed: 'Failed to remove the user from the role',
    addSubscription: 'Add subscription',
    addSubscriptionSuccess: 'The subscription has been updated.',
    addSubscriptionFailed: 'Failed to add the subscription',
    removeOrgSubscription: 'Remove subscription',
    areYouSureRemoveOrgSubscription:
      'Are you sure you want to remove the subscription of Feature: {{featureName}} - Installation: {{installationName}} - App: {{appName}} from organisation {{organisationName}}? Access to this feature will be revoked for all the users of this organisation.',
    removeOrgSubscriptionSuccess: 'The subscription has been removed.',
    removeOrgSubscriptionFailed: 'Failed to remove the subscription',
    communityIdEmptyErr: 'Please select a community',
    organisationIdEmptyErr: 'Please select an organisation',
    principalIdEmptyErr: 'Please select a user',
    assignmentType: 'Assignment Type',
    assignments: 'Assignments',
    principalName: 'Principal Name',
    organisationCityEmptyErr: 'Please enter a city',
    organisationCountryEmptyErr: 'Please enter a country',
    organisationDetailsDescription: 'Fill in the details of the organisation',
    organisationNameEmptyErr: 'Please enter an organisation name',
    organisationRole: 'Organisation role',
    organisationRoles: 'Organisation role',
    organisationRoles_plural: 'Organisation roles',
    organisationType: 'Organisation type',
    organisations: 'Organisations',
    organisationsOverview: 'Organisations overview',
    owners: 'Owners',
    parentOrganisation: 'Parent organisation',
    passwordToDelete: 'Password to delete',
    pending: 'Pending',
    pendingInvitations: 'Pending invitation',
    pendingInvitations_plural: 'Pending invitations',
    phoneNumber: 'Phone number',
    pleaseAcceptOurTermsAndConditions: 'Please accept our terms and conditions',
    pleaseCompleteOrganisationDetails: 'Please complete the details of your organisation below.',
    postalCodeEmptyErr: 'Please fill in a postal code',
    primaryEmailAddressEmptyErr: 'Please enter a valid email address',
    primaryPhoneNumberEmptyErr: 'Please enter a valid phone number',
    principalFullNameEmptyErr: 'Please enter a full name',
    principalLanguageIdEmptyErr: 'Please select a language',
    principals: 'user',
    principalTimeZoneEmptyErr: 'Please select a time zone',
    reInvite: 'Re-invite',
    relationType: 'Relation',
    relationTypeIdEmptyErr: 'Please select a relation type',
    relationTypes: 'Relation type',
    relationTypes_plural: 'Relation types',
    removeApp: 'Remove app',
    removeAppAndRoles: 'Remove app, features & roles',
    removeAppSubscriptionFailed: 'Remove subscription failed',
    removeAppSubscriptionSuccess: 'Remove subscription success',
    removeFeature: 'Remove feature',
    removeThisFeature: 'Remove this feature',
    removeThisRole: 'Remove role',
    removeThisSuite: 'Remove this suite',
    removeThisTier: 'Remove this tier',
    requestToJoin: 'Request to join',
    requestToJoinInfo:
      'If your organisation would like to join this community, please fill in the form.<br/>The community admin will review your application and contact you shortly.',
    requiresSubscription: 'Require subscription',
    resendInvitationFailed: "Couldn't resend the invitation",
    resendInvitationSuccess: 'The invitation has been resent',
    resetPassword: 'Reset password',
    reviewJoinRequest: 'Review join request',
    selectAnApp: 'Select an app',
    selectAnApplication: 'Select an app',
    sendInvitation: 'Send invitation',
    sometingWentWrong: 'Something went wrong',
    source: 'Source',
    sourceIdEmptyErr: 'Please select a source',
    sourceOrganisationRoles: 'Source organisation roles',
    stateName: 'State',
    status: 'Status',
    streetAndNumberEmptyErr: 'Please fill in a street & number',
    tag: 'Tag',
    tagEmptyErr: 'Please fill in a tag',
    tagExplainer: 'Starts with alphabetic character, max length of 20',
    target: 'Target',
    targetIdEmptyErr: 'Please select a target',
    targetOrganisationRoles: 'Target organisation roles',
    template: 'Template',
    templateHasNoConfiguration: 'Template has no configuration',
    templateInfo1:
      'A template will give the administrator access to a set of apps and give him a list of organisation roles.',
    templateInfo2: 'Select a template to view its configuration',
    textMessage: 'Text message',
    noUserGroupsFound: 'No user groups found',
    areYouSureRemoveUserGroup: 'Are you sure you want to remove this user group?',
    createUserGroupFailed: "Couldn't create user group",
    createUserGroupSuccess: 'User group created',
    updateUserGroupFailed: "Couldn't update user group",
    updateUserGroupSuccess: 'User group updated',
    getUserGroupFailed: "Couldn't get user group",
    addUserGroup: 'Add user group',
    newUserGroup: 'New user group',
    noAppsFeaturesRolesDefined: 'No apps, features, roles defined',
    createUserGroupMemberFailed: "Couldn't create user group member",
    createUserGroupMemberSuccess: 'User group member created',
    removeUserGroupMemberFailed: "Couldn't remove user group member",
    removeUserGroupMemberSuccess: 'User group member remove',
    getUserGroupMembersFailed: "Couldn't get user group members",
    membersOfUserGroup: 'Members of user group',
    timezoneEmptyErr: 'Please select a time zone',
    timeZoneEmptyErr: 'Please select a time zone',
    timeZoneIdEmptyErr: 'Please select a timezone',
    unauthorized: 'You are not authorized to perform this action.',
    unlink: 'Unlink',
    unlinkIdentityFailed: "Couldn't unlink the account",
    unlinkIdentitySuccess: 'The account has been unlinked',
    unlisted: 'Unlisted',
    updateAppFailed: "Couldn't update the app",
    updateAppSubscriptionFailed: "Couldn't update the app subscription",
    updateAppSubscriptionSuccess: 'The app subscription has been updated',
    updateAppSuccess: 'The app has been updated',
    updateCommunityAppFailed: "Couldn't update the community app",
    updateCommunityAppSuccess: 'The community app has been updated',
    updateCommunityMemberFailed: "Couldn't update the community member",
    updateCommunityMemberRolesFailed: "Couldn't update the community member roles",
    updateCommunityMemberRolesSuccess: 'The community member roles have been updated',
    updateCommunityMemberSuccess: 'The community member has been updated',
    updateCommunityRoleFailed: "Couldn't update the community role",
    updateCommunityRoleSuccess: 'The community role has been updated',
    updateCommunitySuiteFailed: "Couldn't update the community suite",
    updateCommunitySuiteSuccess: 'The community suite has been updated',
    updateIdentificationCodeTypeFailed: "Couldn't update the identificationcode type",
    updateIdentificationCodeTypeSuccess: 'The identificationcode type has been updated',
    updateOnboardingTemplateFailed: "Couldn't update the onboarding template",
    updateOnboardingTemplateSuccess: 'The onboarding template has been updated',
    updateOrganisationRoleFailed: "Couldn't update the organisation role",
    updateOrganisationRoleSuccess: 'The organisation role has been updated',
    updatePrincipalFailed: "Couldn't update the user",
    updatePrincipalSuccess: 'The user has been updated',
    updateRelationFailed: "Couldn't update the relation",
    updateRelationSuccess: 'The relation has been updated',
    updateRelationTypeFailed: "Couldn't update the relation type",
    updateRelationTypeSuccess: 'The relation type has been updated',
    updateUserSuccess: 'The user has been updated',
    url: 'Url',
    urlEmptyErr: 'Please enter an url',
    useATemplate: 'Use a template',
    user: 'User',
    userDetailsDescription: 'Fill in the user details',
    validationPattern: 'Validation pattern',
    verifiedStatus: 'Verified status',
    view: 'View',
    viewMore: 'View More',
    viewSubscribedOrganisations: 'View subscribed organisations',
    viewTemplate: 'View template',
    welcomeToThePlatform: 'Welcome to the platform!',
    welcomeToThePlatformInfo:
      'Your user account has been successfully registered on the Nallian platform. To continue and start using the applications, please click "Proceed" to login to the Nallian Portal.',
    searchAndAddMember: 'Search and add a member',
    searchForNameOrEmailOfUser: 'Search for a name or email of a user',
    editUserGroup: 'Edit user group',
    manageMembers: 'View/manage members',
    userGroupHasNoMembers: 'This user group has no members',
    organisationsForRole: 'Organisations for community role',
    noOrganisationsFound: 'No organisations found',
    viewOrganisations: 'View organisations',
    appSubscriptions: 'App Subscriptions',
    createdByOrganisation: 'Created by organisation',
    metaData: 'Meta data',
    lastModifiedOn: 'Last modified on',
    linkedAccounts: 'Linked accounts',
    relations: 'Relations',
    youHaveBeenInvited: 'You have been invited',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Are you sure want to remove the subscription for this feature? Access to this feature will be revoked for all the users of this organisation.',
    applyOnboardingTemplate: 'Apply onboarding template',
    getOnboardingTemplatesFailed: 'Could not get onboarding templates',
    selectAnOnboardingTemplate: 'Select an onboarding template',
    onboardingTemplateIdEmptyErr: 'Please select an onboarding template',
    applyOnboardingTemplateFailed: 'Could not apply onboarding template',
    applyOnboardingTemplateSuccess: 'Onboarding template applied',
    addTemplateInfo:
      'The template will add the following apps & community roles to the organisation',
    filters: 'Filters',
    filterOnUserRole: 'Filter on user role',
    identityOrClient: 'Account or client',
    searchForAnIdentityOrAddClientId: 'Search for an account or add a client ID',
    filterOnIdentificationCode: 'Filter on identification code',
    useNoTemplate: 'Use no template',
    templateInfo: 'Select a template',
    userInfo: 'User info',
    invalidUrlCommuntiyAppFeature: 'Must be a valid URL or must contain [EnvironmentUrl]',
    communitiesOverview: 'Communities overview',
    createCommunityFailed: "Couldn't create community",
    createCommunitySuccess: 'Community created',
    newCommunity: 'New community',
    themeName: 'Theme name',
    defaultLanguage: 'Default language',
    mustBeValidUrl: 'Must be a valid URL',
    updateCommunityFailed: "Couldn't update community",
    updateCommunitySuccess: 'Community updated',
    fixedCommunityId:
      'ID (not mandatory, only if you want the same community ID on all environments)',
    updateNotificationSettingsFailed: "Couldn't update notification settings",
    updateNotificationSettingsSuccess: 'Notification settings updated',
    notificationSettings: 'Notification settings',
    fromName: 'From name',
    fromEmail: 'From email',
    replyToEmail: 'Reply to email',
    replyToName: 'Reply to name',
    emailSubjectPrefix: 'Email subject prefix',
    contactEmail: 'Contact email',
    updateHostsFailed: "Couldn't update hosts",
    updateHostsSuccess: 'Hosts updated',
    noHostsYet: 'No hosts yet',
    addHost: 'Add host',
    host: 'Host',
    hosts: 'Hosts',
    isPrimary: 'Is primary',
    onlyOnePrimaryHost: 'Only one host can be primary',
    minOnePrimaryHost: 'Minium one host must be primary',
    pleaseEnterAHost: 'Please enter a (valid) host',
    tenantId: 'Tenant ID',
    tenantHostUrl: 'Tenant host url',
    tenantInformation: 'Tenant information',

    communityWelcomeText: 'Community welcome text',
    legalDocuments: 'Legal documents',
    uploadNewGeneralTermsAndConditions: 'Upload new General Terms & Conditions',
    documents: 'Documents',
    title: 'Title',
    revision: 'Revision',
    download: 'Download',
    // theme lookups (internal)
    themeLookups_plural: 'Theme lookups',
    newThemeLookup: 'New theme lookup',
    createThemeLookupFailed: "Couldn't create theme lookup",
    createThemeLookupSuccess: 'Theme lookup created',
    updateThemeLookupFailed: "Couldn't update theme lookup",
    updateThemeLookupSuccess: 'Theme lookup updated',
    editThemeLookup: 'Edit theme lookup',
    themeLookups: 'Theme lookup',
    titleEmptyErr: 'Please enter a title',
    hostEmptyErr: 'Please enter a host',
    themeNameEmptyErr: 'Please enter a theme name',
    editCommunityTextFailed: "Couldn't update community text",
    editCommunityTextSuccess: 'Community text updated',
    documentUploaded: 'Document uploaded',
    documentUploadFailed: 'Document upload failed',
    noCommunityTextYet: 'No community welcome text yet',
    noDocumentsYet: 'No documents yet',
    noWelcomeTextAvailable: 'No welcome information available for this community.',
    addLanguage: 'Add language',
    enterLanguageKey: 'Enter your language key',
    emailNotificationFooter: 'Email notification footer',
    emailNotificationHeader: 'Email notification header',
    removeCommunityAppClientFailed: "Couldn't remove client",
    removeCommunityAppClientSuccess: 'Client removed',
    createCommunityAppClientFailed: "Couldn't create client",
    createCommunityAppClientSuccess: 'Client created',
    getCommunityAppClientsFailed: "Couldn't get clients",
    manageClientsForCommunityApp: 'Manage clients',
    addClient: 'Add client',
    manageAppClients: 'Manage app clients',
    noClientsYet: 'No clients yet',
    unknownIdentityProvider: 'Unknown identity provider',
    areYouSureRemoveOrganisation:
      'Are you sure you want to remove the organisation "{{item.name}}"?',
    timeSettings: 'Time settings',
    userDetails: 'User details',
    appsAndRoles: 'Apps & roles',
    accountsIdentities: 'Linked accounts',
    accounts: 'Accounts',
    areYouSureContinueWithoutUserHasRoles:
      'Are you sure you do not want to give access to any application for this user?',
    principalRemoved: 'User removed',
    userGroups: 'User groups',
    userGroup: 'User group',
    selectUserGroups: 'Select user groups',
    rolesFromUserGroups: 'Roles from user groups',
    noRolesInUserGroup: 'No roles assigned to this user group',
    noRolesInSelectedUserGroups: 'No roles assigned to the selected user groups',
    data: 'Data',
    id: 'ID',
    shortName: 'Short name',
    installations: 'Installations',
    isGlobal: 'Is global',
    isCrossCommunity: 'Is cross community',
    isObsolete: 'Is obsolete',
    copyToClipboard: 'Copy to clipboard',
    administrators: 'Administrators',
    welcomeText: 'Community welcome text',
    overviewText: 'Home page overview text',
    pleaseTypeToEnableConfirmButton: "Please type '{{message}}' to enable the confirm button.",
    pleaseTypeHere: 'Please type here',
    removeOrganisation: 'Remove organisation',
    removeOrganisationFailed: 'Could not remove organisation',
    removeOrganisationSuccess: 'Organisation removed',
    removeAppInstallation: 'Remove app installation',
    areYouSureRemoveAppInstallation:
      'Are you sure you want to remove the app installation "{{item.name}}"?',
    removeAppInstallationFailed: 'Could not remove app installation',
    removeAppInstallationSuccess: 'App installation removed',
    areYouSureRemoveApp: 'Are you sure you want to remove the app "{{item.name}}"?',
    removeAppFailed: 'Could not remove app',
    removeAppSuccess: 'App removed',
    roleInFeature: 'Role in {{featureName}}',
    featureInInstallation: 'Feature in {{installationName}}',
    installationOfApp: 'Installation of {{appName}}',
    installation: 'Installation',
    removeFeatureSubscriptionFailed: 'Could not remove feature subscription',
    removeFeatureSubscriptionSuccess: 'Feature subscription removed',
    removeSubscription: 'Remove subscription',
    areYouSureRemoveSubscription:
      'Are you sure you want to remove the subscription for "{{organisationName}}"?',
    identificationCodesCount: '{{count}} identification code(s)',
    noIdentificationCodes: 'No identification codes',
    principalCount: '{{count}} principal(s)',
    noPrincipals: 'No principals',
    errorLoadingPrincipals: 'Error loading principals',
    unnamed: 'Unnamed',
    linkedPrincipals: 'Linked principals',
    allIdentities: 'All identities',
    provider: 'Provider',
    anonymizeIdentity: 'Anonymize Identity',
    areYouSureYouWantToAnonymiseIdentity:
      'Are you sure you want to anonymise identity for {{fullName}}?',
    anonymizeIdentitySuccess: 'Identity anonymized successfully',
    anonymizeIdentityFailed: 'Failed to anonymize identity',
    noIdentitiesFound: 'No identities found',
    typeMinimum2Characters: 'Type min. 2 characters',
    startWithPlusEgFormat: 'Start with +, e.g. +32',
    noRoles: 'No roles',
    rolesCount: '{{count}} role(s)',
    noIdentificationCodeTypesFound: 'No identification code types found',
    isRequired: 'Is required',
    identificationCodeTypeTagEmptyErr: 'Please select an identification code type',
    editType: 'Edit type',
    theFollowingIdentificationCodeTypesAreRequired:
      'The following identification codes are missing: {{missingTypes}}',
    updateContactFailed: 'Could not update contact',
    updateContactSuccess: 'Contact updated',
    createContactFailed: 'Could not create contact',
    createContactSuccess: 'Contact created',
    removeContactFailed: 'Could not remove contact',
    removeContactSuccess: 'Contact removed',
    contacts: 'Contacts',
    noContactsYet: 'No contacts yet.',
    newContact: 'New contact',
    editContact: 'Edit contact',
    areYouSureYouWantToRemoveContact: 'Are you sure you want to remove this contact?',
    logo: 'Logo',
    uploadANewLogo: 'Upload a new logo',
    noLogoAvailable: 'No logo yet.',
    viewLogo: 'View logo',
    uploadLogo: 'Upload logo',
    removeOrganisationLogoFailed: 'Could not remove logo',
    removeOrganisationLogoSuccess: 'Logo removed',
    uploadLogoSuccess: 'Logo uploaded',
    uploadLogoError: 'Could not upload logo',
    removeLogo: 'Remove logo',
    areYouSureYouWantToRemoveLogo: 'Are you sure you want to remove the logo?',
    fileEmptyErr: 'Please upload a valid file',
    noFeatureDetails: 'No feature details',
    pleaseSelectRoles: 'Please select one or more roles',
    idpUserGroup: 'Automatically managed user group',
    idpUserGroupInfo:
      "This group is kept up to date with your organization's user list. You can still add users manually — but if someone logs in through your company's login system, your changes might be undone the next time they sign in.",
    viaIdp: 'Assigned automatically',
    invitationIsExpired: 'This invitation is expired',
    inviationNotValidAnymore: 'This invitation has been retracted',
    invitationUsedProceedLogin:
      'It looks like this invitation has already been used. You can go ahead and sign in to your account.',
    invitationUsedProceedProcess:
      'This invitation has already been used, but your account is nearly ready. To complete your registration, please sign in, fill in your company details, and accept the terms and conditions.',
    completeRegistration: 'Complete registration',
    signIn: 'Sign in',
    inviteAlreadyUsed: 'Invitation already used',
    updateOrganisationFailed: 'Could not update organisation',
    organisationUpdated: 'Organisation updated',
    getCommunityRoleFailed: 'Could not get community role',
    createOrganisation: 'Create organisation',
    organisationCreated: 'Organisation created',
    createOrganisationFailed: 'Could not create organisation',
    onboardingTemplates: 'Onboarding templates',
    identificationCodeTypes: 'Identification code types',
    notification: 'Notification',
    textsAndLegal: 'Texts & legal',
    exportAsJSON: 'Export as JSON',
    addContact: 'Add contact',
    selectCommunityForInvitation:
      'Select the community context in which you want to send the invitation',
    allUsers: 'All users',
    codeCannotHaveTrailingSpaces: 'Code cannot have trailing spaces',
    deleteRole: 'Delete role',
    areYouSureDeleteRole: 'Are you sure you want to delete the role "{{name}}"?',
    pleaseTypeRoleNameToConfirm: 'Please type "{{name}}" to confirm',
    acknowledgeRoleNotObsolete:
      'I understand that this role is not yet flagged as obsolete and I still want to delete this role',
    removeRoleFailed: 'Failed to remove role',
    removeRoleSuccess: 'Role removed successfully',
    deleteFeature: 'Delete feature',
    areYouSureDeleteFeature: 'Are you sure you want to delete the feature "{{name}}"?',
    pleaseTypeFeatureNameToConfirm: 'Please type "{{name}}" to confirm',
    acknowledgeFeatureNotObsolete:
      'I understand that this feature is not yet flagged as obsolete and I still want to delete this feature',
    removeFeatureFailed: 'Failed to remove feature',
    removeFeatureSuccess: 'Feature removed successfully',
    noFeaturesYet: 'No features yet',

    /* documents */
    documents: 'Documents',
    documentsOverview: 'Documents overview',
    uploadDocument: 'Upload Document',
    documentType: 'Document Type',
    documentType_CompanyEmployeeRegistration: 'Company Employee Registration',
    documentType_AirportAccreditation: 'Airport Accreditation',
    documentType_Passport: 'Passport',
    documentType_DriverLicense: 'Driver License',
    documentType_IDCard: 'ID Card',
    selectDocumentType: 'Select document type',
    fileUpload: 'File Upload',
    documentName: 'Document name',
    fileSize: 'File size',
    uploadedBy: 'Uploaded by',
    uploadedAt: 'Uploaded at',
    expirationDate: 'Expiration Date',
    expirationDateHelperText: 'Date must be today or later, up to 10 years from today',
    pending: 'Pending',
    validated: 'Validated',
    expired: 'Expired',
    superseded: 'Superseded',
    rejected: 'Rejected',
    expiring: 'Expiring',
    approve: 'Approve',
    reject: 'Reject',
    preview: 'Preview',
    history: 'History',
    pleaseSelectDocumentType: 'Please select a document type',
    unsupportedFileType: 'Unsupported file type. Only JPEG and PNG files are allowed.',
    fileTooLarge: 'File is too large. Maximum file size is 10 MB.',
    expirationDateRequired: 'Please select an expiration date',
    expirationDatePast: 'Expiration date cannot be in the past',
    expirationDateTooFar: 'Expiration date cannot be more than 10 years in the future',
    uploadSuccessful: 'Document uploaded successfully',
    uploadFailed: 'Document upload failed',
    documentApproved: 'Document approved successfully',
    documentPreviewTitle: 'Document Preview',
    documentPreviewCaption: 'Sensitive information has been redacted for privacy protection',
    documentPreviewError: 'Unable to load document preview. Please try again.',
    documentApproveWarning:
      'By approving this document, you confirm that you have reviewed the redacted image. Please ensure that only the name, sex, and photo are visible and that all other sensitive information is properly blacked out. If you are not satisfied with the system-generated redaction, you may reject the document and re-upload a pre-redacted document instead.',
    documentRedactingPlaceholder:
      'Please wait. Your document is being redacted and will be available shortly.',
    documentRejected: 'Document rejected successfully',
    confirmApprove: 'Confirm Approve',
    confirmReject: 'Confirm Reject',
    documentRejectedReuploadPrompt:
      'The document has been rejected. Would you like to re-upload a new version?',
    uploadLater: 'Upload Later',
    reuploadNow: 'Re-upload Now',
    consentWarning:
      'By uploading this document, you confirm that the document owner has consented to its storage and processing.',
    consentCheckbox: 'I acknowledge and agree to the above statement',
    noDocumentsFound: 'No documents found',
    rejectReason: 'Reason for rejection',
    approveDocumentFailed: 'Could not approve document',
    rejectDocumentFailed: 'Could not reject document',
    areYouSureApproveDocument: 'Are you sure you want to approve this document?',
    areYouSureRejectDocument: 'Are you sure you want to reject this document?',
    viewHistory: 'View history',
    documentHistory: 'Document History',
    // Document translations (shared keys needed by app components)
    'documents.title': 'Documents',
    'documents.type': 'Document type',
    'documents.fileName': 'File name',
    'documents.uploadedAt': 'Uploaded at',
    'documents.uploadedBy': 'Uploaded by',
    'documents.expirationDate': 'Expiration date',
    'documents.status': 'Status',
    'documents.actions': 'Actions',
    'documents.preview': 'Preview',
    'documents.noDocumentsFound': 'No documents found',
    'documents.failedToLoad': 'Failed to load documents',
    'documents.previewTitle': 'Document Preview',
    'documents.previewCaption': 'This is a preview of the document',
    'documents.previewError': 'Failed to load document preview',
    'documents.type_CompanyEmployeeRegistration': 'Company Employee Registration',
    'documents.type_AirportAccreditation': 'Airport Accreditation',
    'documents.type_Passport': 'Passport',
    'documents.type_DriverLicense': 'Driver License',
    'documents.type_IDCard': 'ID Card',
    'documents.status.pending': 'Pending',
    'documents.status.validated': 'Validated',
    'documents.status.expired': 'Expired',
    'documents.status.superseded': 'Superseded',
    'documents.status.rejected': 'Rejected',
    'documents.status.expiring': 'Expiring',
    // Document translations (app-specific)
    'documents.confirmUploadTitle': 'Review & Confirm Document',
    'documents.confirmUpload': 'Confirm Upload',
    'documents.redactWarning.intro':
      'By approving this document, you confirm that you have reviewed the redacted image.',
    'documents.redactWarning.visibleInfo': 'Only the following information should remain visible:',
    'documents.redactWarning.fullName': 'Full name',
    'documents.redactWarning.photo': 'Photo',
    'documents.redactWarning.expirationDate': 'Expiration date',
    'documents.redactWarning.mustBlackOut':
      'All other sensitive information must be fully blacked out.',
    'documents.redactWarning.adjustInstructions':
      'If you are not satisfied with the system-generated redactions, you can adjust them by dragging your mouse over any area to add a new redaction or clicking "x" to remove one.',
    'documents.history': 'Document History',
    'documents.redactingPlaceholder': 'Processing document for redaction...',
    'documents.showFinalPreview': 'Show final result',
    'documents.thisIsHowImageWillBeSaved': 'this is how the image will be saved',
    'documents.failedToLoadImage': 'Failed to load image',
    'documents.upload': 'Upload document',
    'documents.documentConfirmed': 'Document confirmed successfully',
    'documents.confirmFailed': 'Failed to confirm document',
    'documents.analyzeFailed': 'Failed to analyze document',
    'documents.uploadSuccessful': 'Document uploaded successfully',
    'documents.uploadFailed': 'Failed to upload document',
    'documents.consentWarning':
      'By uploading this document, you confirm that the document owner has consented to its storage and processing.',
    'documents.consentCheckbox':
      'I acknowledge that the document owner has provided consent to its storage and processing.',
    'documents.redactConfirmCheckbox':
      'I confirm this document has been properly redacted and only permitted information remains visible.',
    'documents.selectType': 'Select document type',
    'documents.pleaseSelectType': 'Please select a document type',
    'documents.file': 'File',
    'documents.unsupportedFileType': 'Please select a valid file',
    'documents.expirationDateRequired': 'Expiration date is required',
    'documents.expirationDatePast': 'Expiration date cannot be in the past',
    'documents.expirationDateTooFar': 'Expiration date cannot be more than 10 years in the future',
    'documents.expirationDateHelperText': 'Date must be today or later, up to 10 years from today',
    'documents.approveWarning': 'Please review this document carefully before approving.',
    'documents.rejected': 'Document Rejected',
    'documents.rejectedReuploadPrompt':
      'The document has been rejected. Would you like to upload a new version?',
    'documents.uploadLater': 'Upload Later',
    'documents.reuploadNow': 'Reupload Now',
    'documents.areYouSureReject': 'Are you sure you want to reject this document?',
    'documents.confirmReject': 'Reject',
    'documents.areYouSureApprove': 'Are you sure you want to approve this document?',
    'documents.confirmApprove': 'Approve',
    // Impersonation
    requestImpersonation: 'Request Impersonation',
    impersonationRequest: 'Impersonation Request',
    support: 'Support',
    implementation: 'Implementation',
    duration: 'Duration',
    ticketProjectReference: 'Ticket/Project reference',
    ticketProjectReferencePlaceholder: 'e.g., TICKET-1234 or PROJECT-5678',
    documentAccess: 'Document access',
    documentAccessTooltip:
      'Grants access to identification documents linked to this account (e.g., Driver License, ID Card, Passport). Enable only if necessary, as this will require approval from an Organization Admin.',
    reason: 'Reason',
    reasonPlaceholder: 'Enter a reason for impersonation...',
    impersonationInfoBanner:
      'The impersonation session is activated once the target user accepts the request.',
    submitRequest: 'Submit Request',
    impersonationRequestCreated: 'Impersonation request submitted successfully',
    impersonationRequestFailed: 'Failed to submit impersonation request',
    reasonEmptyErr: 'Reason is required',
    requestedDurationEmptyErr: 'Duration is required',
    reasonTooLong: 'Reason must be {{max}} characters or less',
    // Impersonation Requests List
    impersonationRequests: 'Impersonation Requests',
    // Short tab labels
    'tab.invitations': 'Invitations',
    'tab.apps': 'Apps',
    'tab.idCodes': 'ID codes',
    'tab.documents': 'Documents',
    'tab.impersonation': 'Impersonation',
    impersonationRequestDetails: 'Impersonation Request Details',
    noImpersonationRequestsFound: 'No impersonation requests found',
    targetUser: 'Target User',
    requestedAt: 'Requested At',
    activeUntil: 'Active Until',
    activeFrom: 'Active From',
    requester: 'Requester',
    approvedDuration: 'Approved duration',
    requestValidUntil: 'Request valid until',
    resolvedBy: 'Resolved by',
    resolvedAt: 'Resolved at',
    coResolvedBy: 'Co-resolved by',
    coResolvedAt: 'Co-resolved at',
    coDenialReason: 'Co-denial reason',
    revokedBy: 'Revoked by',
    revokedAt: 'Revoked at',
    revocationReason: 'Revocation reason',
    'impersonation.confirmApprove': 'Are you sure you want to approve this request?',
    'impersonation.confirmDeny': 'Are you sure you want to deny this request?',
    terminateAccess: 'Terminate Access',
    terminateImpersonationSuccess: 'Impersonation access terminated successfully',
    terminateImpersonationFailed: 'Failed to terminate impersonation access',
    pendingCoApproval: 'Pending Co-Approval',
    revoked: 'Revoked',
    consolidated: 'Consolidated',
    denied: 'Denied',
    coApproveImpersonationSuccess: 'Impersonation request approved',
    coApproveImpersonationFailed: 'Failed to approve impersonation request',
    coDenyImpersonationSuccess: 'Impersonation request denied',
    coDenyImpersonationFailed: 'Failed to deny impersonation request',
    impersonating: 'Impersonating',
    expiresIn: 'Expires in',
    expiresAt: 'Expires at',
  },
  de: {
    noCommunityData: 'Keine Community-Daten verfügbar',
    password: 'Passwort',
    verifyPassword: 'Passwort bestätigen',
    passwordsDontMatch: 'Die Passwörter stimmen nicht überein',
    userName: 'Benutzername (E-Mail)',
    language: 'Sprache',
    fullName: 'Vollständiger Name',
    next: 'Weiter',
    nameRequired: 'Bitte geben Sie einen Namen an',
    cityRequired: 'Bitte geben Sie eine Stadt an',
    descriptionRequired: 'Bitte geben Sie eine Beschreibung an',
    selectCountry: 'Bitte wählen Sie ein Land',
    name: 'Name',
    city: 'Stadt',
    postalCode: 'Postleitzahl',
    streetAndNumber: 'Straße und Nummer',
    country: 'Land',
    createUser: 'Benutzer erstellen',
    signLegalDocuments: 'Nutzungsbedingungen',
    suggestionsRequired: 'Bitte wählen Sie eine Organisation',
    streetAndNumberRequired: 'Straße und Hausnummer sind erforderlich',
    postalCodeRequired: 'Postleitzahl ist erforderlich',
    suggestions: 'Vorschläge',
    selectPlaceholder: 'Wählen...',
    createAnAccount: 'Bitte erstellen Sie ein Benutzerkonto',
    loginToYourAccount: 'Bitte melden Sie sich mit Ihrem Benutzerkonto an',
    join: 'Beitreten',
    joinOrganisationOnPlatform:
      'Bitte treten Sie einer Organisation bei, die bereits auf der Plattform vorhanden ist',
    register: 'Registrieren',
    registerOrganisationOnPlatform:
      'Bitte registrieren Sie eine neue Organisation auf der Plattform',
    confirmationEmailSent: 'Eine Bestätigungsmail wurde gesendet',
    resendEmail: 'E-Mail erneut senden',
    confirmationEmailContent:
      'Eine E-Mail wurde an {{email}} gesendet.\n\nBitte öffnen Sie Ihre E-Mail und klicken Sie auf den Bestätigungslink, um mit Ihrer Registrierung fortzufahren. Wenn Sie eine E-Mail nicht finden können, überprüfen Sie Ihren SPAM oder senden Sie die E-Mail mit der Schaltfläche unten erneut.\n\nDieses Fenster kann geschlossen werden',
    passwordRequired: 'Bitte geben Sie ein Passwort ein',
    passwordMinimum12charactersErr: 'Ein Passwort muss aus mindestens 12 Zeichen bestehen',
    passwordMaximum80charactersErr: 'Ein Passwort kann maximal 80 Zeichen enthalten',
    reEnterPassword: 'Bitte geben Sie Ihr Passwort erneut ein',
    joinRequestSent: 'Beitrittsanfrage abgeschickt',
    joinRequestContent:
      'Bitte warten Sie auf die Bestätigung Ihrer Beitrittsanfrage durch den Administrator',
    readAllLegalDocuments:
      'Ich habe die oben genannten Dokumenten gelesen und bin damit einverstanden',
    sign: 'Akzeptieren',
    welcome: 'Herzlich willkommen',
    chooseRoles: 'Bitte wählen Sie Benutzerrollen',
    login: 'Bitte einloggen',
    communityMembershipTemplateGetFailed:
      'Es ist ein Fehler aufgetreten. Das System konnte keine Community-Vorlagen abrufen',
    membershipAlreadyRequested: 'Die Mitgliedschaft ist bereits angefordert',
    noLegalDocumentsToSign: 'Es sind keine Dokumente zum Unterschreiben vorhanden',
    welcomeToTheCommunity: 'Willkommen in der Community',
    viewApps: 'Schauen Sie sich die Apps an',
    membershipRequestFailed: 'Die Anfrage zur Teilnahme an der Community ist fehlgeschlagen',
    error: 'Fehler',
    chooseSuggestedOrganisationToJoin:
      'Anhand Ihrer E-Mail-Adresse möchten Sie möglicherweise einer der folgenden bestehenden Organisationen beitreten.',
    joinSuggestedOrganisation:
      'Anhand Ihrer E-Mail-Adresse möchten Sie möglicherweise dieser bestehenden Organisation beitreten.',
    selectAnOrganisation: 'Bitte wählen Sie eine Organisation',
    organisationName: 'Name der Organisation',
    requestedAt: 'Angefragt am',
    back: 'Zurück',
    addIdentificationCode: 'Bitte fügen Sie einen Identifikationscode hinzu',
    identificationCode: 'Identifikationscode',
    identificationcode: 'Identifikationscodes',
    welcomeMessageTitle: 'Willkommen auf der Plattform!',
    selectLanguage: 'Bitte wählen Sie eine Sprache',
    selectTimezone: 'Bitte wählen Sie eine Zeitzone',
    type: 'Art',
    organisationNameAlreadyExists: 'Name der Organisation ist bereits vorhanden',
    errorWhileValidatingOrganisationName:
      'Beim Überprüfen des Organisationsnamens ist ein Fehler aufgetreten',
    thisIdentificationCodeIsAlreadyInUse: 'Der Identifikationscode ist bereits vorhanden',
    errorWhileIdentificationCodeName:
      'Beim Überprüfen des Identifikationscodes ist ein Fehler aufgetreten',
    continue: 'Weiter',
    invalidEmailErr: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    dear: 'Sehr geehrter {{user}},',
    successfullyReceivedRegistration:
      'Wir haben Ihre Registrierung erfolgreich erhalten. Sie erhalten innerhalb eines Arbeitstages eine E-Mail mit einem Link, über den Sie auf die Anwendung (en) zugreifen können, für die Sie sich registriert haben.',
    furtherQuestions:
      'Wenn Sie weitere Fragen haben, wenden Sie sich bitte an Ihren Community-Administrator.',
    'sorry!': 'Entschuldigung!',
    pageRequestedNotFound: 'Die von Ihnen angeforderte Seite wurde nicht gefunden.',
    toTheCommunityPortal: 'Zum Community-Portal.',
    validateUsernameFailed: 'Fehler bei der Überprüfung des Benutzernamens',
    myOrganisation: 'Meine Organisation',
    noMembershipRequests: 'Keine Mitgliedschaftsanfragen vorhanden',
    membershipRequests: 'Mitgliedschaftsanträge',
    createdOn: 'Erstellt am',
    areYouSureYouWantToDenyUser: 'Möchten Sie diesem Benutzer wirklich den Zugriff verweigern?',
    cancel: 'Abbrechen',
    deny: 'Verweigern',
    requestOfOrganisation: 'Anfrage von {{organisation}}',
    applications: 'Anwendungen',
    roles: 'Rollen',
    signedLegalDocuments: 'Vereinbarte rechtliche Dokumente',
    accept: 'Akzeptieren',
    membershipRequestUpdateFailed: 'Die Mitgliedschaftsanfrage konnte nicht aktualisiert werden',
    membershipRequestUpdateSuccess: 'Mitgliedschaftsanfrage aktualisiert',
    areYouSureYouWantToendMembership:
      'Sind Sie sicher, dass Sie die Mitgliedschaft beenden möchten?',
    overview: 'Überblick',
    eMailaddress: 'E-Mail-Addresse (beruflich)',
    membershipRequestAccepted: 'Mitgliedsanfrage angenommen',
    membershipRequestDenied: 'Mitgliedsanfrage abgelehnt',
    dashboard: 'Dashboard',
    getLanguagesErr: 'Es ist ein Fehler aufgetreten: Es konnten keine Sprachen abgerufen werden.',
    getAuthorizationRolesErr:
      'Es ist ein Fehler aufgetreten: Autorisierungsrollen konnten nicht abgerufen werden.',
    getTimezonesErr: 'Es ist ein Fehler aufgetreten: Es konnte keine Zeitzone abgerufen werden.',
    getOrganisationStatsErr:
      'Es ist ein Fehler Aufgetreten: Es konnten keine Statistiken abgerufen werden.',
    users: 'Benutzer',
    noUserPresent: 'Keine Benutzer anwesend',
    state: 'Zustand',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer entfernen',
    areYouSureYouWantToDeleteUser: 'Möchten Sie {{userName}} entfernen?',
    inviteNewUser: 'Neuen Benutzer einladen',
    save: 'Speichern',
    invite: 'Einladen',
    inviteUserSendEmailToAddress: 'Benutzer einladen, E-Mail an folgende Adresse senden:',
    createUserWithPassword: 'Benutzer mit Passwort erstellen:',
    enterPassword: 'Passwort eingeben',
    forceUserToChooseNewPassword:
      'Benutzer auffordern, bei der ersten Anmeldung ein neues Passwort zu wählen',
    pleaseEnterEmailAddress: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    pleaseEnterRecipient: 'Bitte geben Sie einen Empfänger ein',
    pleaseEnterPassword: 'Bitte Passwort eingeben',
    selectRole: 'Bitte wählen Sie mindestens eine Rolle aus.',
    usernameTaken: 'Dieser Benutzername ist bereits vergeben',
    userUpdated: 'Benutzer aktualisiert',
    inviteUserFailed: 'Es ist ein Fehler aufgetreten: Benutzer konnte nicht eingeladen werden.',
    inviteUser: 'Benutzer einladen',
    userInvited: 'Benutzer eingeladen',
    userDeleted: 'Benutzer gelöscht',
    deleteUserFailed: 'Es ist ein Fehler aufgetreten: Benutzer konnte nicht gelöscht werden',
    delete: 'Löschen',
    noOrganisationRegistrations: 'Keine Organisationsregistrierungen',
    trustedDomains: 'Vertrauenswürdige Domäne',
    trustedDomains_plural: 'Vertrauenswürdige Domänen',
    trustedDomainsOverview: 'Vertrauenswürdige Domänen',
    createTrustedDomainSuccess: 'Vertrauenswürdige Domäne wird erstellt',
    createTrustedDomainFailed:
      'Es ist ein Fehler aufgetreten: Es konnte keine vertrauenswürdige Domäne erstellt werden.',
    updateTrustedDomainSuccess: 'Vertrauenswürdige Domäne wurde aktualisiert',
    addTrustedDomain: 'Fügen Sie eine vertrauenswürdige Domain hinzu',
    updateTrustedDomainFailed:
      'Es ist ein Fehler aufgetreten: Die vertrauenswürdige Domäne konnte nicht aktualisiert werden',
    domain: 'Domäne',
    domainEmptyErr: 'Bitte geben Sie eine Domäne ein',
    domainInvalidErr: 'Bitte überprüfen Sie den Domänennamen.',
    autoJoin: 'Automatisch beitreten',
    remove: 'Entfernen',
    organisation: 'Organisation',
    areYouSureYouWantToDenyOrganisation:
      'Möchten Sie den Zugriff auf diese Organisation wirklich verweigern?',
    areYouSureYouWantToRemoveTheRequest: 'Möchten Sie die Anforderung wirklich entfernen?',
    myCommunity: 'Meine Community',
    noMembersPresent: 'Keine Mitglieder anwesend.',
    addMember: 'Mitglied hinzufügen',
    edit: 'Bearbeiten',
    endMembership: 'Mitgliedschaft kündigen',
    editMembership: 'Mitgliedschaft bearbeiten',
    areYouSureYouWantToEndMembership:
      'Möchten Sie die Mitgliedschaft von {{organisationName}} wirklich beenden?',
    communityMembershipEnded: 'Community-Mitgliedschaft beendet',
    endCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Die Mitgliedschaft konnte nicht beendet werden.',
    communityMembershipUpdate: 'Community-Mitgliedschaft wurde aktualisiert.',
    updateCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Die Community-Mitgliedschaft konnte nicht aktualisiert werden.',
    getCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Die Community-Mitgliedschaft konnte nicht abgerufen werden.',
    communityMembershipCreated: 'Community-Mitglied erstellt',
    createCommunityMembershipFailed:
      'Es ist ein Fehler aufgetreten: Es konnte kein Community-Mitglied erstellt werden.',
    addACommunityMember: 'ein Community-Mitglied hinzufügen',
    updateMembershipOf: 'Mitgliedschaft aktualisieren {{organisationName}}',
    members: 'Mitglieder',
    getUserStatesErr:
      'Es ist ein Fehler aufgetreten: Benutzerstatus konnte nicht abgerufen werden.',
    rejectionNotice: 'Ablehnungsnotiz',
    addApp: 'App hinzufügen',
    app: 'App',
    actions: 'Aktionen',
    role: 'Rolle',
    registerError: 'Bei der Registrierung ist ein Fehler aufgetreten.',
    contactAdministrator:
      'Weitere Informationen zur Verwendung dieses Community-Portals erhalten Sie von Ihrem Community-Administrator.',
    registerEmailDomainAsTrustedRequired: 'Sie müssen dieses Feld aktivieren oder deaktivieren.',
    proceed: 'Fortfahren',
    privateCommunityTitle: 'Private Gemeinschaft',
    privateCommunityDescription:
      'Dies ist eine private Gemeinschaft, der man nicht beitreten kann.',
    pleaseSelectOrganisation: 'Bitte wählen Sie eine Organisation aus',
    pleaseSelectMinimumOneRole: 'Bitte wählen Sie mindestens eine Rolle aus',
    none: 'Keine',
    membershipRequestGetFailed:
      'Es ist ein Fehler aufgetreten: Es konnten keine Mitgliedschaftsanfragen abgerufen werden.',
    getCommunityStatsErr:
      'Es ist ein Fehler aufgetreten: Es konnten keine Community-Statistiken abgerufen werden.',
    communityMember: 'Community Mitglied',
    registrationGetFailed: 'Es ist ein Fehler aufgetreten: Konnte keine Registrierung abrufen.',
    getTrustedDomainFailed:
      'Es ist ein Fehler aufgetreten: Es konnte keine vertrauenswürdige Domäne abgerufen werden.',
    pleaseEnterAnEmailAddress: 'Bitte geben Sie eine E-Mail-Adresse ein',
    noUsersPresent: 'Keine Benutzer anwesend',
    communities: 'Communities',
    noCommunitiesFound: 'Keine Communities gefunden',
    home: 'Startseite',
    getIdentificationCodeTypesFailed:
      'Es ist ein Fehler aufgetreten: Identifikationscodetypen konnten nicht abgerufen werden.',
    pleaseSelectAType: 'Bitte wählen Sie einen Typ',
    pleaseEnterAValue: 'Bitte einen Wert eingeben',
    disabled: 'Deaktiviert',
    unverified: 'Unbestätigt',
    verified: 'Bestätigt',
    userState: 'Benutzerstatus',
    couldNotGetCommunityTemplate:
      'Es ist ein Fehler aufgetreten, die Community-Beschreibung konnte nicht abgerufen werden',
    getTermsAndConditionsFailed:
      'Es ist ein Fehler aufgetreten, die Allgemeinen Geschäftsbedingungen konnten nicht abgerufen werden',
    chooseAPassword: 'Wählen Sie ein Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    userAccountReady: 'Benutzerkonto bereit!',
    passwordResetSuccess:
      'Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt bei Ihren Apps anmelden.',
    failedContactOur:
      'Das Passwort konnte nicht zurückgesetzt werden. Bitte wenden Sie sich an unsere',
    support: 'Support',
    department: 'Abteilung',
    pleaseConfirmUserAccount: 'Bitte bestätigen Sie, dass dies Ihr Benutzerkonto ist',
    confirm: 'Bestätigen',
    invalidToken: 'Ungültiger Token',
    needTechnicalSupport:
      'Wenn Sie technische Unterstützung benötigen, wenden Sie sich bitte an unsere',
    passwordMin8Char: 'Wählen Sie ein Passwort mit mindestens 8 Zeichen',
    passwordConfirmIncorrect: 'Die Bestätigung des Passworts ist falsch',
    pleaseEnterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    forgotPassword: 'Passwort vergessen',
    requestNewPassword: 'Neues Passwort anfordern',
    resetPasswordRequested: 'Passwort zurücksetzen angefordert!',
    resetPasswordRequestText:
      'Wenn Sie ein registrierter Benutzer sind, wurde eine E-Mail an Ihr Postfach gesendet, um Ihr Passwort zurückzusetzen. Bitte klicken Sie auf den Link in dieser E-Mail, um fortzufahren. Sie können dieses Fenster jetzt schließen.',
    somethingWentWrong: 'Etwas ist schief gelaufen.',
    pleaseContactOur: 'Bitte kontaktieren Sie unsere',
    failedResentEmail: 'Einladungs-E-Mail konnte nicht erneut gesendet werden',
    resentEmailSuccess: 'Die Einladungs-E-Mail wurde erneut gesendet',
    ohNo: 'Oh nein!',
    invitationExpired: 'Ihre Einladung ist abgelaufen. Lassen Sie sich eine neue Einladung senden:',
    resentInvitationEmail: 'Einladungs-E-Mail erneut senden',
    thanksForSubscribing: 'Vielen Dank für Ihr Abonnement und willkommen auf der Plattform!',
    activatedBasicAccount:
      'Wir haben Ihr Basiskonto aktiviert, mit dem Sie auf die verschiedenen Anwendungen zugreifen können, die für Ihr Konto verfügbar sind.',
    accessApplications:
      'Sie können auf die Anträge zugreifen, sobald wir die entsprechenden unterschriebenen Vertragsformulare erhalten haben.',
    beAware:
      'Bitte beachten Sie, dass für bestimmte Anwendungen möglicherweise ein Go-Live-Datum zu einem späteren Zeitpunkt gilt.',
    contactUs: 'Kontaktieren Sie uns',
    ifQuestions: 'falls Sie Fragen haben.',
    failedToActivateUserAccount: 'Benutzerkonto konnte nicht aktiviert werden',
    goodNews: 'Gute Nachrichten!',
    accountAlreadyActivated:
      'Ihr Benutzerkonto ist bereits aktiviert. Bitte starten Sie die App über den direkten Link, wie in den App-Anweisungen angegeben.',
    invalidTokenText:
      'Ihr Aktivierungstoken ist ungültig. Stellen Sie sicher, dass Sie den Aktivierungslink in der zuletzt empfangenen Einladungs-E-Mail verwenden. Wenn Sie diese E-Mail nicht erhalten haben (vergessen Sie nicht Ihren Spam-Ordner!), können Sie sich jederzeit an unseren Support wenden',
    passwordInvalidErr: 'Bitte geben Sie ein gültiges Passwort ein',
    inviteSuccessMessage:
      'Ihr Benutzerkonto wurde erfolgreich auf der Nallian-Plattform registriert. Um fortzufahren und die Anwendungen zu verwenden, klicken Sie bitte auf "Fortfahren", um sich beim Nallian Portal anzumelden.',
    address: 'Adresse',
    getOrganisationIdentificationCodesFailed:
      'Fehler beim Abrufen der Organisationsidentifikationscodes',
    getOrganisationFailed: 'Organisationsinformationen konnten nicht abgerufen werden',
    identificationCodes: 'Identifikationscodes',
    getOrganisationAddressFailed: 'Fehler beim Abrufen der Organisationsadresse',
    membershipOf: 'Mitgliedschaft bei {{organisation}}',
    organisationInfo: 'Organisationsinformationen',
    noRolesFound: 'Keine Rollen gefunden',
    noAppsFound: 'Keine Apps gefunden',
    organisationUsers: 'Benutzer',
    userReinvited: 'Benutzer erneut eingeladen',
    userReinviteFailed: 'Benutzer konnte nicht erneut eingeladen werden',
    reinviteUser: 'Benutzer erneut einladen',
    areYouSureReinvite: 'Möchten Sie den Benutzer {{userName}} wirklich erneut einladen?',
    yes: 'Ja',
    no: 'Nein',
    dontHaveAnAccountYet: 'Sie haben noch kein Konto?',
    registerHere: 'Hier registrieren!',
    inviteInfo:
      'Jemand aus Ihrer Organisation hat Sie eingeladen, der Plattform beizutreten. Bitte bestätigen Sie, dass die unten angezeigten Details Ihnen gehören.',
    chooseAPasswordInfo: 'Bitte wählen Sie ein Passwort, um den Einladungsprozess abzuschließen.',
    resetYourPassword: 'Setzen Sie Ihr Passwort zurück',
    createAnotherUser: 'Einen anderen Benutzer erstellen',
    createdBy: 'Erstellt von',
    createCommunityMember: 'Community-Mitglied erstellen',
    isTest: 'Ist Test',
    isDefault: 'Ist Standard',
    isMessageCode: 'Ist Nachrichtencode',
    code: 'Code',
    codeValue: 'Code',
    description: 'Beschreibung',
    updateIdentificationCodeFailed: 'Aktualisierung des Identifikationscodes fehlgeschlagen',
    updateIdentificationCodeSuccess: 'Aktualisierung des Identifikationscodes erfolgreich',
    addIdentificationCodeFailed: 'Hinzufügen des Identifikationscodes fehlgeschlagen',
    addIdentificationCodeSuccess: 'Identifikationscode erfolgreich hinzugefügt',
    getIdentificationCodeFailed: 'Abrufen des Identifikationscodes fehlgeschlagen',
    identificationCodeType: 'Art des Identifikationscodes',
    removeIdentificationCode: 'Identifikationscode entfernen',
    add: 'Hinzufügen',
    editIdentificationCode: 'Identifikationscode bearbeiten',
    viewIdentificationCode: 'Identifikationscode anzeigen',
    routings: 'Routings',
    order: 'Reihenfolge',
    regex: 'Regex',
    emailAddresses: 'E-Mail-Adressen',
    toZendesk: 'An Zendesk',
    enabled: 'Aktiviert',
    editRouting: 'Routing bearbeiten',
    addRouting: 'Routing hinzufügen',
    removeRouting: 'Möchten Sie dieses Routing wirklich entfernen?',
    toVoid: 'Ins Leere',
    addAttachments: 'Anhänge hinzufügen',
    stopProcessing: 'Verarbeitung stoppen',
    zendeskTags: 'Zendesk-Tags',
    priority: 'Priorität',
    mustFillInEmailNoZendeskAndNoVoid:
      'Sie müssen eine E-Mail ausfüllen, wenn "Ins Leere" oder "An Zendesk" nicht aktiviert ist',
    nameEmptyErr: 'Bitte füllen Sie einen Namen aus',
    orderEmptyErr: 'Bitte füllen Sie eine Reihenfolge aus',
    regexEmptyErr: 'Bitte füllen Sie einen Regex aus',
    priorityIdEmptyErr: 'Bitte wählen Sie eine Priorität',
    routingsOrder: 'Reihenfolge der Routings',
    updateRoutingsOrderSuccess: 'Reihenfolge der Routings erfolgreich aktualisiert',
    updateRoutingsOrderFailed: 'Aktualisierung der Routings-Reihenfolge fehlgeschlagen',
    saveOrder: 'Reihenfolge speichern',
    apiResources: 'API-Ressource',
    apiResources_plural: 'API-Ressourcen',
    tokenLifetime: 'Token-Lebensdauer',
    stsclients: 'STS-Client',
    stsclients_plural: 'STS-Clients',
    clientName: 'Client-Name',
    clientId: 'Client-ID',
    fillForm: 'Formular ausfüllen',
    clientNameInfo:
      'Anzeigename des Clients (wird für Protokollierung und Zustimmungsbildschirm verwendet)',
    clientIdInfo: 'Eindeutige ID des Clients',
    clientUri: 'Client-URI',
    clientUriInfo:
      'URI zu weiteren Informationen über den Client (wird auf dem Zustimmungsbildschirm verwendet)',
    logoUri: 'Logo-URI',
    logoUriInfo: 'URI zum Client-Logo (wird auf dem Zustimmungsbildschirm verwendet)',
    allowedScopes: 'Erlaubte Geltungsbereiche',
    allowedScopesInfo:
      'Standardmäßig hat ein Client keinen Zugriff auf Ressourcen. Geben Sie die erlaubten Ressourcen an, indem Sie die entsprechenden Geltungsbereichsnamen hinzufügen.',
    allowedGranttypes: 'Erlaubte Grant-Typen',
    allowedGranttypesInfo:
      'Gibt die Grant-Typen an, die der Client verwenden darf. Verwenden Sie die GrantTypes-Klasse für gängige Kombinationen.',
    protocolType: 'Protokolltyp',
    rowVersion: 'Zeilenversion',
    enableClient: 'Client aktivieren',
    enableClientInfo: 'Gibt an, ob der Client aktiviert ist. Standardmäßig auf true.',
    allowOfflineAccessInfo:
      'Gibt an, ob dieser Client Aktualisierungs-Tokens anfordern kann (durch Anfordern des offline_access-Geltungsbereichs)',
    allowOfflineAccess: 'Aktualisierungs-Tokens erlauben',
    requireClientSecret: 'Client-Geheimnis erforderlich',
    requireClientSecretInfo:
      'Gibt an, ob dieser Client ein Geheimnis benötigt, um Tokens vom Token-Endpunkt anzufordern (standardmäßig auf true)',
    noAppSubscriptionRequired: 'Kein App-Abonnement erforderlich',
    allowAccessTokensViaBrowser: 'Zugriffstokens über Browser erlauben',
    allowAccessTokensViaBrowserInfo:
      'Gibt an, ob dieser Client Zugriffstokens über den Browser empfangen darf. Dies ist nützlich, um Abläufe zu härten, die mehrere Antworttypen zulassen.',
    requirePkce: 'PKCE erfordern',
    requirePkceInfo:
      'Gibt an, ob Clients, die einen Autorisierungscode-basierten Grant-Typ verwenden, einen Proof Key senden müssen (standardmäßig auf true).',
    allowPlainTextPkce: 'PKCE im Klartext erlauben',
    allowPlainTextPkceInfo:
      'Gibt an, ob Clients, die PKCE verwenden, eine Klartext-Code-Challenge verwenden können (nicht empfohlen - standardmäßig auf false)',
    redirectUrisInfo:
      'Gibt die erlaubten URIs an, an die Tokens oder Autorisierungscodes zurückgegeben werden sollen',
    redirectUris: 'Weiterleitungs-URIs',
    postLogoutRedirectUris: 'Post-Logout-Weiterleitungs-URIs',
    postLogoutRedirectUrisInfo:
      'Gibt erlaubte URIs an, zu denen nach dem Logout weitergeleitet wird. Weitere Details finden Sie in der OIDC Connect Session Management-Spezifikation.',
    identityProviderRestrictions: 'Identitätsanbieter-Einschränkungen',
    identityProviderRestrictionsInfo:
      'Gibt an, welche externen IdPs mit diesem Client verwendet werden können (wenn die Liste leer ist, sind alle IdPs erlaubt). Standardmäßig leer.',
    frontChannelLogoutSessionRequired: 'Front-Channel-Logout-Sitzung erforderlich',
    frontChannelLogoutSessionRequiredInfo:
      'Gibt an, ob die Sitzungs-ID des Benutzers an die FrontChannelLogoutUri gesendet werden soll. Standardmäßig auf true.',
    frontChannelLogoutUri: 'Front-Channel-Logout-URI',
    frontChannelLogoutUriInfo:
      'Gibt die Logout-URI am Client für HTTP-basiertes Front-Channel-Logout an. Weitere Details finden Sie in der OIDC Front-Channel-Spezifikation.',
    backChannelLogoutSessionRequired: 'Back-Channel-Logout-Sitzung erforderlich',
    backChannelLogoutSessionRequiredInfo:
      'Gibt an, ob die Sitzungs-ID des Benutzers in der Anfrage an die BackChannelLogoutUri gesendet werden soll. Standardmäßig auf true.',
    backChannelLogoutUri: 'Back-Channel-Logout-URI',
    backChannelLogoutUriInfo:
      'Gibt die Logout-URI am Client für HTTP-basiertes Back-Channel-Logout an. Weitere Details finden Sie in der OIDC Back-Channel-Spezifikation.',
    logoutSession: 'Logout-Sitzung',
    enableLocalLogin: 'Lokale Anmeldung aktivieren',
    enableLocalLoginInfo:
      'Gibt an, ob dieser Client lokale Konten oder nur externe IdPs verwenden kann. Standardmäßig auf true.',
    accessTokenLifetime: 'Lebensdauer des Zugriffstokens',
    accessTokenLifetimeInfo:
      'Lebensdauer des Zugriffstokens in Sekunden (standardmäßig 3600 Sekunden / 1 Stunde)',
    absoluteRefreshTokenLifetime: 'Absolute Lebensdauer des Aktualisierungs-Tokens',
    absoluteRefreshTokenLifetimeInfo:
      'Maximale Lebensdauer eines Aktualisierungs-Tokens in Sekunden. Standardmäßig 2592000 Sekunden / 30 Tage',
    identityTokenLifetime: 'Lebensdauer des Identitätstokens',
    identityTokenLifetimeInfo:
      'Lebensdauer des Identitätstokens in Sekunden (standardmäßig 300 Sekunden / 5 Minuten)',
    authorizationCodeLifetime: 'Lebensdauer des Autorisierungscodes',
    authorizationCodeLifetimeInfo:
      'Lebensdauer des Autorisierungscodes in Sekunden (standardmäßig 300 Sekunden / 5 Minuten)',
    slidingRefreshTokenLifetime: 'Gleitende Lebensdauer des Aktualisierungs-Tokens',
    slidingRefreshTokenLifetimeInfo:
      'Gleitende Lebensdauer eines Aktualisierungs-Tokens in Sekunden. Standardmäßig 1296000 Sekunden / 15 Tage',
    clientClaimsPrefix: 'Präfix für Client-Ansprüche',
    clientClaimsPrefixInfo:
      'Wenn festgelegt, wird den Client-Anspruchstypen ein Präfix vorangestellt. Standardmäßig client_. Dies soll versehentliche Kollisionen mit Benutzeransprüchen vermeiden.',
    pairWiseSubjectSalt: 'Paarweises Subjekt-Salt',
    pairWiseSubjectSaltInfo:
      'Salt-Wert, der bei der paarweisen subjectId-Generierung für Benutzer dieses Clients verwendet wird.',
    updateAccessTokenClaimsOnRefresh: 'Zugriffstoken-Ansprüche bei Aktualisierung aktualisieren',
    updateAccessTokenClaimsOnRefreshInfo:
      'Ruft einen Wert ab oder legt diesen fest, der angibt, ob das Zugriffstoken (und seine Ansprüche) bei einer Aktualisierungs-Token-Anforderung aktualisiert werden sollen.',
    accessTokenType: 'Referenz-Zugriffstoken',
    accessTokenTypeInfo:
      'Gibt an, ob das Zugriffstoken ein Referenz-Token oder ein eigenständiges JWT-Token ist (standardmäßig Jwt).',
    includeJwtId: 'JWT-ID einschließen',
    includeJwtIdInfo:
      'Gibt an, ob JWT-Zugriffstokens eine eingebettete eindeutige ID haben sollen (über den jti-Anspruch). Standardmäßig auf true.',
    alwaysSendClientClaims: 'Client-Ansprüche immer senden',
    alwaysSendClientClaimsInfo:
      'Wenn festgelegt, werden die Client-Ansprüche für jeden Ablauf gesendet. Wenn nicht, nur für den Client-Credentials-Ablauf (Standard ist false)',
    alwaysIncludeUserClaimsInIdToken: 'Benutzeransprüche immer in Identitätstoken einschließen',
    alwaysIncludeUserClaimsInIdTokenInfo:
      'Wenn sowohl ein Identitätstoken als auch ein Zugriffstoken angefordert werden, sollten die Benutzeransprüche immer zum Identitätstoken hinzugefügt werden, anstatt vom Client die Verwendung des userinfo-Endpunkts zu verlangen. Standard ist false.',
    allowedCorsOriginsInfo:
      'Wenn angegeben, wird von den standardmäßigen CORS-Richtliniendienstimplementierungen (In-Memory und EF) verwendet, um eine CORS-Richtlinie für JavaScript-Clients zu erstellen.',
    allowedCorsOrigins: 'Erlaubte CORS-Ursprünge',
    consentLifetimeInfo:
      'Lebensdauer einer Benutzereinwilligung in Sekunden. Standardmäßig null (kein Ablauf).',
    consentLifetime: 'Lebensdauer der Einwilligung',
    requireConsent: 'Einwilligung erforderlich',
    requireConsentInfo:
      'Gibt an, ob ein Einwilligungsbildschirm erforderlich ist. Standardmäßig false.',
    allowRememberConsent: 'Einwilligungsentscheidungen speichern erlauben',
    allowRememberConsentInfo:
      'Gibt an, ob der Benutzer Einwilligungsentscheidungen speichern kann. Standardmäßig auf true.',
    refreshTokenUsage: 'Verwendung von Aktualisierungs-Token',
    refreshTokenUsageInfo:
      "'ReUse' der Aktualisierungs-Token-Handle bleibt beim Aktualisieren von Tokens gleich. 'OneTime' der Aktualisierungs-Token-Handle wird beim Aktualisieren von Tokens aktualisiert. Dies ist der Standard.",
    refreshTokenExpiration: 'Ablauf des Aktualisierungs-Tokens',
    refreshTokenExpirationInfo:
      "'Absolute' das Aktualisierungs-Token läuft zu einem festen Zeitpunkt ab. Dies ist der Standard. 'Sliding' beim Aktualisieren des Tokens wird die Lebensdauer des Aktualisierungs-Tokens erneuert. Die Lebensdauer überschreitet nicht die AbsoluteRefreshTokenLifetime.",
    reUse: 'Wiederverwenden',
    oneTimeOnly: 'Nur einmal',
    sliding: 'Gleitend',
    absolute: 'Absolut',
    updateUserFailed: 'Benutzeraktualisierung fehlgeschlagen',
    getUserFailed: 'Benutzerabruf fehlgeschlagen',
    isHidden: 'Versteckt',
    isOwner: 'Eigentümer',
    updateSuiteFailed: 'Suite-Aktualisierung fehlgeschlagen',
    updateSuiteSuccess: 'Suite erfolgreich aktualisiert',
    suites_plural: 'Suiten',
    suites: 'Suite',
    tiers: 'Stufen',
    apps: 'Apps',
    allApplications: 'Alle Anwendungen',
    appCountSingular: '{{count}} Anwendung',
    appCountPlural: '{{count}} Anwendungen',
    addAppFeature: 'App-Funktion hinzufügen',
    tierApps: 'Stufen-Apps',
    suite: 'Suite',
    tier: 'Stufe',
    suiteTier: 'Stufe',
    suiteIdEmptyErr: 'Bitte wählen Sie eine Suite',
    suiteTierIdEmptyErr: 'Bitte wählen Sie eine Stufe',
    timezone: 'Zeitzone',
    communityMembers: 'Community-Mitglied',
    communityMembers_plural: 'Community-Mitglieder',
    getCommunityRolesFailed: 'Abruf der Community-Rollen fehlgeschlagen',
    myApps: 'Meine Apps',
    principalJoinRequests: 'Beitrittsanfragen',
    selectExistingUser:
      'Nach einem vorhandenen Benutzer suchen (dies überschreibt das Profil des vorhandenen Benutzers mit den folgenden Informationen)',
    acceptJoinRequestFor: 'Beitrittsanfrage von {{user}} annehmen',
    preApproveForLinking: 'Vorabgenehmigung zur Verknüpfung',
    areYouSureYouWantToUnlinkIdentity: 'Möchten Sie das Konto wirklich vom Benutzer trennen?',
    preApproveForLinkingInfo:
      'Die Beitrittsanfrage automatisch genehmigen, wenn jemand sein Konto mit diesem Benutzer verknüpfen möchte',
    acceptJoinRequestFailed: 'Annahme der Beitrittsanfrage fehlgeschlagen',
    acceptJoinRequestSuccess: 'Beitrittsanfrage erfolgreich angenommen',
    viewOrganisation: 'Organisation anzeigen',
    myIdentity: 'Mein Konto',
    active: 'Aktiv',
    activeState: 'Aktiver Zustand',
    activeStatus: 'Aktiver Status',
    addApplication: 'App hinzufügen',
    addAppSubscription: 'App-Abonnement hinzufügen',
    addCommunityRoleFailed: 'Community-Rolle konnte nicht hinzugefügt werden',
    addCommunityRoleSuccess: 'Die Community-Rolle wurde hinzugefügt',
    addFeature: 'Funktion hinzufügen',
    addOwner: 'Eigentümer hinzufügen',
    addRole: 'Rolle hinzufügen',
    addSubscription: 'Abonnement hinzufügen',
    addSuite: 'Suite hinzufügen',
    addTier: 'Stufe hinzufügen',
    addUser: 'Benutzer hinzufügen',
    alias: 'Alias',
    aliasEmptyErr: 'Bitte geben Sie einen Alias ein',
    appDetailsAliasEmptyErr: 'Bitte geben Sie einen Alias ein',
    appDetailsTagEmptyErr: 'Bitte wählen Sie eine App aus',
    appDetailsUrlEmptyErr: 'Bitte geben Sie eine URL ein',
    appFeatures: 'App-Funktionen',
    appInstallationFeatureTagEmptyErr: 'Bitte wählen Sie eine Funktion aus',
    appInstallationIdEmptyErr: 'Bitte wählen Sie eine App aus',
    appInstallations: 'App-Installationen',
    application: 'App',
    apps_plural: 'Apps',
    appSubscription: 'App-Abonnement',
    appTypeIdEmptyErr: 'Bitte wählen Sie einen App-Typ aus',
    areYouSureRemoveIdentificationCodeType:
      'Möchten Sie diesen Identifikationscode-Typ wirklich entfernen?',
    areYouSureRemoveOnboardingTemplate: 'Möchten Sie diese Onboarding-Vorlage wirklich entfernen?',
    areYouSureRemovePrincipal: 'Möchten Sie {{name}} ({{email}}) wirklich entfernen?',
    areYouSureActivatePrincipal: 'Möchten Sie {{name}} wirklich aktivieren?',
    activatePrincipal: 'Benutzer aktivieren',
    activate: 'Aktivieren',
    activatePrincipalSuccess: 'Der Benutzer wurde aktiviert',
    activatePrincipalFailed: 'Benutzer konnte nicht aktiviert werden',
    areYouSureRemoveRelation: 'Möchten Sie diese Beziehung wirklich entfernen?',
    areYouSureYouWantToDenyJoinRequest: 'Möchten Sie diese Beitrittsanfrage wirklich ablehnen?',
    cityEmptyErr: 'Bitte füllen Sie eine Stadt aus',
    close: 'Schließen',
    community: 'Community',
    communityApps: 'Community-App',
    communityApps_plural: 'Community-Apps',
    communityMemberCreatedAndInvited:
      'Das Community-Mitglied wurde erstellt und der Benutzer wurde eingeladen',
    communityMemberCreatedAndInvitedError:
      'Community-Mitglied konnte nicht erstellt und Benutzer nicht eingeladen werden',
    communityRoles: 'Community-Rolle',
    communityRoles_plural: 'Community-Rollen',
    communitySuites: 'Community-Suite',
    communitySuites_plural: 'Community-Suiten',
    communityInfo: 'Community-Informationen',
    communityManagement: 'Community-Verwaltung',
    confirmInvitationInfo:
      'Bitte bestätigen Sie, dass die untenstehenden Angaben korrekt sind. In den nächsten Schritten können Sie Ihre Kontoinformationen vervollständigen und den Registrierungsprozess abschließen.',
    couldNotCompleteInvitation:
      'Leider konnten wir Ihre Einladung nicht abschließen.Versuchen Sie es erneut oder kontaktieren Sie unseren Support <1>{{text}}</1>.',
    countryEmptyErr: 'Bitte wählen Sie ein Land',
    createAppFailed: 'App konnte nicht erstellt werden',
    createAppSubscriptionFailed: 'App-Abonnement konnte nicht erstellt werden',
    createAppSubscriptionSuccess: 'Das App-Abonnement wurde erstellt',
    createAppSuccess: 'Die App wurde erstellt',
    createCommunityAppFailed: 'Community-App konnte nicht erstellt werden',
    createCommunityAppSuccess: 'Die Community-App wurde erstellt',
    createCommunityMemberFailed: 'Community-Mitglied konnte nicht erstellt werden',
    createCommunityMemberSuccess: 'Das Community-Mitglied wurde erstellt',
    createCommunitySuiteFailed: 'Community-Suite konnte nicht erstellt werden',
    createCommunitySuiteSuccess: 'Die Community-Suite wurde erstellt',
    createIdentificationCodeTypeFailed: 'Identifikationscode-Typ konnte nicht erstellt werden',
    createIdentificationCodeTypeSuccess: 'Der Identifikationscode-Typ wurde erstellt',
    createNewMember: 'Neues Mitglied erstellen',
    createNewOrganisation: 'Neue Organisation erstellen',
    createOnboardingTemplateFailed: 'Onboarding-Vorlage konnte nicht erstellt werden',
    createOnboardingTemplateSuccess: 'Die Onboarding-Vorlage wurde erstellt',
    createOrganisationRoleFailed: 'Organisationsrolle konnte nicht erstellt werden',
    createOrganisationRoleSuccess: 'Die Organisationsrolle wurde erstellt',
    createPrincipalFailed: 'Benutzer konnte nicht erstellt werden',
    createPrincipalSuccess: 'Der Benutzer wurde erstellt',
    createRelationFailed: 'Beziehung konnte nicht erstellt werden',
    createRelationSuccess: 'Die Beziehung wurde erstellt',
    createRelationTypeFailed: 'Beziehungstyp konnte nicht erstellt werden',
    createRelationTypeSuccess: 'Der Beziehungstyp wurde erstellt',
    createSuiteFailed: 'Suite konnte nicht erstellt werden',
    createSuiteSuccess: 'Die Suite wurde erstellt',
    createUserFailed: 'Benutzer konnte nicht erstellt werden',
    createUserSuccess: 'Der Benutzer wurde erstellt',
    defaultCommunity: 'Standard-Community',
    deleted: 'Gelöscht',
    denyJoinRequestFailed: 'Beitrittsanfrage konnte nicht abgelehnt werden',
    denyJoinRequestSuccess: 'Die Beitrittsanfrage wurde abgelehnt',
    markUniqueJoinRequestFailed: 'Beitrittsanfrage konnte nicht als kein Duplikat markiert werden',
    markUniqueJoinRequestSuccess: 'Beitrittsanfrage als kein Duplikat markiert',
    markNotDuplicateConfirmation:
      'Diese Beitrittsanfrage als kein Duplikat markieren. Der Status wird auf "Neu" geändert und der Community-Administrator wird benachrichtigt.',
    descriptionEmptyErr: 'Bitte geben Sie eine Beschreibung ein',
    details: 'Details',
    displayName: 'Anzeigename',
    editApp: 'App bearbeiten',
    editCommunityApp: 'Community-App bearbeiten',
    editCommunityMember: 'Community-Mitglied bearbeiten',
    editCommunityRole: 'Community-Rolle bearbeiten',
    editFeature: 'Funktion bearbeiten',
    editOrganisationRole: 'Organisationsrolle bearbeiten',
    editSubscription: 'Abonnement bearbeiten',
    email: 'E-Mail-Adresse',
    emailAddress: 'E-Mail-Adresse',
    emailAddressEmptyErr: 'Bitte geben Sie eine E-Mail-Adresse ein',
    emailOrPhoneNumberRequiredError:
      'Eine gültige E-Mail-Adresse oder Telefonnummer ist erforderlich',
    externalIdentifier: 'Externe Kennung',
    feature: 'Funktion',
    featureName: 'Funktionsname',
    features: 'Funktionen',
    featureSubscriptions: 'Abonnements',
    subscriptions: 'Abonnements',
    subscriptionRequired: 'Abonnement erforderlich',
    noSubscriptionRequired: 'Kein Abonnement erforderlich',
    firstSelectAFeature: 'Wählen Sie zuerst eine Funktion',
    firstSelectAnApp: 'Wählen Sie zuerst eine App',
    fullNameEmptyErr: 'Bitte geben Sie einen vollständigen Namen ein',
    general: 'Allgemein',
    getAppFailed: 'App konnte nicht abgerufen werden',
    getAppInstallationFailed: 'App-Installation konnte nicht abgerufen werden',
    getAppInstallationsFailed: 'App-Installationen konnten nicht abgerufen werden',
    getAppsFailed: 'Apps konnten nicht abgerufen werden',
    getAppSubscriptionsFailed: 'App-Abonnements konnten nicht abgerufen werden',
    getAvailableRolesFailed: 'Verfügbare Rollen konnten nicht abgerufen werden',
    getCommunityAppsFailed: 'Community-Apps konnten nicht abgerufen werden',
    getCommunityMemberRolesFailed: 'Rollen für diese Organisation konnten nicht abgerufen werden',
    getIdentificationCodeTypeFailed: 'Identifikationstyp konnte nicht abgerufen werden',
    getJoinRequestFailed: 'Beitrittsanfrage konnte nicht abgerufen werden',
    getOnboardingTemplateFailed: 'Onboarding-Vorlage konnte nicht abgerufen werden',
    getOrganisationRolesFailed: 'Rollen konnten nicht abgerufen werden',
    getPrincipalFailed: 'Benutzer konnte nicht abgerufen werden',
    getRelationFailed: 'Beziehung konnte nicht abgerufen werden',
    getRelationsFailed: 'Beziehungen konnten nicht abgerufen werden',
    getRelationTypeFailed: 'Beziehungstyp konnte nicht abgerufen werden',
    getRelationTypesFailed: 'Beziehungstypen konnten nicht abgerufen werden',
    getSuiteFailed: 'Suite konnte nicht abgerufen werden',
    getSuitesFailed: 'Suiten konnten nicht abgerufen werden',
    global: 'Global',
    here: 'hier',
    hostedAt: 'Gehostet bei',
    identificationcodetypes: 'Identifikationscode-Typ',
    identificationcodetypes_plural: 'Identifikationscode-Typen',
    identities: 'Konten',
    identity: 'Konto',
    inactive: 'Inaktiv',
    installationIndex: 'Installationsindex',
    introducedInVersion: 'Eingeführt in Version',
    introducedInVersionEmptyErr:
      'Bitte geben Sie ein, in welcher Version diese Funktion eingeführt wurde',
    invalidInvitation1: 'Beim Abrufen Ihrer Einladung ist etwas schief gelaufen.',
    invalidInvitation2: 'Sie ist möglicherweise abgelaufen oder existiert nicht.',
    invitationExpiresOn: 'Einladung läuft ab am',
    invitationInfo:
      '<bold>{{username}}</bold> von Organisation <bold>{{organisation}}</bold> hat Sie eingeladen, der <bold>{{community}}</bold> Community beizutreten.',
    invitationSentOn: 'Einladung gesendet am',
    invitationState: 'Einladungsstatus',
    invitationType: 'Einladungstyp',
    invited: 'Eingeladen',
    inviteFreeText:
      'Fügen Sie eine Nachricht hinzu, die in der Einladungs-E-Mail enthalten sein wird',
    isCustomer: 'Ist Kunde',
    isGloballyManaged: 'Verfügbar für Community-Admins',
    isOptional: 'Ist optional',
    isSystem: 'Ist System',
    isVisible: 'Ist sichtbar',
    joinMessage: 'Ihre Nachricht für den Community-Admin',
    joinRequestAcceptedInfo: 'Sehr geehrte(r) {{fullName}}, Ihre Beitrittsanfrage wurde genehmigt.',
    joinRequestError: 'Beitrittsanfrage konnte nicht gesendet werden',
    joinRequestErrorMessage:
      'Beim Senden Ihrer Beitrittsanfrage an den Community-Admin ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    joinRequests: 'Beitrittsanfragen',
    joinRequestSentToCommunityAdmin: 'Beitrittsanfrage an Community-Admins gesendet',
    joinRequestSentToCommunityAdminDescription:
      'Ihre Beitrittsanfrage wurde an die Community-Admins gesendet, um Ihnen Zugang zu Community-Apps zu gewähren.',
    new: 'Neu',
    notADuplicate: 'Kein Duplikat',
    potentialDuplicate: 'Mögliches Duplikat',
    potentialDuplicates: 'Mögliche Duplikate',
    potentialDuplicateTooltip:
      'Diese Anfrage wird von Nallian geprüft, bevor sie fortgesetzt wird.',
    potentialDuplicationDetails: 'Mögliche Duplikate Details',
    potentialDuplicateCannotManage:
      'Da diese Beitrittsanfrage ein mögliches Duplikat sein könnte, wird sie von Nallian überprüft, bevor fortgefahren wird. Diese Beitrittsanfrage kann derzeit nicht angenommen oder abgelehnt werden.',
    duplicateByIdentificationCode:
      'Dieses Duplikat wurde durch einen oder mehrere übereinstimmende Identifikationscodes erkannt',
    joinRequest: 'Beitrittsanfrage',
    score: 'Punktzahl',
    languageEmptyErr: 'Bitte wählen Sie eine Sprache',
    languageIdEmptyErr: 'Bitte wählen Sie eine Sprache',
    linkExistingOrganisation: 'Bestehende Organisation verknüpfen',
    linkIdentityFailed: 'Konto konnte nicht mit Benutzer verknüpft werden',
    linkIdentitySuccess: 'Konto mit Benutzer verknüpft',
    linkMyIdentityToPrincipal: 'Mein Konto mit Benutzer verknüpfen',
    location: 'Standort',
    lockedOut: 'Gesperrt',
    management: 'Verwaltung',
    mine: '(mein Konto)',
    newApp: 'Neue App',
    newAppSubscription: 'Neues App-Abonnement',
    newCommunityApp: 'Neue Community-App',
    newCommunityMember: 'Neues Community-Mitglied',
    newCommunityRole: 'Neue Community-Rolle',
    newCommunitySuite: 'Neue Community-Suite',
    newFeature: 'Neue Funktion',
    newIdentificationCodeType: 'Typ hinzufügen',
    newOnboardingTemplate: 'Neue Onboarding-Vorlage',
    newOrganisationRole: 'Neue Organisationsrolle',
    newRelation: 'Neue Beziehung',
    newRelationType: 'Neuer Beziehungstyp',
    newSuite: 'Neue Suite',
    newUser: 'Neuer Benutzer',
    noAppsConfiguredForOnboardingTemplate: 'Keine Apps für Vorlage konfiguriert.',
    noFeaturesDefined: 'Keine Funktionen definiert',
    noFeaturesDefinedYet: 'Noch keine Funktionen konfiguriert',
    noFeaturesFound: 'Keine Funktionen gefunden',
    noLinkedAccountsYet: 'Noch keine verknüpften Konten.',
    noPendingInvitationsFound: 'Keine ausstehenden Einladungen gefunden',
    noRolesDefined: 'Keine Rollen definiert',
    noSuitesFound: 'Keine Suiten gefunden',
    noTiersFound: 'Keine Stufen gefunden',
    noUsersFound: 'Keine Benutzer gefunden',
    noAssignmentsFound: 'Keine Zuweisungen gefunden',
    noSubscriptionsFound: 'Keine Abonnements gefunden',
    subscriptionId: 'Abonnement-ID',
    createFeatureSubscription: 'Feature-Abonnement erstellen',
    createSubscription: 'Abonnement erstellen',
    createFeatureSubscriptionSuccess: 'Feature-Abonnement erfolgreich erstellt',
    createFeatureSubscriptionFailed: 'Feature-Abonnement konnte nicht erstellt werden',
    createRoleAssignmentSuccess: 'Die Zuweisung wurde aktualisiert.',
    createRoleAssignmentFailed: 'Der Benutzer konnte der Rolle nicht hinzugefügt werden',
    removeUser: 'Benutzer entfernen',
    areYouSureRemoveRoleAssignment:
      'Möchten Sie {{name}} - {{email}} wirklich aus dieser Rolle entfernen?',
    removeRoleAssignmentSuccess: 'Der Benutzer wurde aus der Rolle entfernt.',
    removeRoleAssignmentFailed: 'Der Benutzer konnte nicht aus der Rolle entfernt werden',
    addSubscription: 'Abonnement hinzufügen',
    addSubscriptionSuccess: 'Das Abonnement wurde aktualisiert.',
    addSubscriptionFailed: 'Das Abonnement konnte nicht hinzugefügt werden',
    removeOrgSubscription: 'Abonnement entfernen',
    areYouSureRemoveOrgSubscription:
      'Möchten Sie das Abonnement von Feature: {{featureName}} - Installation: {{installationName}} - App: {{appName}} wirklich für die Organisation {{organisationName}} entfernen? Der Zugriff auf dieses Feature wird für alle Benutzer dieser Organisation widerrufen.',
    removeOrgSubscriptionSuccess: 'Das Abonnement wurde entfernt.',
    removeOrgSubscriptionFailed: 'Das Abonnement konnte nicht entfernt werden',
    communityIdEmptyErr: 'Bitte wählen Sie eine Community',
    organisationIdEmptyErr: 'Bitte wählen Sie eine Organisation',
    principalIdEmptyErr: 'Bitte wählen Sie einen Benutzer',
    assignmentType: 'Zuweisungstyp',
    assignments: 'Zuweisungen',
    principalName: 'Hauptbenutzer',
    organisationCityEmptyErr: 'Bitte geben Sie eine Stadt ein',
    organisationCountryEmptyErr: 'Bitte geben Sie ein Land ein',
    organisationDetailsDescription: 'Füllen Sie die Details der Organisation aus',
    organisationNameEmptyErr: 'Bitte geben Sie einen Organisationsnamen ein',
    organisationRole: 'Organisationsrolle',
    organisationRoles: 'Organisationsrolle',
    organisationRoles_plural: 'Organisationsrollen',
    organisationType: 'Organisationstyp',
    organisations: 'Organisationen',
    organisationsOverview: 'Organisationsübersicht',
    owners: 'Eigentümer',
    parentOrganisation: 'Übergeordnete Organisation',
    passwordToDelete: 'Passwort zum Löschen',
    pending: 'Ausstehend',
    pendingInvitations: 'Ausstehende Einladung',
    pendingInvitations_plural: 'Ausstehende Einladungen',
    phoneNumber: 'Telefonnummer',
    pleaseAcceptOurTermsAndConditions:
      'Bitte akzeptieren Sie unsere Allgemeinen Geschäftsbedingungen',
    pleaseCompleteOrganisationDetails:
      'Bitte vervollständigen Sie die Details Ihrer Organisation unten.',
    postalCodeEmptyErr: 'Bitte füllen Sie eine Postleitzahl aus',
    primaryEmailAddressEmptyErr: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    primaryPhoneNumberEmptyErr: 'Bitte geben Sie eine gültige Telefonnummer ein',
    principalFullNameEmptyErr: 'Bitte geben Sie einen vollständigen Namen ein',
    principalLanguageIdEmptyErr: 'Bitte wählen Sie eine Sprache',
    principals: 'Benutzer',
    principalTimeZoneEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    reInvite: 'Erneut einladen',
    relationType: 'Beziehung',
    relationTypeIdEmptyErr: 'Bitte wählen Sie einen Beziehungstyp',
    relationTypes: 'Beziehungstyp',
    relationTypes_plural: 'Beziehungstypen',
    removeApp: 'App entfernen',
    removeAppAndRoles: 'App, Funktionen & Rollen entfernen',
    removeAppSubscriptionFailed: 'Entfernen des Abonnements fehlgeschlagen',
    removeAppSubscriptionSuccess: 'Abonnement erfolgreich entfernt',
    removeFeature: 'Funktion entfernen',
    removeThisFeature: 'Diese Funktion entfernen',
    removeThisRole: 'Rolle entfernen',
    removeThisSuite: 'Diese Suite entfernen',
    removeThisTier: 'Diese Stufe entfernen',
    requestToJoin: 'Beitrittsanfrage',
    requestToJoinInfo:
      'Wenn Ihre Organisation dieser Community beitreten möchte, füllen Sie bitte das Formular aus.<br/>Der Community-Admin wird Ihre Anfrage prüfen und sich in Kürze mit Ihnen in Verbindung setzen.',
    requiresSubscription: 'Abonnement erforderlich',
    resendInvitationFailed: 'Einladung konnte nicht erneut gesendet werden',
    resendInvitationSuccess: 'Die Einladung wurde erneut gesendet',
    resetPassword: 'Passwort zurücksetzen',
    reviewJoinRequest: 'Beitrittsanfrage prüfen',
    selectAnApp: 'Wählen Sie eine App aus',
    selectAnApplication: 'Wählen Sie eine Anwendung aus',
    sendInvitation: 'Einladung senden',
    sometingWentWrong: 'Etwas ist schief gelaufen',
    source: 'Quelle',
    sourceIdEmptyErr: 'Bitte wählen Sie eine Quelle aus',
    sourceOrganisationRoles: 'Quellorganisationsrollen',
    stateName: 'Status',
    status: 'Status',
    streetAndNumberEmptyErr: 'Bitte füllen Sie Straße und Hausnummer aus',
    tag: 'Tag',
    tagEmptyErr: 'Bitte füllen Sie ein Tag aus',
    tagExplainer: 'Beginnt mit einem alphabetischen Zeichen, maximale Länge von 20',
    target: 'Ziel',
    targetIdEmptyErr: 'Bitte wählen Sie ein Ziel aus',
    targetOrganisationRoles: 'Zielorganisationsrollen',
    template: 'Vorlage',
    templateHasNoConfiguration: 'Vorlage hat keine Konfiguration',
    templateInfo1:
      'Eine Vorlage gibt dem Administrator Zugriff auf eine Reihe von Apps und eine Liste von Organisationsrollen.',
    templateInfo2: 'Wählen Sie eine Vorlage aus, um deren Konfiguration anzuzeigen',
    textMessage: 'Textnachricht',
    noUserGroupsFound: 'Keine Benutzergruppen gefunden',
    areYouSureRemoveUserGroup: 'Möchten Sie diese Benutzergruppe wirklich entfernen?',
    createUserGroupFailed: 'Benutzergruppe konnte nicht erstellt werden',
    createUserGroupSuccess: 'Benutzergruppe erstellt',
    updateUserGroupFailed: 'Benutzergruppe konnte nicht aktualisiert werden',
    updateUserGroupSuccess: 'Benutzergruppe aktualisiert',
    getUserGroupFailed: 'Benutzergruppe konnte nicht abgerufen werden',
    addUserGroup: 'Benutzergruppe hinzufügen',
    newUserGroup: 'Neue Benutzergruppe',
    noAppsFeaturesRolesDefined: 'Keine Apps, Funktionen, Rollen definiert',
    createUserGroupMemberFailed: 'Benutzergruppenmitglied konnte nicht erstellt werden',
    createUserGroupMemberSuccess: 'Benutzergruppenmitglied erstellt',
    removeUserGroupMemberFailed: 'Benutzergruppenmitglied konnte nicht entfernt werden',
    removeUserGroupMemberSuccess: 'Benutzergruppenmitglied entfernt',
    getUserGroupMembersFailed: 'Benutzergruppenmitglieder konnten nicht abgerufen werden',
    membersOfUserGroup: 'Mitglieder der Benutzergruppe',
    timezoneEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    timeZoneEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    timeZoneIdEmptyErr: 'Bitte wählen Sie eine Zeitzone',
    unauthorized: 'Sie sind nicht berechtigt, diese Aktion auszuführen.',
    unlink: 'Verknüpfung aufheben',
    unlinkIdentityFailed: 'Verknüpfung des Kontos konnte nicht aufgehoben werden',
    unlinkIdentitySuccess: 'Das Konto wurde entkoppelt',
    unlisted: 'Nicht gelistet',
    updateAppFailed: 'App konnte nicht aktualisiert werden',
    updateAppSubscriptionFailed: 'App-Abonnement konnte nicht aktualisiert werden',
    updateAppSubscriptionSuccess: 'Das App-Abonnement wurde aktualisiert',
    updateAppSuccess: 'Die App wurde aktualisiert',
    updateCommunityAppFailed: 'Community-App konnte nicht aktualisiert werden',
    updateCommunityAppSuccess: 'Die Community-App wurde aktualisiert',
    updateCommunityMemberFailed: 'Community-Mitglied konnte nicht aktualisiert werden',
    updateCommunityMemberRolesFailed:
      'Rollen der Community-Mitglieder konnten nicht aktualisiert werden',
    updateCommunityMemberRolesSuccess: 'Die Rollen der Community-Mitglieder wurden aktualisiert',
    updateCommunityMemberSuccess: 'Das Community-Mitglied wurde aktualisiert',
    updateCommunityRoleFailed: 'Community-Rolle konnte nicht aktualisiert werden',
    updateCommunityRoleSuccess: 'Die Community-Rolle wurde aktualisiert',
    updateCommunitySuiteFailed: 'Community-Suite konnte nicht aktualisiert werden',
    updateCommunitySuiteSuccess: 'Die Community-Suite wurde aktualisiert',
    updateIdentificationCodeTypeFailed: 'Identifikationscode-Typ konnte nicht aktualisiert werden',
    updateIdentificationCodeTypeSuccess: 'Der Identifikationscode-Typ wurde aktualisiert',
    updateOnboardingTemplateFailed: 'Onboarding-Vorlage konnte nicht aktualisiert werden',
    updateOnboardingTemplateSuccess: 'Die Onboarding-Vorlage wurde aktualisiert',
    updateOrganisationRoleFailed: 'Organisationsrolle konnte nicht aktualisiert werden',
    updateOrganisationRoleSuccess: 'Die Organisationsrolle wurde aktualisiert',
    updatePrincipalFailed: 'Benutzer konnte nicht aktualisiert werden',
    updatePrincipalSuccess: 'Der Benutzer wurde aktualisiert',
    updateRelationFailed: 'Beziehung konnte nicht aktualisiert werden',
    updateRelationSuccess: 'Die Beziehung wurde aktualisiert',
    updateRelationTypeFailed: 'Beziehungstyp konnte nicht aktualisiert werden',
    updateRelationTypeSuccess: 'Der Beziehungstyp wurde aktualisiert',
    updateUserSuccess: 'Der Benutzer wurde aktualisiert',
    url: 'URL',
    urlEmptyErr: 'Bitte geben Sie eine URL ein',
    useATemplate: 'Verwenden Sie eine Vorlage',
    user: 'Benutzer',
    userDetailsDescription: 'Füllen Sie die Benutzerdetails aus',
    validationPattern: 'Validierungsmuster',
    verifiedStatus: 'Verifizierter Status',
    view: 'Anzeigen',
    viewMore: 'Mehr anzeigen',
    viewSubscribedOrganisations: 'Abonnierte Organisationen anzeigen',
    viewTemplate: 'Vorlage anzeigen',
    welcomeToThePlatform: 'Willkommen auf der Plattform!',
    welcomeToThePlatformInfo:
      'Ihr Benutzerkonto wurde erfolgreich auf der Nallian-Plattform registriert. Um fortzufahren und die Anwendungen zu verwenden, klicken Sie bitte auf "Fortfahren", um sich beim Nallian-Portal anzumelden.',
    searchAndAddMember: 'Mitglied suchen und hinzufügen',
    searchForNameOrEmailOfUser: 'Suchen Sie nach einem Namen oder einer E-Mail eines Benutzers',
    editUserGroup: 'Benutzergruppe bearbeiten',
    manageMembers: 'Mitglieder anzeigen/verwalten',
    userGroupHasNoMembers: 'Diese Benutzergruppe hat keine Mitglieder',
    organisationsForRole: 'Organisationen für Community-Rolle',
    noOrganisationsFound: 'Keine Organisationen gefunden',
    viewOrganisations: 'Organisationen anzeigen',
    appSubscriptions: 'App-Abonnements',
    createdByOrganisation: 'Erstellt von Organisation',
    metaData: 'Metadaten',
    lastModifiedOn: 'Zuletzt geändert am',
    linkedAccounts: 'Verknüpfte Konten',
    relations: 'Beziehungen',
    youHaveBeenInvited: 'Sie wurden eingeladen',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Möchten Sie das Abonnement für diese Funktion wirklich entfernen? Der Zugriff auf diese Funktion wird für alle Benutzer dieser Organisation widerrufen.',
    applyOnboardingTemplate: 'Onboarding-Vorlage anwenden',
    getOnboardingTemplatesFailed: 'Onboarding-Vorlagen konnten nicht abgerufen werden',
    selectAnOnboardingTemplate: 'Wählen Sie eine Onboarding-Vorlage aus',
    onboardingTemplateIdEmptyErr: 'Bitte wählen Sie eine Onboarding-Vorlage aus',
    applyOnboardingTemplateFailed: 'Onboarding-Vorlage konnte nicht angewendet werden',
    applyOnboardingTemplateSuccess: 'Onboarding-Vorlage angewendet',
    addTemplateInfo:
      'Die Vorlage fügt der Organisation die folgenden Apps und Community-Rollen hinzu',
    filters: 'Filter',
    filterOnUserRole: 'Nach Benutzerrolle filtern',
    identityOrClient: 'Konto oder Client',
    searchForAnIdentityOrAddClientId:
      'Suchen Sie nach einem Konto oder fügen Sie eine Client-ID hinzu',
    filterOnIdentificationCode: 'Nach Identifikationscode filtern',
    useNoTemplate: 'Keine Vorlage verwenden',
    templateInfo: 'Wählen Sie eine Vorlage aus',
    userInfo: 'Benutzerinformationen',
    invalidUrlCommuntiyAppFeature: 'Muss eine gültige URL sein oder [EnvironmentUrl] enthalten',
    communitiesOverview: 'Community-Übersicht',
    createCommunityFailed: 'Community konnte nicht erstellt werden',
    createCommunitySuccess: 'Community erstellt',
    newCommunity: 'Neue Community',
    themeName: 'Themenname',
    defaultLanguage: 'Standardsprache',
    mustBeValidUrl: 'Muss eine gültige URL sein',
    updateCommunityFailed: 'Community konnte nicht aktualisiert werden',
    updateCommunitySuccess: 'Community aktualisiert',
    fixedCommunityId:
      'ID (nicht obligatorisch, nur wenn Sie auf allen Umgebungen dieselbe Community-ID wünschen)',
    updateNotificationSettingsFailed:
      'Benachrichtigungseinstellungen konnten nicht aktualisiert werden',
    updateNotificationSettingsSuccess: 'Benachrichtigungseinstellungen aktualisiert',
    notificationSettings: 'Benachrichtigungseinstellungen',
    fromName: 'Von Name',
    fromEmail: 'Von E-Mail',
    replyToEmail: 'Antwort an E-Mail',
    replyToName: 'Antwort an Name',
    emailSubjectPrefix: 'E-Mail-Betreff-Präfix',
    contactEmail: 'Kontakt-E-Mail',
    updateHostsFailed: 'Hosts konnten nicht aktualisiert werden',
    updateHostsSuccess: 'Hosts aktualisiert',
    noHostsYet: 'Noch keine Hosts',
    addHost: 'Host hinzufügen',
    host: 'Host',
    hosts: 'Hosts',
    isPrimary: 'Ist primär',
    onlyOnePrimaryHost: 'Nur ein Host kann primär sein',
    minOnePrimaryHost: 'Mindestens ein Host muss primär sein',
    pleaseEnterAHost: 'Bitte geben Sie einen (gültigen) Host ein',
    tenantId: 'Mandanten-ID',
    tenantHostUrl: 'Mandanten-Host-URL',
    tenantInformation: 'Mandanteninformationen',
    communityWelcomeText: 'Willkommenstext der Community',
    legalDocuments: 'Rechtliche Dokumente',
    uploadNewGeneralTermsAndConditions: 'Neue Allgemeine Geschäftsbedingungen hochladen',
    documents: 'Dokumente',
    title: 'Titel',
    revision: 'Revision',
    download: 'Herunterladen',
    themeLookups_plural: 'Themen-Lookups',
    newThemeLookup: 'Neues Themen-Lookup',
    createThemeLookupFailed: 'Themen-Lookup konnte nicht erstellt werden',
    createThemeLookupSuccess: 'Themen-Lookup erstellt',
    updateThemeLookupFailed: 'Themen-Lookup konnte nicht aktualisiert werden',
    updateThemeLookupSuccess: 'Themen-Lookup aktualisiert',
    editThemeLookup: 'Themen-Lookup bearbeiten',
    themeLookups: 'Themen-Lookup',
    titleEmptyErr: 'Bitte geben Sie einen Titel ein',
    hostEmptyErr: 'Bitte geben Sie einen Host ein',
    themeNameEmptyErr: 'Bitte geben Sie einen Themennamen ein',
    editCommunityTextFailed: 'Community-Text konnte nicht aktualisiert werden',
    editCommunityTextSuccess: 'Community-Text aktualisiert',
    documentUploaded: 'Dokument hochgeladen',
    documentUploadFailed: 'Hochladen des Dokuments fehlgeschlagen',
    noCommunityTextYet: 'Noch kein Community-Willkommenstext',
    noDocumentsYet: 'Noch keine Dokumente',
    noWelcomeTextAvailable: 'Keine Willkommensinformationen für diese Community verfügbar.',
    addLanguage: 'Sprache hinzufügen',
    enterLanguageKey: 'Geben Sie Ihren Sprachschlüssel ein',
    emailNotificationFooter: 'E-Mail-Benachrichtigungsfußzeile',
    emailNotificationHeader: 'E-Mail-Benachrichtigungskopfzeile',
    removeCommunityAppClientFailed: 'Client konnte nicht entfernt werden',
    removeCommunityAppClientSuccess: 'Client entfernt',
    createCommunityAppClientFailed: 'Client konnte nicht erstellt werden',
    createCommunityAppClientSuccess: 'Client erstellt',
    getCommunityAppClientsFailed: 'Clients konnten nicht abgerufen werden',
    manageClientsForCommunityApp: 'Clients verwalten',
    addClient: 'Client hinzufügen',
    manageAppClients: 'App-Clients verwalten',
    noClientsYet: 'Noch keine Clients',
    unknownIdentityProvider: 'Unbekannter Identitätsanbieter',
    areYouSureRemoveOrganisation:
      'Möchten Sie die Organisation "{{item.name}}" wirklich entfernen?',
    timeSettings: 'Zeiteinstellungen',
    userDetails: 'Benutzerdetails',
    appsAndRoles: 'Apps & Rollen',
    accountsIdentities: 'Verknüpfte Konten',
    accounts: 'Konten',
    areYouSureContinueWithoutUserHasRoles:
      'Möchten Sie diesem Benutzer wirklich keinen Zugriff auf eine Anwendung gewähren?',
    principalRemoved: 'Benutzer entfernt',
    userGroups: 'Benutzergruppen',
    userGroup: 'Benutzergruppe',
    selectUserGroups: 'Benutzergruppen auswählen',
    rolesFromUserGroups: 'Rollen aus Benutzergruppen',
    noRolesInUserGroup: 'Dieser Benutzergruppe sind keine Rollen zugewiesen',
    noRolesInSelectedUserGroups: 'Den ausgewählten Benutzergruppen sind keine Rollen zugewiesen',
    data: 'Daten',
    id: 'ID',
    shortName: 'Kurzname',
    installations: 'Installationen',
    isGlobal: 'Ist global',
    isCrossCommunity: 'Ist communityübergreifend',
    isObsolete: 'Ist veraltet',
    copyToClipboard: 'In die Zwischenablage kopieren',
    administrators: 'Administratoren',
    welcomeText: 'Willkommenstext der Community',
    overviewText: 'Übersichtstext der Startseite',
    pleaseTypeToEnableConfirmButton:
      "Bitte geben Sie '{{message}}' ein, um die Bestätigungsschaltfläche zu aktivieren.",
    pleaseTypeHere: 'Bitte hier eingeben',
    removeOrganisation: 'Organisation entfernen',
    removeOrganisationFailed: 'Organisation konnte nicht entfernt werden',
    removeOrganisationSuccess: 'Organisation entfernt',
    removeAppInstallation: 'App-Installation entfernen',
    areYouSureRemoveAppInstallation:
      'Möchten Sie die App-Installation "{{item.name}}" wirklich entfernen?',
    removeAppInstallationFailed: 'App-Installation konnte nicht entfernt werden',
    removeAppInstallationSuccess: 'App-Installation entfernt',
    areYouSureRemoveApp: 'Möchten Sie die App "{{item.name}}" wirklich entfernen?',
    removeAppFailed: 'App konnte nicht entfernt werden',
    removeAppSuccess: 'App entfernt',
    roleInFeature: 'Rolle in {{featureName}}',
    featureInInstallation: 'Feature in {{installationName}}',
    installationOfApp: 'Installation von {{appName}}',
    installation: 'Installation',
    removeFeatureSubscriptionFailed: 'Feature-Abonnement konnte nicht entfernt werden',
    removeFeatureSubscriptionSuccess: 'Feature-Abonnement entfernt',
    removeSubscription: 'Abonnement entfernen',
    areYouSureRemoveSubscription:
      'Möchten Sie das Abonnement für "{{organisationName}}" wirklich entfernen?',
    identificationCodesCount: '{{count}} Identifikationscode(s)',
    noIdentificationCodes: 'Keine Identifikationscodes',
    principalCount: '{{count}} Prinzipal(e)',
    noPrincipals: 'Keine Principals',
    errorLoadingPrincipals: 'Fehler beim Laden der Principals',
    unnamed: 'Unbenannt',
    linkedPrincipals: 'Verknüpfte Principals',
    allIdentities: 'Alle Identitäten',
    provider: 'Anbieter',
    anonymizeIdentity: 'Identität anonymisieren',
    areYouSureYouWantToAnonymiseIdentity:
      'Sind Sie sicher, dass Sie die Identität für {{fullName}} anonymisieren möchten?',
    anonymizeIdentitySuccess: 'Identität erfolgreich anonymisiert',
    anonymizeIdentityFailed: 'Identität konnte nicht anonymisiert werden',
    noIdentitiesFound: 'Keine Identitäten gefunden',
    typeMinimum2Characters: 'Mindestens 2 Zeichen eingeben',
    startWithPlusEgFormat: 'Beginnen Sie mit +, z.B. +32',
    noRoles: 'Keine Rollen',
    rolesCount: '{{count}} Rolle(n)',
    noIdentificationCodeTypesFound: 'Keine Identifikationscode-Typen gefunden',
    isRequired: 'Ist erforderlich',
    identificationCodeTypeTagEmptyErr: 'Bitte wählen Sie einen Identifikationscode-Typ',
    editType: 'Typ bearbeiten',
    theFollowingIdentificationCodeTypesAreRequired:
      'Folgende Identifikationscodes fehlen: {{missingTypes}}',
    updateContactFailed: 'Kontakt konnte nicht aktualisiert werden',
    updateContactSuccess: 'Kontakt aktualisiert',
    createContactFailed: 'Kontakt konnte nicht erstellt werden',
    createContactSuccess: 'Kontakt erstellt',
    removeContactFailed: 'Kontakt konnte nicht entfernt werden',
    removeContactSuccess: 'Kontakt entfernt',
    contacts: 'Kontakte',
    noContactsYet: 'Noch keine Kontakte.',
    newContact: 'Neuer Kontakt',
    editContact: 'Kontakt bearbeiten',
    areYouSureYouWantToRemoveContact: 'Möchten Sie diesen Kontakt wirklich entfernen?',
    logo: 'Logo',
    uploadANewLogo: 'Neues Logo hochladen',
    noLogoAvailable: 'Noch kein Logo vorhanden.',
    viewLogo: 'Logo anzeigen',
    uploadLogo: 'Logo hochladen',
    removeOrganisationLogoFailed: 'Logo konnte nicht entfernt werden',
    removeOrganisationLogoSuccess: 'Logo entfernt',
    uploadLogoSuccess: 'Logo hochgeladen',
    uploadLogoError: 'Logo konnte nicht hochgeladen werden',
    removeLogo: 'Logo entfernen',
    areYouSureYouWantToRemoveLogo: 'Möchten Sie das Logo wirklich entfernen?',
    fileEmptyErr: 'Bitte laden Sie eine gültige Datei hoch',
    noFeatureDetails: 'Keine Funktionsdetails',
    pleaseSelectRoles: 'Bitte wählen Sie eine oder mehrere Rollen aus',
    idpUserGroup: 'Automatisch verwaltete Benutzergruppe',
    idpUserGroupInfo:
      'Diese Gruppe wird mit der Benutzerliste Ihrer Organisation auf dem neuesten Stand gehalten. Sie können Benutzer weiterhin manuell hinzufügen - aber wenn sich jemand über das Anmeldesystem Ihres Unternehmens anmeldet, können Ihre Änderungen bei der nächsten Anmeldung rückgängig gemacht werden.',
    viaIdp: 'Automatisch zugewiesen',
    invitationIsExpired: 'Diese Einladung ist abgelaufen',
    inviationNotValidAnymore: 'Diese Einladung wurde widerrufen',
    invitationUsedProceedLogin:
      'Es scheint, dass diese Einladung bereits verwendet wurde. Sie können sich jetzt in Ihr Konto einloggen.',
    invitationUsedProceedProcess:
      'Diese Einladung wurde bereits verwendet, aber Ihr Konto ist fast fertig. Um Ihre Registrierung abzuschließen, melden Sie sich bitte an, geben Sie Ihre Firmendaten ein und akzeptieren Sie die Allgemeinen Geschäftsbedingungen.',
    completeRegistration: 'Registrierung abschließen',
    signIn: 'Anmelden',
    inviteAlreadyUsed: 'Einladung bereits verwendet',
    updateOrganisationFailed: 'Organisation konnte nicht aktualisiert werden',
    organisationUpdated: 'Organisation aktualisiert',
    getCommunityRoleFailed: 'Community-Rolle konnte nicht abgerufen werden',
    createOrganisation: 'Organisation erstellen',
    organisationCreated: 'Organisation erstellt',
    createOrganisationFailed: 'Organisation konnte nicht erstellt werden',
    onboardingTemplates: 'Onboarding templates',
    identificationCodeTypes: 'Identification code types',
    notification: 'Notification',
    textsAndLegal: 'Texts & legal',
    exportAsJSON: 'Als JSON exportieren',
    addContact: 'Kontakt hinzufügen',
    selectCommunityForInvitation:
      'Wählen Sie den Community-Kontext aus, in dem Sie die Einladung senden möchten',
    allUsers: 'Alle Benutzer',
    codeCannotHaveTrailingSpaces: 'Der Code darf keine Leerzeichen am Ende haben',
    deleteRole: 'Rolle löschen',
    areYouSureDeleteRole: 'Sind Sie sicher, dass Sie die Rolle "{{name}}" löschen möchten?',
    pleaseTypeRoleNameToConfirm: 'Bitte geben Sie "{{name}}" ein, um zu bestätigen',
    acknowledgeRoleNotObsolete:
      'Ich verstehe, dass diese Rolle noch nicht als veraltet markiert ist und ich sie trotzdem löschen möchte',
    removeRoleFailed: 'Rolle konnte nicht entfernt werden',
    removeRoleSuccess: 'Rolle erfolgreich entfernt',
    deleteFeature: 'Feature löschen',
    areYouSureDeleteFeature: 'Sind Sie sicher, dass Sie das Feature "{{name}}" löschen möchten?',
    pleaseTypeFeatureNameToConfirm: 'Bitte geben Sie "{{name}}" ein, um zu bestätigen',
    acknowledgeFeatureNotObsolete:
      'Ich verstehe, dass dieses Feature noch nicht als veraltet markiert ist und ich es trotzdem löschen möchte',
    removeFeatureFailed: 'Feature konnte nicht entfernt werden',
    removeFeatureSuccess: 'Feature erfolgreich entfernt',
    noFeaturesYet: 'Noch keine Features',

    /* documents */
    documents: 'Dokumente',
    documentsOverview: 'Dokumentenübersicht',
    uploadDocument: 'Dokument hochladen',
    documentType: 'Dokumenttyp',
    documentType_CompanyEmployeeRegistration: 'Firmen-Mitarbeiterregistrierung',
    documentType_AirportAccreditation: 'Flughafenakkreditierung',
    documentType_Passport: 'Reisepass',
    documentType_DriverLicense: 'Führerschein',
    documentType_IDCard: 'Personalausweis',
    selectDocumentType: 'Dokumenttyp auswählen',
    fileUpload: 'Datei hochladen',
    documentName: 'Dokumentname',
    fileSize: 'Dateigröße',
    uploadedBy: 'Hochgeladen von',
    uploadedAt: 'Hochgeladen am',
    expirationDate: 'Ablaufdatum',
    expirationDateHelperText: 'Das Datum muss heute oder später sein, bis zu 10 Jahre ab heute',
    pending: 'Ausstehend',
    validated: 'Validiert',
    expired: 'Abgelaufen',
    superseded: 'Ersetzt',
    rejected: 'Abgelehnt',
    expiring: 'Läuft ab',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    preview: 'Vorschau',
    history: 'Verlauf',
    pleaseSelectDocumentType: 'Bitte wählen Sie einen Dokumenttyp',
    unsupportedFileType: 'Nicht unterstützter Dateityp. Nur JPEG- und PNG-Dateien sind erlaubt.',
    fileTooLarge: 'Datei ist zu groß. Maximale Dateigröße beträgt 10 MB.',
    expirationDateRequired: 'Bitte wählen Sie ein Ablaufdatum',
    expirationDatePast: 'Das Ablaufdatum darf nicht in der Vergangenheit liegen',
    expirationDateTooFar: 'Das Ablaufdatum darf nicht mehr als 10 Jahre in der Zukunft liegen',
    uploadSuccessful: 'Dokument erfolgreich hochgeladen',
    uploadFailed: 'Hochladen des Dokuments fehlgeschlagen',
    documentApproved: 'Dokument erfolgreich genehmigt',
    documentPreviewTitle: 'Dokumentvorschau: {{name}}',
    documentPreviewCaption:
      'Vertrauliche Informationen wurden zum Schutz der Privatsphäre geschwärzt',
    documentPreviewError:
      'Dokumentvorschau konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    documentApproveWarning:
      'Durch die Genehmigung dieses Dokuments bestätigen Sie, dass Sie das geschwärzte Bild überprüft haben. Bitte stellen Sie sicher, dass nur Name, Geschlecht und Foto sichtbar sind und alle anderen vertraulichen Informationen ordnungsgemäß geschwärzt wurden. Wenn Sie mit der systemgenerierten Schwärzung nicht zufrieden sind, können Sie das Dokument ablehnen und stattdessen ein bereits geschwärztes Dokument erneut hochladen.',
    documentRedactingPlaceholder:
      'Bitte warten. Ihr Dokument wird geschwärzt und ist in Kürze verfügbar.',
    documentRejected: 'Dokument erfolgreich abgelehnt',
    confirmApprove: 'Genehmigung bestätigen',
    confirmReject: 'Ablehnung bestätigen',
    documentRejectedReuploadPrompt:
      'Das Dokument wurde abgelehnt. Möchten Sie eine neue Version hochladen?',
    uploadLater: 'Später hochladen',
    reuploadNow: 'Jetzt erneut hochladen',
    consentWarning:
      'Durch das Hochladen dieses Dokuments bestätigen Sie, dass der Dokumenteninhaber der Speicherung und Verarbeitung zugestimmt hat.',
    consentCheckbox: 'Ich erkenne die obige Erklärung an und stimme ihr zu',
    noDocumentsFound: 'Keine Dokumente gefunden',
    rejectReason: 'Ablehnungsgrund',
    approveDocumentFailed: 'Dokument konnte nicht genehmigt werden',
    rejectDocumentFailed: 'Dokument konnte nicht abgelehnt werden',
    areYouSureApproveDocument: 'Sind Sie sicher, dass Sie dieses Dokument genehmigen möchten?',
    areYouSureRejectDocument: 'Sind Sie sicher, dass Sie dieses Dokument ablehnen möchten?',
    viewHistory: 'Verlauf anzeigen',
    documentHistory: 'Dokumentenverlauf',
    // Document translations (shared keys needed by app components)
    'documents.title': 'Dokumente',
    'documents.type': 'Dokumenttyp',
    'documents.fileName': 'Dateiname',
    'documents.uploadedAt': 'Hochgeladen am',
    'documents.uploadedBy': 'Hochgeladen von',
    'documents.expirationDate': 'Ablaufdatum',
    'documents.status': 'Status',
    'documents.actions': 'Aktionen',
    'documents.preview': 'Vorschau',
    'documents.noDocumentsFound': 'Keine Dokumente gefunden',
    'documents.failedToLoad': 'Dokumente konnten nicht geladen werden',
    'documents.previewTitle': 'Dokumentvorschau',
    'documents.previewCaption': 'Dies ist eine Vorschau des Dokuments',
    'documents.previewError': 'Dokumentvorschau konnte nicht geladen werden',
    'documents.type_CompanyEmployeeRegistration': 'Firmenmitarbeiterregistrierung',
    'documents.type_AirportAccreditation': 'Flughafenakkreditierung',
    'documents.type_Passport': 'Reisepass',
    'documents.type_DriverLicense': 'Führerschein',
    'documents.type_IDCard': 'Personalausweis',
    'documents.status.pending': 'Ausstehend',
    'documents.status.validated': 'Validiert',
    'documents.status.expired': 'Abgelaufen',
    'documents.status.superseded': 'Ersetzt',
    'documents.status.rejected': 'Abgelehnt',
    'documents.status.expiring': 'Läuft ab',
    // Document translations (app-specific)
    'documents.confirmUploadTitle': 'Dokument überprüfen & bestätigen',
    'documents.confirmUpload': 'Upload bestätigen',
    'documents.redactWarning.intro':
      'Mit der Genehmigung dieses Dokuments bestätigen Sie, dass Sie das geschwärzte Bild überprüft haben.',
    'documents.redactWarning.visibleInfo':
      'Nur die folgenden Informationen sollten sichtbar bleiben:',
    'documents.redactWarning.fullName': 'Vollständiger Name',
    'documents.redactWarning.photo': 'Foto',
    'documents.redactWarning.expirationDate': 'Ablaufdatum',
    'documents.redactWarning.mustBlackOut':
      'Alle anderen sensiblen Informationen müssen vollständig geschwärzt sein.',
    'documents.redactWarning.adjustInstructions':
      'Wenn Sie mit den systemgenerierten Schwärzungen nicht zufrieden sind, können Sie diese anpassen, indem Sie mit der Maus über einen Bereich ziehen, um eine neue Schwärzung hinzuzufügen, oder auf "x" klicken, um eine zu entfernen.',
    'documents.history': 'Dokumentverlauf',
    'documents.redactingPlaceholder': 'Dokument wird für Schwärzung verarbeitet...',
    'documents.showFinalPreview': 'Endergebnis anzeigen',
    'documents.thisIsHowImageWillBeSaved': 'so wird das Bild gespeichert',
    'documents.failedToLoadImage': 'Bild konnte nicht geladen werden',
    'documents.upload': 'Dokument hochladen',
    'documents.documentConfirmed': 'Dokument erfolgreich bestätigt',
    'documents.confirmFailed': 'Dokument konnte nicht bestätigt werden',
    'documents.analyzeFailed': 'Dokument konnte nicht analysiert werden',
    'documents.uploadSuccessful': 'Dokument erfolgreich hochgeladen',
    'documents.uploadFailed': 'Dokument konnte nicht hochgeladen werden',
    'documents.consentWarning':
      'Mit dem Hochladen dieses Dokuments bestätigen Sie, dass der Dokumenteninhaber der Speicherung und Verarbeitung zugestimmt hat.',
    'documents.consentCheckbox':
      'Ich bestätige, dass der Dokumenteninhaber der Speicherung und Verarbeitung zugestimmt hat.',
    'documents.redactConfirmCheckbox':
      'Ich bestätige, dass dieses Dokument ordnungsgemäß geschwärzt wurde und nur zulässige Informationen sichtbar bleiben.',
    'documents.selectType': 'Dokumenttyp auswählen',
    'documents.pleaseSelectType': 'Bitte wählen Sie einen Dokumenttyp',
    'documents.file': 'Datei',
    'documents.unsupportedFileType': 'Bitte wählen Sie eine gültige Datei',
    'documents.expirationDateRequired': 'Ablaufdatum ist erforderlich',
    'documents.expirationDatePast': 'Ablaufdatum darf nicht in der Vergangenheit liegen',
    'documents.expirationDateTooFar':
      'Ablaufdatum darf nicht mehr als 10 Jahre in der Zukunft liegen',
    'documents.expirationDateHelperText':
      'Das Datum muss heute oder später sein, bis zu 10 Jahre ab heute',
    'documents.approveWarning':
      'Bitte überprüfen Sie dieses Dokument sorgfältig, bevor Sie es genehmigen.',
    'documents.rejected': 'Dokument abgelehnt',
    'documents.rejectedReuploadPrompt':
      'Das Dokument wurde abgelehnt. Möchten Sie eine neue Version hochladen?',
    'documents.uploadLater': 'Später hochladen',
    'documents.reuploadNow': 'Jetzt erneut hochladen',
    'documents.areYouSureReject': 'Sind Sie sicher, dass Sie dieses Dokument ablehnen möchten?',
    'documents.confirmReject': 'Ablehnen',
    'documents.areYouSureApprove': 'Sind Sie sicher, dass Sie dieses Dokument genehmigen möchten?',
    'documents.confirmApprove': 'Genehmigen',
    // Impersonation
    requestImpersonation: 'Identitätswechsel anfordern',
    impersonationRequest: 'Identitätswechsel-Anfrage',
    support: 'Support',
    implementation: 'Implementierung',
    duration: 'Dauer',
    ticketProjectReference: 'Ticket/Projektreferenz',
    ticketProjectReferencePlaceholder: 'z.B. TICKET-1234 oder PROJECT-5678',
    documentAccess: 'Dokumentenzugriff',
    documentAccessTooltip:
      'Gewährt Zugriff auf Identifikationsdokumente, die mit diesem Konto verknüpft sind (z.B. Führerschein, Personalausweis, Reisepass). Nur bei Bedarf aktivieren, da dies die Genehmigung eines Organisationsadministrators erfordert.',
    reason: 'Grund',
    reasonPlaceholder: 'Geben Sie einen Grund für den Identitätswechsel ein...',
    impersonationInfoBanner:
      'Die Identitätswechsel-Sitzung wird aktiviert, sobald der Zielbenutzer die Anfrage akzeptiert.',
    submitRequest: 'Anfrage senden',
    impersonationRequestCreated: 'Identitätswechsel-Anfrage erfolgreich gesendet',
    impersonationRequestFailed: 'Identitätswechsel-Anfrage konnte nicht gesendet werden',
    reasonEmptyErr: 'Grund ist erforderlich',
    requestedDurationEmptyErr: 'Dauer ist erforderlich',
    reasonTooLong: 'Grund darf maximal {{max}} Zeichen lang sein',
    // Impersonation Requests List
    impersonationRequests: 'Identitätswechsel-Anfragen',
    'tab.invitations': 'Einladungen',
    'tab.apps': 'Apps',
    'tab.idCodes': 'ID-Codes',
    'tab.documents': 'Dokumente',
    'tab.impersonation': 'Identitätswechsel',
    impersonationRequestDetails: 'Details der Identitätswechsel-Anfrage',
    noImpersonationRequestsFound: 'Keine Identitätswechsel-Anfragen gefunden',
    targetUser: 'Zielbenutzer',
    requestedAt: 'Angefordert am',
    activeUntil: 'Aktiv bis',
    activeFrom: 'Aktiv ab',
    requester: 'Anforderer',
    approvedDuration: 'Genehmigte Dauer',
    requestValidUntil: 'Anfrage gültig bis',
    resolvedBy: 'Aufgelöst von',
    resolvedAt: 'Aufgelöst am',
    coResolvedBy: 'Mitaufgelöst von',
    coResolvedAt: 'Mitaufgelöst am',
    coDenialReason: 'Mitablehnungsgrund',
    revokedBy: 'Widerrufen von',
    revokedAt: 'Widerrufen am',
    revocationReason: 'Widerrufsgrund',
    'impersonation.confirmApprove': 'Sind Sie sicher, dass Sie diese Anfrage genehmigen möchten?',
    'impersonation.confirmDeny': 'Sind Sie sicher, dass Sie diese Anfrage ablehnen möchten?',
    terminateAccess: 'Zugriff beenden',
    terminateImpersonationSuccess: 'Identitätswechsel-Zugriff erfolgreich beendet',
    terminateImpersonationFailed: 'Identitätswechsel-Zugriff konnte nicht beendet werden',
    pendingCoApproval: 'Mitgenehmigung ausstehend',
    revoked: 'Widerrufen',
    consolidated: 'Konsolidiert',
    denied: 'Abgelehnt',
    coApproveImpersonationSuccess: 'Identitätswechsel-Anfrage genehmigt',
    coApproveImpersonationFailed: 'Identitätswechsel-Anfrage konnte nicht genehmigt werden',
    coDenyImpersonationSuccess: 'Identitätswechsel-Anfrage abgelehnt',
    coDenyImpersonationFailed: 'Identitätswechsel-Anfrage konnte nicht abgelehnt werden',
    impersonating: 'Identitätswechsel',
    expiresIn: 'Läuft ab in',
    expiresAt: 'Läuft ab um',
  },
  nl: {
    noCommunityData: 'Geen communitygegevens beschikbaar',
    password: 'Wachtwoord',
    verifyPassword: 'Bevestig wachtwoord',
    passwordsDontMatch: 'Wachtwoorden komen niet overeen',
    userName: 'Gebruikersnaam (e-mail)',
    language: 'Taal',
    fullName: 'Volledige naam',
    next: 'Volgende',
    nameRequired: 'Voer een naam in',
    cityRequired: 'Voer een stad in',
    descriptionRequired: 'Voer een beschrijving in',
    selectCountry: 'Selecteer een land',
    name: 'Naam',
    city: 'Stad',
    postalCode: 'Postcode',
    streetAndNumber: 'Straat en nummer',
    country: 'Land',
    createUser: 'Gebruiker aanmaken',
    signLegalDocuments: 'Akkoord met gebruiksvoorwaarden',
    suggestionsRequired: 'Selecteer een organisatie',
    streetAndNumberRequired: 'Straat en nummer zijn verplicht',
    postalCodeRequired: 'Postcode is verplicht',
    suggestions: 'Suggesties',
    selectPlaceholder: 'Selecteer...',
    createAnAccount: 'Account aanmaken',
    loginToYourAccount: 'Inloggen op uw account',
    join: 'Lid worden',
    joinOrganisationOnPlatform: 'Lid worden van een organisatie die al op het platform is',
    register: 'Registreren',
    registerOrganisationOnPlatform: 'Een nieuwe organisatie op het platform registreren',
    confirmationEmailSent: 'Controleer uw e-mail',
    resendEmail: 'E-mail opnieuw verzenden',
    confirmationEmailContent:
      'Er is een e-mail verzonden naar {{email}}.\n\nOpen uw e-mail en klik op de validatielink om door te gaan met uw registratie. Als u geen e-mail kunt vinden, controleer dan uw SPAM of verzend de e-mail opnieuw met de onderstaande knop.\n\nDit venster kan worden gesloten.',
    passwordRequired: 'Voer een wachtwoord in',
    passwordMinimum12charactersErr: 'Een wachtwoord moet minimaal 12 tekens lang zijn',
    passwordMaximum80charactersErr: 'Een wachtwoord mag maximaal 80 tekens lang zijn',
    reEnterPassword: 'Voer uw wachtwoord opnieuw in',
    joinRequestSent: 'Lidmaatschapsverzoek verzonden',
    joinRequestContent:
      'Wacht tot de organisatiebeheerder uw lidmaatschapsverzoek accepteert. Neem contact op met uw organisatiemanager/beheerder voor verdere opvolging.',
    readAllLegalDocuments: 'Ik heb bovenstaande documenten gelezen en ga ermee akkoord',
    sign: 'Akkoord',
    welcome: 'Welkom',
    chooseRoles: 'Kies rollen',
    login: 'Inloggen',
    communityMembershipTemplateGetFailed:
      'Er is iets misgegaan, kon de community-lidmaatschapssjabloon niet ophalen',
    membershipAlreadyRequested: 'Lidmaatschap al aangevraagd',
    noLegalDocumentsToSign: 'Geen documenten om mee akkoord te gaan',
    welcomeToTheCommunity: 'Welkom bij de community.',
    viewApps: 'Bekijk apps',
    membershipRequestFailed: 'Oeps, verzoek om lid te worden van de community is mislukt',
    error: 'Fout',
    chooseSuggestedOrganisationToJoin:
      'Op basis van uw e-mailadres wilt u zich misschien aansluiten bij een van de volgende bestaande organisaties.',
    joinSuggestedOrganisation:
      'Op basis van uw e-mailadres wilt u zich misschien aansluiten bij deze bestaande organisatie.',
    selectAnOrganisation: 'Selecteer een organisatie',
    organisationName: 'Organisatienaam',
    requestedAt: 'Aangevraagd op',
    back: 'Terug',
    addIdentificationCode: 'Identificatiecode toevoegen',
    identificationCode: 'Identificatiecode',
    identificationcode: 'Identificatiecodes',
    welcomeMessageTitle: 'Welkom op het platform!',
    selectLanguage: 'Selecteer een taal',
    selectTimezone: 'Selecteer een tijdzone',
    type: 'Type',
    organisationNameAlreadyExists: 'Organisatienaam bestaat al',
    errorWhileValidatingOrganisationName:
      'Oeps, er is een fout opgetreden bij het valideren van de organisatienaam',
    thisIdentificationCodeIsAlreadyInUse: 'Deze identificatiecode is al in gebruik',
    errorWhileIdentificationCodeName:
      'Oeps, er is een fout opgetreden bij het valideren van de identificatiecode',
    continue: 'Doorgaan',
    invalidEmailErr: 'Voer een geldig e-mailadres in',
    dear: 'Beste {{user}},',
    successfullyReceivedRegistration:
      'We hebben uw registratie succesvol ontvangen. U ontvangt binnenkort een e-mail met een link die u toegang geeft tot de applicatie(s) waarvoor u zich heeft geregistreerd.',
    furtherQuestions: 'Mocht u nog vragen hebben, neem dan contact op met uw communitybeheerder.',
    'sorry!': 'Sorry!',
    pageRequestedNotFound: 'De opgevraagde pagina is niet gevonden.',
    toTheCommunityPortal: 'Naar de Nallian-portal.',
    validateUsernameFailed: 'Fout bij het valideren van de gebruikersnaam',
    myOrganisation: 'Mijn organisatie',
    noMembershipRequests: 'Geen lidmaatschapsverzoeken aanwezig',
    membershipRequests: 'Lidmaatschapsverzoeken',
    createdOn: 'Aangemaakt op',
    areYouSureYouWantToDenyUser: 'Weet u zeker dat u de toegang voor deze gebruiker wilt weigeren?',
    cancel: 'Annuleren',
    deny: 'Weigeren',
    requestOfOrganisation: 'Verzoek van {{organisation}}',
    applications: 'Applicaties',
    roles: 'Rollen',
    signedLegalDocuments: 'Goedgekeurde juridische documenten',
    accept: 'Accepteren',
    membershipRequestUpdateFailed: 'Oeps, kon lidmaatschapsverzoek niet bijwerken',
    membershipRequestUpdateSuccess: 'Lidmaatschapsverzoek bijgewerkt',
    areYouSureYouWantToendMembership: 'Weet u zeker dat u het lidmaatschap wilt beëindigen?',
    overview: 'Overzicht',
    eMailaddress: 'E-mailadres (professioneel)',
    membershipRequestAccepted: 'Lidmaatschapsverzoek geaccepteerd',
    membershipRequestDenied: 'Lidmaatschapsverzoek geweigerd',
    dashboard: 'Dashboard',
    getLanguagesErr: 'Oeps, kon talen niet ophalen',
    getAuthorizationRolesErr: 'Oeps, kon autorisatierollen niet ophalen',
    getTimezonesErr: 'Oeps, kon tijdzones niet ophalen',
    getOrganisationStatsErr: 'Oeps, kon statistieken niet ophalen',
    users: 'Gebruikers',
    noUserPresent: 'Geen gebruikers aanwezig',
    state: 'Staat',
    editUser: 'Gebruiker bewerken',
    deleteUser: 'Gebruiker verwijderen',
    areYouSureYouWantToDeleteUser: 'Wilt u {{userName}} verwijderen?',
    inviteNewUser: 'Nieuwe gebruiker uitnodigen',
    save: 'Opslaan',
    invite: 'Uitnodigen',
    inviteUserSendEmailToAddress: 'Gebruiker uitnodigen, e-mail sturen naar volgend adres:',
    createUserWithPassword: 'Gebruiker aanmaken met wachtwoord:',
    enterPassword: 'Voer wachtwoord in',
    forceUserToChooseNewPassword:
      'Dwing gebruiker om een nieuw wachtwoord te kiezen bij eerste login',
    pleaseEnterEmailAddress: 'Voer een geldig e-mailadres in',
    pleaseEnterRecipient: 'Voer een ontvanger in',
    pleaseEnterPassword: 'Voer een wachtwoord in',
    selectRole: 'Selecteer ten minste één rol.',
    usernameTaken: 'Deze gebruikersnaam is al in gebruik',
    userUpdated: 'Gebruiker bijgewerkt',
    inviteUserFailed: 'Oeps, kon gebruiker niet uitnodigen',
    inviteUser: 'Gebruiker uitnodigen',
    userInvited: 'Gebruiker uitgenodigd',
    userDeleted: 'Gebruiker verwijderd',
    deleteUserFailed: 'Oeps, kon gebruiker niet verwijderen',
    delete: 'Verwijderen',
    noOrganisationRegistrations: 'Geen organisatieregistraties',
    trustedDomains: 'Vertrouwd domein',
    trustedDomains_plural: 'Vertrouwde domeinen',
    trustedDomainsOverview: 'Overzicht vertrouwde domeinen',
    createTrustedDomainSuccess: 'Vertrouwd domein is aangemaakt',
    createTrustedDomainFailed: 'Er is iets misgegaan, kon vertrouwd domein niet aanmaken',
    updateTrustedDomainSuccess: 'Vertrouwd domein bijgewerkt',
    addTrustedDomain: 'Vertrouwd domein toevoegen',
    updateTrustedDomainFailed: 'Er is iets misgegaan, kon vertrouwd domein niet bijwerken',
    domain: 'Domein',
    domainEmptyErr: 'Voer een domein in',
    domainInvalidErr: 'Controleer de domeinnaam.',
    autoJoin: 'Automatisch lid worden',
    remove: 'Verwijderen',
    organisation: 'Organisatie',
    areYouSureYouWantToDenyOrganisation:
      'Weet u zeker dat u de toegang tot deze organisatie wilt weigeren?',
    areYouSureYouWantToRemoveTheRequest: 'Weet u zeker dat u het verzoek wilt verwijderen?',
    myCommunity: 'Mijn community',
    noMembersPresent: 'Geen leden aanwezig.',
    addMember: 'Lid toevoegen',
    edit: 'Bewerken',
    endMembership: 'Lidmaatschap opzeggen',
    editMembership: 'Lidmaatschap bewerken',
    areYouSureYouWantToEndMembership:
      'Weet u zeker dat u het lidmaatschap van {{organisationName}} wilt beëindigen?',
    communityMembershipEnded: 'Community-lidmaatschap beëindigd',
    endCommunityMembershipFailed: 'Er is iets misgegaan, kon lidmaatschap niet beëindigen',
    communityMembershipUpdate: 'Community-lidmaatschap bijgewerkt',
    updateCommunityMembershipFailed:
      'Er is iets misgegaan, kon community-lidmaatschap niet bijwerken',
    getCommunityMembershipFailed: 'Er is iets misgegaan, kon community-lidmaatschap niet ophalen',
    communityMembershipCreated: 'Community-lid aangemaakt',
    createCommunityMembershipFailed: 'Er is iets misgegaan, kon community-lid niet aanmaken',
    addACommunityMember: 'Een community-lid toevoegen',
    updateMembershipOf: 'Lidmaatschap bijwerken {{organisationName}}',
    members: 'Leden',
    getUserStatesErr: 'Er is iets misgegaan, kon gebruikersstatussen niet ophalen',
    rejectionNotice: 'Afwijzingsbericht',
    addApp: 'App toevoegen',
    app: 'App',
    actions: 'Acties',
    role: 'Rol',
    registerError: 'Er is iets misgegaan tijdens de registratie.',
    contactAdministrator:
      'Voor meer informatie over het gebruik van deze Nallian Portal, neem contact op met uw communitybeheerder.',
    registerEmailDomainAsTrustedRequired: 'U moet dit veld in- of uitschakelen.',
    proceed: 'Doorgaan',
    privateCommunityTitle: 'Privécommunity',
    privateCommunityDescription: 'Dit is een privécommunity waar u geen lid van kunt worden.',
    pleaseSelectOrganisation: 'Selecteer een organisatie',
    pleaseSelectMinimumOneRole: 'Selecteer minimaal één rol',
    none: 'Geen',
    membershipRequestGetFailed: 'Er is iets misgegaan, kon lidmaatschapsverzoek niet ophalen',
    getCommunityStatsErr: 'Er is iets misgegaan, kon community-statistieken niet ophalen',
    communityMember: 'Community-lid',
    registrationGetFailed: 'Er is iets misgegaan, kon registratie niet ophalen',
    getTrustedDomainFailed: 'Er is iets misgegaan, kon vertrouwd domein niet ophalen',
    pleaseEnterAnEmailAddress: 'Voer een e-mailadres in',
    noUsersPresent: 'Geen gebruikers aanwezig',
    communities: 'Communities',
    noCommunitiesFound: 'Geen communities gevonden',
    home: 'Home',
    getIdentificationCodeTypesFailed:
      'Er is iets misgegaan, kon identificatiecodetypes niet ophalen',
    pleaseSelectAType: 'Selecteer een type',
    pleaseEnterAValue: 'Voer een waarde in',
    disabled: 'Uitgeschakeld',
    unverified: 'Ongeverifieerd',
    verified: 'Geverifieerd',
    userState: 'Gebruikersstatus',
    couldNotGetCommunityTemplate:
      'Er is iets misgegaan, kon de community-beschrijving niet ophalen',
    getTermsAndConditionsFailed: 'Er is iets misgegaan, kon de Algemene Voorwaarden niet ophalen',
    chooseAPassword: 'Kies een wachtwoord',
    newPassword: 'Nieuw wachtwoord',
    confirmPassword: 'Bevestig wachtwoord',
    userAccountReady: 'Gebruikersaccount klaar!',
    passwordResetSuccess:
      'Uw wachtwoord is succesvol opnieuw ingesteld. U kunt nu inloggen op uw apps.',
    failedContactOur: 'Wachtwoord opnieuw instellen mislukt, neem contact op met onze',
    support: 'Support',
    department: 'afdeling',
    pleaseConfirmUserAccount: 'Bevestig dat dit uw gebruikersaccount is',
    confirm: 'Bevestigen',
    invalidToken: 'Ongeldige token',
    needTechnicalSupport:
      'Als u technische ondersteuning nodig heeft, neem dan contact op met onze',
    passwordMin8Char: 'Kies een wachtwoord van minimaal 8 tekens',
    passwordConfirmIncorrect: 'Bevestiging van wachtwoord is onjuist',
    pleaseEnterValidEmail: 'Voer een geldig e-mailadres in',
    forgotPassword: 'Wachtwoord vergeten',
    requestNewPassword: 'Nieuw wachtwoord aanvragen',
    resetPasswordRequested: 'Wachtwoord opnieuw instellen aangevraagd!',
    resetPasswordRequestText:
      'Als u een geregistreerde gebruiker bent, is er een e-mail naar uw mailbox gestuurd om uw wachtwoord opnieuw in te stellen. Klik op de link in deze e-mail om verder te gaan. U kunt dit venster nu sluiten.',
    somethingWentWrong: 'Er is iets misgegaan',
    pleaseContactOur: 'Neem contact op met onze',
    failedResentEmail: 'Uitnodigingsmail opnieuw verzenden mislukt',
    resentEmailSuccess: 'Uitnodigingsmail is opnieuw verzonden',
    ohNo: 'Oh nee!',
    invitationExpired: 'Uw uitnodiging is verlopen. Laat ons u een nieuwe uitnodiging sturen:',
    resentInvitationEmail: 'Uitnodigingsmail opnieuw verzenden',
    thanksForSubscribing: 'Bedankt voor uw inschrijving en welkom op het Platform!',
    activatedBasicAccount:
      'We hebben uw basisaccount geactiveerd waarmee u toegang krijgt tot de verschillende applicaties die beschikbaar zijn voor uw account.',
    accessApplications:
      'U kunt toegang krijgen tot de applicaties zodra we de bijbehorende ondertekende overeenkomst(en) hebben ontvangen.',
    beAware:
      'Houd er rekening mee dat voor bepaalde applicaties een Go-Live-datum op een later tijdstip van toepassing kan zijn.',
    contactUs: 'Neem contact met ons op',
    ifQuestions: 'in geval van vragen.',
    failedToActivateUserAccount: 'Activeren van gebruikersaccount mislukt',
    goodNews: 'Goed nieuws!',
    accountAlreadyActivated:
      'Uw account is al geactiveerd. Ga naar de app via de directe link zoals vermeld in de App-instructies.',
    invalidTokenText:
      'Uw activeringstoken is ongeldig, zorg ervoor dat u de activeringslink in de laatst ontvangen uitnodigingsmail gebruikt. Als u deze e-mail niet heeft ontvangen (vergeet uw SPAM niet!), kunt u altijd contact opnemen met onze',
    passwordInvalidErr: 'Voer een geldig wachtwoord in',
    inviteSuccessMessage:
      'Uw gebruikersaccount is succesvol geregistreerd op het Nallian-platform. Klik op "Doorgaan" om in te loggen op de Nallian Portal en de applicaties te gaan gebruiken.',
    address: 'Adres',
    getOrganisationIdentificationCodesFailed: 'Ophalen van organisatie-identificatiecodes mislukt',
    getOrganisationFailed: 'Ophalen van organisatie-info mislukt',
    identificationCodes: 'Identificatiecodes',
    getOrganisationAddressFailed: 'Ophalen van organisatieadres mislukt',
    membershipOf: 'Lidmaatschap van {{organisation}}',
    organisationInfo: 'Organisatie-info',
    noRolesFound: 'Geen rollen gevonden',
    noAppsFound: 'Geen apps gevonden',
    organisationUsers: 'Gebruiker',
    userReinvited: 'Gebruiker opnieuw uitgenodigd',
    userReinviteFailed: 'Kon gebruiker niet opnieuw uitnodigen',
    reinviteUser: 'Gebruiker opnieuw uitnodigen',
    areYouSureReinvite: 'Weet u zeker dat u {{userName}} opnieuw wilt uitnodigen?',
    yes: 'Ja',
    no: 'Nee',
    dontHaveAnAccountYet: 'Nog geen account?',
    registerHere: 'Registreer hier!',
    inviteInfo:
      'Iemand van uw organisatie heeft u uitgenodigd om lid te worden van het platform. Bevestig dat de onderstaande gegevens van u zijn.',
    chooseAPasswordInfo: 'Kies een wachtwoord om het uitnodigingsproces te voltooien.',
    resetYourPassword: 'Stel uw wachtwoord opnieuw in',
    createAnotherUser: 'Een andere gebruiker aanmaken',
    createdBy: 'Aangemaakt door',
    createCommunityMember: 'Community-lid aanmaken',
    isTest: 'Is test',
    isDefault: 'Is standaard',
    isMessageCode: 'Is berichtcode',
    code: 'Code',
    codeValue: 'Code',
    description: 'Beschrijving',
    updateIdentificationCodeFailed: 'Bijwerken identificatiecode mislukt',
    updateIdentificationCodeSuccess: 'Bijwerken identificatiecode geslaagd',
    addIdentificationCodeFailed: 'Toevoegen identificatiecode mislukt',
    addIdentificationCodeSuccess: 'Identificatiecode succesvol toegevoegd',
    getIdentificationCodeFailed: 'Ophalen identificatiecode mislukt',
    identificationCodeType: 'Type identificatiecode',
    removeIdentificationCode: 'Identificatiecode verwijderen',
    add: 'Toevoegen',
    editIdentificationCode: 'Identificatiecode bewerken',
    viewIdentificationCode: 'Identificatiecode bekijken',
    routings: 'Routings',
    order: 'Volgorde',
    regex: 'Regex',
    emailAddresses: 'E-mailadressen',
    toZendesk: 'Naar Zendesk',
    enabled: 'Ingeschakeld',
    editRouting: 'Routing bewerken',
    addRouting: 'Routing toevoegen',
    removeRouting: 'Weet u zeker dat u deze routing wilt verwijderen?',
    toVoid: 'Naar prullenbak',
    addAttachments: 'Bijlagen toevoegen',
    stopProcessing: 'Verwerking stoppen',
    zendeskTags: 'Zendesk-tags',
    priority: 'Prioriteit',
    mustFillInEmailNoZendeskAndNoVoid:
      'U moet een e-mail invullen als "Naar prullenbak" of "Naar Zendesk" niet is ingeschakeld',
    nameEmptyErr: 'Vul een naam in',
    orderEmptyErr: 'Vul een volgorde in',
    regexEmptyErr: 'Vul een regex in',
    priorityIdEmptyErr: 'Selecteer een prioriteit',
    routingsOrder: 'Volgorde van routings',
    updateRoutingsOrderSuccess: 'Volgorde van routings succesvol bijgewerkt',
    updateRoutingsOrderFailed: 'Bijwerken van volgorde van routings mislukt',
    saveOrder: 'Volgorde opslaan',
    apiResources: 'API-resource',
    apiResources_plural: 'API-resources',
    tokenLifetime: 'Token-levensduur',
    stsclients: 'STS-client',
    stsclients_plural: 'STS-clients',
    clientName: 'Clientnaam',
    clientId: 'Client-ID',
    fillForm: 'Formulier invullen',
    clientNameInfo: 'Weergavenaam van de client (gebruikt voor logging en toestemmingsscherm)',
    clientIdInfo: 'Unieke ID van de client',
    clientUri: 'Client-URI',
    clientUriInfo: 'URI naar meer informatie over de client (gebruikt op toestemmingsscherm)',
    logoUri: 'Logo-URI',
    logoUriInfo: 'URI naar clientlogo (gebruikt op toestemmingsscherm)',
    allowedScopes: 'Toegestane scopes',
    allowedScopesInfo:
      'Standaard heeft een client geen toegang tot resources. Specificeer de toegestane resources door de bijbehorende scope-namen toe te voegen.',
    allowedGranttypes: 'Toegestane grant-types',
    allowedGranttypesInfo:
      'Specificeert de grant-types die de client mag gebruiken. Gebruik de GrantTypes-klasse voor veelvoorkomende combinaties.',
    protocolType: 'Protocoltype',
    rowVersion: 'Rijversie',
    enableClient: 'Client inschakelen',
    enableClientInfo: 'Specificeert of de client is ingeschakeld. Standaard op true.',
    allowOfflineAccessInfo:
      'Specificeert of deze client refresh tokens kan aanvragen (door de offline_access-scope aan te vragen)',
    allowOfflineAccess: 'Refresh tokens toestaan',
    requireClientSecret: 'Clientgeheim vereist',
    requireClientSecretInfo:
      'Specificeert of deze client een geheim nodig heeft om tokens van het token-eindpunt aan te vragen (standaard op true)',
    noAppSubscriptionRequired: 'Geen app-abonnement vereist',
    allowAccessTokensViaBrowser: 'Toegangstokens via browser toestaan',
    allowAccessTokensViaBrowserInfo:
      'Specificeert of deze client toegangstokens via de browser mag ontvangen. Dit is handig om stromen die meerdere responstypes toestaan te verharden.',
    requirePkce: 'PKCE vereisen',
    requirePkceInfo:
      'Specificeert of clients die een op autorisatiecode gebaseerd grant-type gebruiken, een proof key moeten sturen (standaard op true).',
    allowPlainTextPkce: 'Platte tekst PKCE toestaan',
    allowPlainTextPkceInfo:
      'Specificeert of clients die PKCE gebruiken, een platte tekst code-challenge kunnen gebruiken (niet aanbevolen - en standaard op false)',
    redirectUrisInfo:
      "Specificeert de toegestane URI's om tokens of autorisatiecodes naar terug te sturen",
    redirectUris: "Redirect URI's",
    postLogoutRedirectUris: "Post-logout redirect URI's",
    postLogoutRedirectUrisInfo:
      "Specificeert toegestane URI's om na het uitloggen naartoe om te leiden. Zie de OIDC Connect Session Management-specificatie voor meer details.",
    identityProviderRestrictions: 'Identiteitsproviderbeperkingen',
    identityProviderRestrictionsInfo:
      "Specificeert welke externe IdP's met deze client kunnen worden gebruikt (als de lijst leeg is, zijn alle IdP's toegestaan). Standaard leeg.",
    frontChannelLogoutSessionRequired: 'Front-channel logout-sessie vereist',
    frontChannelLogoutSessionRequiredInfo:
      'Specificeert of de sessie-ID van de gebruiker naar de FrontChannelLogoutUri moet worden verzonden. Standaard op true.',
    frontChannelLogoutUri: 'Front-channel logout URI',
    frontChannelLogoutUriInfo:
      'Specificeert logout-URI bij de client voor HTTP-gebaseerde front-channel logout. Zie de OIDC Front-Channel-specificatie voor meer details.',
    backChannelLogoutSessionRequired: 'Back-channel logout-sessie vereist',
    backChannelLogoutSessionRequiredInfo:
      'Specificeert of de sessie-ID van de gebruiker in het verzoek naar de BackChannelLogoutUri moet worden verzonden. Standaard op true.',
    backChannelLogoutUri: 'Back-channel logout URI',
    backChannelLogoutUriInfo:
      'Specificeert logout-URI bij de client voor HTTP-gebaseerde back-channel logout. Zie de OIDC Back-Channel-specificatie voor meer details.',
    logoutSession: 'Logout-sessie',
    enableLocalLogin: 'Lokale login inschakelen',
    enableLocalLoginInfo:
      "Specificeert of deze client lokale accounts kan gebruiken, of alleen externe IdP's. Standaard op true.",
    accessTokenLifetime: 'Levensduur van access token',
    accessTokenLifetimeInfo:
      'Levensduur van access token in seconden (standaard 3600 seconden / 1 uur)',
    absoluteRefreshTokenLifetime: 'Absolute levensduur van refresh token',
    absoluteRefreshTokenLifetimeInfo:
      'Maximale levensduur van een refresh token in seconden. Standaard 2592000 seconden / 30 dagen',
    identityTokenLifetime: 'Levensduur van identity token',
    identityTokenLifetimeInfo:
      'Levensduur van identity token in seconden (standaard 300 seconden / 5 minuten)',
    authorizationCodeLifetime: 'Levensduur van authorization code',
    authorizationCodeLifetimeInfo:
      'Levensduur van authorization code in seconden (standaard 300 seconden / 5 minuten)',
    slidingRefreshTokenLifetime: 'Glijdende levensduur van refresh token',
    slidingRefreshTokenLifetimeInfo:
      'Glijdende levensduur van een refresh token in seconden. Standaard 1296000 seconden / 15 dagen',
    clientClaimsPrefix: 'Voorvoegsel voor client-claims',
    clientClaimsPrefixInfo:
      'Indien ingesteld, wordt het voorvoegsel voor client-claimtypes voorafgegaan. Standaard client_. Dit om onbedoelde botsingen met gebruikersclaims te voorkomen.',
    pairWiseSubjectSalt: 'Paarsgewijs subject-salt',
    pairWiseSubjectSaltInfo:
      'Zoutwaarde die wordt gebruikt bij het paarsgewijs genereren van subjectId voor gebruikers van deze client.',
    updateAccessTokenClaimsOnRefresh: 'Access token-claims bijwerken bij vernieuwing',
    updateAccessTokenClaimsOnRefreshInfo:
      'Haalt een waarde op of stelt deze in die aangeeft of het access token (en de bijbehorende claims) moet worden bijgewerkt bij een refresh token-verzoek.',
    accessTokenType: 'Referentie-access-token',
    accessTokenTypeInfo:
      'Specificeert of het access token een referentietoken is of een op zichzelf staand JWT-token (standaard Jwt).',
    includeJwtId: 'JWT-ID opnemen',
    includeJwtIdInfo:
      'Specificeert of JWT-access-tokens een ingebedde unieke ID moeten hebben (via de jti-claim). Standaard op true.',
    alwaysSendClientClaims: 'Client-claims altijd verzenden',
    alwaysSendClientClaimsInfo:
      'Indien ingesteld, worden de client-claims voor elke stroom verzonden. Zo niet, alleen voor client-credentials-stroom (standaard is false)',
    alwaysIncludeUserClaimsInIdToken: 'Gebruikersclaims altijd opnemen in identity token',
    alwaysIncludeUserClaimsInIdTokenInfo:
      'Wanneer zowel een identity token als een access token wordt aangevraagd, moeten de gebruikersclaims dan altijd aan het identity token worden toegevoegd in plaats van dat de client het userinfo-eindpunt moet gebruiken. Standaard is false.',
    allowedCorsOriginsInfo:
      'Indien gespecificeerd, wordt gebruikt door de standaard CORS-beleidsservice-implementaties (In-Memory en EF) om een CORS-beleid voor JavaScript-clients te bouwen.',
    allowedCorsOrigins: 'Toegestane CORS-origins',
    consentLifetimeInfo:
      'Levensduur van een gebruikerstoestemming in seconden. Standaard null (geen vervaldatum).',
    consentLifetime: 'Levensduur van toestemming',
    requireConsent: 'Toestemming vereisen',
    requireConsentInfo: 'Specificeert of een toestemmingsscherm vereist is. Standaard false.',
    allowRememberConsent: 'Toestemmingsbeslissingen onthouden toestaan',
    allowRememberConsentInfo:
      'Specificeert of de gebruiker kan kiezen om toestemmingsbeslissingen op te slaan. Standaard op true.',
    refreshTokenUsage: 'Gebruik van refresh token',
    refreshTokenUsageInfo:
      "'ReUse': de refresh token-handle blijft hetzelfde bij het vernieuwen van tokens. 'OneTime': de refresh token-handle wordt bijgewerkt bij het vernieuwen van tokens. Dit is de standaard.",
    refreshTokenExpiration: 'Vervaldatum van refresh token',
    refreshTokenExpirationInfo:
      "'Absolute': het refresh token vervalt op een vast tijdstip. Dit is de standaard. 'Sliding': bij het vernieuwen van het token wordt de levensduur van het refresh token verlengd. De levensduur zal de AbsoluteRefreshTokenLifetime niet overschrijden.",
    reUse: 'Hergebruiken',
    oneTimeOnly: 'Eenmalig',
    sliding: 'Glijdend',
    absolute: 'Absoluut',
    updateUserFailed: 'Bijwerken van gebruiker mislukt',
    getUserFailed: 'Ophalen van gebruiker mislukt',
    isHidden: 'Verborgen',
    isOwner: 'Eigenaar',
    updateSuiteFailed: 'Bijwerken van suite mislukt',
    updateSuiteSuccess: 'Suite succesvol bijgewerkt',
    suites_plural: 'Suites',
    suites: 'Suite',
    tiers: 'Tiers',
    apps: 'Apps',
    allApplications: 'Alle Applicaties',
    appCountSingular: '{{count}} applicatie',
    appCountPlural: '{{count}} applicaties',
    addAppFeature: 'App-functie toevoegen',
    tierApps: 'Tier-apps',
    suite: 'Suite',
    tier: 'Tier',
    suiteTier: 'Tier',
    suiteIdEmptyErr: 'Selecteer een suite',
    suiteTierIdEmptyErr: 'Selecteer een tier',
    timezone: 'Tijdzone',
    communityMembers: 'Community-lid',
    communityMembers_plural: 'Community-leden',
    getCommunityRolesFailed: 'Ophalen van community-rollen mislukt',
    myApps: 'Mijn apps',
    principalJoinRequests: 'Lidmaatschapsverzoeken',
    selectExistingUser:
      'Zoek naar een bestaande gebruiker (dit overschrijft het profiel van de bestaande gebruiker met de onderstaande informatie)',
    acceptJoinRequestFor: 'Lidmaatschapsverzoek van {{user}} accepteren',
    preApproveForLinking: 'Vooraf goedkeuren voor koppeling',
    areYouSureYouWantToUnlinkIdentity:
      'Weet u zeker dat u het account van de gebruiker wilt loskoppelen?',
    preApproveForLinkingInfo:
      'Het lidmaatschapsverzoek automatisch goedkeuren als iemand zijn account aan deze gebruiker wil koppelen',
    acceptJoinRequestFailed: 'Accepteren van lidmaatschapsverzoek mislukt',
    acceptJoinRequestSuccess: 'Lidmaatschapsverzoek succesvol geaccepteerd',
    viewOrganisation: 'Organisatie bekijken',
    myIdentity: 'Mijn account',
    active: 'Actief',
    activeState: 'Actieve staat',
    activeStatus: 'Actieve status',
    addApplication: 'App toevoegen',
    addAppSubscription: 'App-abonnement toevoegen',
    addCommunityRoleFailed: 'Kon de community-rol niet toevoegen',
    addCommunityRoleSuccess: 'De community-rol is toegevoegd',
    addFeature: 'Functie toevoegen',
    addOwner: 'Eigenaar toevoegen',
    addRole: 'Rol toevoegen',
    addSubscription: 'Abonnement toevoegen',
    addSuite: 'Suite toevoegen',
    addTier: 'Tier toevoegen',
    addUser: 'Gebruiker toevoegen',
    alias: 'Alias',
    aliasEmptyErr: 'Voer een alias in',
    appDetailsAliasEmptyErr: 'Voer een alias in',
    appDetailsTagEmptyErr: 'Selecteer een app',
    appDetailsUrlEmptyErr: 'Voer een url in',
    appFeatures: 'App-functies',
    appInstallationFeatureTagEmptyErr: 'Selecteer een functie',
    appInstallationIdEmptyErr: 'Selecteer een app',
    appInstallations: 'App-installaties',
    application: 'App',
    apps_plural: 'Apps',
    appSubscription: 'App-abonnement',
    appTypeIdEmptyErr: 'Selecteer een app-type',
    areYouSureRemoveIdentificationCodeType:
      'Weet u zeker dat u dit identificatiecodetype wilt verwijderen?',
    areYouSureRemoveOnboardingTemplate:
      'Weet u zeker dat u deze onboarding-template wilt verwijderen?',
    areYouSureRemovePrincipal: 'Weet u zeker dat u {{name}} ({{email}}) wilt verwijderen?',
    areYouSureActivatePrincipal: 'Weet u zeker dat u {{name}} wilt activeren?',
    activatePrincipal: 'Gebruiker activeren',
    activate: 'Activeren',
    activatePrincipalSuccess: 'De gebruiker is geactiveerd',
    activatePrincipalFailed: 'Kon de gebruiker niet activeren',
    areYouSureRemoveRelation: 'Weet u zeker dat u deze relatie wilt verwijderen?',
    areYouSureYouWantToDenyJoinRequest:
      'Weet u zeker dat u dit lidmaatschapsverzoek wilt weigeren?',
    cityEmptyErr: 'Vul een stad in',
    close: 'Sluiten',
    community: 'Community',
    communityApps: 'Community-app',
    communityApps_plural: 'Community-apps',
    communityMemberCreatedAndInvited:
      'Het community-lid is aangemaakt en de gebruiker is uitgenodigd',
    communityMemberCreatedAndInvitedError:
      'Kon het community-lid niet aanmaken en de gebruiker niet uitnodigen',
    communityRoles: 'Community-rol',
    communityRoles_plural: 'Community-rollen',
    communitySuites: 'Community-suite',
    communitySuites_plural: 'Community-suites',
    communityInfo: 'Community Informatie',
    communityManagement: 'Community Beheer',
    confirmInvitationInfo:
      'Bevestig dat de onderstaande gegevens correct zijn. In de volgende stappen kunt u uw accountgegevens invullen en het registratieproces voltooien.',
    couldNotCompleteInvitation:
      'Helaas konden we uw uitnodiging niet voltooien.<0></0>Probeer het opnieuw of neem contact op met onze supportdesk <1>{{text}}</1>.',
    countryEmptyErr: 'Selecteer een land',
    createAppFailed: 'Kon de app niet aanmaken',
    createAppSubscriptionFailed: 'Kon het app-abonnement niet aanmaken',
    createAppSubscriptionSuccess: 'Het app-abonnement is aangemaakt',
    createAppSuccess: 'De app is aangemaakt',
    createCommunityAppFailed: 'Kon de community-app niet aanmaken',
    createCommunityAppSuccess: 'De community-app is aangemaakt',
    createCommunityMemberFailed: 'Kon het community-lid niet aanmaken',
    createCommunityMemberSuccess: 'Het community-lid is aangemaakt',
    createCommunitySuiteFailed: 'Kon de community-suite niet aanmaken',
    createCommunitySuiteSuccess: 'De community-suite is aangemaakt',
    createIdentificationCodeTypeFailed: 'Kon het identificatiecodetype niet aanmaken',
    createIdentificationCodeTypeSuccess: 'Het identificatiecodetype is aangemaakt',
    createNewMember: 'Nieuw lid aanmaken',
    createNewOrganisation: 'Nieuwe organisatie aanmaken',
    createOnboardingTemplateFailed: 'Kon de onboarding-template niet aanmaken',
    createOnboardingTemplateSuccess: 'De onboarding-template is aangemaakt',
    createOrganisationRoleFailed: 'Kon de organisatierol niet aanmaken',
    createOrganisationRoleSuccess: 'De organisatierol is aangemaakt',
    createPrincipalFailed: 'Kon de gebruiker niet aanmaken',
    createPrincipalSuccess: 'De gebruiker is aangemaakt',
    createRelationFailed: 'Kon de relatie niet aanmaken',
    createRelationSuccess: 'De relatie is aangemaakt',
    createRelationTypeFailed: 'Kon het relatietype niet aanmaken',
    createRelationTypeSuccess: 'Het relatietype is aangemaakt',
    createSuiteFailed: 'Kon de suite niet aanmaken',
    createSuiteSuccess: 'De suite is aangemaakt',
    createUserFailed: 'Kon de gebruiker niet aanmaken',
    createUserSuccess: 'De gebruiker is aangemaakt',
    defaultCommunity: 'Standaard community',
    deleted: 'Verwijderd',
    denyJoinRequestFailed: 'Kon het lidmaatschapsverzoek niet weigeren',
    denyJoinRequestSuccess: 'Het lidmaatschapsverzoek is geweigerd',
    markUniqueJoinRequestFailed: 'Kon lidmaatschapsverzoek niet als geen duplicaat markeren',
    markUniqueJoinRequestSuccess: 'Lidmaatschapsverzoek gemarkeerd als geen duplicaat',
    markNotDuplicateConfirmation:
      'Markeer dit lidmaatschapsverzoek als geen duplicaat. De status wijzigt naar Nieuw en de Community-beheerder wordt op de hoogte gebracht.',
    descriptionEmptyErr: 'Vul een beschrijving in',
    details: 'Details',
    displayName: 'Weergavenaam',
    editApp: 'App bewerken',
    editCommunityApp: 'Community-app bewerken',
    editCommunityMember: 'Community-lid bewerken',
    editCommunityRole: 'Community-rol bewerken',
    editFeature: 'Functie bewerken',
    editOrganisationRole: 'Organisatierol bewerken',
    editSubscription: 'Abonnement bewerken',
    email: 'E-mailadres',
    emailAddress: 'E-mailadres',
    emailAddressEmptyErr: 'Vul een e-mailadres in',
    emailOrPhoneNumberRequiredError: 'Een geldig e-mailadres of telefoonnummer is vereist',
    externalIdentifier: 'Externe identificatie',
    feature: 'Functie',
    featureName: 'Functienaam',
    features: 'Functies',
    featureSubscriptions: 'Abonnementen',
    subscriptions: 'Abonnementen',
    subscriptionRequired: 'Abonnement vereist',
    noSubscriptionRequired: 'Geen abonnement vereist',
    firstSelectAFeature: 'Selecteer eerst een functie',
    firstSelectAnApp: 'Selecteer eerst een app',
    fullNameEmptyErr: 'Voer een volledige naam in',
    general: 'Algemeen',
    getAppFailed: 'Kon de app niet ophalen',
    getAppInstallationFailed: 'Kon de app-installatie niet ophalen',
    getAppInstallationsFailed: 'Kon de app-installaties niet ophalen',
    getAppsFailed: 'Kon de apps niet ophalen',
    getAppSubscriptionsFailed: 'Kon de app-abonnementen niet ophalen',
    getAvailableRolesFailed: 'Kon de beschikbare rollen niet ophalen',
    getCommunityAppsFailed: 'Kon de community-apps niet ophalen',
    getCommunityMemberRolesFailed: 'Kon de rollen voor deze organisatie niet ophalen',
    getIdentificationCodeTypeFailed: 'Kon het identificatietype niet ophalen',
    getJoinRequestFailed: 'Kon het lidmaatschapsverzoek niet ophalen',
    getOnboardingTemplateFailed: 'Kon de onboarding-template niet ophalen',
    getOrganisationRolesFailed: 'Kon de rollen niet ophalen',
    getPrincipalFailed: 'Kon de gebruiker niet ophalen',
    getRelationFailed: 'Kon de relatie niet ophalen',
    getRelationsFailed: 'Kon de relaties niet ophalen',
    getRelationTypeFailed: 'Kon het relatietype niet ophalen',
    getRelationTypesFailed: 'Kon de relatietypes niet ophalen',
    getSuiteFailed: 'Kon de suite niet ophalen',
    getSuitesFailed: 'Kon de suites niet ophalen',
    global: 'Globaal',
    here: 'hier',
    hostedAt: 'Gehost op',
    identificationcodetypes: 'Identificatiecodetype',
    identificationcodetypes_plural: 'Identificatiecode types',
    identities: 'Accounts',
    identity: 'Account',
    inactive: 'Inactief',
    installationIndex: 'Installatie-index',
    introducedInVersion: 'Geïntroduceerd in versie',
    introducedInVersionEmptyErr: 'Voer in welke versie deze functie is geïntroduceerd',
    invalidInvitation1: 'Er is iets misgegaan bij het ophalen van uw uitnodiging.',
    invalidInvitation2: 'Deze is mogelijk verlopen of bestaat niet.',
    invitationExpiresOn: 'Uitnodiging verloopt op',
    invitationInfo:
      '<bold>{{username}}</bold> van organisatie <bold>{{organisation}}</bold> heeft u uitgenodigd om lid te worden van de <bold>{{community}}</bold>-community.',
    invitationSentOn: 'Uitnodiging verzonden op',
    invitationState: 'Uitnodigingsstatus',
    invitationType: 'Uitnodigingstype',
    invited: 'Uitgenodigd',
    inviteFreeText: 'Voeg een bericht toe dat in de uitnodigingsmail wordt opgenomen',
    isCustomer: 'Is klant',
    isGloballyManaged: 'Beschikbaar voor communitybeheerders',
    isOptional: 'Is optioneel',
    isSystem: 'Is systeem',
    isVisible: 'Is zichtbaar',
    joinMessage: 'Uw bericht voor de communitybeheerder',
    joinRequestAcceptedInfo: 'Beste {{fullName}}, uw lidmaatschapsverzoek is goedgekeurd.',
    joinRequestError: 'Lidmaatschapsverzoek kon niet worden verzonden',
    joinRequestErrorMessage:
      'Er is iets misgegaan bij het verzenden van uw lidmaatschapsverzoek naar de communitybeheerder. Probeer het later opnieuw.',
    joinRequests: 'Lidmaatschapsverzoeken',
    joinRequestSentToCommunityAdmin: 'Lidmaatschapsverzoek verzonden naar communitybeheerders',
    joinRequestSentToCommunityAdminDescription:
      'Uw lidmaatschapsverzoek is naar de communitybeheerders gestuurd om u toegang te verlenen tot community-apps.',
    new: 'Nieuw',
    notADuplicate: 'Geen duplicaat',
    potentialDuplicate: 'Mogelijk duplicaat',
    potentialDuplicates: 'Mogelijke duplicaten',
    potentialDuplicateTooltip:
      'Dit verzoek wordt door Nallian beoordeeld voordat het wordt voortgezet.',
    potentialDuplicationDetails: 'Mogelijke Duplicaten Details',
    potentialDuplicateCannotManage:
      'Aangezien dit lidmaatschapsverzoek een mogelijk duplicaat kan zijn, wordt het door Nallian beoordeeld voordat er wordt verdergegaan. Dit lidmaatschapsverzoek kan op dit moment niet worden geaccepteerd of geweigerd.',
    duplicateByIdentificationCode:
      'Dit duplicaat is gedetecteerd door één of meerdere overeenkomende identificatiecodes',
    joinRequest: 'Lidmaatschapsverzoek',
    score: 'Score',
    languageEmptyErr: 'Selecteer een taal',
    languageIdEmptyErr: 'Selecteer een taal',
    linkExistingOrganisation: 'Bestaande organisatie koppelen',
    linkIdentityFailed: 'Kon account niet aan gebruiker koppelen',
    linkIdentitySuccess: 'Account gekoppeld aan gebruiker',
    linkMyIdentityToPrincipal: 'Mijn account aan gebruiker koppelen',
    location: 'Locatie',
    lockedOut: 'Buitengesloten',
    management: 'Beheer',
    mine: '(mijn account)',
    newApp: 'Nieuwe app',
    newAppSubscription: 'Nieuw app-abonnement',
    newCommunityApp: 'Nieuwe community-app',
    newCommunityMember: 'Nieuw community-lid',
    newCommunityRole: 'Nieuwe community-rol',
    newCommunitySuite: 'Nieuwe community-suite',
    newFeature: 'Nieuwe functie',
    newIdentificationCodeType: 'Type toevoegen',
    newOnboardingTemplate: 'Nieuwe onboarding-template',
    newOrganisationRole: 'Nieuwe organisatierol',
    newRelation: 'Nieuwe relatie',
    newRelationType: 'Nieuw relatietype',
    newSuite: 'Nieuwe suite',
    newUser: 'Nieuwe gebruiker',
    noAppsConfiguredForOnboardingTemplate: 'Geen apps geconfigureerd voor sjabloon.',
    noFeaturesDefined: 'Geen functies gedefinieerd',
    noFeaturesDefinedYet: 'Nog geen functies geconfigureerd',
    noFeaturesFound: 'Geen functies gevonden',
    noLinkedAccountsYet: 'Nog geen gekoppelde accounts.',
    noPendingInvitationsFound: 'Geen openstaande uitnodigingen gevonden',
    noRolesDefined: 'Geen rollen gedefinieerd',
    noSuitesFound: 'Geen suites gevonden',
    noTiersFound: 'Geen tiers gevonden',
    noUsersFound: 'Geen gebruikers gevonden',
    noAssignmentsFound: 'Geen toewijzingen gevonden',
    noSubscriptionsFound: 'Geen abonnementen gevonden',
    subscriptionId: 'Abonnement-ID',
    createFeatureSubscription: 'Feature-abonnement aanmaken',
    createSubscription: 'Abonnement aanmaken',
    createFeatureSubscriptionSuccess: 'Feature-abonnement succesvol aangemaakt',
    createFeatureSubscriptionFailed: 'Feature-abonnement kon niet worden aangemaakt',
    createRoleAssignmentSuccess: 'De toewijzing is bijgewerkt.',
    createRoleAssignmentFailed: 'De gebruiker kon niet aan de rol worden toegevoegd',
    removeUser: 'Gebruiker verwijderen',
    areYouSureRemoveRoleAssignment:
      'Weet u zeker dat u {{name}} - {{email}} uit deze rol wilt verwijderen?',
    removeRoleAssignmentSuccess: 'De gebruiker is uit de rol verwijderd.',
    removeRoleAssignmentFailed: 'De gebruiker kon niet uit de rol worden verwijderd',
    addSubscription: 'Abonnement toevoegen',
    addSubscriptionSuccess: 'Het abonnement is bijgewerkt.',
    addSubscriptionFailed: 'Het abonnement kon niet worden toegevoegd',
    removeOrgSubscription: 'Abonnement verwijderen',
    areYouSureRemoveOrgSubscription:
      'Weet u zeker dat u het abonnement van Feature: {{featureName}} - Installatie: {{installationName}} - App: {{appName}} voor organisatie {{organisationName}} wilt verwijderen? De toegang tot deze feature wordt ingetrokken voor alle gebruikers van deze organisatie.',
    removeOrgSubscriptionSuccess: 'Het abonnement is verwijderd.',
    removeOrgSubscriptionFailed: 'Het abonnement kon niet worden verwijderd',
    communityIdEmptyErr: 'Selecteer een community',
    organisationIdEmptyErr: 'Selecteer een organisatie',
    principalIdEmptyErr: 'Selecteer een gebruiker',
    assignmentType: 'Toewijzingstype',
    assignments: 'Toewijzingen',
    principalName: 'Hoofdgebruiker',
    organisationCityEmptyErr: 'Voer een stad in',
    organisationCountryEmptyErr: 'Voer een land in',
    organisationDetailsDescription: 'Vul de gegevens van de organisatie in',
    organisationNameEmptyErr: 'Voer een organisatienaam in',
    organisationRole: 'Organisatierol',
    organisationRoles: 'Organisatierol',
    organisationRoles_plural: 'Organisatierollen',
    organisationType: 'Organisatietype',
    organisations: 'Organisaties',
    organisationsOverview: 'Organisatieoverzicht',
    owners: 'Eigenaars',
    parentOrganisation: 'Bovenliggende organisatie',
    passwordToDelete: 'Wachtwoord om te verwijderen',
    pending: 'In behandeling',
    pendingInvitations: 'Openstaande uitnodiging',
    pendingInvitations_plural: 'Openstaande uitnodigingen',
    phoneNumber: 'Telefoonnummer',
    pleaseAcceptOurTermsAndConditions: 'Accepteer onze algemene voorwaarden',
    pleaseCompleteOrganisationDetails: 'Vul hieronder de gegevens van uw organisatie in.',
    postalCodeEmptyErr: 'Vul een postcode in',
    primaryEmailAddressEmptyErr: 'Voer een geldig e-mailadres in',
    primaryPhoneNumberEmptyErr: 'Voer een geldig telefoonnummer in',
    principalFullNameEmptyErr: 'Voer een volledige naam in',
    principalLanguageIdEmptyErr: 'Selecteer een taal',
    principals: 'gebruiker',
    principalTimeZoneEmptyErr: 'Selecteer een tijdzone',
    reInvite: 'Opnieuw uitnodigen',
    relationType: 'Relatie',
    relationTypeIdEmptyErr: 'Selecteer een relatietype',
    relationTypes: 'Relatietype',
    relationTypes_plural: 'Relatietypes',
    removeApp: 'App verwijderen',
    removeAppAndRoles: 'App, functies & rollen verwijderen',
    removeAppSubscriptionFailed: 'Abonnement verwijderen mislukt',
    removeAppSubscriptionSuccess: 'Abonnement succesvol verwijderd',
    removeFeature: 'Functie verwijderen',
    removeThisFeature: 'Deze functie verwijderen',
    removeThisRole: 'Rol verwijderen',
    removeThisSuite: 'Deze suite verwijderen',
    removeThisTier: 'Deze tier verwijderen',
    requestToJoin: 'Verzoek om lid te worden',
    requestToJoinInfo:
      'Als uw organisatie lid wil worden van deze community, vul dan het formulier in.<br/>De communitybeheerder zal uw aanvraag beoordelen en spoedig contact met u opnemen.',
    requiresSubscription: 'Abonnement vereisen',
    resendInvitationFailed: 'Kon de uitnodiging niet opnieuw verzenden',
    resendInvitationSuccess: 'De uitnodiging is opnieuw verzonden',
    resetPassword: 'Wachtwoord opnieuw instellen',
    reviewJoinRequest: 'Lidmaatschapsverzoek beoordelen',
    selectAnApp: 'Selecteer een app',
    selectAnApplication: 'Selecteer een applicatie',
    sendInvitation: 'Uitnodiging verzenden',
    sometingWentWrong: 'Er is iets misgegaan',
    source: 'Bron',
    sourceIdEmptyErr: 'Selecteer een bron',
    sourceOrganisationRoles: 'Bronorganisatierollen',
    stateName: 'Staat',
    status: 'Status',
    streetAndNumberEmptyErr: 'Vul een straat & nummer in',
    tag: 'Tag',
    tagEmptyErr: 'Vul een tag in',
    tagExplainer: 'Begint met een letter, maximale lengte van 20',
    target: 'Doel',
    targetIdEmptyErr: 'Selecteer een doel',
    targetOrganisationRoles: 'Doelorganisatierollen',
    template: 'Sjabloon',
    templateHasNoConfiguration: 'Sjabloon heeft geen configuratie',
    templateInfo1:
      'Een sjabloon geeft de beheerder toegang tot een reeks apps en een lijst met organisatierollen.',
    templateInfo2: 'Selecteer een sjabloon om de configuratie te bekijken',
    textMessage: 'Tekstbericht',
    noUserGroupsFound: 'Geen gebruikersgroepen gevonden',
    areYouSureRemoveUserGroup: 'Weet u zeker dat u deze gebruikersgroep wilt verwijderen?',
    createUserGroupFailed: 'Kon gebruikersgroep niet aanmaken',
    createUserGroupSuccess: 'Gebruikersgroep aangemaakt',
    updateUserGroupFailed: 'Kon gebruikersgroep niet bijwerken',
    updateUserGroupSuccess: 'Gebruikersgroep bijgewerkt',
    getUserGroupFailed: 'Kon gebruikersgroep niet ophalen',
    addUserGroup: 'Gebruikersgroep toevoegen',
    newUserGroup: 'Nieuwe gebruikersgroep',
    noAppsFeaturesRolesDefined: 'Geen apps, functies, rollen gedefinieerd',
    createUserGroupMemberFailed: 'Kon lid van gebruikersgroep niet aanmaken',
    createUserGroupMemberSuccess: 'Lid van gebruikersgroep aangemaakt',
    removeUserGroupMemberFailed: 'Kon lid van gebruikersgroep niet verwijderen',
    removeUserGroupMemberSuccess: 'Lid van gebruikersgroep verwijderd',
    getUserGroupMembersFailed: 'Kon leden van gebruikersgroep niet ophalen',
    membersOfUserGroup: 'Leden van gebruikersgroep',
    timezoneEmptyErr: 'Selecteer een tijdzone',
    timeZoneEmptyErr: 'Selecteer een tijdzone',
    timeZoneIdEmptyErr: 'Selecteer een tijdzone',
    unauthorized: 'U bent niet bevoegd om deze actie uit te voeren.',
    unlink: 'Ontkoppelen',
    unlinkIdentityFailed: 'Kon het account niet ontkoppelen',
    unlinkIdentitySuccess: 'Het account is ontkoppeld',
    unlisted: 'Niet vermeld',
    updateAppFailed: 'Kon de app niet bijwerken',
    updateAppSubscriptionFailed: 'Kon het app-abonnement niet bijwerken',
    updateAppSubscriptionSuccess: 'Het app-abonnement is bijgewerkt',
    updateAppSuccess: 'De app is bijgewerkt',
    updateCommunityAppFailed: 'Kon de community-app niet bijwerken',
    updateCommunityAppSuccess: 'De community-app is bijgewerkt',
    updateCommunityMemberFailed: 'Kon het community-lid niet bijwerken',
    updateCommunityMemberRolesFailed: 'Kon de community-lidrollen niet bijwerken',
    updateCommunityMemberRolesSuccess: 'De community-lidrollen zijn bijgewerkt',
    updateCommunityMemberSuccess: 'Het community-lid is bijgewerkt',
    updateCommunityRoleFailed: 'Kon de community-rol niet bijwerken',
    updateCommunityRoleSuccess: 'De community-rol is bijgewerkt',
    updateCommunitySuiteFailed: 'Kon de community-suite niet bijwerken',
    updateCommunitySuiteSuccess: 'De community-suite is bijgewerkt',
    updateIdentificationCodeTypeFailed: 'Kon het identificatiecodetype niet bijwerken',
    updateIdentificationCodeTypeSuccess: 'Het identificatiecodetype is bijgewerkt',
    updateOnboardingTemplateFailed: 'Kon de onboarding-template niet bijwerken',
    updateOnboardingTemplateSuccess: 'De onboarding-template is bijgewerkt',
    updateOrganisationRoleFailed: 'Kon de organisatierol niet bijwerken',
    updateOrganisationRoleSuccess: 'De organisatierol is bijgewerkt',
    updatePrincipalFailed: 'Kon de gebruiker niet bijwerken',
    updatePrincipalSuccess: 'De gebruiker is bijgewerkt',
    updateRelationFailed: 'Kon de relatie niet bijwerken',
    updateRelationSuccess: 'De relatie is bijgewerkt',
    updateRelationTypeFailed: 'Kon het relatietype niet bijwerken',
    updateRelationTypeSuccess: 'Het relatietype is bijgewerkt',
    updateUserSuccess: 'De gebruiker is bijgewerkt',
    url: 'Url',
    urlEmptyErr: 'Voer een url in',
    useATemplate: 'Gebruik een sjabloon',
    user: 'Gebruiker',
    userDetailsDescription: 'Vul de gebruikersgegevens in',
    validationPattern: 'Validatiepatroon',
    verifiedStatus: 'Geverifieerde status',
    view: 'Bekijken',
    viewMore: 'Meer bekijken',
    viewSubscribedOrganisations: 'Bekijk geabonneerde organisaties',
    viewTemplate: 'Sjabloon bekijken',
    welcomeToThePlatform: 'Welkom op het platform!',
    welcomeToThePlatformInfo:
      'Uw gebruikersaccount is succesvol geregistreerd op het Nallian-platform. Klik op "Doorgaan" om in te loggen op de Nallian Portal en de applicaties te gaan gebruiken.',
    searchAndAddMember: 'Zoek en voeg een lid toe',
    searchForNameOrEmailOfUser: 'Zoek naar een naam of e-mail van een gebruiker',
    editUserGroup: 'Gebruikersgroep bewerken',
    manageMembers: 'Leden bekijken/beheren',
    userGroupHasNoMembers: 'Deze gebruikersgroep heeft geen leden',
    organisationsForRole: 'Organisaties voor community-rol',
    noOrganisationsFound: 'Geen organisaties gevonden',
    viewOrganisations: 'Organisaties bekijken',
    appSubscriptions: 'App-abonnementen',
    createdByOrganisation: 'Aangemaakt door organisatie',
    metaData: 'Metadata',
    lastModifiedOn: 'Laatst gewijzigd op',
    linkedAccounts: 'Gekoppelde accounts',
    relations: 'Relaties',
    youHaveBeenInvited: 'U bent uitgenodigd',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Weet u zeker dat u het abonnement voor deze functie wilt verwijderen? De toegang tot deze functie wordt voor alle gebruikers van deze organisatie ingetrokken.',
    applyOnboardingTemplate: 'Onboarding-template toepassen',
    getOnboardingTemplatesFailed: 'Kon onboarding-sjablonen niet ophalen',
    selectAnOnboardingTemplate: 'Selecteer een onboarding-template',
    onboardingTemplateIdEmptyErr: 'Selecteer een onboarding-template',
    applyOnboardingTemplateFailed: 'Kon onboarding-template niet toepassen',
    applyOnboardingTemplateSuccess: 'Onboarding-template toegepast',
    addTemplateInfo: 'De sjabloon voegt de volgende apps & community-rollen toe aan de organisatie',
    filters: 'Filters',
    filterOnUserRole: 'Filteren op gebruikersrol',
    identityOrClient: 'Account of client',
    searchForAnIdentityOrAddClientId: 'Zoek naar een account of voeg een client-ID toe',
    filterOnIdentificationCode: 'Filteren op identificatiecode',
    useNoTemplate: 'Geen sjabloon gebruiken',
    templateInfo: 'Selecteer een sjabloon',
    userInfo: 'Gebruikersinfo',
    invalidUrlCommuntiyAppFeature: 'Moet een geldige URL zijn of moet [EnvironmentUrl] bevatten',
    communitiesOverview: 'Community-overzicht',
    createCommunityFailed: 'Kon community niet aanmaken',
    createCommunitySuccess: 'Community aangemaakt',
    newCommunity: 'Nieuwe community',
    themeName: 'Themanaam',
    defaultLanguage: 'Standaardtaal',
    mustBeValidUrl: 'Moet een geldige URL zijn',
    updateCommunityFailed: 'Kon community niet bijwerken',
    updateCommunitySuccess: 'Community bijgewerkt',
    fixedCommunityId:
      'ID (niet verplicht, alleen als u dezelfde community-ID op alle omgevingen wilt)',
    updateNotificationSettingsFailed: 'Kon notificatie-instellingen niet bijwerken',
    updateNotificationSettingsSuccess: 'Notificatie-instellingen bijgewerkt',
    notificationSettings: 'Notificatie-instellingen',
    fromName: 'Van naam',
    fromEmail: 'Van e-mail',
    replyToEmail: 'Antwoord-naar-e-mail',
    replyToName: 'Antwoord-naar-naam',
    emailSubjectPrefix: 'Voorvoegsel e-mailonderwerp',
    contactEmail: 'Contact-e-mail',
    updateHostsFailed: 'Kon hosts niet bijwerken',
    updateHostsSuccess: 'Hosts bijgewerkt',
    noHostsYet: 'Nog geen hosts',
    addHost: 'Host toevoegen',
    host: 'Host',
    hosts: 'Hosts',
    isPrimary: 'Is primair',
    onlyOnePrimaryHost: 'Slechts één host kan primair zijn',
    minOnePrimaryHost: 'Minimaal één host moet primair zijn',
    pleaseEnterAHost: 'Voer een (geldige) host in',
    tenantId: 'Tenant-ID',
    tenantHostUrl: 'Tenant host-url',
    tenantInformation: 'Tenant-informatie',
    communityWelcomeText: 'Community-welkomsttekst',
    legalDocuments: 'Juridische documenten',
    uploadNewGeneralTermsAndConditions: 'Nieuwe Algemene Voorwaarden uploaden',
    documents: 'Documenten',
    title: 'Titel',
    revision: 'Revisie',
    download: 'Downloaden',
    themeLookups_plural: 'Theme lookups',
    newThemeLookup: 'Nieuwe theme lookup',
    createThemeLookupFailed: 'Kon theme lookup niet aanmaken',
    createThemeLookupSuccess: 'Theme lookup aangemaakt',
    updateThemeLookupFailed: 'Kon theme lookup niet bijwerken',
    updateThemeLookupSuccess: 'Theme lookup bijgewerkt',
    editThemeLookup: 'Theme lookup bewerken',
    themeLookups: 'Theme lookup',
    titleEmptyErr: 'Voer een titel in',
    hostEmptyErr: 'Voer een host in',
    themeNameEmptyErr: 'Voer een themanaam in',
    editCommunityTextFailed: 'Kon community-tekst niet bijwerken',
    editCommunityTextSuccess: 'Community-tekst bijgewerkt',
    documentUploaded: 'Document geüpload',
    documentUploadFailed: 'Document uploaden mislukt',
    noCommunityTextYet: 'Nog geen community-welkomsttekst',
    noDocumentsYet: 'Nog geen documenten',
    noWelcomeTextAvailable: 'Geen welkomstinformatie beschikbaar voor deze community.',
    addLanguage: 'Taal toevoegen',
    enterLanguageKey: 'Voer uw taalsleutel in',
    emailNotificationFooter: 'Voettekst e-mailnotificatie',
    emailNotificationHeader: 'Koptekst e-mailnotificatie',
    removeCommunityAppClientFailed: 'Kon client niet verwijderen',
    removeCommunityAppClientSuccess: 'Client verwijderd',
    createCommunityAppClientFailed: 'Kon client niet aanmaken',
    createCommunityAppClientSuccess: 'Client aangemaakt',
    getCommunityAppClientsFailed: 'Kon clients niet ophalen',
    manageClientsForCommunityApp: 'Clients beheren',
    addClient: 'Client toevoegen',
    manageAppClients: 'App-clients beheren',
    noClientsYet: 'Nog geen clients',
    unknownIdentityProvider: 'Onbekende identiteitsprovider',
    areYouSureRemoveOrganisation:
      'Weet u zeker dat u de organisatie "{{item.name}}" wilt verwijderen?',
    timeSettings: 'Tijdsinstellingen',
    userDetails: 'Gebruikersdetails',
    appsAndRoles: 'Apps & rollen',
    accountsIdentities: 'Gekoppelde accounts',
    accounts: 'Accounts',
    areYouSureContinueWithoutUserHasRoles:
      'Weet u zeker dat u deze gebruiker geen toegang wilt geven tot enige applicatie?',
    principalRemoved: 'Gebruiker verwijderd',
    userGroups: 'Gebruikersgroepen',
    userGroup: 'Gebruikersgroep',
    selectUserGroups: 'Selecteer gebruikersgroepen',
    rolesFromUserGroups: 'Rollen van gebruikersgroepen',
    noRolesInUserGroup: 'Geen rollen toegewezen aan deze gebruikersgroep',
    noRolesInSelectedUserGroups: 'Geen rollen toegewezen aan de geselecteerde gebruikersgroepen',
    data: 'Data',
    id: 'ID',
    shortName: 'Korte naam',
    installations: 'Installaties',
    isGlobal: 'Is globaal',
    isCrossCommunity: 'Is cross-community',
    isObsolete: 'Is verouderd',
    copyToClipboard: 'Kopiëren naar klembord',
    administrators: 'Beheerders',
    welcomeText: 'Community-welkomsttekst',
    overviewText: 'Overzichtstekst startpagina',
    pleaseTypeToEnableConfirmButton: "Typ '{{message}}' om de bevestigingsknop in te schakelen.",
    pleaseTypeHere: 'Typ hier',
    removeOrganisation: 'Organisatie verwijderen',
    removeOrganisationFailed: 'Kon organisatie niet verwijderen',
    removeOrganisationSuccess: 'Organisatie verwijderd',
    removeAppInstallation: 'App-installatie verwijderen',
    areYouSureRemoveAppInstallation:
      'Weet u zeker dat u de app-installatie "{{item.name}}" wilt verwijderen?',
    removeAppInstallationFailed: 'Kon app-installatie niet verwijderen',
    removeAppInstallationSuccess: 'App-installatie verwijderd',
    areYouSureRemoveApp: 'Weet u zeker dat u de app "{{item.name}}" wilt verwijderen?',
    removeAppFailed: 'Kon app niet verwijderen',
    removeAppSuccess: 'App verwijderd',
    roleInFeature: 'Rol in {{featureName}}',
    featureInInstallation: 'Feature in {{installationName}}',
    installationOfApp: 'Installatie van {{appName}}',
    installation: 'Installatie',
    removeFeatureSubscriptionFailed: 'Kon feature-abonnement niet verwijderen',
    removeFeatureSubscriptionSuccess: 'Feature-abonnement verwijderd',
    removeSubscription: 'Abonnement verwijderen',
    areYouSureRemoveSubscription:
      'Weet u zeker dat u het abonnement voor "{{organisationName}}" wilt verwijderen?',
    identificationCodesCount: '{{count}} identificatiecode(s)',
    noIdentificationCodes: 'Geen identificatiecodes',
    principalCount: '{{count}} principal(s)',
    noPrincipals: 'Geen principals',
    errorLoadingPrincipals: 'Fout bij het laden van principals',
    unnamed: 'Naamloos',
    linkedPrincipals: 'Gekoppelde principals',
    allIdentities: 'Alle identiteiten',
    provider: 'Provider',
    anonymizeIdentity: 'Identiteit anonimiseren',
    areYouSureYouWantToAnonymiseIdentity:
      'Weet u zeker dat u de identiteit voor {{fullName}} wilt anonimiseren?',
    anonymizeIdentitySuccess: 'Identiteit succesvol geanonimiseerd',
    anonymizeIdentityFailed: 'Identiteit kon niet worden geanonimiseerd',
    noIdentitiesFound: 'Geen identiteiten gevonden',
    typeMinimum2Characters: 'Type min. 2 tekens',
    startWithPlusEgFormat: 'Begin met +, bijv. +32',
    noRoles: 'Geen rollen',
    rolesCount: '{{count}} rol(len)',
    noIdentificationCodeTypesFound: 'Geen identificatiecodetypes gevonden',
    isRequired: 'Is vereist',
    identificationCodeTypeTagEmptyErr: 'Selecteer een identificatiecodetype',
    editType: 'Type bewerken',
    theFollowingIdentificationCodeTypesAreRequired:
      'De volgende identificatiecodes ontbreken: {{missingTypes}}',
    updateContactFailed: 'Kon contact niet bijwerken',
    updateContactSuccess: 'Contact bijgewerkt',
    createContactFailed: 'Kon contact niet aanmaken',
    createContactSuccess: 'Contact aangemaakt',
    removeContactFailed: 'Kon contact niet verwijderen',
    removeContactSuccess: 'Contact verwijderd',
    contacts: 'Contacten',
    noContactsYet: 'Nog geen contacten.',
    newContact: 'Nieuw contact',
    editContact: 'Contact bewerken',
    areYouSureYouWantToRemoveContact: 'Weet u zeker dat u dit contact wilt verwijderen?',
    logo: 'Logo',
    uploadANewLogo: 'Upload een nieuw logo',
    noLogoAvailable: 'Nog geen logo.',
    viewLogo: 'Logo bekijken',
    uploadLogo: 'Logo uploaden',
    removeOrganisationLogoFailed: 'Kon logo niet verwijderen',
    removeOrganisationLogoSuccess: 'Logo verwijderd',
    uploadLogoSuccess: 'Logo geüpload',
    uploadLogoError: 'Kon logo niet uploaden',
    removeLogo: 'Logo verwijderen',
    areYouSureYouWantToRemoveLogo: 'Weet u zeker dat u het logo wilt verwijderen?',
    fileEmptyErr: 'Upload een geldig bestand',
    noFeatureDetails: 'Geen functie-details',
    pleaseSelectRoles: 'Selecteer een of meer rollen',
    idpUserGroup: 'Automatisch beheerde gebruikersgroep',
    idpUserGroupInfo:
      'Deze groep wordt up-to-date gehouden met de gebruikerslijst van uw organisatie. U kunt nog steeds handmatig gebruikers toevoegen, maar als iemand inlogt via het inlogsysteem van uw bedrijf, kunnen uw wijzigingen ongedaan worden gemaakt de volgende keer dat ze inloggen.',
    viaIdp: 'Automatisch toegewezen',
    invitationIsExpired: 'Deze uitnodiging is verlopen',
    inviationNotValidAnymore: 'Deze uitnodiging is ingetrokken',
    invitationUsedProceedLogin:
      'Het lijkt erop dat deze uitnodiging al is gebruikt. U kunt doorgaan en inloggen op uw account.',
    invitationUsedProceedProcess:
      'Deze uitnodiging is al gebruikt, maar uw account is bijna klaar. Om uw registratie te voltooien, logt u in, vult u uw bedrijfsgegevens in en accepteert u de algemene voorwaarden.',
    completeRegistration: 'Registratie voltooien',
    signIn: 'Inloggen',
    inviteAlreadyUsed: 'Uitnodiging al gebruikt',
    updateOrganisationFailed: 'Organisatie kon niet worden bijgewerkt',
    organisationUpdated: 'Organisatie bijgewerkt',
    getCommunityRoleFailed: 'Communityrol kon niet worden opgehaald',
    createOrganisation: 'Organisatie aanmaken',
    organisationCreated: 'Organisatie aangemaakt',
    createOrganisationFailed: 'Organisatie kon niet worden aangemaakt',
    onboardingTemplates: 'Onboarding templates',
    identificationCodeTypes: 'Identificatiecode types',
    notification: 'Notificatie',
    textsAndLegal: 'Texts & legal',
    exportAsJSON: 'Als JSON exporteren',
    addContact: 'Contact toevoegen',
    selectCommunityForInvitation:
      'Selecteer de community-context waarin u de uitnodiging wilt verzenden',
    allUsers: 'Alle gebruikers',
    codeCannotHaveTrailingSpaces: 'De code mag geen spaties aan het einde hebben',
    deleteRole: 'Rol verwijderen',
    areYouSureDeleteRole: 'Weet u zeker dat u de rol "{{name}}" wilt verwijderen?',
    pleaseTypeRoleNameToConfirm: 'Typ "{{name}}" om te bevestigen',
    acknowledgeRoleNotObsolete:
      'Ik begrijp dat deze rol nog niet als verouderd is gemarkeerd en ik wil deze rol toch verwijderen',
    removeRoleFailed: 'Rol kon niet worden verwijderd',
    removeRoleSuccess: 'Rol succesvol verwijderd',
    deleteFeature: 'Feature verwijderen',
    areYouSureDeleteFeature: 'Weet u zeker dat u de feature "{{name}}" wilt verwijderen?',
    pleaseTypeFeatureNameToConfirm: 'Typ "{{name}}" om te bevestigen',
    acknowledgeFeatureNotObsolete:
      'Ik begrijp dat deze feature nog niet als verouderd is gemarkeerd en ik wil deze feature toch verwijderen',
    removeFeatureFailed: 'Feature kon niet worden verwijderd',
    removeFeatureSuccess: 'Feature succesvol verwijderd',
    noFeaturesYet: 'Nog geen features',

    /* documents */
    documents: 'Documenten',
    documentsOverview: 'Documentenoverzicht',
    uploadDocument: 'Document uploaden',
    documentType: 'Documenttype',
    documentType_CompanyEmployeeRegistration: 'Bedrijfsmedewerkerregistratie',
    documentType_AirportAccreditation: 'Luchthavenaccreditatie',
    documentType_Passport: 'Paspoort',
    documentType_DriverLicense: 'Rijbewijs',
    documentType_IDCard: 'Identiteitskaart',
    selectDocumentType: 'Selecteer documenttype',
    fileUpload: 'Bestand uploaden',
    documentName: 'Documentnaam',
    fileSize: 'Bestandsgrootte',
    uploadedBy: 'Geüpload door',
    uploadedAt: 'Geüpload op',
    expirationDate: 'Vervaldatum',
    expirationDateHelperText: 'Datum moet vandaag of later zijn, tot 10 jaar vanaf vandaag',
    pending: 'In afwachting',
    validated: 'Gevalideerd',
    expired: 'Verlopen',
    superseded: 'Vervangen',
    rejected: 'Afgewezen',
    expiring: 'Verloopt binnenkort',
    approve: 'Goedkeuren',
    reject: 'Afwijzen',
    preview: 'Voorbeeld',
    history: 'Geschiedenis',
    pleaseSelectDocumentType: 'Selecteer een documenttype',
    unsupportedFileType:
      'Niet-ondersteund bestandstype. Alleen JPEG- en PNG-bestanden zijn toegestaan.',
    fileTooLarge: 'Bestand is te groot. Maximale bestandsgrootte is 10 MB.',
    expirationDateRequired: 'Selecteer een vervaldatum',
    expirationDatePast: 'De vervaldatum mag niet in het verleden liggen',
    expirationDateTooFar: 'De vervaldatum mag niet meer dan 10 jaar in de toekomst liggen',
    uploadSuccessful: 'Document succesvol geüpload',
    uploadFailed: 'Document uploaden mislukt',
    documentApproved: 'Document succesvol goedgekeurd',
    documentPreviewTitle: 'Documentvoorbeeld: {{name}}',
    documentPreviewCaption: 'Gevoelige informatie is om privacyredenen onleesbaar gemaakt',
    documentPreviewError: 'Kan documentvoorbeeld niet laden. Probeer het opnieuw.',
    documentApproveWarning:
      'Door dit document goed te keuren, bevestigt u dat u de onleesbaar gemaakte afbeelding heeft beoordeeld. Zorg ervoor dat alleen de naam, het geslacht en de foto zichtbaar zijn en dat alle andere gevoelige informatie goed is afgedekt. Als u niet tevreden bent met de door het systeem gegenereerde onleesbaar making, kunt u het document afwijzen en in plaats daarvan een reeds onleesbaar gemaakt document opnieuw uploaden.',
    documentRedactingPlaceholder:
      'Even geduld. Uw document wordt onleesbaar gemaakt en is binnenkort beschikbaar.',
    documentRejected: 'Document succesvol afgewezen',
    confirmApprove: 'Goedkeuring bevestigen',
    confirmReject: 'Afwijzing bevestigen',
    documentRejectedReuploadPrompt: 'Het document is afgewezen. Wilt u een nieuwe versie uploaden?',
    uploadLater: 'Later uploaden',
    reuploadNow: 'Nu opnieuw uploaden',
    consentWarning:
      'Door dit document te uploaden, bevestigt u dat de documenteigenaar heeft ingestemd met de opslag en verwerking ervan.',
    consentCheckbox: 'Ik erken en ga akkoord met bovenstaande verklaring',
    noDocumentsFound: 'Geen documenten gevonden',
    rejectReason: 'Reden voor afwijzing',
    approveDocumentFailed: 'Document kon niet worden goedgekeurd',
    rejectDocumentFailed: 'Document kon niet worden afgewezen',
    areYouSureApproveDocument: 'Weet u zeker dat u dit document wilt goedkeuren?',
    areYouSureRejectDocument: 'Weet u zeker dat u dit document wilt afwijzen?',
    viewHistory: 'Geschiedenis bekijken',
    documentHistory: 'Documentgeschiedenis',
    // Document translations (shared keys needed by app components)
    'documents.title': 'Documenten',
    'documents.type': 'Documenttype',
    'documents.fileName': 'Bestandsnaam',
    'documents.uploadedAt': 'Geüpload op',
    'documents.uploadedBy': 'Geüpload door',
    'documents.expirationDate': 'Vervaldatum',
    'documents.status': 'Status',
    'documents.actions': 'Acties',
    'documents.preview': 'Voorbeeld',
    'documents.noDocumentsFound': 'Geen documenten gevonden',
    'documents.failedToLoad': 'Documenten konden niet worden geladen',
    'documents.previewTitle': 'Documentvoorbeeld',
    'documents.previewCaption': 'Dit is een voorbeeld van het document',
    'documents.previewError': 'Documentvoorbeeld kon niet worden geladen',
    'documents.type_CompanyEmployeeRegistration': 'Bedrijfsmedewerkerregistratie',
    'documents.type_AirportAccreditation': 'Luchthavenaccreditatie',
    'documents.type_Passport': 'Paspoort',
    'documents.type_DriverLicense': 'Rijbewijs',
    'documents.type_IDCard': 'Identiteitskaart',
    'documents.status.pending': 'In afwachting',
    'documents.status.validated': 'Gevalideerd',
    'documents.status.expired': 'Verlopen',
    'documents.status.superseded': 'Vervangen',
    'documents.status.rejected': 'Afgewezen',
    'documents.status.expiring': 'Verloopt binnenkort',
    // Document translations (app-specific)
    'documents.confirmUploadTitle': 'Document controleren & bevestigen',
    'documents.confirmUpload': 'Upload bevestigen',
    'documents.redactWarning.intro':
      'Door dit document goed te keuren, bevestigt u dat u de afgeschermde afbeelding hebt gecontroleerd.',
    'documents.redactWarning.visibleInfo': 'Alleen de volgende informatie mag zichtbaar blijven:',
    'documents.redactWarning.fullName': 'Volledige naam',
    'documents.redactWarning.photo': 'Foto',
    'documents.redactWarning.expirationDate': 'Vervaldatum',
    'documents.redactWarning.mustBlackOut':
      'Alle andere gevoelige informatie moet volledig worden afgeschermd.',
    'documents.redactWarning.adjustInstructions':
      'Als u niet tevreden bent met de door het systeem gegenereerde afschermingen, kunt u deze aanpassen door met uw muis over een gebied te slepen om een nieuwe afscherming toe te voegen of op "x" te klikken om er een te verwijderen.',
    'documents.history': 'Documentgeschiedenis',
    'documents.redactingPlaceholder': 'Document wordt verwerkt voor redactie...',
    'documents.showFinalPreview': 'Eindresultaat tonen',
    'documents.thisIsHowImageWillBeSaved': 'zo wordt de afbeelding opgeslagen',
    'documents.failedToLoadImage': 'Afbeelding kon niet worden geladen',
    'documents.upload': 'Document uploaden',
    'documents.documentConfirmed': 'Document succesvol bevestigd',
    'documents.confirmFailed': 'Document bevestigen mislukt',
    'documents.analyzeFailed': 'Document analyseren mislukt',
    'documents.uploadSuccessful': 'Document succesvol geüpload',
    'documents.uploadFailed': 'Document uploaden mislukt',
    'documents.consentWarning':
      'Door dit document te uploaden, bevestigt u dat de documenteigenaar heeft ingestemd met de opslag en verwerking ervan.',
    'documents.consentCheckbox':
      'Ik bevestig dat de documenteigenaar toestemming heeft gegeven voor de opslag en verwerking ervan.',
    'documents.redactConfirmCheckbox':
      'Ik bevestig dat dit document correct is afgeschermd en dat alleen toegestane informatie zichtbaar blijft.',
    'documents.selectType': 'Selecteer documenttype',
    'documents.pleaseSelectType': 'Selecteer een documenttype',
    'documents.file': 'Bestand',
    'documents.unsupportedFileType': 'Selecteer een geldig bestand',
    'documents.expirationDateRequired': 'Vervaldatum is verplicht',
    'documents.expirationDatePast': 'Vervaldatum mag niet in het verleden liggen',
    'documents.expirationDateTooFar': 'Vervaldatum mag niet meer dan 10 jaar in de toekomst liggen',
    'documents.expirationDateHelperText':
      'Datum moet vandaag of later zijn, tot 10 jaar vanaf vandaag',
    'documents.approveWarning': 'Controleer dit document zorgvuldig voordat u het goedkeurt.',
    'documents.rejected': 'Document afgewezen',
    'documents.rejectedReuploadPrompt':
      'Het document is afgewezen. Wilt u een nieuwe versie uploaden?',
    'documents.uploadLater': 'Later uploaden',
    'documents.reuploadNow': 'Nu opnieuw uploaden',
    'documents.areYouSureReject': 'Weet u zeker dat u dit document wilt afwijzen?',
    'documents.confirmReject': 'Afwijzen',
    'documents.areYouSureApprove': 'Weet u zeker dat u dit document wilt goedkeuren?',
    'documents.confirmApprove': 'Goedkeuren',
    // Impersonation
    requestImpersonation: 'Imitatie aanvragen',
    impersonationRequest: 'Imitatie-aanvraag',
    support: 'Support',
    implementation: 'Implementatie',
    duration: 'Duur',
    ticketProjectReference: 'Ticket/Projectreferentie',
    ticketProjectReferencePlaceholder: 'bijv. TICKET-1234 of PROJECT-5678',
    documentAccess: 'Documenttoegang',
    documentAccessTooltip:
      'Verleent toegang tot identificatiedocumenten gekoppeld aan dit account (bijv. rijbewijs, identiteitskaart, paspoort). Schakel alleen in indien nodig, aangezien dit goedkeuring van een organisatiebeheerder vereist.',
    reason: 'Reden',
    reasonPlaceholder: 'Voer een reden in voor de imitatie...',
    impersonationInfoBanner:
      'De imitatiesessie wordt geactiveerd zodra de doelgebruiker de aanvraag accepteert.',
    submitRequest: 'Aanvraag indienen',
    impersonationRequestCreated: 'Imitatie-aanvraag succesvol ingediend',
    impersonationRequestFailed: 'Imitatie-aanvraag kon niet worden ingediend',
    reasonEmptyErr: 'Reden is verplicht',
    requestedDurationEmptyErr: 'Duur is verplicht',
    reasonTooLong: 'Reden mag maximaal {{max}} tekens bevatten',
    // Impersonation Requests List
    impersonationRequests: 'Imitatie-aanvragen',
    'tab.invitations': 'Uitnodigingen',
    'tab.apps': 'Apps',
    'tab.idCodes': 'ID-codes',
    'tab.documents': 'Documenten',
    'tab.impersonation': 'Imitatie',
    impersonationRequestDetails: 'Details van imitatie-aanvraag',
    noImpersonationRequestsFound: 'Geen imitatie-aanvragen gevonden',
    targetUser: 'Doelgebruiker',
    requestedAt: 'Aangevraagd op',
    activeUntil: 'Actief tot',
    activeFrom: 'Actief vanaf',
    requester: 'Aanvrager',
    approvedDuration: 'Goedgekeurde duur',
    requestValidUntil: 'Aanvraag geldig tot',
    resolvedBy: 'Opgelost door',
    resolvedAt: 'Opgelost op',
    coResolvedBy: 'Mede-opgelost door',
    coResolvedAt: 'Mede-opgelost op',
    coDenialReason: 'Reden mede-afwijzing',
    revokedBy: 'Ingetrokken door',
    revokedAt: 'Ingetrokken op',
    revocationReason: 'Reden intrekking',
    'impersonation.confirmApprove': 'Weet je zeker dat je deze aanvraag wilt goedkeuren?',
    'impersonation.confirmDeny': 'Weet je zeker dat je deze aanvraag wilt afwijzen?',
    terminateAccess: 'Toegang beëindigen',
    terminateImpersonationSuccess: 'Imitatie-toegang succesvol beëindigd',
    terminateImpersonationFailed: 'Imitatie-toegang kon niet worden beëindigd',
    pendingCoApproval: 'Mede-goedkeuring vereist',
    revoked: 'Ingetrokken',
    consolidated: 'Geconsolideerd',
    denied: 'Afgewezen',
    coApproveImpersonationSuccess: 'Imitatie-aanvraag goedgekeurd',
    coApproveImpersonationFailed: 'Imitatie-aanvraag kon niet worden goedgekeurd',
    coDenyImpersonationSuccess: 'Imitatie-aanvraag afgewezen',
    coDenyImpersonationFailed: 'Imitatie-aanvraag kon niet worden afgewezen',
    impersonating: 'Imitatie actief',
    expiresIn: 'Verloopt over',
    expiresAt: 'Verloopt om',
  },
  el: {
    noCommunityData: 'Δεν υπάρχουν διαθέσιμα δεδομένα κοινότητας',
    password: 'Κωδικός πρόσβασης',
    verifyPassword: 'Επιβεβαίωση κωδικού πρόσβασης',
    passwordsDontMatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    userName: 'Όνομα χρήστη (e-mail)',
    language: 'Γλώσσα',
    fullName: 'Πλήρες όνομα',
    next: 'Επόμενο',
    nameRequired: 'Εισάγετε ένα όνομα',
    cityRequired: 'Εισάγετε μια πόλη',
    descriptionRequired: 'Εισάγετε μια περιγραφή',
    selectCountry: 'Επιλέξτε μια χώρα',
    name: 'Όνομα',
    city: 'Πόλη',
    postalCode: 'Ταχυδρομικός κώδικας',
    streetAndNumber: 'Οδός και αριθμός',
    country: 'Χώρα',
    createUser: 'Δημιουργία χρήστη',
    signLegalDocuments: 'Συμφωνώ με τους όρους χρήσης',
    suggestionsRequired: 'Επιλέξτε έναν οργανισμό',
    streetAndNumberRequired: 'Η οδός και ο αριθμός είναι υποχρεωτικά',
    postalCodeRequired: 'Ο ταχυδρομικός κώδικας είναι υποχρεωτικός',
    suggestions: 'Προτάσεις',
    selectPlaceholder: 'Επιλογή...',
    createAnAccount: 'Δημιουργία λογαριασμού',
    loginToYourAccount: 'Σύνδεση στον λογαριασμό σας',
    join: 'Εγγραφή',
    joinOrganisationOnPlatform: 'Συμμετοχή σε οργανισμό που υπάρχει ήδη στην πλατφόρμα',
    register: 'Εγγραφή',
    registerOrganisationOnPlatform: 'Καταχώρηση νέου οργανισμού στην πλατφόρμα',
    confirmationEmailSent: 'Ελέγξτε το e-mail σας',
    resendEmail: 'Επανάληψη αποστολής e-mail',
    confirmationEmailContent:
      'Έχει σταλεί ένα e-mail στο {{email}}.\n\nΑνοίξτε το e-mail σας και κάντε κλικ στον σύνδεσμο επικύρωσης για να συνεχίσετε με την εγγραφή σας. Εάν δεν βρίσκετε το e-mail, ελέγξτε τον φάκελο SPAM ή στείλτε το ξανά με το παρακάτω κουμπί.\n\nΑυτό το παράθυρο μπορεί να κλείσει.',
    passwordRequired: 'Εισάγετε έναν κωδικό πρόσβασης',
    passwordMinimum12charactersErr: 'Ο κωδικός πρόσβασης πρέπει να έχει τουλάχιστον 12 χαρακτήρες',
    passwordMaximum80charactersErr: 'Ο κωδικός πρόσβασης μπορεί να έχει έως 80 χαρακτήρες',
    reEnterPassword: 'Εισάγετε ξανά τον κωδικό πρόσβασης',
    joinRequestSent: 'Το αίτημα συμμετοχής στάλθηκε',
    joinRequestContent:
      'Παρακαλώ περιμένετε την αποδοχή του αιτήματός σας από τον διαχειριστή του οργανισμού. Επικοινωνήστε με τον διαχειριστή του οργανισμού σας για περαιτέρω παρακολούθηση.',
    readAllLegalDocuments: 'Έχω διαβάσει και συμφωνώ με τα παραπάνω έγγραφα',
    sign: 'Συμφωνώ',
    welcome: 'Καλώς ήρθατε',
    chooseRoles: 'Επιλέξτε ρόλους',
    login: 'Σύνδεση',
    communityMembershipTemplateGetFailed:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση του προτύπου μέλους κοινότητας',
    membershipAlreadyRequested: 'Το αίτημα μέλους έχει ήδη υποβληθεί',
    noLegalDocumentsToSign: 'Δεν υπάρχουν έγγραφα προς συμφωνία',
    welcomeToTheCommunity: 'Καλώς ήρθατε στην κοινότητα.',
    viewApps: 'Προβολή εφαρμογών',
    membershipRequestFailed: 'Ωχ, το αίτημα συμμετοχής στην κοινότητα απέτυχε',
    error: 'Σφάλμα',
    chooseSuggestedOrganisationToJoin:
      'Με βάση τη διεύθυνση e-mail σας, ίσως θέλετε να συμμετάσχετε σε έναν από τους ακόλουθους υπάρχοντες οργανισμούς.',
    joinSuggestedOrganisation:
      'Με βάση τη διεύθυνση e-mail σας, ίσως θέλετε να συμμετάσχετε σε αυτόν τον υπάρχοντα οργανισμό.',
    selectAnOrganisation: 'Επιλέξτε έναν οργανισμό',
    organisationName: 'Όνομα οργανισμού',
    requestedAt: 'Αιτήθηκε στις',
    back: 'Πίσω',
    addIdentificationCode: 'Προσθήκη κωδικού αναγνώρισης',
    identificationCode: 'Κωδικός αναγνώρισης',
    identificationcode: 'Κωδικοί αναγνώρισης',
    welcomeMessageTitle: 'Καλώς ήρθατε στην πλατφόρμα!',
    selectLanguage: 'Επιλέξτε μια γλώσσα',
    selectTimezone: 'Επιλέξτε μια ζώνη ώρας',
    type: 'Τύπος',
    organisationNameAlreadyExists: 'Το όνομα οργανισμού υπάρχει ήδη',
    errorWhileValidatingOrganisationName:
      'Ωχ, παρουσιάστηκε σφάλμα κατά την επικύρωση του ονόματος οργανισμού',
    thisIdentificationCodeIsAlreadyInUse: 'Αυτός ο κωδικός αναγνώρισης χρησιμοποιείται ήδη',
    errorWhileIdentificationCodeName:
      'Ωχ, παρουσιάστηκε σφάλμα κατά την επικύρωση του κωδικού αναγνώρισης',
    continue: 'Συνέχεια',
    invalidEmailErr: 'Εισάγετε μια έγκυρη διεύθυνση e-mail',
    dear: 'Αγαπητέ/ή {{user}},',
    successfullyReceivedRegistration:
      ' Η εγγραφή σας ελήφθη επιτυχώς. Θα λάβετε σύντομα ένα e-mail με σύνδεσμο που θα σας δίνει πρόσβαση στις εφαρμογές για τις οποίες έχετε εγγραφεί.',
    furtherQuestions:
      'Εάν έχετε περαιτέρω ερωτήσεις, επικοινωνήστε με τον διαχειριστή της κοινότητάς σας.',
    'sorry!': 'Λυπούμαστε!',
    pageRequestedNotFound: 'Η σελίδα που ζητήσατε δεν βρέθηκε.',
    toTheCommunityPortal: 'Προς το Nallian Portal.',
    validateUsernameFailed: 'Σφάλμα κατά την επικύρωση του ονόματος χρήστη',

    /* user mgmt + request membership */
    myOrganisation: 'Ο οργανισμός μου',
    noMembershipRequests: 'Δεν υπάρχουν αιτήματα συμμετοχής',
    membershipRequests: 'Αιτήματα συμμετοχής',
    createdOn: 'Δημιουργήθηκε στις',
    areYouSureYouWantToDenyUser:
      'Είστε σίγουρος/η ότι θέλετε να αρνηθείτε την πρόσβαση σε αυτόν τον χρήστη;',
    cancel: 'Ακύρωση',
    deny: 'Άρνηση',
    requestOfOrganisation: 'Αίτημα του {{organisation}}',
    applications: 'Εφαρμογές',
    roles: 'Ρόλοι',
    signedLegalDocuments: 'Συμφωνημένα νομικά έγγραφα',
    accept: 'Αποδοχή',
    membershipRequestUpdateFailed: 'Ωχ, δεν ήταν δυνατή η ενημέρωση του αιτήματος συμμετοχής',
    membershipRequestUpdateSuccess: 'Το αίτημα συμμετοχής ενημερώθηκε',
    areYouSureYouWantToendMembership: 'Είστε σίγουρος/η ότι θέλετε να τερματίσετε τη συμμετοχή;',
    overview: 'Επισκόπηση',
    eMailaddress: 'Διεύθυνση e-mail (επαγγελματική)',
    membershipRequestAccepted: 'Το αίτημα συμμετοχής έγινε αποδεκτό',
    membershipRequestDenied: 'Το αίτημα συμμετοχής απορρίφθηκε',
    dashboard: 'Πίνακας ελέγχου',
    getLanguagesErr: 'Ωχ, δεν ήταν δυνατή η ανάκτηση των γλωσσών',
    getAuthorizationRolesErr: 'Ωχ, δεν ήταν δυνατή η ανάκτηση των ρόλων εξουσιοδότησης',
    getTimezonesErr: 'Ωχ, δεν ήταν δυνατή η ανάκτηση των ζωνών ώρας',
    getOrganisationStatsErr: 'Ωχ, δεν ήταν δυνατή η ανάκτηση των στατιστικών',
    users: 'Χρήστες',
    noUserPresent: 'Δεν υπάρχουν χρήστες',
    state: 'Κατάσταση',
    editUser: 'Επεξεργασία χρήστη',
    deleteUser: 'Αφαίρεση χρήστη',
    areYouSureYouWantToDeleteUser: 'Θέλετε να αφαιρέσετε τον/την {{userName}};',
    inviteNewUser: 'Πρόσκληση νέου χρήστη',
    save: 'Αποθήκευση',
    invite: 'Πρόσκληση',
    inviteUserSendEmailToAddress: 'Προσκαλέστε χρήστη, αποστολή e-mail στην ακόλουθη διεύθυνση:',
    createUserWithPassword: 'Δημιουργία χρήστη με κωδικό πρόσβασης:',
    enterPassword: 'Εισάγετε τον κωδικό πρόσβασης',
    forceUserToChooseNewPassword: 'Επιβολή επιλογής νέου κωδικού πρόσβασης κατά την πρώτη σύνδεση',
    pleaseEnterEmailAddress: 'Εισάγετε μια έγκυρη διεύθυνση e-mail',
    pleaseEnterRecipient: 'Εισάγετε έναν παραλήπτη',
    pleaseEnterPassword: 'Εισάγετε έναν κωδικό πρόσβασης',
    selectRole: 'Επιλέξτε τουλάχιστον έναν ρόλο.',
    usernameTaken: 'Αυτό το όνομα χρήστη χρησιμοποιείται ήδη',
    userUpdated: 'Ο χρήστης ενημερώθηκε',
    inviteUserFailed: 'Ωχ, δεν ήταν δυνατή η πρόσκληση χρήστη',
    inviteUser: 'Πρόσκληση χρήστη',
    userInvited: 'Ο χρήστης προσκλήθηκε',
    userDeleted: 'Ο χρήστης διαγράφηκε',
    deleteUserFailed: 'Ωχ, δεν ήταν δυνατή η διαγραφή χρήστη',
    delete: 'Διαγραφή',
    noOrganisationRegistrations: 'Δεν υπάρχουν εγγραφές οργανισμών',
    trustedDomains: 'Έμπιστος τομέας',
    trustedDomains_plural: 'Έμπιστοι τομείς',
    trustedDomainsOverview: 'Έμπιστοι τομείς',
    createTrustedDomainSuccess: 'Ο έμπιστος τομέας δημιουργήθηκε',
    createTrustedDomainFailed: 'Κάτι πήγε στραβά, δεν ήταν δυνατή η δημιουργία του έμπιστου τομέα',
    updateTrustedDomainSuccess: 'Ο έμπιστος τομέας ενημερώθηκε',
    addTrustedDomain: 'Προσθήκη έμπιστου τομέα',
    updateTrustedDomainFailed: 'Κάτι πήγε στραβά, δεν ήταν δυνατή η ενημέρωση του έμπιστου τομέα',
    domain: 'Τομέας',
    domainEmptyErr: 'Εισάγετε έναν τομέα',
    domainInvalidErr: 'Ελέγξτε το όνομα τομέα.',
    autoJoin: 'Αυτόματη συμμετοχή',

    /* community mgmt */
    remove: 'Αφαίρεση',
    organisation: 'Οργανισμός',
    areYouSureYouWantToDenyOrganisation:
      'Είστε σίγουρος/η ότι θέλετε να αρνηθείτε την πρόσβαση σε αυτόν τον οργανισμό;',
    areYouSureYouWantToRemoveTheRequest: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε το αίτημα;',
    myCommunity: 'Η κοινότητά μου',
    noMembersPresent: 'Δεν υπάρχουν μέλη.',
    addMember: 'Προσθήκη μέλους',
    edit: 'Επεξεργασία',
    endMembership: 'Ακύρωση συμμετοχής',
    editMembership: 'Επεξεργασία συμμετοχής',
    areYouSureYouWantToEndMembership:
      'Είστε σίγουρος/η ότι θέλετε να τερματίσετε τη συμμετοχή του {{organisationName}};',
    communityMembershipEnded: 'Η συμμετοχή στην κοινότητα τερματίστηκε',
    endCommunityMembershipFailed: 'Κάτι πήγε στραβά, δεν ήταν δυνατός ο τερματισμός της συμμετοχής',
    communityMembershipUpdate: 'Η συμμετοχή στην κοινότητα ενημερώθηκε',
    updateCommunityMembershipFailed:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η ενημέρωση της συμμετοχής στην κοινότητα',
    getCommunityMembershipFailed:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση της συμμετοχής στην κοινότητα',
    communityMembershipCreated: 'Δημιουργήθηκε μέλος κοινότητας',
    createCommunityMembershipFailed:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η δημιουργία μέλους κοινότητας',
    addACommunityMember: 'Προσθήκη μέλους κοινότητας',
    updateMembershipOf: 'Ενημέρωση συμμετοχής {{organisationName}}',
    members: 'Μέλη',
    getUserStatesErr: 'Κάτι πήγε στραβά, δεν ήταν δυνατή η λήψη των καταστάσεων χρηστών',
    rejectionNotice: 'Ειδοποίηση απόρριψης',
    addApp: 'Προσθήκη εφαρμογής',
    app: 'Εφαρμογή',
    actions: 'Ενέργειες',
    role: 'Ρόλος',
    registerError: 'Κάτι πήγε στραβά κατά την εγγραφή.',
    contactAdministrator:
      'Για περισσότερες πληροφορίες σχετικά με τη χρήση αυτού του Nallian Portal, επικοινωνήστε με τον διαχειριστή της κοινότητάς σας.',
    registerEmailDomainAsTrustedRequired:
      'Πρέπει να ενεργοποιήσετε ή να απενεργοποιήσετε αυτό το πεδίο.',
    proceed: 'Συνέχεια',
    privateCommunityTitle: 'Ιδιωτική κοινότητα',
    privateCommunityDescription:
      'Αυτή είναι μια ιδιωτική κοινότητα στην οποία δεν είναι δυνατή η συμμετοχή.',

    pleaseSelectOrganisation: 'Επιλέξτε έναν οργανισμό',
    pleaseSelectMinimumOneRole: 'Επιλέξτε τουλάχιστον έναν ρόλο',
    none: 'Κανένα',
    membershipRequestGetFailed:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση του αιτήματος συμμετοχής',
    getCommunityStatsErr: 'Κάτι πήγε στραβά, δεν ήταν δυνατή η λήψη στατιστικών κοινότητας',
    communityMember: 'Μέλος κοινότητας',
    registrationGetFailed: 'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση της εγγραφής',
    getTrustedDomainFailed: 'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση του έμπιστου τομέα',
    pleaseEnterAnEmailAddress: 'Εισάγετε μια διεύθυνση e-mail',
    noUsersPresent: 'Δεν υπάρχουν χρήστες',
    communities: 'Κοινότητες',
    noCommunitiesFound: 'Δεν βρέθηκαν κοινότητες',
    home: 'Αρχική',
    getIdentificationCodeTypesFailed:
      'Κάτι πήγε στραβά, απέτυχε η ανάκτηση των τύπων κωδικών αναγνώρισης',
    pleaseSelectAType: 'Επιλέξτε έναν τύπο',
    pleaseEnterAValue: 'Εισάγετε μια τιμή',
    disabled: 'Απενεργοποιημένο',
    unverified: 'Μη επαληθευμένο',
    verified: 'Επαληθευμένο',
    userState: 'Κατάσταση χρήστη',
    couldNotGetCommunityTemplate:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση της περιγραφής κοινότητας',
    getTermsAndConditionsFailed:
      'Κάτι πήγε στραβά, δεν ήταν δυνατή η ανάκτηση των όρων και προϋποθέσεων',
    chooseAPassword: 'Επιλέξτε έναν κωδικό πρόσβασης',
    newPassword: 'Νέος κωδικός πρόσβασης',
    confirmPassword: 'Επιβεβαίωση κωδικού πρόσβασης',
    userAccountReady: 'Ο λογαριασμός χρήστη είναι έτοιμος!',
    passwordResetSuccess:
      'Ο κωδικός πρόσβασής σας επαναφέρθηκε επιτυχώς. Μπορείτε τώρα να συνδεθείτε στις εφαρμογές σας.',
    failedContactOur: 'Η επαναφορά κωδικού απέτυχε, επικοινωνήστε με την',
    support: 'Υποστήριξη',
    department: 'υπηρεσία μας',
    pleaseConfirmUserAccount: 'Επιβεβαιώστε ότι αυτός είναι ο λογαριασμός χρήστη σας',
    confirm: 'Επιβεβαίωση',
    invalidToken: 'Μη έγκυρο token',
    needTechnicalSupport: 'Εάν χρειάζεστε τεχνική υποστήριξη, επικοινωνήστε με την',
    passwordMin8Char: 'Επιλέξτε κωδικό πρόσβασης τουλάχιστον 8 χαρακτήρων',
    passwordConfirmIncorrect: 'Η επιβεβαίωση του κωδικού πρόσβασης είναι λανθασμένη',
    pleaseEnterValidEmail: 'Εισάγετε μια έγκυρη διεύθυνση e-mail',
    forgotPassword: 'Ξεχάσατε τον κωδικό πρόσβασης',
    requestNewPassword: 'Αίτηση νέου κωδικού πρόσβασης',
    resetPasswordRequested: 'Ζητήθηκε επαναφορά κωδικού πρόσβασης!',
    resetPasswordRequestText:
      'Εάν είστε εγγεγραμμένος/η χρήστης, έχει σταλεί ένα e-mail στο γραμματοκιβώτιό σας για επαναφορά του κωδικού. Κάντε κλικ στον σύνδεσμο σε αυτό το e-mail για να συνεχίσετε. Μπορείτε τώρα να κλείσετε αυτό το παράθυρο.',
    somethingWentWrong: 'Κάτι πήγε στραβά',
    pleaseContactOur: 'Επικοινωνήστε με την',
    failedResentEmail: 'Απέτυχε η επανάληψη αποστολής του e-mail πρόσκλησης',
    resentEmailSuccess: 'Το e-mail πρόσκλησης στάλθηκε ξανά',
    ohNo: 'Ωχ όχι!',
    invitationExpired: 'Η πρόσκλησή σας έχει λήξει. Σας στέλνουμε νέα πρόσκληση:',
    resentInvitationEmail: 'Επανάληψη αποστολής e-mail πρόσκλησης',
    thanksForSubscribing: 'Σας ευχαριστούμε για την εγγραφή και καλώς ήρθατε στην πλατφόρμα!',
    activatedBasicAccount:
      'Ενεργοποιήσαμε τον βασικό σας λογαριασμό, ο οποίος θα σας επιτρέψει να έχετε πρόσβαση στις διάφορες εφαρμογές που είναι διαθέσιμες για τον λογαριασμό σας.',
    accessApplications:
      'Θα μπορείτε να έχετε πρόσβαση στις εφαρμογές μόλις λάβουμε τις σχετικές υπογεγραμμένες φόρμες συμφωνίας.',
    beAware:
      'Λάβετε υπόψη ότι για ορισμένες εφαρμογές ενδέχεται να ισχύει μεταγενέστερη ημερομηνία Go-Live.',
    contactUs: 'Επικοινωνήστε μαζί μας',
    ifQuestions: 'σε περίπτωση που έχετε ερωτήσεις.',
    failedToActivateUserAccount: 'Απέτυχε η ενεργοποίηση του λογαριασμού χρήστη',
    goodNews: 'Καλά νέα!',
    accountAlreadyActivated:
      'Ο λογαριασμός σας είναι ήδη ενεργοποιημένος. Παρακαλώ μεταβείτε στην εφαρμογή χρησιμοποιώντας τον σύνδεσμο όπως παρέχεται στις οδηγίες της εφαρμογής.',
    invalidTokenText:
      'Το token ενεργοποίησής σας δεν είναι έγκυρο, βεβαιωθείτε ότι χρησιμοποιείτε τον σύνδεσμο ενεργοποίησης από το τελευταίο e-mail πρόσκλησης που λάβατε. Εάν δεν λάβατε αυτό το e-mail (μην ξεχάσετε τον φάκελο SPAM!), μπορείτε πάντα να επικοινωνήσετε με την',
    passwordInvalidErr: 'Εισάγετε έναν έγκυρο κωδικό πρόσβασης',
    inviteSuccessMessage:
      'Ο λογαριασμός χρήστη σας έχει εγγραφεί επιτυχώς στην πλατφόρμα Nallian. Για να συνεχίσετε και να αρχίσετε να χρησιμοποιείτε τις εφαρμογές, κάντε κλικ στο "Συνέχεια" για σύνδεση στο Nallian Portal.',
    address: 'Διεύθυνση',
    getOrganisationIdentificationCodesFailed:
      'Απέτυχε η ανάκτηση των κωδικών αναγνώρισης οργανισμού',
    getOrganisationFailed: 'Απέτυχε η ανάκτηση των πληροφοριών οργανισμού',
    identificationCodes: 'Κωδικοί αναγνώρισης',
    getOrganisationAddressFailed: 'Απέτυχε η ανάκτηση της διεύθυνσης του οργανισμού',
    membershipOf: 'Συμμετοχή του {{organisation}}',
    organisationInfo: 'Πληροφορίες οργανισμού',
    noRolesFound: 'Δεν βρέθηκαν ρόλοι',
    noAppsFound: 'Δεν βρέθηκαν εφαρμογές',
    organisationUsers: 'Χρήστης',
    userReinvited: 'Ο χρήστης προσκλήθηκε ξανά',
    userReinviteFailed: 'Δεν ήταν δυνατή η εκ νέου πρόσκληση χρήστη',
    reinviteUser: 'Επανάληψη πρόσκλησης χρήστη',
    areYouSureReinvite: 'Είστε σίγουρος/η ότι θέλετε να προσκαλέσετε ξανά τον/την {{userName}};',
    yes: 'Ναι',
    no: 'Όχι',
    dontHaveAnAccountYet: 'Δεν έχετε λογαριασμό ακόμη;',
    registerHere: 'Εγγραφείτε εδώ!',
    inviteInfo:
      'Κάποιος από τον οργανισμό σας σας έχει προσκαλέσει να συμμετάσχετε στην πλατφόρμα. Επιβεβαιώστε ότι τα παρακάτω στοιχεία είναι δικά σας.',
    chooseAPasswordInfo:
      'Επιλέξτε έναν κωδικό πρόσβασης για να ολοκληρώσετε τη διαδικασία πρόσκλησης.',
    resetYourPassword: 'Επαναφορά του κωδικού πρόσβασής σας',
    createAnotherUser: 'Δημιουργία άλλου χρήστη',
    createdBy: 'Δημιουργήθηκε από',
    createCommunityMember: 'Δημιουργία μέλους κοινότητας',
    isTest: 'Είναι δοκιμή',
    isDefault: 'Είναι προεπιλογή',
    isMessageCode: 'Είναι κωδικός μηνύματος',
    code: 'Κωδικός',
    codeValue: 'Κωδικός',
    description: 'Περιγραφή',
    updateIdentificationCodeFailed: 'Η ενημέρωση κωδικού αναγνώρισης απέτυχε',
    updateIdentificationCodeSuccess: 'Η ενημέρωση κωδικού αναγνώρισης ολοκληρώθηκε',
    addIdentificationCodeFailed: 'Η προσθήκη κωδικού αναγνώρισης απέτυχε',
    addIdentificationCodeSuccess: 'Η προσθήκη κωδικού αναγνώρισης ολοκληρώθηκε',
    getIdentificationCodeFailed: 'Η ανάκτηση κωδικού αναγνώρισης απέτυχε',
    identificationCodeType: 'Τύπος κωδικού αναγνώρισης',
    removeIdentificationCode: 'Αφαίρεση κωδικού αναγνώρισης',
    add: 'Προσθήκη',
    editIdentificationCode: 'Επεξεργασία κωδικού αναγνώρισης',
    viewIdentificationCode: 'Προβολή κωδικού αναγνώρισης',
    routings: 'Δρομολογήσεις',
    order: 'Σειρά',
    regex: 'Regex',
    emailAddresses: 'Διευθύνσεις e-mail',
    toZendesk: 'Προς Zendesk',
    enabled: 'Ενεργοποιημένο',
    editRouting: 'Επεξεργασία δρομολόγησης',
    addRouting: 'Προσθήκη δρομολόγησης',
    removeRouting: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε αυτή τη δρομολόγηση;',
    toVoid: 'Προς ακύρωση',
    addAttachments: 'Προσθήκη συνημμένων',
    stopProcessing: 'Διακοπή επεξεργασίας',
    zendeskTags: 'Ετικέτες Zendesk',
    priority: 'Προτεραιότητα',
    mustFillInEmailNoZendeskAndNoVoid:
      'Πρέπει να συμπληρώσετε ένα e-mail εάν δεν είναι ενεργοποιημένο το "Προς ακύρωση" ή "Προς Zendesk"',
    nameEmptyErr: 'Συμπληρώστε ένα όνομα',
    orderEmptyErr: 'Συμπληρώστε μια σειρά',
    regexEmptyErr: 'Συμπληρώστε ένα regex',
    priorityIdEmptyErr: 'Επιλέξτε μια προτεραιότητα',
    routingsOrder: 'Σειρά δρομολογήσεων',
    updateRoutingsOrderSuccess: 'Η ενημέρωση της σειράς δρομολογήσεων ολοκληρώθηκε',
    updateRoutingsOrderFailed: 'Η ενημέρωση της σειράς δρομολογήσεων απέτυχε',
    saveOrder: 'Αποθήκευση σειράς',
    apiResources: 'Πόρος API',
    apiResources_plural: 'Πόροι API',
    tokenLifetime: 'Διάρκεια ζωής token',
    stsclients: 'STS Client',
    stsclients_plural: 'STS Clients',
    clientName: 'Όνομα πελάτη',
    clientId: 'Client ID',
    fillForm: 'Συμπλήρωση φόρμας',
    clientNameInfo:
      'Εμφανιζόμενο όνομα πελάτη (χρησιμοποιείται για logging και την οθόνη συναίνεσης)',
    clientIdInfo: 'Μοναδικό ID του πελάτη',
    clientUri: 'Client Uri',
    clientUriInfo:
      'URI για περαιτέρω πληροφορίες σχετικά με τον πελάτη (εμφανίζεται στην οθόνη συναίνεσης)',
    logoUri: 'Logo Uri',
    logoUriInfo: 'URI του λογότυπου του πελάτη (εμφανίζεται στην οθόνη συναίνεσης)',
    allowedScopes: 'Επιτρεπόμενα scopes',
    allowedScopesInfo:
      'Από προεπιλογή, ένας πελάτης δεν έχει πρόσβαση σε κανέναν πόρο — καθορίστε τους επιτρεπόμενους πόρους προσθέτοντας τα αντίστοιχα ονόματα scopes',
    allowedGranttypes: 'Επιτρεπόμενοι τύποι granttype',
    allowedGranttypesInfo:
      'Καθορίζει τους τύπους grant που επιτρέπεται να χρησιμοποιήσει ο πελάτης. Χρησιμοποιήστε την κλάση GrantTypes για συνηθισμένους συνδυασμούς.',
    protocolType: 'Τύπος πρωτοκόλλου',
    rowVersion: 'Έκδοση εγγραφής',
    enableClient: 'Ενεργοποίηση πελάτη',
    enableClientInfo: 'Καθορίζει εάν ο πελάτης είναι ενεργοποιημένος. Προεπιλογή: true.',
    allowOfflineAccessInfo:
      'Καθορίζει εάν αυτός ο πελάτης μπορεί να ζητά refresh token (ζητώντας το scope offline_access)',
    allowOfflineAccess: 'Επιτρέπονται refresh token',
    requireClientSecret: 'Απαιτείται client secret',
    requireClientSecretInfo:
      'Καθορίζει εάν αυτός ο πελάτης χρειάζεται secret για να ζητά token από το token endpoint (προεπιλογή: true)',
    noAppSubscriptionRequired: 'Δεν απαιτείται συνδρομή εφαρμογής',
    allowAccessTokensViaBrowser: 'Επιτρέπονται access token μέσω browser',
    allowAccessTokensViaBrowserInfo:
      'Καθορίζει εάν αυτός ο πελάτης επιτρέπεται να λαμβάνει access token μέσω του browser. Χρήσιμο για την ενίσχυση των ροών που επιτρέπουν πολλαπλούς τύπους απάντησης (π.χ. αποτρέποντας έναν hybrid flow πελάτη που χρησιμοποιεί code id_token από το να προσθέσει τύπο απάντησης token και να διαρρεύσει το token στον browser).',
    requirePkce: 'Απαιτείται PKCE',
    requirePkceInfo:
      'Καθορίζει εάν οι πελάτες που χρησιμοποιούν grant type βασισμένο σε authorization code πρέπει να στέλνουν proof key (προεπιλογή: true).',
    allowPlainTextPkce: 'Επιτρέπεται plain text PKCE',
    allowPlainTextPkceInfo:
      'Καθορίζει εάν οι πελάτες που χρησιμοποιούν PKCE μπορούν να χρησιμοποιήσουν plain text code challenge (δεν συνιστάται — προεπιλογή: false)',
    redirectUrisInfo: 'Καθορίζει τα επιτρεπόμενα URI για επιστροφή token ή authorization code',
    redirectUris: 'Redirect uris',
    postLogoutRedirectUris: 'Post logout redirect uris',
    postLogoutRedirectUrisInfo:
      'Καθορίζει τα επιτρεπόμενα URI για ανακατεύθυνση μετά το logout. Δείτε το OIDC Connect Session Management spec για περισσότερες λεπτομέρειες.',
    identityProviderRestrictions: 'Περιορισμοί παρόχου ταυτότητας',
    identityProviderRestrictionsInfo:
      'Καθορίζει ποιοι εξωτερικοί IdP μπορούν να χρησιμοποιηθούν με αυτόν τον πελάτη (εάν η λίστα είναι κενή, επιτρέπονται όλοι οι IdP). Προεπιλογή: κενό.',
    frontChannelLogoutSessionRequired: 'Απαιτείται frontchannel logoutsession',
    frontChannelLogoutSessionRequiredInfo:
      'Καθορίζει εάν το session id του χρήστη πρέπει να αποστέλλεται στο FrontChannelLogoutUri. Προεπιλογή: true.',
    frontChannelLogoutUri: 'Front channel logout uri',
    frontChannelLogoutUriInfo:
      'Καθορίζει το URI logout στον πελάτη για HTTP based front-channel logout. Δείτε το OIDC Front-Channel spec για περισσότερες λεπτομέρειες.',
    backChannelLogoutSessionRequired: 'Απαιτείται backchannel logoutsession',
    backChannelLogoutSessionRequiredInfo:
      'Καθορίζει εάν το session id του χρήστη πρέπει να αποστέλλεται στο αίτημα προς το BackChannelLogoutUri. Προεπιλογή: true.',
    backChannelLogoutUri: 'Logout-uri:',
    backChannelLogoutUriInfo:
      'Καθορίζει το URI logout στον πελάτη για HTTP based back-channel logout. Δείτε το OIDC Back-Channel spec για περισσότερες λεπτομέρειες.',
    logoutSession: 'Συνεδρία αποσύνδεσης',
    enableLocalLogin: 'Ενεργοποίηση τοπικής σύνδεσης',
    enableLocalLoginInfo:
      'Καθορίζει εάν αυτός ο πελάτης μπορεί να χρησιμοποιεί τοπικούς λογαριασμούς ή μόνο εξωτερικούς IdP. Προεπιλογή: true.',
    accessTokenLifetime: 'Διάρκεια ζωής access token',
    accessTokenLifetimeInfo:
      'Διάρκεια ζωής του access token σε δευτερόλεπτα (προεπιλογή: 3600 δευτερόλεπτα / 1 ώρα)',
    absoluteRefreshTokenLifetime: 'Απόλυτη διάρκεια ζωής refresh token',
    absoluteRefreshTokenLifetimeInfo:
      'Μέγιστη διάρκεια ζωής ενός refresh token σε δευτερόλεπτα. Προεπιλογή: 2592000 δευτερόλεπτα / 30 ημέρες',
    identityTokenLifetime: 'Διάρκεια ζωής identity token',
    identityTokenLifetimeInfo:
      'Διάρκεια ζωής του identity token σε δευτερόλεπτα (προεπιλογή: 300 δευτερόλεπτα / 5 λεπτά)',
    authorizationCodeLifetime: 'Διάρκεια ζωής authorization code',
    authorizationCodeLifetimeInfo:
      'Διάρκεια ζωής του authorization code σε δευτερόλεπτα (προεπιλογή: 300 δευτερόλεπτα / 5 λεπτά)',
    slidingRefreshTokenLifetime: 'Sliding διάρκεια ζωής refresh token',
    slidingRefreshTokenLifetimeInfo:
      'Sliding διάρκεια ζωής ενός refresh token σε δευτερόλεπτα. Προεπιλογή: 1296000 δευτερόλεπτα / 15 ημέρες',
    clientClaimsPrefix: 'Πρόθεμα client claims',
    clientClaimsPrefixInfo:
      'Εάν οριστεί, οι τύποι client claim θα έχουν αυτό το πρόθεμα. Προεπιλογή: client_. Σκοπός είναι να διασφαλιστεί ότι δεν θα συγκρούονται κατά λάθος με τα user claims.',
    pairWiseSubjectSalt: 'Pair wise subject salt',
    pairWiseSubjectSaltInfo:
      'Τιμή salt που χρησιμοποιείται για τη δημιουργία pair-wise subjectId για τους χρήστες αυτού του πελάτη.',
    updateAccessTokenClaimsOnRefresh: 'Ενημέρωση των claims του access token κατά την ανανέωση',
    updateAccessTokenClaimsOnRefreshInfo:
      'Λαμβάνει ή ορίζει μια τιμή που υποδεικνύει εάν το access token (και τα claims του) πρέπει να ενημερώνεται κατά το αίτημα refresh token.',
    accessTokenType: 'Reference access token',
    accessTokenTypeInfo:
      'Καθορίζει εάν το access token είναι reference token ή self-contained JWT token (προεπιλογή: Jwt).',
    includeJwtId: 'Συμπερίληψη JWT ID',
    includeJwtIdInfo:
      'Καθορίζει εάν τα JWT access tokens πρέπει να έχουν ενσωματωμένο μοναδικό ID (μέσω του claim jti). Προεπιλογή: true.',
    alwaysSendClientClaims: 'Πάντα αποστολή client claims',
    alwaysSendClientClaimsInfo:
      'Εάν οριστεί, τα client claims θα αποστέλλονται για κάθε flow. Διαφορετικά, μόνο για το client credentials flow (προεπιλογή: false)',
    alwaysIncludeUserClaimsInIdToken: 'Πάντα συμπερίληψη user claims στο identity token',
    alwaysIncludeUserClaimsInIdTokenInfo:
      'Όταν ζητούνται και id token και access token, να προστίθενται πάντα τα user claims στο id token αντί να απαιτείται από τον πελάτη να χρησιμοποιήσει το userinfo endpoint. Προεπιλογή: false.',
    allowedCorsOriginsInfo:
      'Εάν καθοριστεί, θα χρησιμοποιηθεί από τις προεπιλεγμένες υλοποιήσεις της υπηρεσίας CORS policy (In-Memory και EF) για τη δημιουργία πολιτικής CORS για JavaScript πελάτες.',
    allowedCorsOrigins: 'Επιτρεπόμενα CORS origins',
    consentLifetimeInfo:
      'Διάρκεια ζωής της συναίνεσης χρήστη σε δευτερόλεπτα. Προεπιλογή: null (χωρίς λήξη).',
    consentLifetime: 'Διάρκεια ζωής συναίνεσης',
    requireConsent: 'Απαιτείται συναίνεση',
    requireConsentInfo: 'Καθορίζει εάν απαιτείται οθόνη συναίνεσης. Προεπιλογή: false.',
    allowRememberConsent: 'Επιτρέπεται απομνημόνευση συναίνεσης',
    allowRememberConsentInfo:
      'Καθορίζει εάν ο χρήστης μπορεί να επιλέξει να αποθηκεύσει τις αποφάσεις συναίνεσης. Προεπιλογή: true.',
    refreshTokenUsage: 'Χρήση refresh token',
    refreshTokenUsageInfo:
      "'ReUse' το refresh token handle θα παραμείνει το ίδιο κατά την ανανέωση token. 'OneTime' το refresh token handle θα ενημερώνεται κατά την ανανέωση token. Αυτή είναι η προεπιλογή.",
    refreshTokenExpiration: 'Λήξη refresh token',
    refreshTokenExpirationInfo:
      "'Absolute' το refresh token θα λήξει σε σταθερό χρονικό σημείο (όπως καθορίζεται από το AbsoluteRefreshTokenLifetime). Αυτή είναι η προεπιλογή. 'Sliding' κατά την ανανέωση του token, η διάρκεια ζωής του refresh token θα ανανεώνεται (κατά το ποσό που καθορίζεται στο SlidingRefreshTokenLifetime). Η διάρκεια ζωής δεν θα υπερβαίνει το AbsoluteRefreshTokenLifetime.",
    reUse: 'Επαναχρήση',
    oneTimeOnly: 'Μόνο μία φορά',
    sliding: 'Sliding',
    absolute: 'Απόλυτη',
    updateUserFailed: 'Η ενημέρωση χρήστη απέτυχε',
    getUserFailed: 'Η ανάκτηση χρήστη απέτυχε',
    isHidden: 'Κρυφό',
    isOwner: 'Ιδιοκτήτης',
    updateSuiteFailed: 'Η ενημέρωση της σουίτας απέτυχε',
    updateSuiteSuccess: 'Η ενημέρωση της σουίτας ολοκληρώθηκε',
    suites_plural: 'Σουίτες',
    suites: 'Σουίτα',
    tiers: 'Επίπεδα',
    apps: 'Εφαρμογή',
    allApplications: 'Όλες οι εφαρμογές',
    appCountSingular: '{{count}} εφαρμογή',
    appCountPlural: '{{count}} εφαρμογές',
    addAppFeature: 'Προσθήκη χαρακτηριστικού εφαρμογής',
    tierApps: 'Εφαρμογές επιπέδου',
    suite: 'Σουίτα',
    tier: 'Επίπεδο',
    suiteTier: 'Επίπεδο',
    suiteIdEmptyErr: 'Επιλέξτε μια σουίτα',
    suiteTierIdEmptyErr: 'Επιλέξτε ένα επίπεδο',
    timezone: 'Ζώνη ώρας',
    communityMembers: 'μέλος κοινότητας',
    communityMembers_plural: 'Μέλη κοινότητας',
    getCommunityRolesFailed: 'Η ανάκτηση ρόλων κοινότητας απέτυχε',
    myApps: 'Οι εφαρμογές μου',
    principalJoinRequests: 'Αιτήματα συμμετοχής',
    selectExistingUser:
      'Αναζητήστε έναν υπάρχοντα χρήστη (αυτό θα αντικαταστήσει το προφίλ του υπάρχοντος χρήστη με τις παρακάτω πληροφορίες)',
    acceptJoinRequestFor: 'Αποδοχή αιτήματος συμμετοχής του/της {{user}}',
    preApproveForLinking: 'Προέγκριση για σύνδεση',
    areYouSureYouWantToUnlinkIdentity:
      'Είστε σίγουρος/η ότι θέλετε να αποσυνδέσετε τον λογαριασμό από τον χρήστη;',
    preApproveForLinkingInfo:
      'Αυτόματη έγκριση του αιτήματος συμμετοχής εάν κάποιος θέλει να συνδέσει τον λογαριασμό του με αυτόν τον χρήστη',
    acceptJoinRequestFailed: 'Η αποδοχή αιτήματος συμμετοχής απέτυχε',
    acceptJoinRequestSuccess: 'Η αποδοχή αιτήματος συμμετοχής ολοκληρώθηκε',
    viewOrganisation: 'Προβολή οργανισμού',
    myIdentity: 'Ο λογαριασμός μου',
    active: 'Ενεργό',
    activeState: 'Ενεργή κατάσταση',
    activeStatus: 'Ενεργή κατάσταση',
    addApplication: 'Προσθήκη εφαρμογής',
    addAppSubscription: 'Προσθήκη συνδρομής εφαρμογής',
    addCommunityRoleFailed: 'Δεν ήταν δυνατή η προσθήκη του ρόλου κοινότητας',
    addCommunityRoleSuccess: 'Ο ρόλος κοινότητας προστέθηκε',
    addFeature: 'Προσθήκη χαρακτηριστικού',
    addOwner: 'Προσθήκη ιδιοκτήτη',
    addRole: 'Προσθήκη ρόλου',
    addSubscription: 'Προσθήκη συνδρομής',
    addSuite: 'Προσθήκη σουίτας',
    addTier: 'Προσθήκη επιπέδου',
    addUser: 'Προσθήκη χρήστη',
    alias: 'Ψευδώνυμο',
    aliasEmptyErr: 'Εισάγετε ένα ψευδώνυμο',
    appDetailsAliasEmptyErr: 'Εισάγετε ένα ψευδώνυμο',
    appDetailsTagEmptyErr: 'Επιλέξτε μια εφαρμογή',
    appDetailsUrlEmptyErr: 'Εισάγετε ένα url',
    appFeatures: 'Χαρακτηριστικά εφαρμογής',
    appInstallationFeatureTagEmptyErr: 'Επιλέξτε ένα χαρακτηριστικό',
    appInstallationIdEmptyErr: 'Επιλέξτε μια εφαρμογή',
    appInstallations: 'Εγκαταστάσεις εφαρμογής',
    application: 'Εφαρμογή',
    apps_plural: 'Εφαρμογές',
    appSubscription: 'Συνδρομή εφαρμογής',
    appTypeIdEmptyErr: 'Επιλέξτε έναν τύπο εφαρμογής',
    areYouSureRemoveIdentificationCodeType:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε αυτόν τον τύπο κωδικού αναγνώρισης;',
    areYouSureRemoveOnboardingTemplate:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε αυτό το πρότυπο onboarding;',
    areYouSureRemovePrincipal:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε τον/την {{name}} ({{email}});',
    areYouSureActivatePrincipal: 'Είστε σίγουρος/η ότι θέλετε να ενεργοποιήσετε τον/την {{name}};',
    activatePrincipal: 'Ενεργοποίηση χρήστη',
    activate: 'Ενεργοποίηση',
    activatePrincipalSuccess: 'Ο χρήστης ενεργοποιήθηκε',
    activatePrincipalFailed: 'Δεν ήταν δυνατή η ενεργοποίηση του χρήστη',
    areYouSureRemoveRelation: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε αυτή τη σχέση;',
    areYouSureYouWantToDenyJoinRequest:
      'Είστε σίγουρος/η ότι θέλετε να απορρίψετε αυτό το αίτημα συμμετοχής;',
    cityEmptyErr: 'Συμπληρώστε μια πόλη',
    close: 'Κλείσιμο',
    community: 'Κοινότητα',
    communityApps: 'Εφαρμογή κοινότητας',
    communityApps_plural: 'Εφαρμογές κοινότητας',
    communityMemberCreatedAndInvited: 'Το μέλος κοινότητας δημιουργήθηκε και ο χρήστης προσκλήθηκε',
    communityMemberCreatedAndInvitedError:
      'Δεν ήταν δυνατή η δημιουργία του μέλους κοινότητας και η πρόσκληση του χρήστη',
    communityRoles: 'Ρόλος κοινότητας',
    communityRoles_plural: 'Ρόλοι κοινότητας',
    communitySuites: 'Σουίτα κοινότητας',
    communitySuites_plural: 'Σουίτες κοινότητας',
    communityInfo: 'Πληροφορίες κοινότητας',
    communityManagement: 'Διαχείριση κοινότητας',
    confirmInvitationInfo:
      'Επιβεβαιώστε ότι τα παρακάτω στοιχεία είναι σωστά. Στα επόμενα βήματα μπορείτε να συμπληρώσετε τις πληροφορίες του λογαριασμού σας και να ολοκληρώσετε τη διαδικασία εγγραφής.',
    couldNotCompleteInvitation:
      'Δυστυχώς δεν ήταν δυνατή η ολοκλήρωση της πρόσκλησής σας.<0></0>Δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξή μας <1>{{text}}</1>.',
    countryEmptyErr: 'Επιλέξτε μια χώρα',
    createAppFailed: 'Δεν ήταν δυνατή η δημιουργία της εφαρμογής',
    createAppSubscriptionFailed: 'Δεν ήταν δυνατή η δημιουργία της συνδρομής εφαρμογής',
    createAppSubscriptionSuccess: 'Η συνδρομή εφαρμογής δημιουργήθηκε',
    createAppSuccess: 'Η εφαρμογή δημιουργήθηκε',
    createCommunityAppFailed: 'Δεν ήταν δυνατή η δημιουργία της εφαρμογής κοινότητας',
    createCommunityAppSuccess: 'Η εφαρμογή κοινότητας δημιουργήθηκε',
    createCommunityMemberFailed: 'Δεν ήταν δυνατή η δημιουργία μέλους κοινότητας',
    createCommunityMemberSuccess: 'Το μέλος κοινότητας δημιουργήθηκε',
    createCommunitySuiteFailed: 'Δεν ήταν δυνατή η δημιουργία σουίτας κοινότητας',
    createCommunitySuiteSuccess: 'Η σουίτα κοινότητας δημιουργήθηκε',
    createIdentificationCodeTypeFailed: 'Δεν ήταν δυνατή η δημιουργία τύπου κωδικού αναγνώρισης',
    createIdentificationCodeTypeSuccess: 'Ο τύπος κωδικού αναγνώρισης δημιουργήθηκε',
    createNewMember: 'Δημιουργία νέου μέλους',
    createNewOrganisation: 'Δημιουργία νέου οργανισμού',
    createOnboardingTemplateFailed: 'Δεν ήταν δυνατή η δημιουργία του προτύπου onboarding',
    createOnboardingTemplateSuccess: 'Το πρότυπο onboarding δημιουργήθηκε',
    createOrganisationRoleFailed: 'Δεν ήταν δυνατή η δημιουργία του ρόλου οργανισμού',
    createOrganisationRoleSuccess: 'Ο ρόλος οργανισμού δημιουργήθηκε',
    createPrincipalFailed: 'Δεν ήταν δυνατή η δημιουργία του χρήστη',
    createPrincipalSuccess: 'Ο χρήστης δημιουργήθηκε',
    createRelationFailed: 'Δεν ήταν δυνατή η δημιουργία της σχέσης',
    createRelationSuccess: 'Η σχέση δημιουργήθηκε',
    createRelationTypeFailed: 'Δεν ήταν δυνατή η δημιουργία του τύπου σχέσης',
    createRelationTypeSuccess: 'Ο τύπος σχέσης δημιουργήθηκε',
    createSuiteFailed: 'Δεν ήταν δυνατή η δημιουργία της σουίτας',
    createSuiteSuccess: 'Η σουίτα δημιουργήθηκε',
    createUserFailed: 'Δεν ήταν δυνατή η δημιουργία του χρήστη',
    createUserSuccess: 'Ο χρήστης δημιουργήθηκε',
    defaultCommunity: 'Προεπιλεγμένη κοινότητα',
    deleted: 'Διαγραμμένο',
    denyJoinRequestFailed: 'Δεν ήταν δυνατή η απόρριψη του αιτήματος συμμετοχής',
    denyJoinRequestSuccess: 'Το αίτημα συμμετοχής απορρίφθηκε',
    markUniqueJoinRequestFailed:
      'Δεν ήταν δυνατή η σήμανση του αιτήματος συμμετοχής ως μη διπλότυπο',
    markUniqueJoinRequestSuccess: 'Το αίτημα συμμετοχής σημάνθηκε ως μη διπλότυπο',
    markNotDuplicateConfirmation:
      'Σήμανση αυτού του αιτήματος συμμετοχής ως μη διπλότυπο. Η κατάσταση θα αλλάξει σε «Νέο» και θα ειδοποιηθεί ο διαχειριστής της κοινότητας.',
    descriptionEmptyErr: 'Συμπληρώστε μια περιγραφή',
    details: 'Λεπτομέρειες',
    displayName: 'Εμφανιζόμενο όνομα',
    editApp: 'Επεξεργασία εφαρμογής',
    editCommunityApp: 'Επεξεργασία εφαρμογής κοινότητας',
    editCommunityMember: 'Επεξεργασία μέλους κοινότητας',
    editCommunityRole: 'Επεξεργασία ρόλου κοινότητας',
    editFeature: 'Επεξεργασία χαρακτηριστικού',
    editOrganisationRole: 'Επεξεργασία ρόλου οργανισμού',
    editSubscription: 'Επεξεργασία συνδρομής',
    email: 'Διεύθυνση e-mail',
    emailAddress: 'Διεύθυνση e-mail',
    emailAddressEmptyErr: 'Συμπληρώστε μια διεύθυνση e-mail',
    emailOrPhoneNumberRequiredError: 'Απαιτείται έγκυρη διεύθυνση e-mail ή αριθμός τηλεφώνου',
    externalIdentifier: 'Εξωτερικό αναγνωριστικό',
    feature: 'Χαρακτηριστικό',
    featureName: 'Όνομα χαρακτηριστικού',
    features: 'Χαρακτηριστικά',
    featureSubscriptions: 'Συνδρομές',
    subscriptions: 'Συνδρομές',
    subscriptionRequired: 'Απαιτείται συνδρομή',
    noSubscriptionRequired: 'Δεν απαιτείται συνδρομή',
    firstSelectAFeature: 'Επιλέξτε πρώτα ένα χαρακτηριστικό',
    firstSelectAnApp: 'Επιλέξτε πρώτα μια εφαρμογή',
    fullNameEmptyErr: 'Εισάγετε ένα πλήρες όνομα',
    general: 'Γενικά',
    getAppFailed: 'Δεν ήταν δυνατή η ανάκτηση της εφαρμογής',
    getAppInstallationFailed: 'Δεν ήταν δυνατή η ανάκτηση της εγκατάστασης εφαρμογής',
    getAppInstallationsFailed: 'Δεν ήταν δυνατή η ανάκτηση των εγκαταστάσεων εφαρμογής',
    getAppsFailed: 'Δεν ήταν δυνατή η ανάκτηση των εφαρμογών',
    getAppSubscriptionsFailed: 'Δεν ήταν δυνατή η ανάκτηση των συνδρομών εφαρμογής',
    getAvailableRolesFailed: 'Δεν ήταν δυνατή η ανάκτηση των διαθέσιμων ρόλων',
    getCommunityAppsFailed: 'Δεν ήταν δυνατή η ανάκτηση των εφαρμογών κοινότητας',
    getCommunityMemberRolesFailed: 'Δεν ήταν δυνατή η ανάκτηση των ρόλων για αυτόν τον οργανισμό',
    getIdentificationCodeTypeFailed: 'Δεν ήταν δυνατή η ανάκτηση του τύπου αναγνώρισης',
    getJoinRequestFailed: 'Δεν ήταν δυνατή η ανάκτηση του αιτήματος συμμετοχής',
    getOnboardingTemplateFailed: 'Δεν ήταν δυνατή η ανάκτηση του προτύπου onboarding',
    getOrganisationRolesFailed: 'Δεν ήταν δυνατή η ανάκτηση των ρόλων',
    getPrincipalFailed: 'Δεν ήταν δυνατή η ανάκτηση του χρήστη',
    getRelationFailed: 'Δεν ήταν δυνατή η ανάκτηση της σχέσης',
    getRelationsFailed: 'Δεν ήταν δυνατή η ανάκτηση των σχέσεων',
    getRelationTypeFailed: 'Δεν ήταν δυνατή η ανάκτηση του τύπου σχέσης',
    getRelationTypesFailed: 'Δεν ήταν δυνατή η ανάκτηση των τύπων σχέσης',
    getSuiteFailed: 'Δεν ήταν δυνατή η ανάκτηση της σουίτας',
    getSuitesFailed: 'Δεν ήταν δυνατή η ανάκτηση των σουιτών',
    global: 'Παγκόσμιο',
    here: 'εδώ',
    hostedAt: 'Φιλοξενείται στο',
    identificationcodetypes: 'Τύπος κωδικού αναγνώρισης',
    identificationcodetypes_plural: 'Τύποι κωδικών αναγνώρισης',
    identities: 'Λογαριασμοί',
    identity: 'Λογαριασμός',
    inactive: 'Ανενεργό',
    installationIndex: 'Δείκτης εγκατάστασης',
    introducedInVersion: 'Εισήχθη στην έκδοση',
    introducedInVersionEmptyErr: 'Εισάγετε σε ποια έκδοση εισήχθη αυτό το χαρακτηριστικό',
    invalidInvitation1: 'Κάτι πήγε στραβά κατά τη λήψη της πρόσκλησής σας.',
    invalidInvitation2: 'Μπορεί να έχει λήξει ή να μην υπάρχει.',
    invitationExpiresOn: 'Η πρόσκληση λήγει στις',
    invitationInfo:
      'Ο/Η <bold>{{username}}</bold> από τον οργανισμό <bold>{{organisation}}</bold> σας προσκαλεί να συμμετάσχετε στην κοινότητα <bold>{{community}}</bold>.',
    invitationSentOn: 'Η πρόσκληση στάλθηκε στις',
    invitationState: 'Κατάσταση πρόσκλησης',
    invitationType: 'Τύπος πρόσκλησης',
    invited: 'Προσκλήθηκε',
    inviteFreeText: 'Προσθέστε ένα μήνυμα που θα συμπεριληφθεί στο e-mail πρόσκλησης',
    isCustomer: 'Είναι πελάτης',
    isGloballyManaged: 'Διαθέσιμο για διαχειριστές κοινότητας',
    isOptional: 'Προαιρετικό',
    isSystem: 'Είναι σύστημα',
    isVisible: 'Ορατό',
    joinMessage: 'Το μήνυμά σας προς τον διαχειριστή κοινότητας',
    joinRequestAcceptedInfo: 'Αγαπητέ/ή {{fullName}}, το αίτημα συμμετοχής σας εγκρίθηκε.',
    joinRequestError: 'Δεν ήταν δυνατή η αποστολή του αιτήματος συμμετοχής',
    joinRequestErrorMessage:
      'Κάτι πήγε στραβά κατά την αποστολή του αιτήματός σας στον διαχειριστή κοινότητας. Παρακαλώ δοκιμάστε ξανά αργότερα.',
    joinRequests: 'Αιτήματα συμμετοχής',
    joinRequestSentToCommunityAdmin: 'Το αίτημα συμμετοχής στάλθηκε στους διαχειριστές κοινότητας',
    joinRequestSentToCommunityAdminDescription:
      'Το αίτημα συμμετοχής σας στάλθηκε στους διαχειριστές κοινότητας ώστε να σας δώσουν πρόσβαση στις εφαρμογές της κοινότητας.',
    new: 'Νέο',
    notADuplicate: 'Μη διπλότυπο',
    potentialDuplicate: 'Πιθανό διπλότυπο',
    potentialDuplicates: 'Πιθανά διπλότυπα',
    potentialDuplicateTooltip: 'Αυτό το αίτημα ελέγχεται από τη Nallian πριν προχωρήσει.',
    potentialDuplicationDetails: 'Λεπτομέρειες πιθανού διπλότυπου',
    potentialDuplicateCannotManage:
      'Επειδή αυτό το αίτημα συμμετοχής ενδέχεται να είναι πιθανό διπλότυπο, ελέγχεται από τη Nallian πριν προχωρήσει. Αυτό το αίτημα συμμετοχής δεν μπορεί να γίνει αποδεκτό ή να απορριφθεί προς το παρόν.',
    duplicateByIdentificationCode:
      'Αυτό το διπλότυπο εντοπίστηκε από έναν ή περισσότερους κωδικούς αναγνώρισης που ταιριάζουν',
    joinRequest: 'Αίτημα συμμετοχής',
    score: 'Βαθμολογία',
    languageEmptyErr: 'Επιλέξτε μια γλώσσα',
    languageIdEmptyErr: 'Επιλέξτε μια γλώσσα',
    linkExistingOrganisation: 'Σύνδεση υπάρχοντος οργανισμού',
    linkIdentityFailed: 'Δεν ήταν δυνατή η σύνδεση του λογαριασμού με τον χρήστη',
    linkIdentitySuccess: 'Ο λογαριασμός συνδέθηκε με τον χρήστη',
    linkMyIdentityToPrincipal: 'Σύνδεση του λογαριασμού μου με χρήστη',
    location: 'Τοποθεσία',
    lockedOut: 'Κλειδωμένος',
    management: 'Διαχείριση',
    mine: '(ο λογαριασμός μου)',
    newApp: 'Νέα εφαρμογή',
    newAppSubscription: 'Νέα συνδρομή εφαρμογής',
    newCommunityApp: 'Νέα εφαρμογή κοινότητας',
    newCommunityMember: 'Νέο μέλος κοινότητας',
    newCommunityRole: 'Νέος ρόλος κοινότητας',
    newCommunitySuite: 'Νέα σουίτα κοινότητας',
    newFeature: 'Νέο χαρακτηριστικό',
    newIdentificationCodeType: 'Προσθήκη τύπου',
    newOnboardingTemplate: 'Νέο πρότυπο onboarding',
    newOrganisationRole: 'Νέος ρόλος οργανισμού',
    newRelation: 'Νέα σχέση',
    newRelationType: 'Νέος τύπος σχέσης',
    newSuite: 'Νέα σουίτα',
    newUser: 'Νέος χρήστης',
    noAppsConfiguredForOnboardingTemplate: 'Δεν έχουν διαμορφωθεί εφαρμογές για το πρότυπο.',
    noFeaturesDefined: 'Δεν έχουν οριστεί χαρακτηριστικά',
    noFeaturesDefinedYet: 'Δεν έχουν διαμορφωθεί ακόμη χαρακτηριστικά',
    noFeaturesFound: 'Δεν βρέθηκαν χαρακτηριστικά',
    noLinkedAccountsYet: 'Δεν υπάρχουν συνδεδεμένοι λογαριασμοί ακόμη.',
    noPendingInvitationsFound: 'Δεν βρέθηκαν εκκρεμείς προσκλήσεις',
    noRolesDefined: 'Δεν έχουν οριστεί ρόλοι',
    noSuitesFound: 'Δεν βρέθηκαν σουίτες',
    noTiersFound: 'Δεν βρέθηκαν επίπεδα',
    noUsersFound: 'Δεν βρέθηκαν χρήστες',
    noAssignmentsFound: 'Δεν βρέθηκαν αναθέσεις',
    noSubscriptionsFound: 'Δεν βρέθηκαν συνδρομές',
    subscriptionId: 'Subscription ID',
    createFeatureSubscription: 'Δημιουργία συνδρομής χαρακτηριστικού',
    createSubscription: 'Δημιουργία συνδρομής',
    createFeatureSubscriptionSuccess: 'Η συνδρομή χαρακτηριστικού δημιουργήθηκε επιτυχώς',
    createFeatureSubscriptionFailed: 'Απέτυχε η δημιουργία της συνδρομής χαρακτηριστικού',
    createRoleAssignmentSuccess: 'Η ανάθεση ενημερώθηκε.',
    createRoleAssignmentFailed: 'Απέτυχε η προσθήκη του χρήστη στον ρόλο',
    removeUser: 'Αφαίρεση χρήστη',
    areYouSureRemoveRoleAssignment:
      'Είστε σίγουροι ότι θέλετε να αφαιρέσετε τον χρήστη {{name}} - {{email}} από αυτόν τον ρόλο;',
    removeRoleAssignmentSuccess: 'Ο χρήστης αφαιρέθηκε από τον ρόλο.',
    removeRoleAssignmentFailed: 'Απέτυχε η αφαίρεση του χρήστη από τον ρόλο',
    addSubscription: 'Προσθήκη συνδρομής',
    addSubscriptionSuccess: 'Η συνδρομή ενημερώθηκε.',
    addSubscriptionFailed: 'Απέτυχε η προσθήκη της συνδρομής',
    removeOrgSubscription: 'Αφαίρεση συνδρομής',
    areYouSureRemoveOrgSubscription:
      'Είστε σίγουροι ότι θέλετε να αφαιρέσετε τη συνδρομή του χαρακτηριστικού: {{featureName}} - Εγκατάσταση: {{installationName}} - Εφαρμογή: {{appName}} από τον οργανισμό {{organisationName}}; Η πρόσβαση σε αυτό το χαρακτηριστικό θα ανακληθεί για όλους τους χρήστες αυτού του οργανισμού.',
    removeOrgSubscriptionSuccess: 'Η συνδρομή αφαιρέθηκε.',
    removeOrgSubscriptionFailed: 'Απέτυχε η αφαίρεση της συνδρομής',
    communityIdEmptyErr: 'Παρακαλώ επιλέξτε μια κοινότητα',
    organisationIdEmptyErr: 'Παρακαλώ επιλέξτε έναν οργανισμό',
    principalIdEmptyErr: 'Παρακαλώ επιλέξτε έναν χρήστη',
    assignmentType: 'Τύπος ανάθεσης',
    assignments: 'Αναθέσεις',
    principalName: 'Όνομα χρήστη',
    organisationCityEmptyErr: 'Εισάγετε μια πόλη',
    organisationCountryEmptyErr: 'Εισάγετε μια χώρα',
    organisationDetailsDescription: 'Συμπληρώστε τα στοιχεία του οργανισμού',
    organisationNameEmptyErr: 'Εισάγετε ένα όνομα οργανισμού',
    organisationRole: 'Ρόλος οργανισμού',
    organisationRoles: 'Ρόλος οργανισμού',
    organisationRoles_plural: 'Ρόλοι οργανισμού',
    organisationType: 'Τύπος οργανισμού',
    organisations: 'Οργανισμοί',
    organisationsOverview: 'Επισκόπηση οργανισμών',
    owners: 'Ιδιοκτήτες',
    parentOrganisation: 'Γονικός οργανισμός',
    passwordToDelete: 'Κωδικός για διαγραφή',
    pending: 'Σε εκκρεμότητα',
    pendingInvitations: 'Εκκρεμής πρόσκληση',
    pendingInvitations_plural: 'Εκκρεμείς προσκλήσεις',
    phoneNumber: 'Αριθμός τηλεφώνου',
    pleaseAcceptOurTermsAndConditions: 'Παρακαλώ αποδεχτείτε τους όρους και τις προϋποθέσεις μας',
    pleaseCompleteOrganisationDetails: 'Συμπληρώστε τα στοιχεία του οργανισμού σας παρακάτω.',
    postalCodeEmptyErr: 'Συμπληρώστε έναν ταχυδρομικό κώδικα',
    primaryEmailAddressEmptyErr: 'Εισάγετε μια έγκυρη διεύθυνση e-mail',
    primaryPhoneNumberEmptyErr: 'Εισάγετε έναν έγκυρο αριθμό τηλεφώνου',
    principalFullNameEmptyErr: 'Εισάγετε ένα πλήρες όνομα',
    principalLanguageIdEmptyErr: 'Επιλέξτε μια γλώσσα',
    principals: 'χρήστης',
    principalTimeZoneEmptyErr: 'Επιλέξτε μια ζώνη ώρας',
    reInvite: 'Εκ νέου πρόσκληση',
    relationType: 'Σχέση',
    relationTypeIdEmptyErr: 'Επιλέξτε έναν τύπο σχέσης',
    relationTypes: 'Τύπος σχέσης',
    relationTypes_plural: 'Τύποι σχέσης',
    removeApp: 'Αφαίρεση εφαρμογής',
    removeAppAndRoles: 'Αφαίρεση εφαρμογής, χαρακτηριστικών & ρόλων',
    removeAppSubscriptionFailed: 'Η αφαίρεση συνδρομής απέτυχε',
    removeAppSubscriptionSuccess: 'Η αφαίρεση συνδρομής ολοκληρώθηκε',
    removeFeature: 'Αφαίρεση χαρακτηριστικού',
    removeThisFeature: 'Αφαίρεση αυτού του χαρακτηριστικού',
    removeThisRole: 'Αφαίρεση ρόλου',
    removeThisSuite: 'Αφαίρεση αυτής της σουίτας',
    removeThisTier: 'Αφαίρεση αυτού του επιπέδου',
    requestToJoin: 'Αίτημα συμμετοχής',
    requestToJoinInfo:
      'Εάν ο οργανισμός σας θέλει να συμμετάσχει σε αυτή την κοινότητα, παρακαλώ συμπληρώστε τη φόρμα.<br/>Ο διαχειριστής κοινότητας θα εξετάσει την αίτησή σας και θα επικοινωνήσει σύντομα μαζί σας.',
    requiresSubscription: 'Απαιτείται συνδρομή',
    resendInvitationFailed: 'Δεν ήταν δυνατή η επανάληψη αποστολής της πρόσκλησης',
    resendInvitationSuccess: 'Η πρόσκληση στάλθηκε ξανά',
    resetPassword: 'Επαναφορά κωδικού πρόσβασης',
    reviewJoinRequest: 'Έλεγχος αιτήματος συμμετοχής',
    selectAnApp: 'Επιλέξτε μια εφαρμογή',
    selectAnApplication: 'Επιλέξτε μια εφαρμογή',
    sendInvitation: 'Αποστολή πρόσκλησης',
    sometingWentWrong: 'Κάτι πήγε στραβά',
    source: 'Πηγή',
    sourceIdEmptyErr: 'Επιλέξτε μια πηγή',
    sourceOrganisationRoles: 'Ρόλοι οργανισμού πηγής',
    stateName: 'Κατάσταση',
    status: 'Κατάσταση',
    streetAndNumberEmptyErr: 'Συμπληρώστε οδό & αριθμό',
    tag: 'Ετικέτα',
    tagEmptyErr: 'Συμπληρώστε μια ετικέτα',
    tagExplainer: 'Ξεκινά με αλφαβητικό χαρακτήρα, μέγιστο μήκος 20',
    target: 'Στόχος',
    targetIdEmptyErr: 'Επιλέξτε έναν στόχο',
    targetOrganisationRoles: 'Ρόλοι οργανισμού στόχου',
    template: 'Πρότυπο',
    templateHasNoConfiguration: 'Το πρότυπο δεν έχει διαμόρφωση',
    templateInfo1:
      'Ένα πρότυπο θα δώσει στον διαχειριστή πρόσβαση σε ένα σύνολο εφαρμογών και έναν κατάλογο ρόλων οργανισμού.',
    templateInfo2: 'Επιλέξτε ένα πρότυπο για να δείτε τη διαμόρφωσή του',
    textMessage: 'Μήνυμα κειμένου',
    noUserGroupsFound: 'Δεν βρέθηκαν ομάδες χρηστών',
    areYouSureRemoveUserGroup: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε αυτή την ομάδα χρηστών;',
    createUserGroupFailed: 'Δεν ήταν δυνατή η δημιουργία ομάδας χρηστών',
    createUserGroupSuccess: 'Η ομάδα χρηστών δημιουργήθηκε',
    updateUserGroupFailed: 'Δεν ήταν δυνατή η ενημέρωση της ομάδας χρηστών',
    updateUserGroupSuccess: 'Η ομάδα χρηστών ενημερώθηκε',
    getUserGroupFailed: 'Δεν ήταν δυνατή η ανάκτηση της ομάδας χρηστών',
    addUserGroup: 'Προσθήκη ομάδας χρηστών',
    newUserGroup: 'Νέα ομάδα χρηστών',
    noAppsFeaturesRolesDefined: 'Δεν έχουν οριστεί εφαρμογές, χαρακτηριστικά, ρόλοι',
    createUserGroupMemberFailed: 'Δεν ήταν δυνατή η δημιουργία μέλους ομάδας χρηστών',
    createUserGroupMemberSuccess: 'Το μέλος ομάδας χρηστών δημιουργήθηκε',
    removeUserGroupMemberFailed: 'Δεν ήταν δυνατή η αφαίρεση μέλους ομάδας χρηστών',
    removeUserGroupMemberSuccess: 'Το μέλος ομάδας χρηστών αφαιρέθηκε',
    getUserGroupMembersFailed: 'Δεν ήταν δυνατή η ανάκτηση των μελών ομάδας χρηστών',
    membersOfUserGroup: 'Μέλη της ομάδας χρηστών',
    timezoneEmptyErr: 'Επιλέξτε μια ζώνη ώρας',
    timeZoneEmptyErr: 'Επιλέξτε μια ζώνη ώρας',
    timeZoneIdEmptyErr: 'Επιλέξτε μια ζώνη ώρας',
    unauthorized: 'Δεν είστε εξουσιοδοτημένος/η για αυτή την ενέργεια.',
    unlink: 'Αποσύνδεση',
    unlinkIdentityFailed: 'Δεν ήταν δυνατή η αποσύνδεση του λογαριασμού',
    unlinkIdentitySuccess: 'Ο λογαριασμός αποσυνδέθηκε',
    unlisted: 'Μη καταχωρημένο',
    updateAppFailed: 'Δεν ήταν δυνατή η ενημέρωση της εφαρμογής',
    updateAppSubscriptionFailed: 'Δεν ήταν δυνατή η ενημέρωση της συνδρομής εφαρμογής',
    updateAppSubscriptionSuccess: 'Η συνδρομή εφαρμογής ενημερώθηκε',
    updateAppSuccess: 'Η εφαρμογή ενημερώθηκε',
    updateCommunityAppFailed: 'Δεν ήταν δυνατή η ενημέρωση της εφαρμογής κοινότητας',
    updateCommunityAppSuccess: 'Η εφαρμογή κοινότητας ενημερώθηκε',
    updateCommunityMemberFailed: 'Δεν ήταν δυνατή η ενημέρωση του μέλους κοινότητας',
    updateCommunityMemberRolesFailed: 'Δεν ήταν δυνατή η ενημέρωση των ρόλων μέλους κοινότητας',
    updateCommunityMemberRolesSuccess: 'Οι ρόλοι μέλους κοινότητας ενημερώθηκαν',
    updateCommunityMemberSuccess: 'Το μέλος κοινότητας ενημερώθηκε',
    updateCommunityRoleFailed: 'Δεν ήταν δυνατή η ενημέρωση του ρόλου κοινότητας',
    updateCommunityRoleSuccess: 'Ο ρόλος κοινότητας ενημερώθηκε',
    updateCommunitySuiteFailed: 'Δεν ήταν δυνατή η ενημέρωση της σουίτας κοινότητας',
    updateCommunitySuiteSuccess: 'Η σουίτα κοινότητας ενημερώθηκε',
    updateIdentificationCodeTypeFailed: 'Δεν ήταν δυνατή η ενημέρωση του τύπου κωδικού αναγνώρισης',
    updateIdentificationCodeTypeSuccess: 'Ο τύπος κωδικού αναγνώρισης ενημερώθηκε',
    updateOnboardingTemplateFailed: 'Δεν ήταν δυνατή η ενημέρωση του προτύπου onboarding',
    updateOnboardingTemplateSuccess: 'Το πρότυπο onboarding ενημερώθηκε',
    updateOrganisationRoleFailed: 'Δεν ήταν δυνατή η ενημέρωση του ρόλου οργανισμού',
    updateOrganisationRoleSuccess: 'Ο ρόλος οργανισμού ενημερώθηκε',
    updatePrincipalFailed: 'Δεν ήταν δυνατή η ενημέρωση του χρήστη',
    updatePrincipalSuccess: 'Ο χρήστης ενημερώθηκε',
    updateRelationFailed: 'Δεν ήταν δυνατή η ενημέρωση της σχέσης',
    updateRelationSuccess: 'Η σχέση ενημερώθηκε',
    updateRelationTypeFailed: 'Δεν ήταν δυνατή η ενημέρωση του τύπου σχέσης',
    updateRelationTypeSuccess: 'Ο τύπος σχέσης ενημερώθηκε',
    updateUserSuccess: 'Ο χρήστης ενημερώθηκε',
    url: 'Url',
    urlEmptyErr: 'Εισάγετε ένα url',
    useATemplate: 'Χρήση προτύπου',
    user: 'Χρήστης',
    userDetailsDescription: 'Συμπληρώστε τα στοιχεία του χρήστη',
    validationPattern: 'Μοτίβο επικύρωσης',
    verifiedStatus: 'Κατάσταση επαλήθευσης',
    view: 'Προβολή',
    viewMore: 'Περισσότερα',
    viewSubscribedOrganisations: 'Προβολή εγγεγραμμένων οργανισμών',
    viewTemplate: 'Προβολή προτύπου',
    welcomeToThePlatform: 'Καλώς ήρθατε στην πλατφόρμα!',
    welcomeToThePlatformInfo:
      'Ο λογαριασμός χρήστη σας έχει εγγραφεί επιτυχώς στην πλατφόρμα Nallian. Για να συνεχίσετε και να αρχίσετε να χρησιμοποιείτε τις εφαρμογές, κάντε κλικ στο "Συνέχεια" για σύνδεση στο Nallian Portal.',
    searchAndAddMember: 'Αναζήτηση και προσθήκη μέλους',
    searchForNameOrEmailOfUser: 'Αναζήτηση ονόματος ή e-mail χρήστη',
    editUserGroup: 'Επεξεργασία ομάδας χρηστών',
    manageMembers: 'Προβολή/διαχείριση μελών',
    userGroupHasNoMembers: 'Αυτή η ομάδα χρηστών δεν έχει μέλη',
    organisationsForRole: 'Οργανισμοί για ρόλο κοινότητας',
    noOrganisationsFound: 'Δεν βρέθηκαν οργανισμοί',
    viewOrganisations: 'Προβολή οργανισμών',
    appSubscriptions: 'Συνδρομές εφαρμογών',
    createdByOrganisation: 'Δημιουργήθηκε από οργανισμό',
    metaData: 'Μεταδεδομένα',
    lastModifiedOn: 'Τελευταία τροποποίηση στις',
    linkedAccounts: 'Συνδεδεμένοι λογαριασμοί',
    relations: 'Σχέσεις',
    youHaveBeenInvited: 'Έχετε προσκληθεί',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε τη συνδρομή για αυτό το χαρακτηριστικό; Η πρόσβαση σε αυτό το χαρακτηριστικό θα ανακληθεί για όλους τους χρήστες αυτού του οργανισμού.',
    applyOnboardingTemplate: 'Εφαρμογή προτύπου onboarding',
    getOnboardingTemplatesFailed: 'Δεν ήταν δυνατή η ανάκτηση των προτύπων onboarding',
    selectAnOnboardingTemplate: 'Επιλέξτε ένα πρότυπο onboarding',
    onboardingTemplateIdEmptyErr: 'Επιλέξτε ένα πρότυπο onboarding',
    applyOnboardingTemplateFailed: 'Δεν ήταν δυνατή η εφαρμογή του προτύπου onboarding',
    applyOnboardingTemplateSuccess: 'Το πρότυπο onboarding εφαρμόστηκε',
    addTemplateInfo:
      'Το πρότυπο θα προσθέσει τις παρακάτω εφαρμογές & ρόλους κοινότητας στον οργανισμό',
    filters: 'Φίλτρα',
    filterOnUserRole: 'Φίλτρο ρόλου χρήστη',
    identityOrClient: 'Λογαριασμός ή client',
    searchForAnIdentityOrAddClientId: 'Αναζήτηση λογαριασμού ή προσθήκη client ID',
    filterOnIdentificationCode: 'Φίλτρο κωδικού αναγνώρισης',
    useNoTemplate: 'Χωρίς πρότυπο',
    templateInfo: 'Επιλέξτε ένα πρότυπο',
    userInfo: 'Πληροφορίες χρήστη',
    invalidUrlCommuntiyAppFeature: 'Πρέπει να είναι έγκυρο URL ή να περιέχει [EnvironmentUrl]',
    communitiesOverview: 'Επισκόπηση κοινοτήτων',
    createCommunityFailed: 'Δεν ήταν δυνατή η δημιουργία της κοινότητας',
    createCommunitySuccess: 'Η κοινότητα δημιουργήθηκε',
    newCommunity: 'Νέα κοινότητα',
    themeName: 'Όνομα θέματος',
    defaultLanguage: 'Προεπιλεγμένη γλώσσα',
    mustBeValidUrl: 'Πρέπει να είναι έγκυρο URL',
    updateCommunityFailed: 'Δεν ήταν δυνατή η ενημέρωση της κοινότητας',
    updateCommunitySuccess: 'Η κοινότητα ενημερώθηκε',
    fixedCommunityId:
      'ID (μη υποχρεωτικό, μόνο εάν θέλετε το ίδιο ID κοινότητας σε όλα τα περιβάλλοντα)',
    updateNotificationSettingsFailed: 'Δεν ήταν δυνατή η ενημέρωση των ρυθμίσεων ειδοποιήσεων',
    updateNotificationSettingsSuccess: 'Οι ρυθμίσεις ειδοποιήσεων ενημερώθηκαν',
    notificationSettings: 'Ρυθμίσεις ειδοποιήσεων',
    fromName: 'Από όνομα',
    fromEmail: 'Από e-mail',
    replyToEmail: 'E-mail απάντησης',
    replyToName: 'Όνομα απάντησης',
    emailSubjectPrefix: 'Πρόθεμα θέματος e-mail',
    contactEmail: 'E-mail επικοινωνίας',
    updateHostsFailed: 'Δεν ήταν δυνατή η ενημέρωση των hosts',
    updateHostsSuccess: 'Οι hosts ενημερώθηκαν',
    noHostsYet: 'Δεν υπάρχουν hosts ακόμη',
    addHost: 'Προσθήκη host',
    host: 'Host',
    hosts: 'Hosts',
    isPrimary: 'Είναι κύριο',
    onlyOnePrimaryHost: 'Μόνο ένας host μπορεί να είναι κύριος',
    minOnePrimaryHost: 'Τουλάχιστον ένας host πρέπει να είναι κύριος',
    pleaseEnterAHost: 'Εισάγετε έναν (έγκυρο) host',
    tenantId: 'Tenant ID',
    tenantHostUrl: 'Tenant host url',
    tenantInformation: 'Πληροφορίες tenant',

    communityWelcomeText: 'Κείμενο καλωσορίσματος κοινότητας',
    legalDocuments: 'Νομικά έγγραφα',
    uploadNewGeneralTermsAndConditions: 'Μεταφόρτωση νέων Γενικών Όρων & Προϋποθέσεων',
    documents: 'Έγγραφα',
    title: 'Τίτλος',
    revision: 'Αναθεώρηση',
    download: 'Λήψη',
    // theme lookups (internal)
    themeLookups_plural: 'Theme lookups',
    newThemeLookup: 'Νέο theme lookup',
    createThemeLookupFailed: 'Δεν ήταν δυνατή η δημιουργία theme lookup',
    createThemeLookupSuccess: 'Το theme lookup δημιουργήθηκε',
    updateThemeLookupFailed: 'Δεν ήταν δυνατή η ενημέρωση του theme lookup',
    updateThemeLookupSuccess: 'Το theme lookup ενημερώθηκε',
    editThemeLookup: 'Επεξεργασία theme lookup',
    themeLookups: 'Theme lookup',
    titleEmptyErr: 'Εισάγετε έναν τίτλο',
    hostEmptyErr: 'Εισάγετε έναν host',
    themeNameEmptyErr: 'Εισάγετε ένα όνομα θέματος',
    editCommunityTextFailed: 'Δεν ήταν δυνατή η ενημέρωση του κειμένου κοινότητας',
    editCommunityTextSuccess: 'Το κείμενο κοινότητας ενημερώθηκε',
    documentUploaded: 'Το έγγραφο μεταφορτώθηκε',
    documentUploadFailed: 'Η μεταφόρτωση του εγγράφου απέτυχε',
    noCommunityTextYet: 'Δεν υπάρχει κείμενο καλωσορίσματος κοινότητας ακόμη',
    noDocumentsYet: 'Δεν υπάρχουν έγγραφα ακόμη',
    noWelcomeTextAvailable:
      'Δεν υπάρχουν διαθέσιμες πληροφορίες καλωσορίσματος για αυτή την κοινότητα.',
    addLanguage: 'Προσθήκη γλώσσας',
    enterLanguageKey: 'Εισάγετε το κλειδί γλώσσας σας',
    emailNotificationFooter: 'Υποσέλιδο ειδοποίησης e-mail',
    emailNotificationHeader: 'Κεφαλίδα ειδοποίησης e-mail',
    removeCommunityAppClientFailed: 'Δεν ήταν δυνατή η αφαίρεση του client',
    removeCommunityAppClientSuccess: 'Ο client αφαιρέθηκε',
    createCommunityAppClientFailed: 'Δεν ήταν δυνατή η δημιουργία του client',
    createCommunityAppClientSuccess: 'Ο client δημιουργήθηκε',
    getCommunityAppClientsFailed: 'Δεν ήταν δυνατή η ανάκτηση των clients',
    manageClientsForCommunityApp: 'Διαχείριση clients',
    addClient: 'Προσθήκη client',
    manageAppClients: 'Διαχείριση clients εφαρμογής',
    noClientsYet: 'Δεν υπάρχουν clients ακόμη',
    unknownIdentityProvider: 'Άγνωστος πάροχος ταυτότητας',
    areYouSureRemoveOrganisation:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε τον οργανισμό "{{item.name}}";',
    timeSettings: 'Ρυθμίσεις ώρας',
    userDetails: 'Στοιχεία χρήστη',
    appsAndRoles: 'Εφαρμογές & ρόλοι',
    accountsIdentities: 'Συνδεδεμένοι λογαριασμοί',
    accounts: 'Λογαριασμοί',
    areYouSureContinueWithoutUserHasRoles:
      'Είστε σίγουρος/η ότι δεν θέλετε να δώσετε πρόσβαση σε καμία εφαρμογή για αυτόν τον χρήστη;',
    principalRemoved: 'Ο χρήστης αφαιρέθηκε',
    userGroups: 'Ομάδες χρηστών',
    userGroup: 'Ομάδα χρηστών',
    selectUserGroups: 'Επιλέξτε ομάδες χρηστών',
    rolesFromUserGroups: 'Ρόλοι από ομάδες χρηστών',
    noRolesInUserGroup: 'Δεν έχουν ανατεθεί ρόλοι σε αυτή την ομάδα χρηστών',
    noRolesInSelectedUserGroups: 'Δεν έχουν ανατεθεί ρόλοι στις επιλεγμένες ομάδες χρηστών',
    data: 'Δεδομένα',
    id: 'ID',
    shortName: 'Σύντομο όνομα',
    installations: 'Εγκαταστάσεις',
    isGlobal: 'Είναι παγκόσμιο',
    isCrossCommunity: 'Είναι διακοινοτικό',
    isObsolete: 'Είναι παρωχημένο',
    copyToClipboard: 'Αντιγραφή στο πρόχειρο',
    administrators: 'Διαχειριστές',
    welcomeText: 'Κείμενο καλωσορίσματος κοινότητας',
    overviewText: 'Κείμενο επισκόπησης αρχικής σελίδας',
    pleaseTypeToEnableConfirmButton:
      'Πληκτρολογήστε "{{message}}" για να ενεργοποιηθεί το κουμπί επιβεβαίωσης.',
    pleaseTypeHere: 'Πληκτρολογήστε εδώ',
    removeOrganisation: 'Αφαίρεση οργανισμού',
    removeOrganisationFailed: 'Δεν ήταν δυνατή η αφαίρεση του οργανισμού',
    removeOrganisationSuccess: 'Ο οργανισμός αφαιρέθηκε',
    removeAppInstallation: 'Αφαίρεση εγκατάστασης εφαρμογής',
    areYouSureRemoveAppInstallation:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε την εγκατάσταση εφαρμογής "{{item.name}}";',
    removeAppInstallationFailed: 'Δεν ήταν δυνατή η αφαίρεση της εγκατάστασης εφαρμογής',
    removeAppInstallationSuccess: 'Η εγκατάσταση εφαρμογής αφαιρέθηκε',
    areYouSureRemoveApp: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε την εφαρμογή "{{item.name}}";',
    removeAppFailed: 'Δεν ήταν δυνατή η αφαίρεση της εφαρμογής',
    removeAppSuccess: 'Η εφαρμογή αφαιρέθηκε',
    roleInFeature: 'Ρόλος στο {{featureName}}',
    featureInInstallation: 'Χαρακτηριστικό στην {{installationName}}',
    installationOfApp: 'Εγκατάσταση του {{appName}}',
    installation: 'Εγκατάσταση',
    removeFeatureSubscriptionFailed: 'Δεν ήταν δυνατή η αφαίρεση της συνδρομής χαρακτηριστικού',
    removeFeatureSubscriptionSuccess: 'Η συνδρομή χαρακτηριστικού αφαιρέθηκε',
    removeSubscription: 'Αφαίρεση συνδρομής',
    areYouSureRemoveSubscription:
      'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε τη συνδρομή για το "{{organisationName}}";',
    identificationCodesCount: '{{count}} κωδικός/-οί αναγνώρισης',
    noIdentificationCodes: 'Δεν υπάρχουν κωδικοί αναγνώρισης',
    principalCount: '{{count}} χρήστης/-ες',
    noPrincipals: 'Δεν υπάρχουν χρήστες',
    errorLoadingPrincipals: 'Σφάλμα κατά τη φόρτωση των χρηστών',
    unnamed: 'Χωρίς όνομα',
    linkedPrincipals: 'Συνδεδεμένοι χρήστες',
    allIdentities: 'Όλες οι ταυτότητες',
    provider: 'Πάροχος',
    anonymizeIdentity: 'Ανωνυμοποίηση ταυτότητας',
    areYouSureYouWantToAnonymiseIdentity:
      'Είστε σίγουρος/η ότι θέλετε να ανωνυμοποιήσετε την ταυτότητα του/της {{fullName}};',
    anonymizeIdentitySuccess: 'Η ταυτότητα ανωνυμοποιήθηκε επιτυχώς',
    anonymizeIdentityFailed: 'Απέτυχε η ανωνυμοποίηση της ταυτότητας',
    noIdentitiesFound: 'Δεν βρέθηκαν ταυτότητες',
    typeMinimum2Characters: 'Πληκτρολογήστε τουλάχιστον 2 χαρακτήρες',
    startWithPlusEgFormat: 'Ξεκινήστε με +, π.χ. +30',
    noRoles: 'Χωρίς ρόλους',
    rolesCount: '{{count}} ρόλος/-οι',
    noIdentificationCodeTypesFound: 'Δεν βρέθηκαν τύποι κωδικών αναγνώρισης',
    isRequired: 'Υποχρεωτικό',
    identificationCodeTypeTagEmptyErr: 'Επιλέξτε έναν τύπο κωδικού αναγνώρισης',
    editType: 'Επεξεργασία τύπου',
    theFollowingIdentificationCodeTypesAreRequired:
      'Λείπουν οι ακόλουθοι κωδικοί αναγνώρισης: {{missingTypes}}',
    updateContactFailed: 'Δεν ήταν δυνατή η ενημέρωση της επαφής',
    updateContactSuccess: 'Η επαφή ενημερώθηκε',
    createContactFailed: 'Δεν ήταν δυνατή η δημιουργία της επαφής',
    createContactSuccess: 'Η επαφή δημιουργήθηκε',
    removeContactFailed: 'Δεν ήταν δυνατή η αφαίρεση της επαφής',
    removeContactSuccess: 'Η επαφή αφαιρέθηκε',
    contacts: 'Επαφές',
    noContactsYet: 'Δεν υπάρχουν επαφές ακόμη.',
    newContact: 'Νέα επαφή',
    editContact: 'Επεξεργασία επαφής',
    areYouSureYouWantToRemoveContact: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε αυτή την επαφή;',
    logo: 'Λογότυπο',
    uploadANewLogo: 'Μεταφόρτωση νέου λογότυπου',
    noLogoAvailable: 'Δεν υπάρχει λογότυπο ακόμη.',
    viewLogo: 'Προβολή λογότυπου',
    uploadLogo: 'Μεταφόρτωση λογότυπου',
    removeOrganisationLogoFailed: 'Δεν ήταν δυνατή η αφαίρεση του λογότυπου',
    removeOrganisationLogoSuccess: 'Το λογότυπο αφαιρέθηκε',
    uploadLogoSuccess: 'Το λογότυπο μεταφορτώθηκε',
    uploadLogoError: 'Δεν ήταν δυνατή η μεταφόρτωση του λογότυπου',
    removeLogo: 'Αφαίρεση λογότυπου',
    areYouSureYouWantToRemoveLogo: 'Είστε σίγουρος/η ότι θέλετε να αφαιρέσετε το λογότυπο;',
    fileEmptyErr: 'Μεταφορτώστε ένα έγκυρο αρχείο',
    noFeatureDetails: 'Δεν υπάρχουν λεπτομέρειες χαρακτηριστικού',
    pleaseSelectRoles: 'Επιλέξτε έναν ή περισσότερους ρόλους',
    idpUserGroup: 'Αυτόματα διαχειριζόμενη ομάδα χρηστών',
    idpUserGroupInfo:
      'Αυτή η ομάδα διατηρείται ενημερωμένη με τη λίστα χρηστών του οργανισμού σας. Μπορείτε ακόμα να προσθέτετε χρήστες χειροκίνητα — αλλά εάν κάποιος συνδεθεί μέσω του συστήματος σύνδεσης της εταιρείας σας, οι αλλαγές σας ενδέχεται να αναιρεθούν την επόμενη φορά που θα συνδεθεί.',
    viaIdp: 'Αυτόματη ανάθεση',
    invitationIsExpired: 'Αυτή η πρόσκληση έχει λήξει',
    inviationNotValidAnymore: 'Αυτή η πρόσκληση έχει ανακληθεί',
    invitationUsedProceedLogin:
      'Φαίνεται ότι αυτή η πρόσκληση έχει ήδη χρησιμοποιηθεί. Μπορείτε να προχωρήσετε και να συνδεθείτε στον λογαριασμό σας.',
    invitationUsedProceedProcess:
      'Αυτή η πρόσκληση έχει ήδη χρησιμοποιηθεί, αλλά ο λογαριασμός σας είναι σχεδόν έτοιμος. Για να ολοκληρώσετε την εγγραφή σας, συνδεθείτε, συμπληρώστε τα στοιχεία της εταιρείας σας και αποδεχτείτε τους όρους και τις προϋποθέσεις.',
    completeRegistration: 'Ολοκλήρωση εγγραφής',
    signIn: 'Σύνδεση',
    inviteAlreadyUsed: 'Η πρόσκληση έχει ήδη χρησιμοποιηθεί',
    updateOrganisationFailed: 'Δεν ήταν δυνατή η ενημέρωση του οργανισμού',
    organisationUpdated: 'Ο οργανισμός ενημερώθηκε',
    getCommunityRoleFailed: 'Δεν ήταν δυνατή η ανάκτηση του ρόλου κοινότητας',
    createOrganisation: 'Δημιουργία οργανισμού',
    organisationCreated: 'Ο οργανισμός δημιουργήθηκε',
    createOrganisationFailed: 'Δεν ήταν δυνατή η δημιουργία του οργανισμού',
    onboardingTemplates: 'Πρότυπα onboarding',
    identificationCodeTypes: 'Τύποι κωδικών αναγνώρισης',
    notification: 'Ειδοποίηση',
    textsAndLegal: 'Κείμενα & νομικά',
    exportAsJSON: 'Εξαγωγή ως JSON',
    addContact: 'Προσθήκη επαφής',
    selectCommunityForInvitation:
      'Επιλέξτε το πλαίσιο κοινότητας στο οποίο θέλετε να στείλετε την πρόσκληση',
    allUsers: 'Όλοι οι χρήστες',
    codeCannotHaveTrailingSpaces: 'Ο κωδικός δεν μπορεί να έχει κενά στο τέλος',
    deleteRole: 'Διαγραφή ρόλου',
    areYouSureDeleteRole: 'Είστε σίγουρος/η ότι θέλετε να διαγράψετε τον ρόλο "{{name}}";',
    pleaseTypeRoleNameToConfirm: 'Πληκτρολογήστε "{{name}}" για επιβεβαίωση',
    acknowledgeRoleNotObsolete:
      'Κατανοώ ότι αυτός ο ρόλος δεν έχει ακόμη επισημανθεί ως παρωχημένος και επιθυμώ να τον διαγράψω',
    removeRoleFailed: 'Απέτυχε η αφαίρεση του ρόλου',
    removeRoleSuccess: 'Ο ρόλος αφαιρέθηκε επιτυχώς',
    deleteFeature: 'Διαγραφή χαρακτηριστικού',
    areYouSureDeleteFeature:
      'Είστε σίγουρος/η ότι θέλετε να διαγράψετε το χαρακτηριστικό "{{name}}";',
    pleaseTypeFeatureNameToConfirm: 'Πληκτρολογήστε "{{name}}" για επιβεβαίωση',
    acknowledgeFeatureNotObsolete:
      'Κατανοώ ότι αυτό το χαρακτηριστικό δεν έχει ακόμη επισημανθεί ως παρωχημένο και επιθυμώ να το διαγράψω',
    removeFeatureFailed: 'Απέτυχε η αφαίρεση του χαρακτηριστικού',
    removeFeatureSuccess: 'Το χαρακτηριστικό αφαιρέθηκε επιτυχώς',
    noFeaturesYet: 'Δεν υπάρχουν χαρακτηριστικά ακόμη',

    /* documents */
    documentsOverview: 'Επισκόπηση εγγράφων',
    uploadDocument: 'Μεταφόρτωση εγγράφου',
    documentType: 'Τύπος εγγράφου',
    documentType_CompanyEmployeeRegistration: 'Καταχώρηση εργαζομένου εταιρείας',
    documentType_AirportAccreditation: 'Διαπίστευση αεροδρομίου',
    documentType_Passport: 'Διαβατήριο',
    documentType_DriverLicense: 'Δίπλωμα οδήγησης',
    documentType_IDCard: 'Δελτίο ταυτότητας',
    selectDocumentType: 'Επιλέξτε τύπο εγγράφου',
    fileUpload: 'Μεταφόρτωση αρχείου',
    documentName: 'Όνομα εγγράφου',
    fileSize: 'Μέγεθος αρχείου',
    uploadedBy: 'Μεταφορτώθηκε από',
    uploadedAt: 'Μεταφορτώθηκε στις',
    expirationDate: 'Ημερομηνία λήξης',
    expirationDateHelperText:
      'Η ημερομηνία πρέπει να είναι σήμερα ή αργότερα, έως 10 έτη από σήμερα',
    validated: 'Επικυρωμένο',
    expired: 'Έληξε',
    superseded: 'Αντικαταστάθηκε',
    rejected: 'Απορρίφθηκε',
    expiring: 'Πλησιάζει η λήξη',
    approve: 'Έγκριση',
    reject: 'Απόρριψη',
    preview: 'Προεπισκόπηση',
    history: 'Ιστορικό',
    pleaseSelectDocumentType: 'Επιλέξτε έναν τύπο εγγράφου',
    unsupportedFileType: 'Μη υποστηριζόμενος τύπος αρχείου. Επιτρέπονται μόνο αρχεία JPEG και PNG.',
    fileTooLarge: 'Το αρχείο είναι πολύ μεγάλο. Το μέγιστο μέγεθος αρχείου είναι 10 MB.',
    expirationDateRequired: 'Επιλέξτε μια ημερομηνία λήξης',
    expirationDatePast: 'Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν',
    expirationDateTooFar: 'Η ημερομηνία λήξης δεν μπορεί να είναι πάνω από 10 έτη στο μέλλον',
    uploadSuccessful: 'Το έγγραφο μεταφορτώθηκε επιτυχώς',
    uploadFailed: 'Η μεταφόρτωση του εγγράφου απέτυχε',
    documentApproved: 'Το έγγραφο εγκρίθηκε επιτυχώς',
    documentPreviewTitle: 'Προεπισκόπηση εγγράφου',
    documentPreviewCaption:
      'Ευαίσθητες πληροφορίες έχουν αποκρυβεί για λόγους προστασίας απορρήτου',
    documentPreviewError: 'Δεν είναι δυνατή η φόρτωση της προεπισκόπησης. Παρακαλώ δοκιμάστε ξανά.',
    documentApproveWarning:
      'Εγκρίνοντας αυτό το έγγραφο, επιβεβαιώνετε ότι έχετε ελέγξει την επεξεργασμένη εικόνα. Βεβαιωθείτε ότι μόνο το όνομα, το φύλο και η φωτογραφία είναι ορατά και ότι όλες οι άλλες ευαίσθητες πληροφορίες έχουν καλυφθεί. Εάν δεν είστε ικανοποιημένος/η με την αυτόματη απόκρυψη του συστήματος, μπορείτε να απορρίψετε το έγγραφο και να μεταφορτώσετε ξανά ένα προ-επεξεργασμένο έγγραφο.',
    documentRedactingPlaceholder:
      'Παρακαλώ περιμένετε. Το έγγραφό σας υφίσταται επεξεργασία και θα είναι σύντομα διαθέσιμο.',
    documentRejected: 'Το έγγραφο απορρίφθηκε επιτυχώς',
    confirmApprove: 'Επιβεβαίωση έγκρισης',
    confirmReject: 'Επιβεβαίωση απόρριψης',
    documentRejectedReuploadPrompt: 'Το έγγραφο απορρίφθηκε. Θέλετε να μεταφορτώσετε νέα έκδοση;',
    uploadLater: 'Μεταφόρτωση αργότερα',
    reuploadNow: 'Μεταφόρτωση ξανά τώρα',
    consentWarning:
      'Μεταφορτώνοντας αυτό το έγγραφο, επιβεβαιώνετε ότι ο κάτοχος του εγγράφου έχει συναινέσει στην αποθήκευση και επεξεργασία του.',
    consentCheckbox: 'Αναγνωρίζω και συμφωνώ με την παραπάνω δήλωση',
    noDocumentsFound: 'Δεν βρέθηκαν έγγραφα',
    rejectReason: 'Λόγος απόρριψης',
    approveDocumentFailed: 'Δεν ήταν δυνατή η έγκριση του εγγράφου',
    rejectDocumentFailed: 'Δεν ήταν δυνατή η απόρριψη του εγγράφου',
    areYouSureApproveDocument: 'Είστε σίγουρος/η ότι θέλετε να εγκρίνετε αυτό το έγγραφο;',
    areYouSureRejectDocument: 'Είστε σίγουρος/η ότι θέλετε να απορρίψετε αυτό το έγγραφο;',
    viewHistory: 'Προβολή ιστορικού',
    documentHistory: 'Ιστορικό εγγράφου',
    // Document translations (shared keys needed by app components)
    'documents.title': 'Έγγραφα',
    'documents.type': 'Τύπος εγγράφου',
    'documents.fileName': 'Όνομα αρχείου',
    'documents.uploadedAt': 'Μεταφορτώθηκε στις',
    'documents.uploadedBy': 'Μεταφορτώθηκε από',
    'documents.expirationDate': 'Ημερομηνία λήξης',
    'documents.status': 'Κατάσταση',
    'documents.actions': 'Ενέργειες',
    'documents.preview': 'Προεπισκόπηση',
    'documents.noDocumentsFound': 'Δεν βρέθηκαν έγγραφα',
    'documents.failedToLoad': 'Απέτυχε η φόρτωση των εγγράφων',
    'documents.previewTitle': 'Προεπισκόπηση εγγράφου',
    'documents.previewCaption': 'Αυτή είναι μια προεπισκόπηση του εγγράφου',
    'documents.previewError': 'Απέτυχε η φόρτωση της προεπισκόπησης',
    'documents.type_CompanyEmployeeRegistration': 'Καταχώρηση εργαζομένου εταιρείας',
    'documents.type_AirportAccreditation': 'Διαπίστευση αεροδρομίου',
    'documents.type_Passport': 'Διαβατήριο',
    'documents.type_DriverLicense': 'Δίπλωμα οδήγησης',
    'documents.type_IDCard': 'Δελτίο ταυτότητας',
    'documents.status.pending': 'Σε εκκρεμότητα',
    'documents.status.validated': 'Επικυρωμένο',
    'documents.status.expired': 'Έληξε',
    'documents.status.superseded': 'Αντικαταστάθηκε',
    'documents.status.rejected': 'Απορρίφθηκε',
    'documents.status.expiring': 'Πλησιάζει η λήξη',
    // Document translations (app-specific)
    'documents.confirmUploadTitle': 'Έλεγχος & επιβεβαίωση εγγράφου',
    'documents.confirmUpload': 'Επιβεβαίωση μεταφόρτωσης',
    'documents.redactWarning.intro':
      'Εγκρίνοντας αυτό το έγγραφο, επιβεβαιώνετε ότι έχετε ελέγξει την επεξεργασμένη εικόνα.',
    'documents.redactWarning.visibleInfo':
      'Μόνο οι ακόλουθες πληροφορίες πρέπει να παραμείνουν ορατές:',
    'documents.redactWarning.fullName': 'Πλήρες όνομα',
    'documents.redactWarning.photo': 'Φωτογραφία',
    'documents.redactWarning.expirationDate': 'Ημερομηνία λήξης',
    'documents.redactWarning.mustBlackOut':
      'Όλες οι άλλες ευαίσθητες πληροφορίες πρέπει να είναι πλήρως καλυμμένες.',
    'documents.redactWarning.adjustInstructions':
      'Εάν δεν είστε ικανοποιημένος/η με τις αυτόματες αποκρύψεις, μπορείτε να τις προσαρμόσετε σύροντας το ποντίκι σας πάνω από οποιαδήποτε περιοχή για να προσθέσετε νέα απόκρυψη ή κάνοντας κλικ στο "x" για αφαίρεση.',
    'documents.history': 'Ιστορικό εγγράφου',
    'documents.redactingPlaceholder': 'Επεξεργασία εγγράφου για απόκρυψη...',
    'documents.showFinalPreview': 'Εμφάνιση τελικού αποτελέσματος',
    'documents.thisIsHowImageWillBeSaved': 'έτσι θα αποθηκευτεί η εικόνα',
    'documents.failedToLoadImage': 'Απέτυχε η φόρτωση της εικόνας',
    'documents.upload': 'Μεταφόρτωση εγγράφου',
    'documents.documentConfirmed': 'Το έγγραφο επιβεβαιώθηκε επιτυχώς',
    'documents.confirmFailed': 'Απέτυχε η επιβεβαίωση του εγγράφου',
    'documents.analyzeFailed': 'Απέτυχε η ανάλυση του εγγράφου',
    'documents.uploadSuccessful': 'Το έγγραφο μεταφορτώθηκε επιτυχώς',
    'documents.uploadFailed': 'Απέτυχε η μεταφόρτωση του εγγράφου',
    'documents.consentWarning':
      'Μεταφορτώνοντας αυτό το έγγραφο, επιβεβαιώνετε ότι ο κάτοχος του εγγράφου έχει συναινέσει στην αποθήκευση και επεξεργασία του.',
    'documents.consentCheckbox':
      'Αναγνωρίζω ότι ο κάτοχος του εγγράφου έχει δώσει συναίνεση για την αποθήκευση και επεξεργασία του.',
    'documents.redactConfirmCheckbox':
      'Επιβεβαιώνω ότι αυτό το έγγραφο έχει επεξεργαστεί σωστά και μόνο οι επιτρεπόμενες πληροφορίες παραμένουν ορατές.',
    'documents.selectType': 'Επιλέξτε τύπο εγγράφου',
    'documents.pleaseSelectType': 'Επιλέξτε έναν τύπο εγγράφου',
    'documents.file': 'Αρχείο',
    'documents.unsupportedFileType': 'Επιλέξτε ένα έγκυρο αρχείο',
    'documents.expirationDateRequired': 'Η ημερομηνία λήξης είναι υποχρεωτική',
    'documents.expirationDatePast': 'Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν',
    'documents.expirationDateTooFar':
      'Η ημερομηνία λήξης δεν μπορεί να είναι πάνω από 10 έτη στο μέλλον',
    'documents.expirationDateHelperText':
      'Η ημερομηνία πρέπει να είναι σήμερα ή αργότερα, έως 10 έτη από σήμερα',
    'documents.approveWarning': 'Παρακαλώ ελέγξτε προσεκτικά αυτό το έγγραφο πριν την έγκριση.',
    'documents.rejected': 'Έγγραφο απορρίφθηκε',
    'documents.rejectedReuploadPrompt':
      'Το έγγραφο απορρίφθηκε. Θέλετε να μεταφορτώσετε νέα έκδοση;',
    'documents.uploadLater': 'Μεταφόρτωση αργότερα',
    'documents.reuploadNow': 'Μεταφόρτωση ξανά τώρα',
    'documents.areYouSureReject': 'Είστε σίγουρος/η ότι θέλετε να απορρίψετε αυτό το έγγραφο;',
    'documents.confirmReject': 'Απόρριψη',
    'documents.areYouSureApprove': 'Είστε σίγουρος/η ότι θέλετε να εγκρίνετε αυτό το έγγραφο;',
    'documents.confirmApprove': 'Έγκριση',
    // Impersonation
    requestImpersonation: 'Αίτημα υποκατάστασης',
    impersonationRequest: 'Αίτημα υποκατάστασης',
    implementation: 'Υλοποίηση',
    duration: 'Διάρκεια',
    ticketProjectReference: 'Αναφορά εισιτηρίου / έργου',
    ticketProjectReferencePlaceholder: 'π.χ., TICKET-1234 ή PROJECT-5678',
    documentAccess: 'Πρόσβαση σε έγγραφα',
    documentAccessTooltip:
      'Παρέχει πρόσβαση στα έγγραφα ταυτοποίησης που σχετίζονται με αυτόν τον λογαριασμό (π.χ. δίπλωμα οδήγησης, ταυτότητα, διαβατήριο). Ενεργοποιήστε μόνο εάν είναι απαραίτητο, καθώς αυτό απαιτεί έγκριση από διαχειριστή του οργανισμού.',
    reason: 'Αιτιολογία',
    reasonPlaceholder: 'Εισάγετε λόγο για την υποκατάσταση...',
    impersonationInfoBanner:
      'Η συνεδρία υποκατάστασης ενεργοποιείται μόλις ο χρήστης-στόχος αποδεχτεί το αίτημα.',
    submitRequest: 'Υποβολή αιτήματος',
    impersonationRequestCreated: 'Το αίτημα υποκατάστασης υποβλήθηκε επιτυχώς',
    impersonationRequestFailed: 'Απέτυχε η υποβολή του αιτήματος υποκατάστασης',
    reasonEmptyErr: 'Η αιτιολογία είναι υποχρεωτική',
    requestedDurationEmptyErr: 'Η διάρκεια είναι υποχρεωτική',
    reasonTooLong: 'Η αιτιολογία πρέπει να είναι το πολύ {{max}} χαρακτήρες',
    // Impersonation Requests List
    impersonationRequests: 'Αιτήματα υποκατάστασης',
    // Short tab labels
    'tab.invitations': 'Προσκλήσεις',
    'tab.apps': 'Εφαρμογές',
    'tab.idCodes': 'Κωδικοί ID',
    'tab.documents': 'Έγγραφα',
    'tab.impersonation': 'Υποκατάσταση',
    impersonationRequestDetails: 'Λεπτομέρειες αιτήματος υποκατάστασης',
    noImpersonationRequestsFound: 'Δεν βρέθηκαν αιτήματα υποκατάστασης',
    targetUser: 'Χρήστης-στόχος',
    activeUntil: 'Ενεργό έως',
    activeFrom: 'Ενεργό από',
    requester: 'Αιτών',
    approvedDuration: 'Εγκεκριμένη διάρκεια',
    requestValidUntil: 'Το αίτημα ισχύει έως',
    resolvedBy: 'Επιλύθηκε από',
    resolvedAt: 'Επιλύθηκε στις',
    coResolvedBy: 'Συν-επιλύθηκε από',
    coResolvedAt: 'Συν-επιλύθηκε στις',
    coDenialReason: 'Λόγος συν-απόρριψης',
    revokedBy: 'Ανακλήθηκε από',
    revokedAt: 'Ανακλήθηκε στις',
    revocationReason: 'Λόγος ανάκλησης',
    'impersonation.confirmApprove': 'Είστε σίγουρος/η ότι θέλετε να εγκρίνετε αυτό το αίτημα;',
    'impersonation.confirmDeny': 'Είστε σίγουρος/η ότι θέλετε να απορρίψετε αυτό το αίτημα;',
    terminateAccess: 'Τερματισμός πρόσβασης',
    terminateImpersonationSuccess: 'Η πρόσβαση υποκατάστασης τερματίστηκε επιτυχώς',
    terminateImpersonationFailed: 'Απέτυχε ο τερματισμός της πρόσβασης υποκατάστασης',
    pendingCoApproval: 'Εκκρεμεί συν-έγκριση',
    revoked: 'Ανακλήθηκε',
    consolidated: 'Ενοποιημένο',
    denied: 'Απορρίφθηκε',
    coApproveImpersonationSuccess: 'Το αίτημα υποκατάστασης εγκρίθηκε',
    coApproveImpersonationFailed: 'Απέτυχε η έγκριση του αιτήματος υποκατάστασης',
    coDenyImpersonationSuccess: 'Το αίτημα υποκατάστασης απορρίφθηκε',
    coDenyImpersonationFailed: 'Απέτυχε η απόρριψη του αιτήματος υποκατάστασης',
    impersonating: 'Υποκατάσταση σε εξέλιξη',
    expiresIn: 'Λήγει σε',
    expiresAt: 'Λήγει στις',
  },
  cs: {
    noCommunityData: 'Nejsou k dispozici žádná data komunity',
    password: 'Heslo',
    verifyPassword: 'Ověření hesla',
    passwordsDontMatch: 'Hesla se neshodují',
    userName: 'Uživatelské jméno (e-mail)',
    language: 'Jazyk',
    fullName: 'Celé jméno',
    next: 'Další',
    nameRequired: 'Zadejte prosím název',
    cityRequired: 'Zadejte prosím město',
    descriptionRequired: 'Zadejte prosím popis',
    selectCountry: 'Vyberte prosím zemi',
    name: 'Název',
    city: 'Město',
    postalCode: 'PSČ',
    streetAndNumber: 'Ulice a číslo',
    country: 'Země',
    createUser: 'Vytvořit uživatele',
    signLegalDocuments: 'Souhlasit s podmínkami použití',
    suggestionsRequired: 'Vyberte prosím organizaci',
    streetAndNumberRequired: 'Ulice a číslo jsou povinné',
    postalCodeRequired: 'PSČ je povinné',
    suggestions: 'Návrhy',
    selectPlaceholder: 'Vyberte...',
    createAnAccount: 'Vytvořit účet',
    loginToYourAccount: 'Přihlaste se ke svému účtu',
    join: 'Připojit se',
    joinOrganisationOnPlatform: 'Připojte se k organizaci, která je již na platformě',
    register: 'Registrovat',
    registerOrganisationOnPlatform: 'Zaregistrujte organizaci, která je na platformě nová',
    confirmationEmailSent: 'Zkontrolujte svůj e-mail',
    resendEmail: 'Znovu odeslat e-mail',
    confirmationEmailContent:
      'Na adresu {{email}} byl odeslán e-mail.\n\nOtevřete prosím svůj e-mail a klikněte na ověřovací odkaz, abyste mohli pokračovat v registraci. Pokud e-mail nemůžete najít, zkontrolujte složku SPAM nebo e-mail znovu odešlete pomocí tlačítka níže.\n\nToto okno můžete zavřít.',
    passwordRequired: 'Zadejte prosím heslo',
    passwordMinimum12charactersErr: 'Heslo musí mít minimálně 12 znaků',
    passwordMaximum80charactersErr: 'Heslo může mít maximálně 80 znaků',
    reEnterPassword: 'Zadejte prosím heslo znovu',
    joinRequestSent: 'Žádost o připojení odeslána',
    joinRequestContent:
      'Vyčkejte prosím, než správce organizace vaši žádost o připojení přijme. Pro další informace kontaktujte manažera/správce své organizace.',
    readAllLegalDocuments: 'Přečetl(a) jsem si výše uvedené dokumenty a souhlasím s nimi',
    sign: 'Souhlasím',
    welcome: 'Vítejte',
    chooseRoles: 'Vyberte role',
    login: 'Přihlásit se',
    communityMembershipTemplateGetFailed:
      'Něco se pokazilo, nepodařilo se načíst šablonu členství v komunitě',
    membershipAlreadyRequested: 'O členství již bylo požádáno',
    noLegalDocumentsToSign: 'Žádné dokumenty k odsouhlasení',
    welcomeToTheCommunity: 'Vítejte v komunitě.',
    viewApps: 'Zobrazit aplikace',
    membershipRequestFailed: 'Jejda, žádost o připojení ke komunitě se nezdařila',
    error: 'Chyba',
    chooseSuggestedOrganisationToJoin:
      'Na základě vaší e-mailové adresy se možná budete chtít připojit k jedné z následujících existujících organizací.',
    joinSuggestedOrganisation:
      'Na základě vaší e-mailové adresy se možná budete chtít připojit k této existující organizaci.',
    selectAnOrganisation: 'Vyberte prosím organizaci',
    organisationName: 'Název organizace',
    requestedAt: 'Požádáno dne',
    back: 'Zpět',
    addIdentificationCode: 'Přidat identifikační kód',
    identificationCode: 'Identifikační kód',
    identificationcode: 'Identifikační kódy',
    welcomeMessageTitle: 'Vítejte na platformě!',
    selectLanguage: 'Vyberte prosím jazyk',
    selectTimezone: 'vyberte prosím časové pásmo',
    type: 'Typ',
    organisationNameAlreadyExists: 'Název organizace již existuje',
    errorWhileValidatingOrganisationName:
      'Jejda, při ověřování názvu organizace došlo k chybě',
    thisIdentificationCodeIsAlreadyInUse: 'Tento identifikační kód se již používá',
    errorWhileIdentificationCodeName:
      'Jejda, při ověřování identifikačního kódu došlo k chybě',
    continue: 'Pokračovat',
    invalidEmailErr: 'Zadejte prosím platnou e-mailovou adresu',
    dear: 'Vážený uživateli {{user}},',
    successfullyReceivedRegistration:
      ' Vaši registraci jsme úspěšně přijali. Brzy obdržíte e-mail s odkazem, který vám umožní přístup k aplikacím, do kterých jste se zaregistrovali.',
    furtherQuestions:
      'V případě dalších dotazů se prosím obraťte na správce své komunity.',
    'sorry!': 'Omlouváme se!',
    pageRequestedNotFound: 'Požadovaná stránka nebyla nalezena.',
    toTheCommunityPortal: 'Na portál Nallian.',
    validateUsernameFailed: 'Chyba při ověřování uživatelského jména',

    /* user mgmt + request membership */
    myOrganisation: 'Moje organizace',
    noMembershipRequests: 'Žádné žádosti o členství',
    membershipRequests: 'Žádosti o členství',
    createdOn: 'Vytvořeno dne',
    areYouSureYouWantToDenyUser: 'Opravdu chcete tomuto uživateli zamítnout přístup?',
    cancel: 'Zrušit',
    deny: 'Zamítnout',
    requestOfOrganisation: 'Žádost organizace {{organisation}}',
    applications: 'Aplikace',
    roles: 'Role',
    signedLegalDocuments: 'Odsouhlasené právní dokumenty',
    accept: 'Přijmout',
    membershipRequestUpdateFailed: 'Jejda, žádost o členství se nepodařilo aktualizovat',
    membershipRequestUpdateSuccess: 'Žádost o členství aktualizována',
    areYouSureYouWantToendMembership: 'Opravdu chcete ukončit členství?',
    overview: 'Přehled',
    eMailaddress: 'E-mailová adresa (pracovní)',
    membershipRequestAccepted: 'Žádost o členství přijata',
    membershipRequestDenied: 'Žádost o členství zamítnuta',
    dashboard: 'Nástěnka',
    getLanguagesErr: 'Jejda, nepodařilo se načíst jazyky',
    getAuthorizationRolesErr: 'Jejda, nepodařilo se načíst autorizační role',
    getTimezonesErr: 'Jejda, nepodařilo se načíst časová pásma',
    getOrganisationStatsErr: 'Jejda, nepodařilo se načíst statistiky',
    users: 'Uživatelé',
    noUserPresent: 'Žádní uživatelé',
    state: 'Stav',
    editUser: 'Upravit uživatele',
    deleteUser: 'Odebrat uživatele',
    areYouSureYouWantToDeleteUser: 'Chcete odebrat uživatele {{userName}}?',
    inviteNewUser: 'Pozvat nového uživatele',
    save: 'Uložit',
    invite: 'Pozvat',
    inviteUserSendEmailToAddress: 'Pozvat uživatele, odeslat e-mail na následující adresu:',
    createUserWithPassword: 'Vytvořit uživatele s heslem:',
    enterPassword: 'Zadejte heslo',
    forceUserToChooseNewPassword: 'Vynutit, aby si uživatel při prvním přihlášení zvolil nové heslo',
    pleaseEnterEmailAddress: 'Zadejte prosím platnou e-mailovou adresu',
    pleaseEnterRecipient: 'Zadejte prosím příjemce',
    pleaseEnterPassword: 'Zadejte prosím heslo',
    selectRole: 'Vyberte prosím alespoň jednu roli.',
    usernameTaken: 'Toto uživatelské jméno je již obsazeno',
    userUpdated: 'Uživatel aktualizován',
    inviteUserFailed: 'Jejda, uživatele se nepodařilo pozvat',
    inviteUser: 'Pozvat uživatele',
    userInvited: 'Uživatel pozván',
    userDeleted: 'Uživatel odstraněn',
    deleteUserFailed: 'Jejda, uživatele se nepodařilo odstranit',
    delete: 'Odstranit',
    noOrganisationRegistrations: 'Žádné registrace organizací',
    trustedDomains: 'Důvěryhodná doména',
    trustedDomains_0: 'Důvěryhodná doména',
    trustedDomains_1: 'Důvěryhodné domény',
    trustedDomains_2: 'Důvěryhodných domén',
    trustedDomains_plural: 'Důvěryhodné domény',
    trustedDomainsOverview: 'Důvěryhodné domény',
    createTrustedDomainSuccess: 'Důvěryhodná doména byla vytvořena',
    createTrustedDomainFailed: 'Něco se pokazilo, důvěryhodnou doménu se nepodařilo vytvořit',
    updateTrustedDomainSuccess: 'Důvěryhodná doména aktualizována',
    addTrustedDomain: 'Přidat důvěryhodnou doménu',
    updateTrustedDomainFailed: 'Něco se pokazilo, důvěryhodnou doménu se nepodařilo aktualizovat',
    domain: 'Doména',
    domainEmptyErr: 'Zadejte prosím doménu',
    domainInvalidErr: 'Zkontrolujte prosím název domény.',
    autoJoin: 'Automatické připojení',

    /* community mgmt */
    remove: 'Odebrat',
    organisation: 'Organizace',
    areYouSureYouWantToDenyOrganisation:
      'Opravdu chcete této organizaci zamítnout přístup?',
    areYouSureYouWantToRemoveTheRequest: 'Opravdu chcete tuto žádost odebrat?',
    myCommunity: 'Moje komunita',
    noMembersPresent: 'Žádní členové.',
    addMember: 'Přidat člena',
    edit: 'Upravit',
    endMembership: 'Zrušit členství',
    editMembership: 'Upravit členství',
    areYouSureYouWantToEndMembership:
      'Opravdu chcete ukončit členství organizace {{organisationName}}?',
    communityMembershipEnded: 'Členství v komunitě ukončeno',
    endCommunityMembershipFailed: 'Něco se pokazilo, členství se nepodařilo ukončit',
    communityMembershipUpdate: 'Členství v komunitě aktualizováno',
    updateCommunityMembershipFailed: 'Něco se pokazilo, členství v komunitě se nepodařilo aktualizovat',
    getCommunityMembershipFailed: 'Něco se pokazilo, členství v komunitě se nepodařilo načíst',
    communityMembershipCreated: 'Člen komunity vytvořen',
    createCommunityMembershipFailed: 'Něco se pokazilo, člena komunity se nepodařilo vytvořit',
    addACommunityMember: 'Přidat člena komunity',
    updateMembershipOf: 'Aktualizovat členství {{organisationName}}',
    members: 'Členové',
    getUserStatesErr: 'Něco se pokazilo, nepodařilo se načíst stavy uživatelů',
    rejectionNotice: 'Oznámení o zamítnutí',
    addApp: 'Přidat aplikaci',
    app: 'Aplikace',
    actions: 'Akce',
    role: 'Role',
    registerError: 'Během registrace se něco pokazilo.',
    contactAdministrator:
      'Pro více informací o používání tohoto portálu Nallian se prosím obraťte na správce své komunity.',
    registerEmailDomainAsTrustedRequired: 'Toto pole musíte povolit nebo zakázat.',
    proceed: 'Pokračovat',
    privateCommunityTitle: 'Soukromá komunita',
    privateCommunityDescription: 'Toto je soukromá komunita, ke které se nelze připojit.',

    pleaseSelectOrganisation: 'Vyberte prosím organizaci',
    pleaseSelectMinimumOneRole: 'Vyberte prosím alespoň jednu roli',
    none: 'Žádné',
    membershipRequestGetFailed: 'Něco se pokazilo, žádost o členství se nepodařilo načíst',
    getCommunityStatsErr: 'Něco se pokazilo, nepodařilo se načíst statistiky komunity',
    communityMember: 'Člen komunity',
    registrationGetFailed: 'Něco se pokazilo, registraci se nepodařilo načíst',
    getTrustedDomainFailed: 'Něco se pokazilo, důvěryhodnou doménu se nepodařilo načíst',
    pleaseEnterAnEmailAddress: 'Zadejte prosím e-mailovou adresu',
    noUsersPresent: 'Žádní uživatelé',
    communities: 'Komunity',
    noCommunitiesFound: 'Nebyly nalezeny žádné komunity',
    home: 'Domů',
    getIdentificationCodeTypesFailed:
      'Něco se pokazilo, nepodařilo se načíst typy identifikačních kódů',
    pleaseSelectAType: 'Vyberte prosím typ',
    pleaseEnterAValue: 'Zadejte prosím hodnotu',
    disabled: 'Deaktivovaný',
    unverified: 'Neověřený',
    verified: 'Ověřený',
    userState: 'Stav uživatele',
    couldNotGetCommunityTemplate:
      'Něco se pokazilo, nepodařilo se načíst popis komunity',
    getTermsAndConditionsFailed:
      'Něco se pokazilo, nepodařilo se načíst smluvní podmínky',
    chooseAPassword: 'Zvolte heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrďte heslo',
    userAccountReady: 'Uživatelský účet je připraven!',
    passwordResetSuccess:
      'Vaše heslo bylo úspěšně obnoveno. Nyní se můžete přihlásit do svých aplikací.',
    failedContactOur: 'Obnovení hesla se nezdařilo, kontaktujte prosím naše',
    support: 'podpůrné',
    department: 'oddělení',
    pleaseConfirmUserAccount: 'Potvrďte prosím, že toto je váš uživatelský účet',
    confirm: 'Potvrdit',
    invalidToken: 'Neplatný token',
    needTechnicalSupport: 'Pokud potřebujete technickou pomoc, kontaktujte prosím naše',
    passwordMin8Char: 'Zvolte heslo o minimálně 8 znacích',
    passwordConfirmIncorrect: 'Potvrzení hesla není správné',
    pleaseEnterValidEmail: 'Zadejte prosím platnou e-mailovou adresu',
    forgotPassword: 'Zapomenuté heslo',
    requestNewPassword: 'Požádat o nové heslo',
    resetPasswordRequested: 'Žádost o obnovení hesla odeslána!',
    resetPasswordRequestText:
      'Pokud jste registrovaný uživatel, byl do vaší schránky odeslán e-mail pro obnovení hesla. Pro pokračování klikněte na odkaz v tomto e-mailu. Toto okno nyní můžete zavřít.',
    somethingWentWrong: 'Něco se pokazilo',
    pleaseContactOur: 'Kontaktujte prosím naše',
    failedResentEmail: 'Nepodařilo se znovu odeslat e-mail s pozvánkou',
    resentEmailSuccess: 'E-mail s pozvánkou byl znovu odeslán',
    ohNo: 'Ale ne!',
    invitationExpired: 'Platnost vaší pozvánky vypršela. Pošleme vám novou pozvánku:',
    resentInvitationEmail: 'Znovu odeslat e-mail s pozvánkou',
    thanksForSubscribing: 'Děkujeme za registraci a vítejte na platformě!',
    activatedBasicAccount:
      'Aktivovali jsme váš základní účet, který vám umožní přístup k různým aplikacím dostupným pro váš účet.',
    accessApplications:
      'K aplikacím budete mít přístup, jakmile obdržíme příslušné podepsané smluvní formuláře.',
    beAware:
      'Upozorňujeme, že u některých aplikací může platit pozdější datum spuštění (go-live).',
    contactUs: 'Kontaktujte nás',
    ifQuestions: 'v případě jakýchkoli dotazů.',
    failedToActivateUserAccount: 'Nepodařilo se aktivovat uživatelský účet',
    goodNews: 'Dobrá zpráva!',
    accountAlreadyActivated:
      'Váš účet je již aktivován. Přejděte prosím do aplikace pomocí přímého odkazu uvedeného v pokynech k aplikaci.',
    invalidTokenText:
      'Váš aktivační token je neplatný. Použijte prosím aktivační odkaz z posledního obdrženého e-mailu s pozvánkou. Pokud jste tento e-mail neobdrželi (nezapomeňte zkontrolovat spam!), můžete vždy kontaktovat naše',
    passwordInvalidErr: 'Zadejte prosím platné heslo',
    inviteSuccessMessage:
      'Váš uživatelský účet byl úspěšně zaregistrován na platformě Nallian. Chcete-li pokračovat a začít používat aplikace, klikněte na "Pokračovat" a přihlaste se do portálu Nallian.',
    address: 'Adresa',
    getOrganisationIdentificationCodesFailed:
      'Nepodařilo se načíst identifikační kódy organizace',
    getOrganisationFailed: 'Nepodařilo se načíst informace o organizaci',
    identificationCodes: 'Identifikační kódy',
    getOrganisationAddressFailed: 'Nepodařilo se načíst adresu organizace',
    membershipOf: 'Členství organizace {{organisation}}',
    organisationInfo: 'Informace o organizaci',
    noRolesFound: 'Nebyly nalezeny žádné role',
    noAppsFound: 'Nebyly nalezeny žádné aplikace',
    organisationUsers: 'Uživatel',
    userReinvited: 'Uživatel znovu pozván',
    userReinviteFailed: 'Uživatele se nepodařilo znovu pozvat',
    reinviteUser: 'Znovu pozvat uživatele',
    areYouSureReinvite: 'Opravdu chcete znovu pozvat uživatele {{userName}}?',
    yes: 'Ano',
    no: 'Ne',
    dontHaveAnAccountYet: 'Ještě nemáte účet?',
    registerHere: 'Zaregistrujte se zde!',
    inviteInfo:
      'Někdo z vaší organizace vás pozval, abyste se připojili k platformě. Potvrďte prosím, že níže uvedené údaje jsou vaše.',
    chooseAPasswordInfo: 'Zvolte prosím heslo pro dokončení procesu pozvání.',
    resetYourPassword: 'Obnovte své heslo',
    createAnotherUser: 'Vytvořit dalšího uživatele',
    createdBy: 'Vytvořil(a)',
    createCommunityMember: 'Vytvořit člena komunity',
    isTest: 'Je testovací',
    isDefault: 'Je výchozí',
    isMessageCode: 'Je kód zprávy',
    code: 'Kód',
    codeValue: 'Kód',
    description: 'Popis',
    updateIdentificationCodeFailed: 'Aktualizace identifikačního kódu se nezdařila',
    updateIdentificationCodeSuccess: 'Identifikační kód byl úspěšně aktualizován',
    addIdentificationCodeFailed: 'Přidání identifikačního kódu se nezdařilo',
    addIdentificationCodeSuccess: 'Identifikační kód byl úspěšně přidán',
    getIdentificationCodeFailed: 'Načtení identifikačního kódu se nezdařilo',
    identificationCodeType: 'Typ identifikačního kódu',
    removeIdentificationCode: 'Odebrat identifikační kód',
    add: 'Přidat',
    editIdentificationCode: 'Upravit identifikační kód',
    viewIdentificationCode: 'Zobrazit identifikační kód',
    routings: 'Směrování',
    order: 'Pořadí',
    regex: 'Regex',
    emailAddresses: 'E-mailové adresy',
    toZendesk: 'Do Zendesku',
    enabled: 'Povoleno',
    editRouting: 'Upravit směrování',
    addRouting: 'Přidat směrování',
    removeRouting: 'Opravdu chcete odebrat toto směrování?',
    toVoid: 'Zahodit',
    addAttachments: 'Přidat přílohy',
    stopProcessing: 'Zastavit zpracování',
    zendeskTags: 'Štítky Zendesk',
    priority: 'Priorita',
    mustFillInEmailNoZendeskAndNoVoid:
      'Pokud není povolena možnost Zahodit ani Do Zendesku, musíte vyplnit e-mail',
    nameEmptyErr: 'Vyplňte prosím název',
    orderEmptyErr: 'Vyplňte prosím pořadí',
    regexEmptyErr: 'Vyplňte prosím regex',
    priorityIdEmptyErr: 'Vyberte prosím prioritu',
    routingsOrder: 'Pořadí směrování',
    updateRoutingsOrderSuccess: 'Pořadí směrování bylo úspěšně aktualizováno',
    updateRoutingsOrderFailed: 'Aktualizace pořadí směrování se nezdařila',
    saveOrder: 'Uložit pořadí',
    apiResources: 'Zdroj API',
    apiResources_0: 'Zdroj API',
    apiResources_1: 'Zdroje API',
    apiResources_2: 'Zdrojů API',
    apiResources_plural: 'Zdroje API',
    tokenLifetime: 'Životnost tokenu',
    stsclients: 'Klient STS',
    stsclients_0: 'Klient STS',
    stsclients_1: 'Klienti STS',
    stsclients_2: 'Klientů STS',
    stsclients_plural: 'Klienti STS',
    clientName: 'Název klienta',
    clientId: 'ID klienta',
    fillForm: 'Vyplnit formulář',
    clientNameInfo: 'Zobrazovaný název klienta (používá se pro protokolování a obrazovku souhlasu)',
    clientIdInfo: 'Jedinečné ID klienta',
    clientUri: 'URI klienta',
    clientUriInfo: 'URI s dalšími informacemi o klientovi (používá se na obrazovce souhlasu)',
    logoUri: 'URI loga',
    logoUriInfo: 'URI loga klienta (používá se na obrazovce souhlasu)',
    allowedScopes: 'Povolené rozsahy (scopes)',
    allowedScopesInfo:
      'Ve výchozím nastavení nemá klient přístup k žádným zdrojům – povolené zdroje určíte přidáním názvů odpovídajících rozsahů (scopes)',
    allowedGranttypes: 'Povolené typy grantů',
    allowedGranttypesInfo:
      'Určuje typy grantů, které smí klient používat. Pro běžné kombinace použijte třídu GrantTypes.',
    protocolType: 'Typ protokolu',
    rowVersion: 'Verze řádku',
    enableClient: 'Povolit klienta',
    enableClientInfo: 'Určuje, zda je klient povolen. Výchozí hodnota je true.',
    allowOfflineAccessInfo:
      'Určuje, zda tento klient může žádat o refresh tokeny (vyžádáním rozsahu offline_access)',
    allowOfflineAccess: 'Povolit refresh tokeny',
    requireClientSecret: 'Vyžadovat client secret',
    requireClientSecretInfo:
      'Určuje, zda tento klient potřebuje secret k vyžádání tokenů z token endpointu (výchozí hodnota je true)',
    noAppSubscriptionRequired: 'Nevyžaduje se předplatné aplikace',
    allowAccessTokensViaBrowser: 'Povolit access tokeny přes prohlížeč',
    allowAccessTokensViaBrowserInfo:
      'Určuje, zda tento klient smí přijímat access tokeny prostřednictvím prohlížeče. To je užitečné pro zabezpečení flow, které umožňují více typů odpovědí (např. tím, že se klientovi s hybrid flow, který má používat code id_token, zakáže přidat typ odpovědi token, a tím uniknout token do prohlížeče.',
    requirePkce: 'Vyžadovat PKCE',
    requirePkceInfo:
      'Určuje, zda klienti používající typ grantu založený na autorizačním kódu musí odesílat proof key (výchozí hodnota je true).',
    allowPlainTextPkce: 'Povolit PKCE v prostém textu',
    allowPlainTextPkceInfo:
      'Určuje, zda klienti používající PKCE mohou použít code challenge v prostém textu (nedoporučuje se – výchozí hodnota je false)',
    redirectUrisInfo: 'Určuje povolené URI, na které se vracejí tokeny nebo autorizační kódy',
    redirectUris: 'URI pro přesměrování',
    postLogoutRedirectUris: 'URI pro přesměrování po odhlášení',
    postLogoutRedirectUrisInfo:
      'Určuje povolené URI pro přesměrování po odhlášení. Další podrobnosti najdete ve specifikaci OIDC Connect Session Management.',
    identityProviderRestrictions: 'Omezení poskytovatelů identity',
    identityProviderRestrictionsInfo:
      'Určuje, které externí IdP lze s tímto klientem používat (pokud je seznam prázdný, jsou povoleny všechny IdP). Výchozí hodnota je prázdný seznam.',
    frontChannelLogoutSessionRequired: 'Vyžaduje se front-channel logout session',
    frontChannelLogoutSessionRequiredInfo:
      'Určuje, zda se má ID relace uživatele odesílat na FrontChannelLogoutUri. Výchozí hodnota je true.',
    frontChannelLogoutUri: 'URI pro front-channel odhlášení',
    frontChannelLogoutUriInfo:
      'Určuje URI pro odhlášení na straně klienta pro front-channel odhlášení přes HTTP. Další podrobnosti najdete ve specifikaci OIDC Front-Channel.',
    backChannelLogoutSessionRequired: 'Vyžaduje se back-channel logout session',
    backChannelLogoutSessionRequiredInfo:
      'Určuje, zda se má ID relace uživatele odesílat v požadavku na BackChannelLogoutUri. Výchozí hodnota je true.',
    backChannelLogoutUri: 'URI pro odhlášení:',
    backChannelLogoutUriInfo:
      'Určuje URI pro odhlášení na straně klienta pro back-channel odhlášení přes HTTP. Další podrobnosti najdete ve specifikaci OIDC Back-Channel.',
    logoutSession: 'Relace odhlášení',
    enableLocalLogin: 'Povolit místní přihlášení',
    enableLocalLoginInfo:
      'Určuje, zda tento klient může používat místní účty, nebo pouze externí IdP. Výchozí hodnota je true.',
    accessTokenLifetime: 'Životnost access tokenu',
    accessTokenLifetimeInfo:
      'Životnost access tokenu v sekundách (výchozí hodnota je 3600 sekund / 1 hodina)',
    absoluteRefreshTokenLifetime: 'Absolutní životnost refresh tokenu',
    absoluteRefreshTokenLifetimeInfo:
      'Maximální životnost refresh tokenu v sekundách. Výchozí hodnota je 2592000 sekund / 30 dní',
    identityTokenLifetime: 'Životnost identity tokenu',
    identityTokenLifetimeInfo:
      'Životnost identity tokenu v sekundách (výchozí hodnota je 300 sekund / 5 minut)',
    authorizationCodeLifetime: 'Životnost autorizačního kódu',
    authorizationCodeLifetimeInfo:
      'Životnost autorizačního kódu v sekundách (výchozí hodnota je 300 sekund / 5 minut)',
    slidingRefreshTokenLifetime: 'Klouzavá životnost refresh tokenu',
    slidingRefreshTokenLifetimeInfo:
      'Klouzavá životnost refresh tokenu v sekundách. Výchozí hodnota je 1296000 sekund / 15 dní',
    clientClaimsPrefix: 'Prefix client claims',
    clientClaimsPrefixInfo:
      'Pokud je nastaveno, budou typy client claims opatřeny tímto prefixem. Výchozí hodnota je client_. Účelem je zajistit, aby se náhodně nestřetávaly s user claims.',
    pairWiseSubjectSalt: 'Pair-wise subject salt',
    pairWiseSubjectSaltInfo:
      'Hodnota salt používaná při pair-wise generování subjectId pro uživatele tohoto klienta.',
    updateAccessTokenClaimsOnRefresh: 'Aktualizovat claims access tokenu při obnovení',
    updateAccessTokenClaimsOnRefreshInfo:
      'Získá nebo nastaví hodnotu určující, zda se má access token (a jeho claims) aktualizovat při požadavku na refresh token.',
    accessTokenType: 'Referenční access token',
    accessTokenTypeInfo:
      'Určuje, zda je access token referenčním tokenem, nebo samostatným tokenem JWT (výchozí hodnota je Jwt).',
    includeJwtId: 'Zahrnout JWT ID',
    includeJwtIdInfo:
      'Určuje, zda mají JWT access tokeny obsahovat vestavěné jedinečné ID (prostřednictvím claimu jti). Výchozí hodnota je true.',
    alwaysSendClientClaims: 'Vždy odesílat client claims',
    alwaysSendClientClaimsInfo:
      'Pokud je nastaveno, budou client claims odesílány pro každý flow. Pokud ne, pouze pro client credentials flow (výchozí hodnota je false)',
    alwaysIncludeUserClaimsInIdToken: 'Vždy zahrnout user claims do identity tokenu',
    alwaysIncludeUserClaimsInIdTokenInfo:
      'Určuje, zda se při požadavku na id token i access token mají user claims vždy přidat do id tokenu namísto toho, aby klient musel použít userinfo endpoint. Výchozí hodnota je false.',
    allowedCorsOriginsInfo:
      'Pokud je zadáno, použijí výchozí implementace služby CORS policy (In-Memory a EF) tuto hodnotu k sestavení CORS policy pro JavaScriptové klienty.',
    allowedCorsOrigins: 'Povolené CORS origins',
    consentLifetimeInfo: 'Životnost souhlasu uživatele v sekundách. Výchozí hodnota je null (bez expirace).',
    consentLifetime: 'Životnost souhlasu',
    requireConsent: 'Vyžadovat souhlas',
    requireConsentInfo: 'Určuje, zda je vyžadována obrazovka souhlasu. Výchozí hodnota je false.',
    allowRememberConsent: 'Povolit zapamatování souhlasu',
    allowRememberConsentInfo:
      'Určuje, zda si uživatel může zvolit uložení rozhodnutí o souhlasu. Výchozí hodnota je true.',
    refreshTokenUsage: 'Použití refresh tokenu',
    refreshTokenUsageInfo:
      "Při volbě 'ReUse' zůstává handle refresh tokenu při obnovování tokenů stejný. Při volbě 'OneTime' se handle refresh tokenu při obnovování tokenů aktualizuje. To je výchozí nastavení.",
    refreshTokenExpiration: 'Vypršení platnosti obnovovacího tokenu',
    refreshTokenExpirationInfo:
      "'Absolute' – obnovovací token vyprší v pevně stanoveném okamžiku (určeném hodnotou AbsoluteRefreshTokenLifetime). Toto je výchozí nastavení. 'Sliding' – při obnovení tokenu se životnost obnovovacího tokenu prodlouží (o hodnotu určenou v SlidingRefreshTokenLifetime). Životnost nepřekročí AbsoluteRefreshTokenLifetime.",
    reUse: 'Opakované použití',
    oneTimeOnly: 'Pouze jednorázově',
    sliding: 'Klouzavá',
    absolute: 'Absolutní',
    updateUserFailed: 'Aktualizace uživatele se nezdařila',
    getUserFailed: 'Načtení uživatele se nezdařilo',
    isHidden: 'Skryté',
    isOwner: 'Vlastník',
    updateSuiteFailed: 'Aktualizace sady aplikací se nezdařila',
    updateSuiteSuccess: 'Sada aplikací byla úspěšně aktualizována',
    suites: 'Sada aplikací',
    suites_0: 'Sada aplikací',
    suites_1: 'Sady aplikací',
    suites_2: 'Sad aplikací',
    suites_plural: 'Sady aplikací',
    tiers: 'Úrovně',
    apps: 'Aplikace',
    allApplications: 'Všechny aplikace',
    appCountSingular: '{{count}} aplikace',
    appCountPlural: '{{count}} aplikací',
    addAppFeature: 'Přidat funkci aplikace',
    tierApps: 'Aplikace úrovně',
    suite: 'Sada aplikací',
    tier: 'Úroveň',
    suiteTier: 'Úroveň',
    suiteIdEmptyErr: 'Vyberte prosím sadu aplikací',
    suiteTierIdEmptyErr: 'Vyberte prosím úroveň',
    timezone: 'Časové pásmo',
    communityMembers: 'člen komunity',
    communityMembers_0: 'Člen komunity',
    communityMembers_1: 'Členové komunity',
    communityMembers_2: 'Členů komunity',
    communityMembers_plural: 'Členové komunity',
    getCommunityRolesFailed: 'Načtení komunitních rolí se nezdařilo',
    myApps: 'Moje aplikace',
    principalJoinRequests: 'Žádosti o připojení',
    selectExistingUser:
      'Vyhledejte existujícího uživatele (profil existujícího uživatele bude přepsán níže uvedenými údaji)',
    acceptJoinRequestFor: 'Přijmout žádost o připojení uživatele {{user}}',
    preApproveForLinking: 'Předběžně schválit pro propojení',
    areYouSureYouWantToUnlinkIdentity: 'Opravdu chcete odpojit účet od uživatele?',
    preApproveForLinkingInfo:
      'Automaticky schválit žádost o připojení, pokud si někdo přeje propojit svůj účet s tímto uživatelem',
    acceptJoinRequestFailed: 'Přijetí žádosti o připojení se nezdařilo',
    acceptJoinRequestSuccess: 'Žádost o připojení byla úspěšně přijata',
    viewOrganisation: 'Zobrazit organizaci',
    myIdentity: 'Můj účet',
    active: 'Aktivní',
    activeState: 'Stav aktivity',
    activeStatus: 'Stav aktivity',
    addApplication: 'Přidat aplikaci',
    addAppSubscription: 'Přidat předplatné aplikace',
    addCommunityRoleFailed: 'Komunitní roli se nepodařilo přidat',
    addCommunityRoleSuccess: 'Komunitní role byla přidána',
    addFeature: 'Přidat funkci',
    addOwner: 'Přidat vlastníka',
    addRole: 'Přidat roli',
    addSubscription: 'Přidat předplatné',
    addSuite: 'Přidat sadu aplikací',
    addTier: 'Přidat úroveň',
    addUser: 'Přidat uživatele',
    alias: 'Alias',
    aliasEmptyErr: 'Zadejte prosím alias',
    appDetailsAliasEmptyErr: 'Zadejte prosím alias',
    appDetailsTagEmptyErr: 'Vyberte prosím aplikaci',
    appDetailsUrlEmptyErr: 'Zadejte prosím URL',
    appFeatures: 'Funkce aplikace',
    appInstallationFeatureTagEmptyErr: 'Vyberte prosím funkci',
    appInstallationIdEmptyErr: 'Vyberte prosím aplikaci',
    appInstallations: 'Instalace aplikací',
    application: 'Aplikace',
    apps_0: 'Aplikace',
    apps_1: 'Aplikace',
    apps_2: 'Aplikací',
    apps_plural: 'Aplikace',
    appSubscription: 'Předplatné aplikace',
    appTypeIdEmptyErr: 'Vyberte prosím typ aplikace',
    areYouSureRemoveIdentificationCodeType:
      'Opravdu chcete odstranit tento typ identifikačního kódu?',
    areYouSureRemoveOnboardingTemplate: 'Opravdu chcete odstranit tuto šablonu onboardingu?',
    areYouSureRemovePrincipal: 'Opravdu chcete odstranit uživatele {{name}} ({{email}})?',
    areYouSureActivatePrincipal: 'Opravdu chcete aktivovat uživatele {{name}}?',
    activatePrincipal: 'Aktivovat uživatele',
    activate: 'Aktivovat',
    activatePrincipalSuccess: 'Uživatel byl aktivován',
    activatePrincipalFailed: 'Uživatele se nepodařilo aktivovat',
    areYouSureRemoveRelation: 'Opravdu chcete odstranit tento vztah?',
    areYouSureYouWantToDenyJoinRequest: 'Opravdu chcete zamítnout tuto žádost o připojení?',
    cityEmptyErr: 'Vyplňte prosím město',
    close: 'Zavřít',
    community: 'Komunita',
    communityApps: 'Komunitní aplikace',
    communityApps_0: 'Komunitní aplikace',
    communityApps_1: 'Komunitní aplikace',
    communityApps_2: 'Komunitních aplikací',
    communityApps_plural: 'Komunitní aplikace',
    communityMemberCreatedAndInvited:
      'Člen komunity byl vytvořen a uživatel byl pozván',
    communityMemberCreatedAndInvitedError:
      'Nepodařilo se vytvořit člena komunity a pozvat uživatele',
    communityRoles: 'Komunitní role',
    communityRoles_0: 'Komunitní role',
    communityRoles_1: 'Komunitní role',
    communityRoles_2: 'Komunitních rolí',
    communityRoles_plural: 'Komunitní role',
    communitySuites: 'Komunitní sada aplikací',
    communitySuites_0: 'Komunitní sada aplikací',
    communitySuites_1: 'Komunitní sady aplikací',
    communitySuites_2: 'Komunitních sad aplikací',
    communitySuites_plural: 'Komunitní sady aplikací',
    communityInfo: 'Informace o komunitě',
    communityManagement: 'Správa komunity',
    confirmInvitationInfo:
      'Potvrďte prosím, že níže uvedené údaje jsou správné. V dalších krocích můžete doplnit informace o svém účtu a dokončit registraci.',
    couldNotCompleteInvitation:
      'Vaši pozvánku se bohužel nepodařilo dokončit.<0></0>Zkuste to znovu nebo kontaktujte naši podporu <1>{{text}}</1>.',
    countryEmptyErr: 'Vyberte prosím zemi',
    createAppFailed: 'Aplikaci se nepodařilo vytvořit',
    createAppSubscriptionFailed: 'Předplatné aplikace se nepodařilo vytvořit',
    createAppSubscriptionSuccess: 'Předplatné aplikace bylo vytvořeno',
    createAppSuccess: 'Aplikace byla vytvořena',
    createCommunityAppFailed: 'Komunitní aplikaci se nepodařilo vytvořit',
    createCommunityAppSuccess: 'Komunitní aplikace byla vytvořena',
    createCommunityMemberFailed: 'Člena komunity se nepodařilo vytvořit',
    createCommunityMemberSuccess: 'Člen komunity byl vytvořen',
    createCommunitySuiteFailed: 'Komunitní sadu aplikací se nepodařilo vytvořit',
    createCommunitySuiteSuccess: 'Komunitní sada aplikací byla vytvořena',
    createIdentificationCodeTypeFailed: 'Typ identifikačního kódu se nepodařilo vytvořit',
    createIdentificationCodeTypeSuccess: 'Typ identifikačního kódu byl vytvořen',
    createNewMember: 'Vytvořit nového člena',
    createNewOrganisation: 'Vytvořit novou organizaci',
    createOnboardingTemplateFailed: 'Šablonu onboardingu se nepodařilo vytvořit',
    createOnboardingTemplateSuccess: 'Šablona onboardingu byla vytvořena',
    createOrganisationRoleFailed: 'Organizační roli se nepodařilo vytvořit',
    createOrganisationRoleSuccess: 'Organizační role byla vytvořena',
    createPrincipalFailed: 'Uživatele se nepodařilo vytvořit',
    createPrincipalSuccess: 'Uživatel byl vytvořen',
    createRelationFailed: 'Vztah se nepodařilo vytvořit',
    createRelationSuccess: 'Vztah byl vytvořen',
    createRelationTypeFailed: 'Typ vztahu se nepodařilo vytvořit',
    createRelationTypeSuccess: 'Typ vztahu byl vytvořen',
    createSuiteFailed: 'Sadu aplikací se nepodařilo vytvořit',
    createSuiteSuccess: 'Sada aplikací byla vytvořena',
    createUserFailed: 'Uživatele se nepodařilo vytvořit',
    createUserSuccess: 'Uživatel byl vytvořen',
    defaultCommunity: 'Výchozí komunita',
    deleted: 'Smazáno',
    denyJoinRequestFailed: 'Žádost o připojení se nepodařilo zamítnout',
    denyJoinRequestSuccess: 'Žádost o připojení byla zamítnuta',
    markUniqueJoinRequestFailed: 'Žádost o připojení se nepodařilo označit jako neduplicitní',
    markUniqueJoinRequestSuccess: 'Žádost o připojení byla označena jako neduplicitní',
    markNotDuplicateConfirmation:
      'Označit tuto žádost o připojení jako neduplicitní. Stav se změní na Nová a správce komunity bude upozorněn.',
    descriptionEmptyErr: 'Vyplňte prosím popis',
    details: 'Podrobnosti',
    displayName: 'Zobrazované jméno',
    editApp: 'Upravit aplikaci',
    editCommunityApp: 'Upravit komunitní aplikaci',
    editCommunityMember: 'Upravit člena komunity',
    editCommunityRole: 'Upravit komunitní roli',
    editFeature: 'Upravit funkci',
    editOrganisationRole: 'Upravit organizační roli',
    editSubscription: 'Upravit předplatné',
    email: 'E-mailová adresa',
    emailAddress: 'E-mailová adresa',
    emailAddressEmptyErr: 'Vyplňte prosím e-mailovou adresu',
    emailOrPhoneNumberRequiredError: 'Je vyžadována platná e-mailová adresa nebo telefonní číslo',
    externalIdentifier: 'Externí identifikátor',
    feature: 'Funkce',
    featureName: 'Název funkce',
    features: 'Funkce',
    featureSubscriptions: 'Předplatná',
    subscriptions: 'Předplatná',
    subscriptionRequired: 'Vyžadováno předplatné',
    noSubscriptionRequired: 'Předplatné není vyžadováno',
    firstSelectAFeature: 'Nejprve vyberte funkci',
    firstSelectAnApp: 'Nejprve vyberte aplikaci',
    fullNameEmptyErr: 'Zadejte prosím celé jméno',
    general: 'Obecné',
    getAppFailed: 'Aplikaci se nepodařilo načíst',
    getAppInstallationFailed: 'Instalaci aplikace se nepodařilo načíst',
    getAppInstallationsFailed: 'Instalace aplikací se nepodařilo načíst',
    getAppsFailed: 'Aplikace se nepodařilo načíst',
    getAppSubscriptionsFailed: 'Předplatná aplikací se nepodařilo načíst',
    getAvailableRolesFailed: 'Dostupné role se nepodařilo načíst',
    getCommunityAppsFailed: 'Komunitní aplikace se nepodařilo načíst',
    getCommunityMemberRolesFailed: 'Role této organizace se nepodařilo načíst',
    getIdentificationCodeTypeFailed: 'Typ identifikačního kódu se nepodařilo načíst',
    getJoinRequestFailed: 'Žádost o připojení se nepodařilo načíst',
    getOnboardingTemplateFailed: 'Šablonu onboardingu se nepodařilo načíst',
    getOrganisationRolesFailed: 'Role se nepodařilo načíst',
    getPrincipalFailed: 'Uživatele se nepodařilo načíst',
    getRelationFailed: 'Vztah se nepodařilo načíst',
    getRelationsFailed: 'Vztahy se nepodařilo načíst',
    getRelationTypeFailed: 'Typ vztahu se nepodařilo načíst',
    getRelationTypesFailed: 'Typy vztahů se nepodařilo načíst',
    getSuiteFailed: 'Sadu aplikací se nepodařilo načíst',
    getSuitesFailed: 'Sady aplikací se nepodařilo načíst',
    global: 'Globální',
    here: 'zde',
    hostedAt: 'Hostováno na',
    identificationcodetypes: 'Typ identifikačního kódu',
    identificationcodetypes_0: 'Typ identifikačního kódu',
    identificationcodetypes_1: 'Typy identifikačních kódů',
    identificationcodetypes_2: 'Typů identifikačních kódů',
    identificationcodetypes_plural: 'Typy identifikačních kódů',
    identities: 'Účty',
    identity: 'Účet',
    inactive: 'Neaktivní',
    installationIndex: 'Index instalace',
    introducedInVersion: 'Zavedeno ve verzi',
    introducedInVersionEmptyErr: 'Zadejte prosím, ve které verzi byla tato funkce zavedena',
    invalidInvitation1: 'Při načítání vaší pozvánky se něco pokazilo.',
    invalidInvitation2: 'Možná vypršela její platnost, nebo neexistuje.',
    invitationExpiresOn: 'Platnost pozvánky vyprší dne',
    invitationInfo:
      '<bold>{{username}}</bold> z organizace <bold>{{organisation}}</bold> vás pozval(a) do komunity <bold>{{community}}</bold>.',
    invitationSentOn: 'Pozvánka odeslána dne',
    invitationState: 'Stav pozvánky',
    invitationType: 'Typ pozvánky',
    invited: 'Pozvaný',
    inviteFreeText: 'Přidejte zprávu, která bude součástí zvacího e-mailu',
    isCustomer: 'Je zákazník',
    isGloballyManaged: 'Dostupné pro správce komunity',
    isOptional: 'Je volitelné',
    isSystem: 'Je systémové',
    isVisible: 'Je viditelné',
    joinMessage: 'Vaše zpráva pro správce komunity',
    joinRequestAcceptedInfo: 'Vážený uživateli {{fullName}}, vaše žádost o připojení byla schválena.',
    joinRequestError: 'Žádost o připojení se nepodařilo odeslat',
    joinRequestErrorMessage:
      'Při odesílání vaší žádosti o připojení správci komunity se něco pokazilo. Zkuste to prosím později.',
    joinRequests: 'Žádosti o připojení',
    joinRequestSentToCommunityAdmin: 'Žádost o připojení byla odeslána správcům komunity',
    joinRequestSentToCommunityAdminDescription:
      'Vaše žádost o připojení byla odeslána správcům komunity, aby vám udělili přístup ke komunitním aplikacím.',
    new: 'Nová',
    notADuplicate: 'Není duplicitní',
    potentialDuplicate: 'Možný duplikát',
    potentialDuplicates: 'Možné duplikáty',
    potentialDuplicateTooltip: 'Tato žádost je před dalším zpracováním posuzována společností Nallian.',
    potentialDuplicationDetails: 'Podrobnosti o možné duplicitě',
    potentialDuplicateCannotManage:
      'Protože tato žádost o připojení může být duplicitní, je před dalším zpracováním posuzována společností Nallian. Tuto žádost o připojení nyní nelze přijmout ani zamítnout.',
    duplicateByIdentificationCode:
      'Tato duplicita byla zjištěna na základě jednoho nebo více shodných identifikačních kódů',
    joinRequest: 'Žádost o připojení',
    score: 'Skóre',
    languageEmptyErr: 'Vyberte prosím jazyk',
    languageIdEmptyErr: 'Vyberte prosím jazyk',
    linkExistingOrganisation: 'Propojit existující organizaci',
    linkIdentityFailed: 'Účet se nepodařilo propojit s uživatelem',
    linkIdentitySuccess: 'Účet byl propojen s uživatelem',
    linkMyIdentityToPrincipal: 'Propojit můj účet s uživatelem',
    location: 'Umístění',
    lockedOut: 'Uzamčeno',
    management: 'Správa',
    mine: '(můj účet)',
    newApp: 'Nová aplikace',
    newAppSubscription: 'Nové předplatné aplikace',
    newCommunityApp: 'Nová komunitní aplikace',
    newCommunityMember: 'Nový člen komunity',
    newCommunityRole: 'Nová komunitní role',
    newCommunitySuite: 'Nová komunitní sada aplikací',
    newFeature: 'Nová funkce',
    newIdentificationCodeType: 'Přidat typ',
    newOnboardingTemplate: 'Nová šablona onboardingu',
    newOrganisationRole: 'Nová organizační role',
    newRelation: 'Nový vztah',
    newRelationType: 'Nový typ vztahu',
    newSuite: 'Nová sada aplikací',
    newUser: 'Nový uživatel',
    noAppsConfiguredForOnboardingTemplate: 'Pro šablonu nejsou nakonfigurovány žádné aplikace.',
    noFeaturesDefined: 'Nejsou definovány žádné funkce',
    noFeaturesDefinedYet: 'Zatím nejsou nakonfigurovány žádné funkce',
    noFeaturesFound: 'Nebyly nalezeny žádné funkce',
    noLinkedAccountsYet: 'Zatím žádné propojené účty.',
    noPendingInvitationsFound: 'Nebyly nalezeny žádné čekající pozvánky',
    noRolesDefined: 'Nejsou definovány žádné role',
    noSuitesFound: 'Nebyly nalezeny žádné sady aplikací',
    noTiersFound: 'Nebyly nalezeny žádné úrovně',
    noUsersFound: 'Nebyli nalezeni žádní uživatelé',
    noAssignmentsFound: 'Nebyla nalezena žádná přiřazení',
    noSubscriptionsFound: 'Nebyla nalezena žádná předplatná',
    subscriptionId: 'ID předplatného',
    createFeatureSubscription: 'Vytvořit předplatné funkce',
    createSubscription: 'Vytvořit předplatné',
    createFeatureSubscriptionSuccess: 'Předplatné funkce bylo úspěšně vytvořeno',
    createFeatureSubscriptionFailed: 'Předplatné funkce se nepodařilo vytvořit',
    createRoleAssignmentSuccess: 'Přiřazení bylo aktualizováno.',
    createRoleAssignmentFailed: 'Uživatele se nepodařilo přidat do role',
    removeUser: 'Odebrat uživatele',
    areYouSureRemoveRoleAssignment:
      'Opravdu chcete odebrat uživatele {{name}} - {{email}} z této role?',
    removeRoleAssignmentSuccess: 'Uživatel byl odebrán z role.',
    removeRoleAssignmentFailed: 'Uživatele se nepodařilo odebrat z role',
    addSubscription: 'Přidat předplatné',
    addSubscriptionSuccess: 'Předplatné bylo aktualizováno.',
    addSubscriptionFailed: 'Předplatné se nepodařilo přidat',
    removeOrgSubscription: 'Odebrat předplatné',
    areYouSureRemoveOrgSubscription:
      'Opravdu chcete odebrat předplatné (funkce: {{featureName}} - instalace: {{installationName}} - aplikace: {{appName}}) organizaci {{organisationName}}? Přístup k této funkci bude odebrán všem uživatelům této organizace.',
    removeOrgSubscriptionSuccess: 'Předplatné bylo odebráno.',
    removeOrgSubscriptionFailed: 'Předplatné se nepodařilo odebrat',
    communityIdEmptyErr: 'Vyberte prosím komunitu',
    organisationIdEmptyErr: 'Vyberte prosím organizaci',
    principalIdEmptyErr: 'Vyberte prosím uživatele',
    assignmentType: 'Typ přiřazení',
    assignments: 'Přiřazení',
    principalName: 'Jméno uživatele',
    organisationCityEmptyErr: 'Zadejte prosím město',
    organisationCountryEmptyErr: 'Zadejte prosím zemi',
    organisationDetailsDescription: 'Vyplňte údaje o organizaci',
    organisationNameEmptyErr: 'Zadejte prosím název organizace',
    organisationRole: 'Organizační role',
    organisationRoles: 'Organizační role',
    organisationRoles_0: 'Organizační role',
    organisationRoles_1: 'Organizační role',
    organisationRoles_2: 'Organizačních rolí',
    organisationRoles_plural: 'Organizační role',
    organisationType: 'Typ organizace',
    organisations: 'Organizace',
    organisationsOverview: 'Přehled organizací',
    owners: 'Vlastníci',
    parentOrganisation: 'Nadřazená organizace',
    passwordToDelete: 'Heslo pro smazání',
    pending: 'Čeká na vyřízení',
    pendingInvitations: 'Čekající pozvánka',
    pendingInvitations_0: 'Čekající pozvánka',
    pendingInvitations_1: 'Čekající pozvánky',
    pendingInvitations_2: 'Čekajících pozvánek',
    pendingInvitations_plural: 'Čekající pozvánky',
    phoneNumber: 'Telefonní číslo',
    pleaseAcceptOurTermsAndConditions: 'Přijměte prosím naše obchodní podmínky',
    pleaseCompleteOrganisationDetails: 'Níže prosím doplňte údaje o vaší organizaci.',
    postalCodeEmptyErr: 'Vyplňte prosím PSČ',
    primaryEmailAddressEmptyErr: 'Zadejte prosím platnou e-mailovou adresu',
    primaryPhoneNumberEmptyErr: 'Zadejte prosím platné telefonní číslo',
    principalFullNameEmptyErr: 'Zadejte prosím celé jméno',
    principalLanguageIdEmptyErr: 'Vyberte prosím jazyk',
    principals: 'uživatel',
    principalTimeZoneEmptyErr: 'Vyberte prosím časové pásmo',
    reInvite: 'Znovu pozvat',
    relationType: 'Vztah',
    relationTypeIdEmptyErr: 'Vyberte prosím typ vztahu',
    relationTypes: 'Typ vztahu',
    relationTypes_0: 'Typ vztahu',
    relationTypes_1: 'Typy vztahů',
    relationTypes_2: 'Typů vztahů',
    relationTypes_plural: 'Typy vztahů',
    removeApp: 'Odebrat aplikaci',
    removeAppAndRoles: 'Odebrat aplikaci, funkce a role',
    removeAppSubscriptionFailed: 'Odebrání předplatného se nezdařilo',
    removeAppSubscriptionSuccess: 'Předplatné bylo úspěšně odebráno',
    removeFeature: 'Odebrat funkci',
    removeThisFeature: 'Odebrat tuto funkci',
    removeThisRole: 'Odebrat roli',
    removeThisSuite: 'Odebrat tuto sadu aplikací',
    removeThisTier: 'Odebrat tuto úroveň',
    requestToJoin: 'Požádat o připojení',
    requestToJoinInfo:
      'Pokud se vaše organizace chce připojit k této komunitě, vyplňte prosím formulář.<br/>Správce komunity vaši žádost posoudí a brzy vás bude kontaktovat.',
    requiresSubscription: 'Vyžadovat předplatné',
    resendInvitationFailed: 'Pozvánku se nepodařilo znovu odeslat',
    resendInvitationSuccess: 'Pozvánka byla znovu odeslána',
    resetPassword: 'Obnovit heslo',
    reviewJoinRequest: 'Posoudit žádost o připojení',
    selectAnApp: 'Vyberte aplikaci',
    selectAnApplication: 'Vyberte aplikaci',
    sendInvitation: 'Odeslat pozvánku',
    sometingWentWrong: 'Něco se pokazilo',
    source: 'Zdroj',
    sourceIdEmptyErr: 'Vyberte prosím zdroj',
    sourceOrganisationRoles: 'Role zdrojové organizace',
    stateName: 'Stát',
    status: 'Stav',
    streetAndNumberEmptyErr: 'Vyplňte prosím ulici a číslo',
    tag: 'Tag',
    tagEmptyErr: 'Vyplňte prosím tag',
    tagExplainer: 'Začíná písmenem, maximální délka 20 znaků',
    target: 'Cíl',
    targetIdEmptyErr: 'Vyberte prosím cíl',
    targetOrganisationRoles: 'Role cílové organizace',
    template: 'Šablona',
    templateHasNoConfiguration: 'Šablona nemá žádnou konfiguraci',
    templateInfo1:
      'Šablona poskytne správci přístup ke skupině aplikací a přidělí mu seznam organizačních rolí.',
    templateInfo2: 'Vyberte šablonu pro zobrazení její konfigurace',
    textMessage: 'Textová zpráva',
    noUserGroupsFound: 'Nebyly nalezeny žádné skupiny uživatelů',
    areYouSureRemoveUserGroup: 'Opravdu chcete odstranit tuto skupinu uživatelů?',
    createUserGroupFailed: 'Skupinu uživatelů se nepodařilo vytvořit',
    createUserGroupSuccess: 'Skupina uživatelů byla vytvořena',
    updateUserGroupFailed: 'Skupinu uživatelů se nepodařilo aktualizovat',
    updateUserGroupSuccess: 'Skupina uživatelů byla aktualizována',
    getUserGroupFailed: 'Skupinu uživatelů se nepodařilo načíst',
    addUserGroup: 'Přidat skupinu uživatelů',
    newUserGroup: 'Nová skupina uživatelů',
    noAppsFeaturesRolesDefined: 'Nejsou definovány žádné aplikace, funkce ani role',
    createUserGroupMemberFailed: 'Člena skupiny uživatelů se nepodařilo přidat',
    createUserGroupMemberSuccess: 'Člen skupiny uživatelů byl přidán',
    removeUserGroupMemberFailed: 'Člena skupiny uživatelů se nepodařilo odebrat',
    removeUserGroupMemberSuccess: 'Člen skupiny uživatelů byl odebrán',
    getUserGroupMembersFailed: 'Členy skupiny uživatelů se nepodařilo načíst',
    membersOfUserGroup: 'Členové skupiny uživatelů',
    timezoneEmptyErr: 'Vyberte prosím časové pásmo',
    timeZoneEmptyErr: 'Vyberte prosím časové pásmo',
    timeZoneIdEmptyErr: 'Vyberte prosím časové pásmo',
    unauthorized: 'K provedení této akce nemáte oprávnění.',
    unlink: 'Odpojit',
    unlinkIdentityFailed: 'Účet se nepodařilo odpojit',
    unlinkIdentitySuccess: 'Účet byl odpojen',
    unlisted: 'Neuvedeno',
    updateAppFailed: 'Aplikaci se nepodařilo aktualizovat',
    updateAppSubscriptionFailed: 'Předplatné aplikace se nepodařilo aktualizovat',
    updateAppSubscriptionSuccess: 'Předplatné aplikace bylo aktualizováno',
    updateAppSuccess: 'Aplikace byla aktualizována',
    updateCommunityAppFailed: 'Komunitní aplikaci se nepodařilo aktualizovat',
    updateCommunityAppSuccess: 'Komunitní aplikace byla aktualizována',
    updateCommunityMemberFailed: 'Člena komunity se nepodařilo aktualizovat',
    updateCommunityMemberRolesFailed: 'Role člena komunity se nepodařilo aktualizovat',
    updateCommunityMemberRolesSuccess: 'Role člena komunity byly aktualizovány',
    updateCommunityMemberSuccess: 'Člen komunity byl aktualizován',
    updateCommunityRoleFailed: 'Komunitní roli se nepodařilo aktualizovat',
    updateCommunityRoleSuccess: 'Komunitní role byla aktualizována',
    updateCommunitySuiteFailed: 'Komunitní sadu aplikací se nepodařilo aktualizovat',
    updateCommunitySuiteSuccess: 'Komunitní sada aplikací byla aktualizována',
    updateIdentificationCodeTypeFailed: 'Typ identifikačního kódu se nepodařilo aktualizovat',
    updateIdentificationCodeTypeSuccess: 'Typ identifikačního kódu byl aktualizován',
    updateOnboardingTemplateFailed: 'Šablonu onboardingu se nepodařilo aktualizovat',
    updateOnboardingTemplateSuccess: 'Šablona onboardingu byla aktualizována',
    updateOrganisationRoleFailed: 'Organizační roli se nepodařilo aktualizovat',
    updateOrganisationRoleSuccess: 'Organizační role byla aktualizována',
    updatePrincipalFailed: 'Uživatele se nepodařilo aktualizovat',
    updatePrincipalSuccess: 'Uživatel byl aktualizován',
    updateRelationFailed: 'Vztah se nepodařilo aktualizovat',
    updateRelationSuccess: 'Vztah byl aktualizován',
    updateRelationTypeFailed: 'Typ vztahu se nepodařilo aktualizovat',
    updateRelationTypeSuccess: 'Typ vztahu byl aktualizován',
    updateUserSuccess: 'Uživatel byl aktualizován',
    url: 'URL',
    urlEmptyErr: 'Zadejte prosím URL',
    useATemplate: 'Použít šablonu',
    user: 'Uživatel',
    userDetailsDescription: 'Vyplňte údaje o uživateli',
    validationPattern: 'Validační vzor',
    verifiedStatus: 'Stav ověření',
    view: 'Zobrazit',
    viewMore: 'Zobrazit více',
    viewSubscribedOrganisations: 'Zobrazit organizace s předplatným',
    viewTemplate: 'Zobrazit šablonu',
    welcomeToThePlatform: 'Vítejte na platformě!',
    welcomeToThePlatformInfo:
      'Váš uživatelský účet byl úspěšně zaregistrován na platformě Nallian. Chcete-li pokračovat a začít používat aplikace, klikněte na „Pokračovat“ a přihlaste se do portálu Nallian.',
    searchAndAddMember: 'Vyhledat a přidat člena',
    searchForNameOrEmailOfUser: 'Vyhledejte jméno nebo e-mail uživatele',
    editUserGroup: 'Upravit skupinu uživatelů',
    manageMembers: 'Zobrazit/spravovat členy',
    userGroupHasNoMembers: 'Tato skupina uživatelů nemá žádné členy',
    organisationsForRole: 'Organizace s komunitní rolí',
    noOrganisationsFound: 'Nebyly nalezeny žádné organizace',
    viewOrganisations: 'Zobrazit organizace',
    appSubscriptions: 'Předplatná aplikací',
    createdByOrganisation: 'Vytvořeno organizací',
    metaData: 'Metadata',
    lastModifiedOn: 'Naposledy změněno dne',
    linkedAccounts: 'Propojené účty',
    relations: 'Vztahy',
    youHaveBeenInvited: 'Byli jste pozváni',
    areYouSureYouWantToRemoveAppFeatureSubscription:
      'Opravdu chcete odebrat předplatné této funkce? Přístup k této funkci bude odebrán všem uživatelům této organizace.',
    applyOnboardingTemplate: 'Použít šablonu onboardingu',
    getOnboardingTemplatesFailed: 'Šablony onboardingu se nepodařilo načíst',
    selectAnOnboardingTemplate: 'Vyberte šablonu onboardingu',
    onboardingTemplateIdEmptyErr: 'Vyberte prosím šablonu onboardingu',
    applyOnboardingTemplateFailed: 'Šablonu onboardingu se nepodařilo použít',
    applyOnboardingTemplateSuccess: 'Šablona onboardingu byla použita',
    addTemplateInfo:
      'Šablona přidá organizaci následující aplikace a komunitní role',
    filters: 'Filtry',
    filterOnUserRole: 'Filtrovat podle role uživatele',
    identityOrClient: 'Účet nebo klient',
    searchForAnIdentityOrAddClientId: 'Vyhledejte účet nebo přidejte ID klienta',
    filterOnIdentificationCode: 'Filtrovat podle identifikačního kódu',
    useNoTemplate: 'Nepoužít žádnou šablonu',
    templateInfo: 'Vyberte šablonu',
    userInfo: 'Informace o uživateli',
    invalidUrlCommuntiyAppFeature: 'Musí být platná URL nebo musí obsahovat [EnvironmentUrl]',
    communitiesOverview: 'Přehled komunit',
    createCommunityFailed: 'Komunitu se nepodařilo vytvořit',
    createCommunitySuccess: 'Komunita byla vytvořena',
    newCommunity: 'Nová komunita',
    themeName: 'Název motivu',
    defaultLanguage: 'Výchozí jazyk',
    mustBeValidUrl: 'Musí být platná URL',
    updateCommunityFailed: 'Komunitu se nepodařilo aktualizovat',
    updateCommunitySuccess: 'Komunita byla aktualizována',
    fixedCommunityId:
      'ID (nepovinné, pouze pokud chcete stejné ID komunity ve všech prostředích)',
    updateNotificationSettingsFailed: 'Nastavení oznámení se nepodařilo aktualizovat',
    updateNotificationSettingsSuccess: 'Nastavení oznámení bylo aktualizováno',
    notificationSettings: 'Nastavení oznámení',
    fromName: 'Jméno odesílatele',
    fromEmail: 'E-mail odesílatele',
    replyToEmail: 'E-mail pro odpověď',
    replyToName: 'Jméno pro odpověď',
    emailSubjectPrefix: 'Předpona předmětu e-mailu',
    contactEmail: 'Kontaktní e-mail',
    updateHostsFailed: 'Hostitele se nepodařilo aktualizovat',
    updateHostsSuccess: 'Hostitelé byli aktualizováni',
    noHostsYet: 'Zatím žádní hostitelé',
    addHost: 'Přidat hostitele',
    host: 'Hostitel',
    hosts: 'Hostitelé',
    isPrimary: 'Je primární',
    onlyOnePrimaryHost: 'Primární může být pouze jeden hostitel',
    minOnePrimaryHost: 'Alespoň jeden hostitel musí být primární',
    pleaseEnterAHost: 'Zadejte prosím platného hostitele',
    tenantId: 'ID tenanta',
    tenantHostUrl: 'URL hostitele tenanta',
    tenantInformation: 'Informace o tenantovi',

    communityWelcomeText: 'Uvítací text komunity',
    legalDocuments: 'Právní dokumenty',
    uploadNewGeneralTermsAndConditions: 'Nahrát nové všeobecné obchodní podmínky',
    documents: 'Dokumenty',
    title: 'Název',
    revision: 'Revize',
    download: 'Stáhnout',
    // theme lookups (internal)
    themeLookups_0: 'Mapování motivu',
    themeLookups_1: 'Mapování motivů',
    themeLookups_2: 'Mapování motivů',
    themeLookups_plural: 'Mapování motivů',
    newThemeLookup: 'Nové mapování motivu',
    createThemeLookupFailed: 'Mapování motivu se nepodařilo vytvořit',
    createThemeLookupSuccess: 'Mapování motivu bylo vytvořeno',
    updateThemeLookupFailed: 'Mapování motivu se nepodařilo aktualizovat',
    updateThemeLookupSuccess: 'Mapování motivu bylo aktualizováno',
    editThemeLookup: 'Upravit mapování motivu',
    themeLookups: 'Mapování motivu',
    titleEmptyErr: 'Zadejte prosím název',
    hostEmptyErr: 'Zadejte prosím hostitele',
    themeNameEmptyErr: 'Zadejte prosím název motivu',
    editCommunityTextFailed: 'Text komunity se nepodařilo aktualizovat',
    editCommunityTextSuccess: 'Text komunity byl aktualizován',
    documentUploaded: 'Dokument byl nahrán',
    documentUploadFailed: 'Nahrání dokumentu se nezdařilo',
    noCommunityTextYet: 'Zatím žádný uvítací text komunity',
    noDocumentsYet: 'Zatím žádné dokumenty',
    noWelcomeTextAvailable: 'Pro tuto komunitu nejsou k dispozici žádné uvítací informace.',
    addLanguage: 'Přidat jazyk',
    enterLanguageKey: 'Zadejte klíč jazyka',
    emailNotificationFooter: 'Zápatí e-mailových oznámení',
    emailNotificationHeader: 'Záhlaví e-mailových oznámení',
    removeCommunityAppClientFailed: 'Klienta se nepodařilo odebrat',
    removeCommunityAppClientSuccess: 'Klient byl odebrán',
    createCommunityAppClientFailed: 'Klienta se nepodařilo vytvořit',
    createCommunityAppClientSuccess: 'Klient byl vytvořen',
    getCommunityAppClientsFailed: 'Klienty se nepodařilo načíst',
    manageClientsForCommunityApp: 'Spravovat klienty',
    addClient: 'Přidat klienta',
    manageAppClients: 'Spravovat klienty aplikace',
    noClientsYet: 'Zatím žádní klienti',
    unknownIdentityProvider: 'Neznámý poskytovatel identity',
    areYouSureRemoveOrganisation:
      'Opravdu chcete odebrat organizaci „{{item.name}}“?',
    timeSettings: 'Nastavení času',
    userDetails: 'Podrobnosti o uživateli',
    appsAndRoles: 'Aplikace a role',
    accountsIdentities: 'Propojené účty',
    accounts: 'Účty',
    areYouSureContinueWithoutUserHasRoles:
      'Opravdu nechcete tomuto uživateli udělit přístup k žádné aplikaci?',
    principalRemoved: 'Uživatel byl odebrán',
    userGroups: 'Skupiny uživatelů',
    userGroup: 'Skupina uživatelů',
    selectUserGroups: 'Vyberte skupiny uživatelů',
    rolesFromUserGroups: 'Role ze skupin uživatelů',
    noRolesInUserGroup: 'Této skupině uživatelů nejsou přiřazeny žádné role',
    noRolesInSelectedUserGroups: 'Vybraným skupinám uživatelů nejsou přiřazeny žádné role',
    data: 'Data',
    id: 'ID',
    shortName: 'Zkrácený název',
    installations: 'Instalace',
    isGlobal: 'Je globální',
    isCrossCommunity: 'Je napříč komunitami',
    isObsolete: 'Je zastaralé',
    copyToClipboard: 'Kopírovat do schránky',
    administrators: 'Správci',
    welcomeText: 'Uvítací text komunity',
    overviewText: 'Přehledový text domovské stránky',
    pleaseTypeToEnableConfirmButton: "Pro aktivaci potvrzovacího tlačítka napište '{{message}}'.",
    pleaseTypeHere: 'Napište prosím sem',
    removeOrganisation: 'Odebrat organizaci',
    removeOrganisationFailed: 'Organizaci se nepodařilo odebrat',
    removeOrganisationSuccess: 'Organizace byla odebrána',
    removeAppInstallation: 'Odebrat instalaci aplikace',
    areYouSureRemoveAppInstallation:
      'Opravdu chcete odebrat instalaci aplikace „{{item.name}}“?',
    removeAppInstallationFailed: 'Instalaci aplikace se nepodařilo odebrat',
    removeAppInstallationSuccess: 'Instalace aplikace byla odebrána',
    areYouSureRemoveApp: 'Opravdu chcete odebrat aplikaci „{{item.name}}“?',
    removeAppFailed: 'Aplikaci se nepodařilo odebrat',
    removeAppSuccess: 'Aplikace byla odebrána',
    roleInFeature: 'Role ve funkci {{featureName}}',
    featureInInstallation: 'Funkce v instalaci {{installationName}}',
    installationOfApp: 'Instalace aplikace {{appName}}',
    installation: 'Instalace',
    removeFeatureSubscriptionFailed: 'Předplatné funkce se nepodařilo odebrat',
    removeFeatureSubscriptionSuccess: 'Předplatné funkce bylo odebráno',
    removeSubscription: 'Odebrat předplatné',
    areYouSureRemoveSubscription:
      'Opravdu chcete odebrat předplatné pro „{{organisationName}}“?',
    identificationCodesCount: 'Počet identifikačních kódů: {{count}}',
    noIdentificationCodes: 'Žádné identifikační kódy',
    principalCount: 'Počet uživatelů: {{count}}',
    noPrincipals: 'Žádní uživatelé',
    errorLoadingPrincipals: 'Chyba při načítání uživatelů',
    unnamed: 'Bez názvu',
    linkedPrincipals: 'Propojení uživatelé',
    allIdentities: 'Všechny identity',
    provider: 'Poskytovatel',
    anonymizeIdentity: 'Anonymizovat identitu',
    areYouSureYouWantToAnonymiseIdentity:
      'Opravdu chcete anonymizovat identitu uživatele {{fullName}}?',
    anonymizeIdentitySuccess: 'Identita byla úspěšně anonymizována',
    anonymizeIdentityFailed: 'Identitu se nepodařilo anonymizovat',
    noIdentitiesFound: 'Nebyly nalezeny žádné identity',
    typeMinimum2Characters: 'Zadejte min. 2 znaky',
    startWithPlusEgFormat: 'Začněte znakem +, např. +32',
    noRoles: 'Žádné role',
    rolesCount: 'Počet rolí: {{count}}',
    noIdentificationCodeTypesFound: 'Nebyly nalezeny žádné typy identifikačních kódů',
    isRequired: 'Je povinné',
    identificationCodeTypeTagEmptyErr: 'Vyberte prosím typ identifikačního kódu',
    editType: 'Upravit typ',
    theFollowingIdentificationCodeTypesAreRequired:
      'Chybí následující identifikační kódy: {{missingTypes}}',
    updateContactFailed: 'Kontakt se nepodařilo aktualizovat',
    updateContactSuccess: 'Kontakt byl aktualizován',
    createContactFailed: 'Kontakt se nepodařilo vytvořit',
    createContactSuccess: 'Kontakt byl vytvořen',
    removeContactFailed: 'Kontakt se nepodařilo odebrat',
    removeContactSuccess: 'Kontakt byl odebrán',
    contacts: 'Kontakty',
    noContactsYet: 'Zatím žádné kontakty.',
    newContact: 'Nový kontakt',
    editContact: 'Upravit kontakt',
    areYouSureYouWantToRemoveContact: 'Opravdu chcete odebrat tento kontakt?',
    logo: 'Logo',
    uploadANewLogo: 'Nahrát nové logo',
    noLogoAvailable: 'Zatím žádné logo.',
    viewLogo: 'Zobrazit logo',
    uploadLogo: 'Nahrát logo',
    removeOrganisationLogoFailed: 'Logo se nepodařilo odebrat',
    removeOrganisationLogoSuccess: 'Logo bylo odebráno',
    uploadLogoSuccess: 'Logo bylo nahráno',
    uploadLogoError: 'Logo se nepodařilo nahrát',
    removeLogo: 'Odebrat logo',
    areYouSureYouWantToRemoveLogo: 'Opravdu chcete odebrat logo?',
    fileEmptyErr: 'Nahrajte prosím platný soubor',
    noFeatureDetails: 'Žádné podrobnosti o funkci',
    pleaseSelectRoles: 'Vyberte prosím jednu nebo více rolí',
    idpUserGroup: 'Automaticky spravovaná skupina uživatelů',
    idpUserGroupInfo:
      'Tato skupina je průběžně synchronizována se seznamem uživatelů vaší organizace. Uživatele můžete stále přidávat ručně – pokud se však někdo přihlásí přes firemní přihlašovací systém, mohou být vaše změny při jeho příštím přihlášení vráceny zpět.',
    viaIdp: 'Přiřazeno automaticky',
    invitationIsExpired: 'Platnost této pozvánky vypršela',
    inviationNotValidAnymore: 'Tato pozvánka byla stažena',
    invitationUsedProceedLogin:
      'Zdá se, že tato pozvánka již byla použita. Můžete se rovnou přihlásit ke svému účtu.',
    invitationUsedProceedProcess:
      'Tato pozvánka již byla použita, ale váš účet je téměř připraven. Pro dokončení registrace se prosím přihlaste, vyplňte údaje o své společnosti a přijměte obchodní podmínky.',
    completeRegistration: 'Dokončit registraci',
    signIn: 'Přihlásit se',
    inviteAlreadyUsed: 'Pozvánka již byla použita',
    updateOrganisationFailed: 'Organizaci se nepodařilo aktualizovat',
    organisationUpdated: 'Organizace byla aktualizována',
    getCommunityRoleFailed: 'Komunitní roli se nepodařilo načíst',
    createOrganisation: 'Vytvořit organizaci',
    organisationCreated: 'Organizace byla vytvořena',
    createOrganisationFailed: 'Organizaci se nepodařilo vytvořit',
    onboardingTemplates: 'Šablony onboardingu',
    identificationCodeTypes: 'Typy identifikačních kódů',
    notification: 'Oznámení',
    textsAndLegal: 'Texty a právní dokumenty',
    exportAsJSON: 'Exportovat jako JSON',
    addContact: 'Přidat kontakt',
    selectCommunityForInvitation:
      'Vyberte kontext komunity, ve kterém chcete pozvánku odeslat',
    allUsers: 'Všichni uživatelé',
    codeCannotHaveTrailingSpaces: 'Kód nesmí končit mezerami',
    deleteRole: 'Smazat roli',
    areYouSureDeleteRole: 'Opravdu chcete smazat roli „{{name}}“?',
    pleaseTypeRoleNameToConfirm: 'Pro potvrzení napište „{{name}}“',
    acknowledgeRoleNotObsolete:
      'Beru na vědomí, že tato role zatím není označena jako zastaralá, a přesto ji chci smazat',
    removeRoleFailed: 'Roli se nepodařilo odebrat',
    removeRoleSuccess: 'Role byla úspěšně odebrána',
    deleteFeature: 'Smazat funkci',
    areYouSureDeleteFeature: 'Opravdu chcete smazat funkci „{{name}}“?',
    pleaseTypeFeatureNameToConfirm: 'Pro potvrzení napište „{{name}}“',
    acknowledgeFeatureNotObsolete:
      'Beru na vědomí, že tato funkce zatím není označena jako zastaralá, a přesto ji chci smazat',
    removeFeatureFailed: 'Funkci se nepodařilo odebrat',
    removeFeatureSuccess: 'Funkce byla úspěšně odebrána',
    noFeaturesYet: 'Zatím žádné funkce',

    /* documents */
    documents: 'Dokumenty',
    documentsOverview: 'Přehled dokumentů',
    uploadDocument: 'Nahrát dokument',
    documentType: 'Typ dokumentu',
    documentType_CompanyEmployeeRegistration: 'Registrace zaměstnance společnosti',
    documentType_AirportAccreditation: 'Letištní akreditace',
    documentType_Passport: 'Cestovní pas',
    documentType_DriverLicense: 'Řidičský průkaz',
    documentType_IDCard: 'Občanský průkaz',
    selectDocumentType: 'Vyberte typ dokumentu',
    fileUpload: 'Nahrání souboru',
    documentName: 'Název dokumentu',
    fileSize: 'Velikost souboru',
    uploadedBy: 'Nahrál(a)',
    uploadedAt: 'Nahráno',
    expirationDate: 'Datum vypršení platnosti',
    expirationDateHelperText: 'Datum musí být dnešní nebo pozdější, nejvýše 10 let od dneška',
    pending: 'Čeká na vyřízení',
    validated: 'Ověřeno',
    expired: 'Platnost vypršela',
    superseded: 'Nahrazeno',
    rejected: 'Zamítnuto',
    expiring: 'Platnost brzy vyprší',
    approve: 'Schválit',
    reject: 'Zamítnout',
    preview: 'Náhled',
    history: 'Historie',
    pleaseSelectDocumentType: 'Vyberte prosím typ dokumentu',
    unsupportedFileType: 'Nepodporovaný typ souboru. Povoleny jsou pouze soubory JPEG a PNG.',
    fileTooLarge: 'Soubor je příliš velký. Maximální velikost souboru je 10 MB.',
    expirationDateRequired: 'Vyberte prosím datum vypršení platnosti',
    expirationDatePast: 'Datum vypršení platnosti nemůže být v minulosti',
    expirationDateTooFar: 'Datum vypršení platnosti nemůže být více než 10 let v budoucnosti',
    uploadSuccessful: 'Dokument byl úspěšně nahrán',
    uploadFailed: 'Nahrání dokumentu se nezdařilo',
    documentApproved: 'Dokument byl úspěšně schválen',
    documentPreviewTitle: 'Náhled dokumentu',
    documentPreviewCaption: 'Citlivé údaje byly z důvodu ochrany soukromí začerněny',
    documentPreviewError: 'Náhled dokumentu se nepodařilo načíst. Zkuste to prosím znovu.',
    documentApproveWarning:
      'Schválením tohoto dokumentu potvrzujete, že jste zkontrolovali redigovaný obrázek. Ujistěte se prosím, že jsou viditelné pouze jméno, pohlaví a fotografie a že všechny ostatní citlivé údaje jsou řádně začerněny. Pokud nejste spokojeni se systémově vygenerovaným začerněním, můžete dokument zamítnout a místo něj nahrát předem redigovaný dokument.',
    documentRedactingPlaceholder:
      'Čekejte prosím. Váš dokument se právě rediguje a bude brzy k dispozici.',
    documentRejected: 'Dokument byl úspěšně zamítnut',
    confirmApprove: 'Potvrdit schválení',
    confirmReject: 'Potvrdit zamítnutí',
    documentRejectedReuploadPrompt:
      'Dokument byl zamítnut. Chcete znovu nahrát novou verzi?',
    uploadLater: 'Nahrát později',
    reuploadNow: 'Znovu nahrát nyní',
    consentWarning:
      'Nahráním tohoto dokumentu potvrzujete, že vlastník dokumentu souhlasil s jeho uložením a zpracováním.',
    consentCheckbox: 'Beru na vědomí výše uvedené prohlášení a souhlasím s ním',
    noDocumentsFound: 'Nebyly nalezeny žádné dokumenty',
    rejectReason: 'Důvod zamítnutí',
    approveDocumentFailed: 'Dokument se nepodařilo schválit',
    rejectDocumentFailed: 'Dokument se nepodařilo zamítnout',
    areYouSureApproveDocument: 'Opravdu chcete schválit tento dokument?',
    areYouSureRejectDocument: 'Opravdu chcete zamítnout tento dokument?',
    viewHistory: 'Zobrazit historii',
    documentHistory: 'Historie dokumentu',
    // Document translations (shared keys needed by app components)
    'documents.title': 'Dokumenty',
    'documents.type': 'Typ dokumentu',
    'documents.fileName': 'Název souboru',
    'documents.uploadedAt': 'Nahráno',
    'documents.uploadedBy': 'Nahrál(a)',
    'documents.expirationDate': 'Datum vypršení platnosti',
    'documents.status': 'Stav',
    'documents.actions': 'Akce',
    'documents.preview': 'Náhled',
    'documents.noDocumentsFound': 'Nebyly nalezeny žádné dokumenty',
    'documents.failedToLoad': 'Dokumenty se nepodařilo načíst',
    'documents.previewTitle': 'Náhled dokumentu',
    'documents.previewCaption': 'Toto je náhled dokumentu',
    'documents.previewError': 'Náhled dokumentu se nepodařilo načíst',
    'documents.type_CompanyEmployeeRegistration': 'Registrace zaměstnance společnosti',
    'documents.type_AirportAccreditation': 'Letištní akreditace',
    'documents.type_Passport': 'Cestovní pas',
    'documents.type_DriverLicense': 'Řidičský průkaz',
    'documents.type_IDCard': 'Občanský průkaz',
    'documents.status.pending': 'Čeká na vyřízení',
    'documents.status.validated': 'Ověřeno',
    'documents.status.expired': 'Platnost vypršela',
    'documents.status.superseded': 'Nahrazeno',
    'documents.status.rejected': 'Zamítnuto',
    'documents.status.expiring': 'Platnost brzy vyprší',
    // Document translations (app-specific)
    'documents.confirmUploadTitle': 'Kontrola a potvrzení dokumentu',
    'documents.confirmUpload': 'Potvrdit nahrání',
    'documents.redactWarning.intro':
      'Schválením tohoto dokumentu potvrzujete, že jste zkontrolovali redigovaný obrázek.',
    'documents.redactWarning.visibleInfo': 'Viditelné by měly zůstat pouze následující údaje:',
    'documents.redactWarning.fullName': 'Celé jméno',
    'documents.redactWarning.photo': 'Fotografie',
    'documents.redactWarning.expirationDate': 'Datum vypršení platnosti',
    'documents.redactWarning.mustBlackOut':
      'Všechny ostatní citlivé údaje musí být zcela začerněny.',
    'documents.redactWarning.adjustInstructions':
      'Pokud nejste spokojeni se systémově vygenerovanými začerněními, můžete je upravit tažením myší přes libovolnou oblast pro přidání nového začernění nebo kliknutím na „x“ pro jeho odstranění.',
    'documents.history': 'Historie dokumentu',
    'documents.redactingPlaceholder': 'Dokument se zpracovává pro začernění...',
    'documents.showFinalPreview': 'Zobrazit konečný výsledek',
    'documents.thisIsHowImageWillBeSaved': 'takto bude obrázek uložen',
    'documents.failedToLoadImage': 'Obrázek se nepodařilo načíst',
    'documents.upload': 'Nahrát dokument',
    'documents.documentConfirmed': 'Dokument byl úspěšně potvrzen',
    'documents.confirmFailed': 'Dokument se nepodařilo potvrdit',
    'documents.analyzeFailed': 'Dokument se nepodařilo analyzovat',
    'documents.uploadSuccessful': 'Dokument byl úspěšně nahrán',
    'documents.uploadFailed': 'Dokument se nepodařilo nahrát',
    'documents.consentWarning':
      'Nahráním tohoto dokumentu potvrzujete, že vlastník dokumentu souhlasil s jeho uložením a zpracováním.',
    'documents.consentCheckbox':
      'Beru na vědomí, že vlastník dokumentu udělil souhlas s jeho uložením a zpracováním.',
    'documents.redactConfirmCheckbox':
      'Potvrzuji, že tento dokument byl řádně redigován a viditelné zůstávají pouze povolené údaje.',
    'documents.selectType': 'Vyberte typ dokumentu',
    'documents.pleaseSelectType': 'Vyberte prosím typ dokumentu',
    'documents.file': 'Soubor',
    'documents.unsupportedFileType': 'Vyberte prosím platný soubor',
    'documents.expirationDateRequired': 'Datum vypršení platnosti je povinné',
    'documents.expirationDatePast': 'Datum vypršení platnosti nemůže být v minulosti',
    'documents.expirationDateTooFar': 'Datum vypršení platnosti nemůže být více než 10 let v budoucnosti',
    'documents.expirationDateHelperText': 'Datum musí být dnešní nebo pozdější, nejvýše 10 let od dneška',
    'documents.approveWarning': 'Před schválením prosím tento dokument pečlivě zkontrolujte.',
    'documents.rejected': 'Dokument zamítnut',
    'documents.rejectedReuploadPrompt':
      'Dokument byl zamítnut. Chcete nahrát novou verzi?',
    'documents.uploadLater': 'Nahrát později',
    'documents.reuploadNow': 'Znovu nahrát nyní',
    'documents.areYouSureReject': 'Opravdu chcete zamítnout tento dokument?',
    'documents.confirmReject': 'Zamítnout',
    'documents.areYouSureApprove': 'Opravdu chcete schválit tento dokument?',
    'documents.confirmApprove': 'Schválit',
    // Impersonation
    requestImpersonation: 'Požádat o impersonaci',
    impersonationRequest: 'Žádost o impersonaci',
    support: 'Podpora',
    implementation: 'Implementace',
    duration: 'Doba trvání',
    ticketProjectReference: 'Reference tiketu/projektu',
    ticketProjectReferencePlaceholder: 'např. TICKET-1234 nebo PROJECT-5678',
    documentAccess: 'Přístup k dokumentům',
    documentAccessTooltip:
      'Uděluje přístup k identifikačním dokumentům propojeným s tímto účtem (např. řidičský průkaz, občanský průkaz, cestovní pas). Povolte pouze v nezbytných případech, protože to vyžaduje schválení správcem organizace.',
    reason: 'Důvod',
    reasonPlaceholder: 'Zadejte důvod impersonace...',
    impersonationInfoBanner:
      'Relace impersonace se aktivuje, jakmile cílový uživatel žádost přijme.',
    submitRequest: 'Odeslat žádost',
    impersonationRequestCreated: 'Žádost o impersonaci byla úspěšně odeslána',
    impersonationRequestFailed: 'Žádost o impersonaci se nepodařilo odeslat',
    reasonEmptyErr: 'Důvod je povinný',
    requestedDurationEmptyErr: 'Doba trvání je povinná',
    reasonTooLong: 'Důvod smí mít nejvýše {{max}} znaků',
    // Impersonation Requests List
    impersonationRequests: 'Žádosti o impersonaci',
    // Short tab labels
    'tab.invitations': 'Pozvánky',
    'tab.apps': 'Aplikace',
    'tab.idCodes': 'ID kódy',
    'tab.documents': 'Dokumenty',
    'tab.impersonation': 'Impersonace',
    impersonationRequestDetails: 'Podrobnosti žádosti o impersonaci',
    noImpersonationRequestsFound: 'Nebyly nalezeny žádné žádosti o impersonaci',
    targetUser: 'Cílový uživatel',
    requestedAt: 'Požádáno',
    activeUntil: 'Aktivní do',
    activeFrom: 'Aktivní od',
    requester: 'Žadatel',
    approvedDuration: 'Schválená doba trvání',
    requestValidUntil: 'Žádost platná do',
    resolvedBy: 'Vyřídil(a)',
    resolvedAt: 'Vyřízeno',
    coResolvedBy: 'Spoluvyřídil(a)',
    coResolvedAt: 'Spoluvyřízeno',
    coDenialReason: 'Důvod spoluzamítnutí',
    revokedBy: 'Odvolal(a)',
    revokedAt: 'Odvoláno',
    revocationReason: 'Důvod odvolání',
    'impersonation.confirmApprove': 'Opravdu chcete schválit tuto žádost?',
    'impersonation.confirmDeny': 'Opravdu chcete zamítnout tuto žádost?',
    terminateAccess: 'Ukončit přístup',
    terminateImpersonationSuccess: 'Přístup přes impersonaci byl úspěšně ukončen',
    terminateImpersonationFailed: 'Přístup přes impersonaci se nepodařilo ukončit',
    pendingCoApproval: 'Čeká na spoluschválení',
    revoked: 'Odvoláno',
    consolidated: 'Konsolidováno',
    denied: 'Zamítnuto',
    coApproveImpersonationSuccess: 'Žádost o impersonaci byla schválena',
    coApproveImpersonationFailed: 'Žádost o impersonaci se nepodařilo schválit',
    coDenyImpersonationSuccess: 'Žádost o impersonaci byla zamítnuta',
    coDenyImpersonationFailed: 'Žádost o impersonaci se nepodařilo zamítnout',
    impersonating: 'Impersonace uživatele',
    expiresIn: 'Vyprší za',
    expiresAt: 'Vyprší',
  },
};
